(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire26b2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire26b2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2AvH9", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("24WJr")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("9Ddln")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("24WJr")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("d6CNR")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("nsqlv")).createPopper; });

var $cEoCh = parcelRequire("cEoCh");

var $1Esf5 = parcelRequire("1Esf5");

var $24WJr = parcelRequire("24WJr");
var $9Ddln = parcelRequire("9Ddln");

var $d6CNR = parcelRequire("d6CNR");

var $nsqlv = parcelRequire("nsqlv");
$parcel$exportWildcard(module.exports, $cEoCh);
$parcel$exportWildcard(module.exports, $1Esf5);

});
parcelRegister("cEoCh", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $935c50c8659545b7$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $935c50c8659545b7$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $935c50c8659545b7$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $935c50c8659545b7$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $935c50c8659545b7$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $935c50c8659545b7$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $935c50c8659545b7$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $935c50c8659545b7$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $935c50c8659545b7$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $935c50c8659545b7$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $935c50c8659545b7$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $935c50c8659545b7$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $935c50c8659545b7$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $935c50c8659545b7$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $935c50c8659545b7$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $935c50c8659545b7$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $935c50c8659545b7$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $935c50c8659545b7$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $935c50c8659545b7$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $935c50c8659545b7$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $935c50c8659545b7$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $935c50c8659545b7$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $935c50c8659545b7$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $935c50c8659545b7$export$d087d3878fdf71d5; });
var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];

});

parcelRegister("1Esf5", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("4dG9Q")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("2P8UZ")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("xcXwJ")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("lsNQz")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("iMl36")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("aKE1P")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("c8CJF")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("ksntq")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("6blW5")).default; });

var $4dG9Q = parcelRequire("4dG9Q");

var $2P8UZ = parcelRequire("2P8UZ");

var $xcXwJ = parcelRequire("xcXwJ");

var $lsNQz = parcelRequire("lsNQz");

var $iMl36 = parcelRequire("iMl36");

var $aKE1P = parcelRequire("aKE1P");

var $c8CJF = parcelRequire("c8CJF");

var $ksntq = parcelRequire("ksntq");

var $6blW5 = parcelRequire("6blW5");

});
parcelRegister("4dG9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $312913fa2edc14b2$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");
// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $9ghG1.isHTMLElement)(element) || !(0, $1DgzM.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $9ghG1.isHTMLElement)(element) || !(0, $1DgzM.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("1DgzM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13064aa41dd611dc$export$2e2bcd8739ae039; });
function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("9ghG1", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $6be351e83d6bf643$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $6be351e83d6bf643$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $6be351e83d6bf643$export$af51f0f06c0f328a; });

var $3s2ws = parcelRequire("3s2ws");
function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $3s2ws.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $3s2ws.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $3s2ws.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("3s2ws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2835f189066da699$export$2e2bcd8739ae039; });
function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("2P8UZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20e743289f291887$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $eQTzt = parcelRequire("eQTzt");

var $1yHmV = parcelRequire("1yHmV");

var $5jKxG = parcelRequire("5jKxG");

var $3m9cx = parcelRequire("3m9cx");

var $6Q9NZ = parcelRequire("6Q9NZ");

var $VHjvt = parcelRequire("VHjvt");

var $jxLne = parcelRequire("jxLne");

var $cEoCh = parcelRequire("cEoCh");
var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $VHjvt.default)(typeof padding !== 'number' ? padding : (0, $jxLne.default)(padding, (0, $cEoCh.basePlacements)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $8MGgd.default)(state.placement);
    var axis = (0, $3m9cx.default)(basePlacement);
    var isVertical = [
        (0, $cEoCh.left),
        (0, $cEoCh.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $eQTzt.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cEoCh.top) : (0, $cEoCh.left);
    var maxProp = axis === 'y' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5jKxG.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $6Q9NZ.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $1yHmV.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("8MGgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6653967f933aaf29$export$2e2bcd8739ae039; });

function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("eQTzt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad01075005a54bff$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");
function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2mYUo.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("2mYUo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b9ce20ada6267ed$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");

var $c79oh = parcelRequire("c79oh");

var $3s2ws = parcelRequire("3s2ws");

var $fvb08 = parcelRequire("fvb08");
function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $9ghG1.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $c79oh.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $c79oh.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $9ghG1.isElement)(element) ? (0, $3s2ws.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fvb08.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("c79oh", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $8d1d6c453d67c9ab$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $8d1d6c453d67c9ab$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $8d1d6c453d67c9ab$export$2077e0241d6afd3c; });
var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("fvb08", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b49248e188a52b8b$export$2e2bcd8739ae039; });

var $cTNvd = parcelRequire("cTNvd");
function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cTNvd.default)());
}

});
parcelRegister("cTNvd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9641053f99441231$export$2e2bcd8739ae039; });
function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("1yHmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $122a9b90bb37fc73$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");
function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $9ghG1.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("5jKxG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3df2d470c30a409e$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");

var $1DgzM = parcelRequire("1DgzM");

var $3lU8c = parcelRequire("3lU8c");

var $9ghG1 = parcelRequire("9ghG1");

var $3pGhD = parcelRequire("3pGhD");

var $gBzyr = parcelRequire("gBzyr");

var $cTNvd = parcelRequire("cTNvd");
function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $9ghG1.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3lU8c.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cTNvd.default)());
    var isIE = /Trident/i.test((0, $cTNvd.default)());
    if (isIE && (0, $9ghG1.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3lU8c.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $gBzyr.default)(element);
    if ((0, $9ghG1.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $9ghG1.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $1DgzM.default)(currentNode)) < 0){
        var css = (0, $3lU8c.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $3s2ws.default)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $3pGhD.default)(offsetParent) && (0, $3lU8c.default)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1DgzM.default)(offsetParent) === 'html' || (0, $1DgzM.default)(offsetParent) === 'body' && (0, $3lU8c.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}

});
parcelRegister("3lU8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $270edfbc2bfbd22f$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $3s2ws.default)(element).getComputedStyle(element);
}

});

parcelRegister("3pGhD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27c48183f07ddbe8$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");
function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $1DgzM.default)(element)) >= 0;
}

});

parcelRegister("gBzyr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c16bae6800ecc025$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");

var $4NPk2 = parcelRequire("4NPk2");

var $9ghG1 = parcelRequire("9ghG1");
function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $1DgzM.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $9ghG1.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4NPk2.default)(element) // fallback
    );
}

});
parcelRegister("4NPk2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37f38c85c1edad4d$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");
function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $9ghG1.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("3m9cx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $271a905a3adf884c$export$2e2bcd8739ae039; });
function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("6Q9NZ", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $4faf3481d1df2f95$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $4faf3481d1df2f95$export$86c8af6d3ef0b4a; });

var $c79oh = parcelRequire("c79oh");
function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $c79oh.max)(min, (0, $c79oh.min)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("VHjvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ad6ec2b432662d8$export$2e2bcd8739ae039; });

var $83sLw = parcelRequire("83sLw");
function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $83sLw.default)(), paddingObject);
}

});
parcelRegister("83sLw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dd4eac14cb3a9cb$export$2e2bcd8739ae039; });
function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("jxLne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a5d8ce75f76756$export$2e2bcd8739ae039; });
function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("xcXwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $063d2297888fea12$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $5jKxG = parcelRequire("5jKxG");

var $3s2ws = parcelRequire("3s2ws");

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $8MGgd = parcelRequire("8MGgd");

var $8Opre = parcelRequire("8Opre");

var $c79oh = parcelRequire("c79oh");
var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $c79oh.round)(x * dpr) / dpr || 0,
        y: (0, $c79oh.round)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cEoCh.left);
    var sideY = (0, $cEoCh.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5jKxG.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $3s2ws.default)(popper)) {
            offsetParent = (0, $4NPk2.default)(popper);
            if ((0, $3lU8c.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cEoCh.top) || (placement === (0, $cEoCh.left) || placement === (0, $cEoCh.right)) && variation === (0, $cEoCh.end)) {
            sideY = (0, $cEoCh.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cEoCh.left) || (placement === (0, $cEoCh.top) || placement === (0, $cEoCh.bottom)) && variation === (0, $cEoCh.end)) {
            sideX = (0, $cEoCh.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $3s2ws.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $8MGgd.default)(state.placement),
        variation: (0, $8Opre.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};

});
parcelRegister("8Opre", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66a6b9b7896d6ec4$export$2e2bcd8739ae039; });
function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("lsNQz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa02e10eb4995658$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $3s2ws.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};

});

parcelRegister("iMl36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dabd09962ff7b702$export$2e2bcd8739ae039; });

var $ivINy = parcelRequire("ivINy");

var $8MGgd = parcelRequire("8MGgd");

var $7Bece = parcelRequire("7Bece");

var $9Ddln = parcelRequire("9Ddln");

var $gnuPI = parcelRequire("gnuPI");

var $cEoCh = parcelRequire("cEoCh");

var $8Opre = parcelRequire("8Opre");
function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $8MGgd.default)(placement) === (0, $cEoCh.auto)) return [];
    var oppositePlacement = (0, $ivINy.default)(placement);
    return [
        (0, $7Bece.default)(placement),
        oppositePlacement,
        (0, $7Bece.default)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $8MGgd.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $ivINy.default)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $8MGgd.default)(placement) === (0, $cEoCh.auto) ? (0, $gnuPI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $8MGgd.default)(placement);
        var isStartVariation = (0, $8Opre.default)(placement) === (0, $cEoCh.start);
        var isVertical = [
            (0, $cEoCh.top),
            (0, $cEoCh.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9Ddln.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cEoCh.right) : (0, $cEoCh.left) : isStartVariation ? (0, $cEoCh.bottom) : (0, $cEoCh.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $ivINy.default)(mainVariationSide);
        var altVariationSide = (0, $ivINy.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("ivINy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d79ddf39683d3f91$export$2e2bcd8739ae039; });
var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}

});

parcelRegister("7Bece", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5887002dcefa0743$export$2e2bcd8739ae039; });
var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}

});

parcelRegister("9Ddln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70321b611e132ecc$export$2e2bcd8739ae039; });

var $cHqSr = parcelRequire("cHqSr");

var $4NPk2 = parcelRequire("4NPk2");

var $2mYUo = parcelRequire("2mYUo");

var $6OVAc = parcelRequire("6OVAc");

var $2tr8P = parcelRequire("2tr8P");

var $cEoCh = parcelRequire("cEoCh");

var $9ghG1 = parcelRequire("9ghG1");

var $VHjvt = parcelRequire("VHjvt");

var $jxLne = parcelRequire("jxLne");
function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cEoCh.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cEoCh.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cEoCh.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $VHjvt.default)(typeof padding !== 'number' ? padding : (0, $jxLne.default)(padding, (0, $cEoCh.basePlacements)));
    var altContext = elementContext === (0, $cEoCh.popper) ? (0, $cEoCh.reference) : (0, $cEoCh.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $cHqSr.default)((0, $9ghG1.isElement)(element) ? element : element.contextElement || (0, $4NPk2.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2mYUo.default)(state.elements.reference);
    var popperOffsets = (0, $6OVAc.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2tr8P.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cEoCh.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cEoCh.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cEoCh.right),
                (0, $cEoCh.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cEoCh.top),
                (0, $cEoCh.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("cHqSr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93ee5964b4e9d426$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $aMU0E = parcelRequire("aMU0E");

var $eHRAH = parcelRequire("eHRAH");

var $3yaXD = parcelRequire("3yaXD");

var $5jKxG = parcelRequire("5jKxG");

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $9ghG1 = parcelRequire("9ghG1");

var $2mYUo = parcelRequire("2mYUo");

var $gBzyr = parcelRequire("gBzyr");

var $1yHmV = parcelRequire("1yHmV");

var $1DgzM = parcelRequire("1DgzM");

var $2tr8P = parcelRequire("2tr8P");

var $c79oh = parcelRequire("c79oh");
function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2mYUo.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cEoCh.viewport) ? (0, $2tr8P.default)((0, $aMU0E.default)(element, strategy)) : (0, $9ghG1.isElement)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2tr8P.default)((0, $eHRAH.default)((0, $4NPk2.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $3yaXD.default)((0, $gBzyr.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3lU8c.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $9ghG1.isHTMLElement)(element) ? (0, $5jKxG.default)(element) : element;
    if (!(0, $9ghG1.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $9ghG1.isElement)(clippingParent) && (0, $1yHmV.default)(clippingParent, clipperElement) && (0, $1DgzM.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $c79oh.max)(rect.top, accRect.top);
        accRect.right = (0, $c79oh.min)(rect.right, accRect.right);
        accRect.bottom = (0, $c79oh.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $c79oh.max)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("aMU0E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7da9d5689cacb0a6$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");

var $4NPk2 = parcelRequire("4NPk2");

var $k1Xeb = parcelRequire("k1Xeb");

var $fvb08 = parcelRequire("fvb08");
function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $3s2ws.default)(element);
    var html = (0, $4NPk2.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fvb08.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $k1Xeb.default)(element),
        y: y
    };
}

});
parcelRegister("k1Xeb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e951d80a0194865c$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");

var $4NPk2 = parcelRequire("4NPk2");

var $VtlZ3 = parcelRequire("VtlZ3");
function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2mYUo.default)((0, $4NPk2.default)(element)).left + (0, $VtlZ3.default)(element).scrollLeft;
}

});
parcelRegister("VtlZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0acc17feb41c51bd$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $3s2ws.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("eHRAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab4ea6dd03061fae$export$2e2bcd8739ae039; });

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $k1Xeb = parcelRequire("k1Xeb");

var $VtlZ3 = parcelRequire("VtlZ3");

var $c79oh = parcelRequire("c79oh");
function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4NPk2.default)(element);
    var winScroll = (0, $VtlZ3.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $c79oh.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $c79oh.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $k1Xeb.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3lU8c.default)(body || html).direction === 'rtl') x += (0, $c79oh.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("3yaXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $295d0ca7e8ef250a$export$2e2bcd8739ae039; });

var $gScKu = parcelRequire("gScKu");

var $gBzyr = parcelRequire("gBzyr");

var $3s2ws = parcelRequire("3s2ws");

var $d5v3T = parcelRequire("d5v3T");
function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $gScKu.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $3s2ws.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $d5v3T.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $gBzyr.default)(target)));
}

});
parcelRegister("gScKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c48b941fd834c962$export$2e2bcd8739ae039; });

var $gBzyr = parcelRequire("gBzyr");

var $d5v3T = parcelRequire("d5v3T");

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");
function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $1DgzM.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $9ghG1.isHTMLElement)(node) && (0, $d5v3T.default)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $gBzyr.default)(node));
}

});
parcelRegister("d5v3T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9873d63ab8539814$export$2e2bcd8739ae039; });

var $3lU8c = parcelRequire("3lU8c");
function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3lU8c.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("2tr8P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cd357ee33805adc$export$2e2bcd8739ae039; });
function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("6OVAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f7414566eeea71a$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $8Opre = parcelRequire("8Opre");

var $3m9cx = parcelRequire("3m9cx");

var $cEoCh = parcelRequire("cEoCh");
function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $8MGgd.default)(placement) : null;
    var variation = placement ? (0, $8Opre.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cEoCh.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cEoCh.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cEoCh.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cEoCh.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $3m9cx.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cEoCh.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cEoCh.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("gnuPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bec6b628c79c2a3d$export$2e2bcd8739ae039; });

var $8Opre = parcelRequire("8Opre");

var $cEoCh = parcelRequire("cEoCh");

var $9Ddln = parcelRequire("9Ddln");

var $8MGgd = parcelRequire("8MGgd");
function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cEoCh.placements) : _options$allowedAutoP;
    var variation = (0, $8Opre.default)(placement);
    var placements = variation ? flipVariations ? (0, $cEoCh.variationPlacements) : (0, $cEoCh.variationPlacements).filter(function(placement) {
        return (0, $8Opre.default)(placement) === variation;
    }) : (0, $cEoCh.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9Ddln.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $8MGgd.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("aKE1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d3d400f3b7c97f3$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $9Ddln = parcelRequire("9Ddln");
function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cEoCh.top),
        (0, $cEoCh.right),
        (0, $cEoCh.bottom),
        (0, $cEoCh.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9Ddln.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9Ddln.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};

});

parcelRegister("c8CJF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d644778f0e020f0$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $cEoCh = parcelRequire("cEoCh");
function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $8MGgd.default)(placement);
    var invertDistance = [
        (0, $cEoCh.left),
        (0, $cEoCh.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cEoCh.left),
        (0, $cEoCh.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cEoCh.placements).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};

});

parcelRegister("ksntq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee48a1861d343976$export$2e2bcd8739ae039; });

var $6OVAc = parcelRequire("6OVAc");
function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $6OVAc.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};

});

parcelRegister("6blW5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4804c92787f86449$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $8MGgd = parcelRequire("8MGgd");

var $3m9cx = parcelRequire("3m9cx");

var $jVRdk = parcelRequire("jVRdk");

var $6Q9NZ = parcelRequire("6Q9NZ");

var $eQTzt = parcelRequire("eQTzt");

var $5jKxG = parcelRequire("5jKxG");

var $9Ddln = parcelRequire("9Ddln");

var $8Opre = parcelRequire("8Opre");

var $83sLw = parcelRequire("83sLw");

var $c79oh = parcelRequire("c79oh");
function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9Ddln.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $8MGgd.default)(state.placement);
    var variation = (0, $8Opre.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $3m9cx.default)(basePlacement);
    var altAxis = (0, $jVRdk.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cEoCh.top) : (0, $cEoCh.left);
        var altSide = mainAxis === 'y' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cEoCh.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cEoCh.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $eQTzt.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $83sLw.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $6Q9NZ.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5jKxG.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $6Q9NZ.within)(tether ? (0, $c79oh.min)(min, tetherMin) : min, offset, tether ? (0, $c79oh.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cEoCh.top) : (0, $cEoCh.left);
        var _altSide = mainAxis === 'x' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cEoCh.top),
            (0, $cEoCh.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $6Q9NZ.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $6Q9NZ.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("jVRdk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82c9e5baaa8e9af$export$2e2bcd8739ae039; });
function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("24WJr", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $1839837374f95732$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $1839837374f95732$export$8f7491d57c8f97a9; });

var $f7rEH = parcelRequire("f7rEH");

var $eQTzt = parcelRequire("eQTzt");

var $3yaXD = parcelRequire("3yaXD");

var $5jKxG = parcelRequire("5jKxG");

var $5XeBn = parcelRequire("5XeBn");

var $9n6Ia = parcelRequire("9n6Ia");

var $b7Gje = parcelRequire("b7Gje");

var $9Ddln = parcelRequire("9Ddln");

var $9ghG1 = parcelRequire("9ghG1");
var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $9ghG1.isElement)(reference) ? (0, $3yaXD.default)(reference) : reference.contextElement ? (0, $3yaXD.default)(reference.contextElement) : [],
                    popper: (0, $3yaXD.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $5XeBn.default)((0, $b7Gje.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $f7rEH.default)(reference, (0, $5jKxG.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $eQTzt.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9n6Ia.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("f7rEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b01cf64433a5b37b$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");

var $fIrSM = parcelRequire("fIrSM");

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");

var $k1Xeb = parcelRequire("k1Xeb");

var $4NPk2 = parcelRequire("4NPk2");

var $d5v3T = parcelRequire("d5v3T");

var $c79oh = parcelRequire("c79oh");
function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $c79oh.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $c79oh.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $9ghG1.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $9ghG1.isHTMLElement)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $4NPk2.default)(offsetParent);
    var rect = (0, $2mYUo.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1DgzM.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $d5v3T.default)(documentElement)) scroll = (0, $fIrSM.default)(offsetParent);
        if ((0, $9ghG1.isHTMLElement)(offsetParent)) {
            offsets = (0, $2mYUo.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $k1Xeb.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("fIrSM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b71097fc0b0e5f5c$export$2e2bcd8739ae039; });

var $VtlZ3 = parcelRequire("VtlZ3");

var $3s2ws = parcelRequire("3s2ws");

var $9ghG1 = parcelRequire("9ghG1");

var $hbsCN = parcelRequire("hbsCN");
function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $3s2ws.default)(node) || !(0, $9ghG1.isHTMLElement)(node)) return (0, $VtlZ3.default)(node);
    else return (0, $hbsCN.default)(node);
}

});
parcelRegister("hbsCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c829ab0279467772$export$2e2bcd8739ae039; });
function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("5XeBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $455dca0e08f2a815$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");
function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $cEoCh.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("9n6Ia", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d2b77c34ff005f5$export$2e2bcd8739ae039; });
function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("b7Gje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81912adbd60ec5c0$export$2e2bcd8739ae039; });
function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("d6CNR", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $98a9ef6d31ff03cd$export$8f7491d57c8f97a9; });

var $24WJr = parcelRequire("24WJr");

var $lsNQz = parcelRequire("lsNQz");

var $ksntq = parcelRequire("ksntq");

var $xcXwJ = parcelRequire("xcXwJ");

var $4dG9Q = parcelRequire("4dG9Q");

var $c8CJF = parcelRequire("c8CJF");

var $iMl36 = parcelRequire("iMl36");

var $6blW5 = parcelRequire("6blW5");

var $2P8UZ = parcelRequire("2P8UZ");

var $aKE1P = parcelRequire("aKE1P");


var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $lsNQz.default),
    (0, $ksntq.default),
    (0, $xcXwJ.default),
    (0, $4dG9Q.default),
    (0, $c8CJF.default),
    (0, $iMl36.default),
    (0, $6blW5.default),
    (0, $2P8UZ.default),
    (0, $aKE1P.default)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $24WJr.popperGenerator)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("nsqlv", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $0468327f9101fb67$export$8f7491d57c8f97a9; });

var $24WJr = parcelRequire("24WJr");

var $lsNQz = parcelRequire("lsNQz");

var $ksntq = parcelRequire("ksntq");

var $xcXwJ = parcelRequire("xcXwJ");

var $4dG9Q = parcelRequire("4dG9Q");
var $0468327f9101fb67$export$d34966752335dd47 = [
    (0, $lsNQz.default),
    (0, $ksntq.default),
    (0, $xcXwJ.default),
    (0, $4dG9Q.default)
];
var $0468327f9101fb67$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $24WJr.popperGenerator)({
    defaultModifiers: $0468327f9101fb67$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


parcelRegister("aJdSK", function(module, exports) {

module.exports = (parcelRequire("4WKyX"))($parcel$resolve("aHoHX")).then(()=>parcelRequire('aOZAM'));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $3445fd7b731be0ed$exports = {};
$parcel$extendImportMap({
    "aHoHX": "opacc.editor.df3c2d8e.js"
});

// Globale Styles und Skripte, die auf allen Seiten zur Verfügung stehen müssen.
// Wird in jedem Page-Layout-Modul importiert.

// SimpleBar wird in project.js als globale Klasse verwendet (new SimpleBar(...))
var $ff8e252796d15e90$exports = {};
/**
 * SimpleBar.js - v5.0.7
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 * src: https://unpkg.com/simplebar@5.0.7/dist/simplebar.min.js
 * src: https://unpkg.com/simplebar@5.0.7/dist/simplebar.js
 */ !function(t, e) {
    $ff8e252796d15e90$exports = e();
}($ff8e252796d15e90$exports, function() {
    "use strict";
    var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
    function e(t, e) {
        return t(e = {
            exports: {}
        }, e.exports), e.exports;
    }
    var r, n, i, o = "object", s = function(t) {
        return t && t.Math == Math && t;
    }, a = s(typeof globalThis == o && globalThis) || s(typeof window == o && window) || s(typeof self == o && self) || s(typeof t == o && t) || Function("return this")(), c = function(t) {
        try {
            return !!t();
        } catch (t) {
            return !0;
        }
    }, l = !c(function() {
        return 7 != Object.defineProperty({}, "a", {
            get: function() {
                return 7;
            }
        }).a;
    }), u = {}.propertyIsEnumerable, f = Object.getOwnPropertyDescriptor, h = {
        f: f && !u.call({
            1: 2
        }, 1) ? function(t) {
            var e = f(this, t);
            return !!e && e.enumerable;
        } : u
    }, d = function(t, e) {
        return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e
        };
    }, p = {}.toString, v = function(t) {
        return p.call(t).slice(8, -1);
    }, g = "".split, y = c(function() {
        return !Object("z").propertyIsEnumerable(0);
    }) ? function(t) {
        return "String" == v(t) ? g.call(t, "") : Object(t);
    } : Object, b = function(t) {
        if (null == t) throw TypeError("Can't call method on " + t);
        return t;
    }, m = function(t) {
        return y(b(t));
    }, x = function(t) {
        return "object" == typeof t ? null !== t : "function" == typeof t;
    }, E = function(t, e) {
        if (!x(t)) return t;
        var r, n;
        if (e && "function" == typeof (r = t.toString) && !x(n = r.call(t))) return n;
        if ("function" == typeof (r = t.valueOf) && !x(n = r.call(t))) return n;
        if (!e && "function" == typeof (r = t.toString) && !x(n = r.call(t))) return n;
        throw TypeError("Can't convert object to primitive value");
    }, w = {}.hasOwnProperty, O = function(t, e) {
        return w.call(t, e);
    }, _ = a.document, S = x(_) && x(_.createElement), A = function(t) {
        return S ? _.createElement(t) : {};
    }, k = !l && !c(function() {
        return 7 != Object.defineProperty(A("div"), "a", {
            get: function() {
                return 7;
            }
        }).a;
    }), L = Object.getOwnPropertyDescriptor, M = {
        f: l ? L : function(t, e) {
            if (t = m(t), e = E(e, !0), k) try {
                return L(t, e);
            } catch (t) {}
            if (O(t, e)) return d(!h.f.call(t, e), t[e]);
        }
    }, j = function(t) {
        if (!x(t)) throw TypeError(String(t) + " is not an object");
        return t;
    }, T = Object.defineProperty, R = {
        f: l ? T : function(t, e, r) {
            if (j(t), e = E(e, !0), j(r), k) try {
                return T(t, e, r);
            } catch (t) {}
            if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
            return "value" in r && (t[e] = r.value), t;
        }
    }, W = l ? function(t, e, r) {
        return R.f(t, e, d(1, r));
    } : function(t, e, r) {
        return t[e] = r, t;
    }, z = function(t, e) {
        try {
            W(a, t, e);
        } catch (r) {
            a[t] = e;
        }
        return e;
    }, C = e(function(t) {
        var e = a["__core-js_shared__"] || z("__core-js_shared__", {});
        (t.exports = function(t, r) {
            return e[t] || (e[t] = void 0 !== r ? r : {});
        })("versions", []).push({
            version: "3.2.1",
            mode: "global",
            copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
        });
    }), N = C("native-function-to-string", Function.toString), I = a.WeakMap, D = "function" == typeof I && /native code/.test(N.call(I)), P = 0, F = Math.random(), V = function(t) {
        return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++P + F).toString(36);
    }, B = C("keys"), H = function(t) {
        return B[t] || (B[t] = V(t));
    }, q = {}, $ = a.WeakMap;
    if (D) {
        var X = new $, Y = X.get, G = X.has, U = X.set;
        r = function(t, e) {
            return U.call(X, t, e), e;
        }, n = function(t) {
            return Y.call(X, t) || {};
        }, i = function(t) {
            return G.call(X, t);
        };
    } else {
        var Q = H("state");
        q[Q] = !0, r = function(t, e) {
            return W(t, Q, e), e;
        }, n = function(t) {
            return O(t, Q) ? t[Q] : {};
        }, i = function(t) {
            return O(t, Q);
        };
    }
    var K = {
        set: r,
        get: n,
        has: i,
        enforce: function(t) {
            return i(t) ? n(t) : r(t, {});
        },
        getterFor: function(t) {
            return function(e) {
                var r;
                if (!x(e) || (r = n(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
                return r;
            };
        }
    }, J = e(function(t) {
        var e = K.get, r = K.enforce, n = String(N).split("toString");
        C("inspectSource", function(t) {
            return N.call(t);
        }), (t.exports = function(t, e, i, o) {
            var s = !!o && !!o.unsafe, c = !!o && !!o.enumerable, l = !!o && !!o.noTargetGet;
            "function" == typeof i && ("string" != typeof e || O(i, "name") || W(i, "name", e), r(i).source = n.join("string" == typeof e ? e : "")), t !== a ? (s ? !l && t[e] && (c = !0) : delete t[e], c ? t[e] = i : W(t, e, i)) : c ? t[e] = i : z(e, i);
        })(Function.prototype, "toString", function() {
            return "function" == typeof this && e(this).source || N.call(this);
        });
    }), Z = a, tt = function(t) {
        return "function" == typeof t ? t : void 0;
    }, et = function(t, e) {
        return arguments.length < 2 ? tt(Z[t]) || tt(a[t]) : Z[t] && Z[t][e] || a[t] && a[t][e];
    }, rt = Math.ceil, nt = Math.floor, it = function(t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? nt : rt)(t);
    }, ot = Math.min, st = function(t) {
        return t > 0 ? ot(it(t), 9007199254740991) : 0;
    }, at = Math.max, ct = Math.min, lt = function(t) {
        return function(e, r, n) {
            var i, o = m(e), s = st(o.length), a = function(t, e) {
                var r = it(t);
                return r < 0 ? at(r + e, 0) : ct(r, e);
            }(n, s);
            if (t && r != r) {
                for(; s > a;)if ((i = o[a++]) != i) return !0;
            } else for(; s > a; a++)if ((t || a in o) && o[a] === r) return t || a || 0;
            return !t && -1;
        };
    }, ut = {
        includes: lt(!0),
        indexOf: lt(!1)
    }.indexOf, ft = function(t, e) {
        var r, n = m(t), i = 0, o = [];
        for(r in n)!O(q, r) && O(n, r) && o.push(r);
        for(; e.length > i;)O(n, r = e[i++]) && (~ut(o, r) || o.push(r));
        return o;
    }, ht = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
    ], dt = ht.concat("length", "prototype"), pt = {
        f: Object.getOwnPropertyNames || function(t) {
            return ft(t, dt);
        }
    }, vt = {
        f: Object.getOwnPropertySymbols
    }, gt = et("Reflect", "ownKeys") || function(t) {
        var e = pt.f(j(t)), r = vt.f;
        return r ? e.concat(r(t)) : e;
    }, yt = function(t, e) {
        for(var r = gt(e), n = R.f, i = M.f, o = 0; o < r.length; o++){
            var s = r[o];
            O(t, s) || n(t, s, i(e, s));
        }
    }, bt = /#|\.prototype\./, mt = function(t, e) {
        var r = Et[xt(t)];
        return r == Ot || r != wt && ("function" == typeof e ? c(e) : !!e);
    }, xt = mt.normalize = function(t) {
        return String(t).replace(bt, ".").toLowerCase();
    }, Et = mt.data = {}, wt = mt.NATIVE = "N", Ot = mt.POLYFILL = "P", _t = mt, St = M.f, At = function(t, e) {
        var r, n, i, o, s, c = t.target, l = t.global, u = t.stat;
        if (r = l ? a : u ? a[c] || z(c, {}) : (a[c] || {}).prototype) for(n in e){
            if (o = e[n], i = t.noTargetGet ? (s = St(r, n)) && s.value : r[n], !_t(l ? n : c + (u ? "." : "#") + n, t.forced) && void 0 !== i) {
                if (typeof o == typeof i) continue;
                yt(o, i);
            }
            (t.sham || i && i.sham) && W(o, "sham", !0), J(r, n, o, t);
        }
    }, kt = function(t) {
        if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
        return t;
    }, Lt = function(t, e, r) {
        if (kt(t), void 0 === e) return t;
        switch(r){
            case 0:
                return function() {
                    return t.call(e);
                };
            case 1:
                return function(r) {
                    return t.call(e, r);
                };
            case 2:
                return function(r, n) {
                    return t.call(e, r, n);
                };
            case 3:
                return function(r, n, i) {
                    return t.call(e, r, n, i);
                };
        }
        return function() {
            return t.apply(e, arguments);
        };
    }, Mt = function(t) {
        return Object(b(t));
    }, jt = Array.isArray || function(t) {
        return "Array" == v(t);
    }, Tt = !!Object.getOwnPropertySymbols && !c(function() {
        return !String(Symbol());
    }), Rt = a.Symbol, Wt = C("wks"), zt = function(t) {
        return Wt[t] || (Wt[t] = Tt && Rt[t] || (Tt ? Rt : V)("Symbol." + t));
    }, Ct = zt("species"), Nt = function(t, e) {
        var r;
        return jt(t) && ("function" != typeof (r = t.constructor) || r !== Array && !jt(r.prototype) ? x(r) && null === (r = r[Ct]) && (r = void 0) : r = void 0), new (void 0 === r ? Array : r)(0 === e ? 0 : e);
    }, It = [].push, Dt = function(t) {
        var e = 1 == t, r = 2 == t, n = 3 == t, i = 4 == t, o = 6 == t, s = 5 == t || o;
        return function(a, c, l, u) {
            for(var f, h, d = Mt(a), p = y(d), v = Lt(c, l, 3), g = st(p.length), b = 0, m = u || Nt, x = e ? m(a, g) : r ? m(a, 0) : void 0; g > b; b++)if ((s || b in p) && (h = v(f = p[b], b, d), t)) {
                if (e) x[b] = h;
                else if (h) switch(t){
                    case 3:
                        return !0;
                    case 5:
                        return f;
                    case 6:
                        return b;
                    case 2:
                        It.call(x, f);
                }
                else if (i) return !1;
            }
            return o ? -1 : n || i ? i : x;
        };
    }, Pt = {
        forEach: Dt(0),
        map: Dt(1),
        filter: Dt(2),
        some: Dt(3),
        every: Dt(4),
        find: Dt(5),
        findIndex: Dt(6)
    }, Ft = function(t, e) {
        var r = [][t];
        return !r || !c(function() {
            r.call(null, e || function() {
                throw 1;
            }, 1);
        });
    }, Vt = Pt.forEach, Bt = Ft("forEach") ? function(t) {
        return Vt(this, t, arguments.length > 1 ? arguments[1] : void 0);
    } : [].forEach;
    At({
        target: "Array",
        proto: !0,
        forced: [].forEach != Bt
    }, {
        forEach: Bt
    });
    var Ht = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    };
    for(var qt in Ht){
        var $t = a[qt], Xt = $t && $t.prototype;
        if (Xt && Xt.forEach !== Bt) try {
            W(Xt, "forEach", Bt);
        } catch (t) {
            Xt.forEach = Bt;
        }
    }
    var Yt = !("undefined" == typeof window || !window.document || !window.document.createElement), Gt = zt("species"), Ut = Pt.filter;
    At({
        target: "Array",
        proto: !0,
        forced: !function(t) {
            return !c(function() {
                var e = [];
                return (e.constructor = {})[Gt] = function() {
                    return {
                        foo: 1
                    };
                }, 1 !== e[t](Boolean).foo;
            });
        }("filter")
    }, {
        filter: function(t) {
            return Ut(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Qt = Object.keys || function(t) {
        return ft(t, ht);
    }, Kt = l ? Object.defineProperties : function(t, e) {
        j(t);
        for(var r, n = Qt(e), i = n.length, o = 0; i > o;)R.f(t, r = n[o++], e[r]);
        return t;
    }, Jt = et("document", "documentElement"), Zt = H("IE_PROTO"), te = function() {}, ee = function() {
        var t, e = A("iframe"), r = ht.length;
        for(e.style.display = "none", Jt.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), ee = t.F; r--;)delete ee.prototype[ht[r]];
        return ee();
    }, re = Object.create || function(t, e) {
        var r;
        return null !== t ? (te.prototype = j(t), r = new te, te.prototype = null, r[Zt] = t) : r = ee(), void 0 === e ? r : Kt(r, e);
    };
    q[Zt] = !0;
    var ne = zt("unscopables"), ie = Array.prototype;
    null == ie[ne] && W(ie, ne, re(null));
    var oe, se, ae, ce = function(t) {
        ie[ne][t] = !0;
    }, le = {}, ue = !c(function() {
        function t() {}
        return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype;
    }), fe = H("IE_PROTO"), he = Object.prototype, de = ue ? Object.getPrototypeOf : function(t) {
        return t = Mt(t), O(t, fe) ? t[fe] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? he : null;
    }, pe = zt("iterator"), ve = !1;
    [].keys && ("next" in (ae = [].keys()) ? (se = de(de(ae))) !== Object.prototype && (oe = se) : ve = !0), null == oe && (oe = {}), O(oe, pe) || W(oe, pe, function() {
        return this;
    });
    var ge = {
        IteratorPrototype: oe,
        BUGGY_SAFARI_ITERATORS: ve
    }, ye = R.f, be = zt("toStringTag"), me = function(t, e, r) {
        t && !O(t = r ? t : t.prototype, be) && ye(t, be, {
            configurable: !0,
            value: e
        });
    }, xe = ge.IteratorPrototype, Ee = function() {
        return this;
    }, we = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var t, e = !1, r = {};
        try {
            (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(r, []), e = r instanceof Array;
        } catch (t) {}
        return function(r, n) {
            return j(r), function(t) {
                if (!x(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
            }(n), e ? t.call(r, n) : r.__proto__ = n, r;
        };
    }() : void 0), Oe = ge.IteratorPrototype, _e = ge.BUGGY_SAFARI_ITERATORS, Se = zt("iterator"), Ae = function() {
        return this;
    }, ke = function(t, e, r, n, i, o, s) {
        !function(t, e, r) {
            var n = e + " Iterator";
            t.prototype = re(xe, {
                next: d(1, r)
            }), me(t, n, !1), le[n] = Ee;
        }(r, e, n);
        var a, c, l, u = function(t) {
            if (t === i && g) return g;
            if (!_e && t in p) return p[t];
            switch(t){
                case "keys":
                case "values":
                case "entries":
                    return function() {
                        return new r(this, t);
                    };
            }
            return function() {
                return new r(this);
            };
        }, f = e + " Iterator", h = !1, p = t.prototype, v = p[Se] || p["@@iterator"] || i && p[i], g = !_e && v || u(i), y = "Array" == e && p.entries || v;
        if (y && (a = de(y.call(new t)), Oe !== Object.prototype && a.next && (de(a) !== Oe && (we ? we(a, Oe) : "function" != typeof a[Se] && W(a, Se, Ae)), me(a, f, !0))), "values" == i && v && "values" !== v.name && (h = !0, g = function() {
            return v.call(this);
        }), p[Se] !== g && W(p, Se, g), le[e] = g, i) {
            if (c = {
                values: u("values"),
                keys: o ? g : u("keys"),
                entries: u("entries")
            }, s) for(l in c)!_e && !h && l in p || J(p, l, c[l]);
            else At({
                target: e,
                proto: !0,
                forced: _e || h
            }, c);
        }
        return c;
    }, Le = K.set, Me = K.getterFor("Array Iterator"), je = ke(Array, "Array", function(t, e) {
        Le(this, {
            type: "Array Iterator",
            target: m(t),
            index: 0,
            kind: e
        });
    }, function() {
        var t = Me(this), e = t.target, r = t.kind, n = t.index++;
        return !e || n >= e.length ? (t.target = void 0, {
            value: void 0,
            done: !0
        }) : "keys" == r ? {
            value: n,
            done: !1
        } : "values" == r ? {
            value: e[n],
            done: !1
        } : {
            value: [
                n,
                e[n]
            ],
            done: !1
        };
    }, "values");
    le.Arguments = le.Array, ce("keys"), ce("values"), ce("entries");
    var Te = Object.assign, Re = !Te || c(function() {
        var t = {}, e = {}, r = Symbol();
        return t[r] = 7, "abcdefghijklmnopqrst".split("").forEach(function(t) {
            e[t] = t;
        }), 7 != Te({}, t)[r] || "abcdefghijklmnopqrst" != Qt(Te({}, e)).join("");
    }) ? function(t, e) {
        for(var r = Mt(t), n = arguments.length, i = 1, o = vt.f, s = h.f; n > i;)for(var a, c = y(arguments[i++]), u = o ? Qt(c).concat(o(c)) : Qt(c), f = u.length, d = 0; f > d;)a = u[d++], l && !s.call(c, a) || (r[a] = c[a]);
        return r;
    } : Te;
    At({
        target: "Object",
        stat: !0,
        forced: Object.assign !== Re
    }, {
        assign: Re
    });
    var We = zt("toStringTag"), ze = "Arguments" == v(function() {
        return arguments;
    }()), Ce = function(t) {
        var e, r, n;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function(t, e) {
            try {
                return t[e];
            } catch (t) {}
        }(e = Object(t), We)) ? r : ze ? v(e) : "Object" == (n = v(e)) && "function" == typeof e.callee ? "Arguments" : n;
    }, Ne = {};
    Ne[zt("toStringTag")] = "z";
    var Ie = "[object z]" !== String(Ne) ? function() {
        return "[object " + Ce(this) + "]";
    } : Ne.toString, De = Object.prototype;
    Ie !== De.toString && J(De, "toString", Ie, {
        unsafe: !0
    });
    var Pe = "\t\n\v\f\r  ???????????????\u2028\u2029\ufeff", Fe = "[" + Pe + "]", Ve = RegExp("^" + Fe + Fe + "*"), Be = RegExp(Fe + Fe + "*$"), He = function(t) {
        return function(e) {
            var r = String(b(e));
            return 1 & t && (r = r.replace(Ve, "")), 2 & t && (r = r.replace(Be, "")), r;
        };
    }, qe = {
        start: He(1),
        end: He(2),
        trim: He(3)
    }.trim, $e = a.parseInt, Xe = /^[+-]?0[Xx]/, Ye = 8 !== $e(Pe + "08") || 22 !== $e(Pe + "0x16") ? function(t, e) {
        var r = qe(String(t));
        return $e(r, e >>> 0 || (Xe.test(r) ? 16 : 10));
    } : $e;
    At({
        global: !0,
        forced: parseInt != Ye
    }, {
        parseInt: Ye
    });
    var Ge = function(t) {
        return function(e, r) {
            var n, i, o = String(b(e)), s = it(r), a = o.length;
            return s < 0 || s >= a ? t ? "" : void 0 : (n = o.charCodeAt(s)) < 55296 || n > 56319 || s + 1 === a || (i = o.charCodeAt(s + 1)) < 56320 || i > 57343 ? t ? o.charAt(s) : n : t ? o.slice(s, s + 2) : i - 56320 + (n - 55296 << 10) + 65536;
        };
    }, Ue = {
        codeAt: Ge(!1),
        charAt: Ge(!0)
    }, Qe = Ue.charAt, Ke = K.set, Je = K.getterFor("String Iterator");
    ke(String, "String", function(t) {
        Ke(this, {
            type: "String Iterator",
            string: String(t),
            index: 0
        });
    }, function() {
        var t, e = Je(this), r = e.string, n = e.index;
        return n >= r.length ? {
            value: void 0,
            done: !0
        } : (t = Qe(r, n), e.index += t.length, {
            value: t,
            done: !1
        });
    });
    var Ze = function(t, e, r) {
        for(var n in e)J(t, n, e[n], r);
        return t;
    }, tr = !c(function() {
        return Object.isExtensible(Object.preventExtensions({}));
    }), er = e(function(t) {
        var e = R.f, r = V("meta"), n = 0, i = Object.isExtensible || function() {
            return !0;
        }, o = function(t) {
            e(t, r, {
                value: {
                    objectID: "O" + ++n,
                    weakData: {}
                }
            });
        }, s = t.exports = {
            REQUIRED: !1,
            fastKey: function(t, e) {
                if (!x(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
                if (!O(t, r)) {
                    if (!i(t)) return "F";
                    if (!e) return "E";
                    o(t);
                }
                return t[r].objectID;
            },
            getWeakData: function(t, e) {
                if (!O(t, r)) {
                    if (!i(t)) return !0;
                    if (!e) return !1;
                    o(t);
                }
                return t[r].weakData;
            },
            onFreeze: function(t) {
                return tr && s.REQUIRED && i(t) && !O(t, r) && o(t), t;
            }
        };
        q[r] = !0;
    }), rr = (er.REQUIRED, er.fastKey, er.getWeakData, er.onFreeze, zt("iterator")), nr = Array.prototype, ir = zt("iterator"), or = function(t, e, r, n) {
        try {
            return n ? e(j(r)[0], r[1]) : e(r);
        } catch (e) {
            var i = t.return;
            throw void 0 !== i && j(i.call(t)), e;
        }
    }, sr = e(function(t) {
        var e = function(t, e) {
            this.stopped = t, this.result = e;
        };
        (t.exports = function(t, r, n, i, o) {
            var s, a, c, l, u, f, h, d = Lt(r, n, i ? 2 : 1);
            if (o) s = t;
            else {
                if ("function" != typeof (a = function(t) {
                    if (null != t) return t[ir] || t["@@iterator"] || le[Ce(t)];
                }(t))) throw TypeError("Target is not iterable");
                if (void 0 !== (h = a) && (le.Array === h || nr[rr] === h)) {
                    for(c = 0, l = st(t.length); l > c; c++)if ((u = i ? d(j(f = t[c])[0], f[1]) : d(t[c])) && u instanceof e) return u;
                    return new e(!1);
                }
                s = a.call(t);
            }
            for(; !(f = s.next()).done;)if ((u = or(s, d, f.value, i)) && u instanceof e) return u;
            return new e(!1);
        }).stop = function(t) {
            return new e(!0, t);
        };
    }), ar = function(t, e, r) {
        if (!(t instanceof e)) throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
        return t;
    }, cr = zt("iterator"), lr = !1;
    try {
        var ur = 0, fr = {
            next: function() {
                return {
                    done: !!ur++
                };
            },
            return: function() {
                lr = !0;
            }
        };
        fr[cr] = function() {
            return this;
        }, Array.from(fr, function() {
            throw 2;
        });
    } catch (t) {}
    var hr = function(t, e, r, n, i) {
        var o = a[t], s = o && o.prototype, l = o, u = n ? "set" : "add", f = {}, h = function(t) {
            var e = s[t];
            J(s, t, "add" == t ? function(t) {
                return e.call(this, 0 === t ? 0 : t), this;
            } : "delete" == t ? function(t) {
                return !(i && !x(t)) && e.call(this, 0 === t ? 0 : t);
            } : "get" == t ? function(t) {
                return i && !x(t) ? void 0 : e.call(this, 0 === t ? 0 : t);
            } : "has" == t ? function(t) {
                return !(i && !x(t)) && e.call(this, 0 === t ? 0 : t);
            } : function(t, r) {
                return e.call(this, 0 === t ? 0 : t, r), this;
            });
        };
        if (_t(t, "function" != typeof o || !(i || s.forEach && !c(function() {
            (new o).entries().next();
        })))) l = r.getConstructor(e, t, n, u), er.REQUIRED = !0;
        else if (_t(t, !0)) {
            var d = new l, p = d[u](i ? {} : -0, 1) != d, v = c(function() {
                d.has(1);
            }), g = function(t, e) {
                if (!e && !lr) return !1;
                var r = !1;
                try {
                    var n = {};
                    n[cr] = function() {
                        return {
                            next: function() {
                                return {
                                    done: r = !0
                                };
                            }
                        };
                    }, t(n);
                } catch (t) {}
                return r;
            }(function(t) {
                new o(t);
            }), y = !i && c(function() {
                for(var t = new o, e = 5; e--;)t[u](e, e);
                return !t.has(-0);
            });
            g || ((l = e(function(e, r) {
                ar(e, l, t);
                var i = function(t, e, r) {
                    var n, i;
                    return we && "function" == typeof (n = e.constructor) && n !== r && x(i = n.prototype) && i !== r.prototype && we(t, i), t;
                }(new o, e, l);
                return null != r && sr(r, i[u], i, n), i;
            })).prototype = s, s.constructor = l), (v || y) && (h("delete"), h("has"), n && h("get")), (y || p) && h(u), i && s.clear && delete s.clear;
        }
        return f[t] = l, At({
            global: !0,
            forced: l != o
        }, f), me(l, t), i || r.setStrong(l, t, n), l;
    }, dr = er.getWeakData, pr = K.set, vr = K.getterFor, gr = Pt.find, yr = Pt.findIndex, br = 0, mr = function(t) {
        return t.frozen || (t.frozen = new xr);
    }, xr = function() {
        this.entries = [];
    }, Er = function(t, e) {
        return gr(t.entries, function(t) {
            return t[0] === e;
        });
    };
    xr.prototype = {
        get: function(t) {
            var e = Er(this, t);
            if (e) return e[1];
        },
        has: function(t) {
            return !!Er(this, t);
        },
        set: function(t, e) {
            var r = Er(this, t);
            r ? r[1] = e : this.entries.push([
                t,
                e
            ]);
        },
        delete: function(t) {
            var e = yr(this.entries, function(e) {
                return e[0] === t;
            });
            return ~e && this.entries.splice(e, 1), !!~e;
        }
    };
    var wr = {
        getConstructor: function(t, e, r, n) {
            var i = t(function(t, o) {
                ar(t, i, e), pr(t, {
                    type: e,
                    id: br++,
                    frozen: void 0
                }), null != o && sr(o, t[n], t, r);
            }), o = vr(e), s = function(t, e, r) {
                var n = o(t), i = dr(j(e), !0);
                return !0 === i ? mr(n).set(e, r) : i[n.id] = r, t;
            };
            return Ze(i.prototype, {
                delete: function(t) {
                    var e = o(this);
                    if (!x(t)) return !1;
                    var r = dr(t);
                    return !0 === r ? mr(e).delete(t) : r && O(r, e.id) && delete r[e.id];
                },
                has: function(t) {
                    var e = o(this);
                    if (!x(t)) return !1;
                    var r = dr(t);
                    return !0 === r ? mr(e).has(t) : r && O(r, e.id);
                }
            }), Ze(i.prototype, r ? {
                get: function(t) {
                    var e = o(this);
                    if (x(t)) {
                        var r = dr(t);
                        return !0 === r ? mr(e).get(t) : r ? r[e.id] : void 0;
                    }
                },
                set: function(t, e) {
                    return s(this, t, e);
                }
            } : {
                add: function(t) {
                    return s(this, t, !0);
                }
            }), i;
        }
    }, Or = (e(function(t) {
        var e, r = K.enforce, n = !a.ActiveXObject && "ActiveXObject" in a, i = Object.isExtensible, o = function(t) {
            return function() {
                return t(this, arguments.length ? arguments[0] : void 0);
            };
        }, s = t.exports = hr("WeakMap", o, wr, !0, !0);
        if (D && n) {
            e = wr.getConstructor(o, "WeakMap", !0), er.REQUIRED = !0;
            var c = s.prototype, l = c.delete, u = c.has, f = c.get, h = c.set;
            Ze(c, {
                delete: function(t) {
                    if (x(t) && !i(t)) {
                        var n = r(this);
                        return n.frozen || (n.frozen = new e), l.call(this, t) || n.frozen.delete(t);
                    }
                    return l.call(this, t);
                },
                has: function(t) {
                    if (x(t) && !i(t)) {
                        var n = r(this);
                        return n.frozen || (n.frozen = new e), u.call(this, t) || n.frozen.has(t);
                    }
                    return u.call(this, t);
                },
                get: function(t) {
                    if (x(t) && !i(t)) {
                        var n = r(this);
                        return n.frozen || (n.frozen = new e), u.call(this, t) ? f.call(this, t) : n.frozen.get(t);
                    }
                    return f.call(this, t);
                },
                set: function(t, n) {
                    if (x(t) && !i(t)) {
                        var o = r(this);
                        o.frozen || (o.frozen = new e), u.call(this, t) ? h.call(this, t, n) : o.frozen.set(t, n);
                    } else h.call(this, t, n);
                    return this;
                }
            });
        }
    }), zt("iterator")), _r = zt("toStringTag"), Sr = je.values;
    for(var Ar in Ht){
        var kr = a[Ar], Lr = kr && kr.prototype;
        if (Lr) {
            if (Lr[Or] !== Sr) try {
                W(Lr, Or, Sr);
            } catch (t) {
                Lr[Or] = Sr;
            }
            if (Lr[_r] || W(Lr, _r, Ar), Ht[Ar]) {
                for(var Mr in je)if (Lr[Mr] !== je[Mr]) try {
                    W(Lr, Mr, je[Mr]);
                } catch (t) {
                    Lr[Mr] = je[Mr];
                }
            }
        }
    }
    var jr = "Expected a function", Tr = NaN, Rr = "[object Symbol]", Wr = /^\s+|\s+$/g, zr = /^[-+]0x[0-9a-f]+$/i, Cr = /^0b[01]+$/i, Nr = /^0o[0-7]+$/i, Ir = parseInt, Dr = "object" == typeof t && t && t.Object === Object && t, Pr = "object" == typeof self && self && self.Object === Object && self, Fr = Dr || Pr || Function("return this")(), Vr = Object.prototype.toString, Br = Math.max, Hr = Math.min, qr = function() {
        return Fr.Date.now();
    };
    function $r(t, e, r) {
        var n, i, o, s, a, c, l = 0, u = !1, f = !1, h = !0;
        if ("function" != typeof t) throw new TypeError(jr);
        function d(e) {
            var r = n, o = i;
            return n = i = void 0, l = e, s = t.apply(o, r);
        }
        function p(t) {
            var r = t - c;
            return void 0 === c || r >= e || r < 0 || f && t - l >= o;
        }
        function v() {
            var t = qr();
            if (p(t)) return g(t);
            a = setTimeout(v, function(t) {
                var r = e - (t - c);
                return f ? Hr(r, o - (t - l)) : r;
            }(t));
        }
        function g(t) {
            return a = void 0, h && n ? d(t) : (n = i = void 0, s);
        }
        function y() {
            var t = qr(), r = p(t);
            if (n = arguments, i = this, c = t, r) {
                if (void 0 === a) return function(t) {
                    return l = t, a = setTimeout(v, e), u ? d(t) : s;
                }(c);
                if (f) return a = setTimeout(v, e), d(c);
            }
            return void 0 === a && (a = setTimeout(v, e)), s;
        }
        return e = Yr(e) || 0, Xr(r) && (u = !!r.leading, o = (f = "maxWait" in r) ? Br(Yr(r.maxWait) || 0, e) : o, h = "trailing" in r ? !!r.trailing : h), y.cancel = function() {
            void 0 !== a && clearTimeout(a), l = 0, n = c = i = a = void 0;
        }, y.flush = function() {
            return void 0 === a ? s : g(qr());
        }, y;
    }
    function Xr(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
    }
    function Yr(t) {
        if ("number" == typeof t) return t;
        if (function(t) {
            return "symbol" == typeof t || function(t) {
                return !!t && "object" == typeof t;
            }(t) && Vr.call(t) == Rr;
        }(t)) return Tr;
        if (Xr(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = Xr(e) ? e + "" : e;
        }
        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(Wr, "");
        var r = Cr.test(t);
        return r || Nr.test(t) ? Ir(t.slice(2), r ? 2 : 8) : zr.test(t) ? Tr : +t;
    }
    var Gr = function(t, e, r) {
        var n = !0, i = !0;
        if ("function" != typeof t) throw new TypeError(jr);
        return Xr(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), $r(t, e, {
            leading: n,
            maxWait: e,
            trailing: i
        });
    }, Ur = "Expected a function", Qr = NaN, Kr = "[object Symbol]", Jr = /^\s+|\s+$/g, Zr = /^[-+]0x[0-9a-f]+$/i, tn = /^0b[01]+$/i, en = /^0o[0-7]+$/i, rn = parseInt, nn = "object" == typeof t && t && t.Object === Object && t, on = "object" == typeof self && self && self.Object === Object && self, sn = nn || on || Function("return this")(), an = Object.prototype.toString, cn = Math.max, ln = Math.min, un = function() {
        return sn.Date.now();
    };
    function fn(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
    }
    function hn(t) {
        if ("number" == typeof t) return t;
        if (function(t) {
            return "symbol" == typeof t || function(t) {
                return !!t && "object" == typeof t;
            }(t) && an.call(t) == Kr;
        }(t)) return Qr;
        if (fn(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = fn(e) ? e + "" : e;
        }
        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(Jr, "");
        var r = tn.test(t);
        return r || en.test(t) ? rn(t.slice(2), r ? 2 : 8) : Zr.test(t) ? Qr : +t;
    }
    var dn = function(t, e, r) {
        var n, i, o, s, a, c, l = 0, u = !1, f = !1, h = !0;
        if ("function" != typeof t) throw new TypeError(Ur);
        function d(e) {
            var r = n, o = i;
            return n = i = void 0, l = e, s = t.apply(o, r);
        }
        function p(t) {
            var r = t - c;
            return void 0 === c || r >= e || r < 0 || f && t - l >= o;
        }
        function v() {
            var t = un();
            if (p(t)) return g(t);
            a = setTimeout(v, function(t) {
                var r = e - (t - c);
                return f ? ln(r, o - (t - l)) : r;
            }(t));
        }
        function g(t) {
            return a = void 0, h && n ? d(t) : (n = i = void 0, s);
        }
        function y() {
            var t = un(), r = p(t);
            if (n = arguments, i = this, c = t, r) {
                if (void 0 === a) return function(t) {
                    return l = t, a = setTimeout(v, e), u ? d(t) : s;
                }(c);
                if (f) return a = setTimeout(v, e), d(c);
            }
            return void 0 === a && (a = setTimeout(v, e)), s;
        }
        return e = hn(e) || 0, fn(r) && (u = !!r.leading, o = (f = "maxWait" in r) ? cn(hn(r.maxWait) || 0, e) : o, h = "trailing" in r ? !!r.trailing : h), y.cancel = function() {
            void 0 !== a && clearTimeout(a), l = 0, n = c = i = a = void 0;
        }, y.flush = function() {
            return void 0 === a ? s : g(un());
        }, y;
    }, pn = "Expected a function", vn = "__lodash_hash_undefined__", gn = "[object Function]", yn = "[object GeneratorFunction]", bn = /^\[object .+?Constructor\]$/, mn = "object" == typeof t && t && t.Object === Object && t, xn = "object" == typeof self && self && self.Object === Object && self, En = mn || xn || Function("return this")();
    var wn = Array.prototype, On = Function.prototype, _n = Object.prototype, Sn = En["__core-js_shared__"], An = function() {
        var t = /[^.]+$/.exec(Sn && Sn.keys && Sn.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
    }(), kn = On.toString, Ln = _n.hasOwnProperty, Mn = _n.toString, jn = RegExp("^" + kn.call(Ln).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Tn = wn.splice, Rn = Fn(En, "Map"), Wn = Fn(Object, "create");
    function zn(t) {
        var e = -1, r = t ? t.length : 0;
        for(this.clear(); ++e < r;){
            var n = t[e];
            this.set(n[0], n[1]);
        }
    }
    function Cn(t) {
        var e = -1, r = t ? t.length : 0;
        for(this.clear(); ++e < r;){
            var n = t[e];
            this.set(n[0], n[1]);
        }
    }
    function Nn(t) {
        var e = -1, r = t ? t.length : 0;
        for(this.clear(); ++e < r;){
            var n = t[e];
            this.set(n[0], n[1]);
        }
    }
    function In(t, e) {
        for(var r, n, i = t.length; i--;)if ((r = t[i][0]) === (n = e) || r != r && n != n) return i;
        return -1;
    }
    function Dn(t) {
        var e;
        return !(!Bn(t) || (e = t, An && An in e)) && ((function(t) {
            var e = Bn(t) ? Mn.call(t) : "";
            return e == gn || e == yn;
        })(t) || function(t) {
            var e = !1;
            if (null != t && "function" != typeof t.toString) try {
                e = !!(t + "");
            } catch (t) {}
            return e;
        }(t) ? jn : bn).test(function(t) {
            if (null != t) {
                try {
                    return kn.call(t);
                } catch (t) {}
                try {
                    return t + "";
                } catch (t) {}
            }
            return "";
        }(t));
    }
    function Pn(t, e) {
        var r, n, i = t.__data__;
        return ("string" == (n = typeof (r = e)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof e ? "string" : "hash"] : i.map;
    }
    function Fn(t, e) {
        var r = function(t, e) {
            return null == t ? void 0 : t[e];
        }(t, e);
        return Dn(r) ? r : void 0;
    }
    function Vn(t, e) {
        if ("function" != typeof t || e && "function" != typeof e) throw new TypeError(pn);
        var r = function() {
            var n = arguments, i = e ? e.apply(this, n) : n[0], o = r.cache;
            if (o.has(i)) return o.get(i);
            var s = t.apply(this, n);
            return r.cache = o.set(i, s), s;
        };
        return r.cache = new (Vn.Cache || Nn), r;
    }
    function Bn(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
    }
    zn.prototype.clear = function() {
        this.__data__ = Wn ? Wn(null) : {};
    }, zn.prototype.delete = function(t) {
        return this.has(t) && delete this.__data__[t];
    }, zn.prototype.get = function(t) {
        var e = this.__data__;
        if (Wn) {
            var r = e[t];
            return r === vn ? void 0 : r;
        }
        return Ln.call(e, t) ? e[t] : void 0;
    }, zn.prototype.has = function(t) {
        var e = this.__data__;
        return Wn ? void 0 !== e[t] : Ln.call(e, t);
    }, zn.prototype.set = function(t, e) {
        return this.__data__[t] = Wn && void 0 === e ? vn : e, this;
    }, Cn.prototype.clear = function() {
        this.__data__ = [];
    }, Cn.prototype.delete = function(t) {
        var e = this.__data__, r = In(e, t);
        return !(r < 0) && (r == e.length - 1 ? e.pop() : Tn.call(e, r, 1), !0);
    }, Cn.prototype.get = function(t) {
        var e = this.__data__, r = In(e, t);
        return r < 0 ? void 0 : e[r][1];
    }, Cn.prototype.has = function(t) {
        return In(this.__data__, t) > -1;
    }, Cn.prototype.set = function(t, e) {
        var r = this.__data__, n = In(r, t);
        return n < 0 ? r.push([
            t,
            e
        ]) : r[n][1] = e, this;
    }, Nn.prototype.clear = function() {
        this.__data__ = {
            hash: new zn,
            map: new (Rn || Cn),
            string: new zn
        };
    }, Nn.prototype.delete = function(t) {
        return Pn(this, t).delete(t);
    }, Nn.prototype.get = function(t) {
        return Pn(this, t).get(t);
    }, Nn.prototype.has = function(t) {
        return Pn(this, t).has(t);
    }, Nn.prototype.set = function(t, e) {
        return Pn(this, t).set(t, e), this;
    }, Vn.Cache = Nn;
    var Hn = Vn, qn = function() {
        if ("undefined" != typeof Map) return Map;
        function t(t, e) {
            var r = -1;
            return t.some(function(t, n) {
                return t[0] === e && (r = n, !0);
            }), r;
        }
        return function() {
            function e() {
                this.__entries__ = [];
            }
            return Object.defineProperty(e.prototype, "size", {
                get: function() {
                    return this.__entries__.length;
                },
                enumerable: !0,
                configurable: !0
            }), e.prototype.get = function(e) {
                var r = t(this.__entries__, e), n = this.__entries__[r];
                return n && n[1];
            }, e.prototype.set = function(e, r) {
                var n = t(this.__entries__, e);
                ~n ? this.__entries__[n][1] = r : this.__entries__.push([
                    e,
                    r
                ]);
            }, e.prototype.delete = function(e) {
                var r = this.__entries__, n = t(r, e);
                ~n && r.splice(n, 1);
            }, e.prototype.has = function(e) {
                return !!~t(this.__entries__, e);
            }, e.prototype.clear = function() {
                this.__entries__.splice(0);
            }, e.prototype.forEach = function(t, e) {
                void 0 === e && (e = null);
                for(var r = 0, n = this.__entries__; r < n.length; r++){
                    var i = n[r];
                    t.call(e, i[1], i[0]);
                }
            }, e;
        }();
    }(), $n = "undefined" != typeof window && "undefined" != typeof document && window.document === document, Xn = "undefined" != typeof $parcel$global && $parcel$global.Math === Math ? $parcel$global : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(), Yn = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(Xn) : function(t) {
        return setTimeout(function() {
            return t(Date.now());
        }, 1e3 / 60);
    }, Gn = 2;
    var Un = 20, Qn = [
        "top",
        "right",
        "bottom",
        "left",
        "width",
        "height",
        "size",
        "weight"
    ], Kn = "undefined" != typeof MutationObserver, Jn = function() {
        function t() {
            this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function(t, e) {
                var r = !1, n = !1, i = 0;
                function o() {
                    r && (r = !1, t()), n && a();
                }
                function s() {
                    Yn(o);
                }
                function a() {
                    var t = Date.now();
                    if (r) {
                        if (t - i < Gn) return;
                        n = !0;
                    } else r = !0, n = !1, setTimeout(s, e);
                    i = t;
                }
                return a;
            }(this.refresh.bind(this), Un);
        }
        return t.prototype.addObserver = function(t) {
            ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
        }, t.prototype.removeObserver = function(t) {
            var e = this.observers_, r = e.indexOf(t);
            ~r && e.splice(r, 1), !e.length && this.connected_ && this.disconnect_();
        }, t.prototype.refresh = function() {
            this.updateObservers_() && this.refresh();
        }, t.prototype.updateObservers_ = function() {
            var t = this.observers_.filter(function(t) {
                return t.gatherActive(), t.hasActive();
            });
            return t.forEach(function(t) {
                return t.broadcastActive();
            }), t.length > 0;
        }, t.prototype.connect_ = function() {
            $n && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Kn ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
                attributes: !0,
                childList: !0,
                characterData: !0,
                subtree: !0
            })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
        }, t.prototype.disconnect_ = function() {
            $n && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
        }, t.prototype.onTransitionEnd_ = function(t) {
            var e = t.propertyName, r = void 0 === e ? "" : e;
            Qn.some(function(t) {
                return !!~r.indexOf(t);
            }) && this.refresh();
        }, t.getInstance = function() {
            return this.instance_ || (this.instance_ = new t), this.instance_;
        }, t.instance_ = null, t;
    }(), Zn = function(t, e) {
        for(var r = 0, n = Object.keys(e); r < n.length; r++){
            var i = n[r];
            Object.defineProperty(t, i, {
                value: e[i],
                enumerable: !1,
                writable: !1,
                configurable: !0
            });
        }
        return t;
    }, ti = function(t) {
        return t && t.ownerDocument && t.ownerDocument.defaultView || Xn;
    }, ei = ai(0, 0, 0, 0);
    function ri(t) {
        return parseFloat(t) || 0;
    }
    function ni(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        return e.reduce(function(e, r) {
            return e + ri(t["border-" + r + "-width"]);
        }, 0);
    }
    function ii(t) {
        var e = t.clientWidth, r = t.clientHeight;
        if (!e && !r) return ei;
        var n = ti(t).getComputedStyle(t), i = function(t) {
            for(var e = {}, r = 0, n = [
                "top",
                "right",
                "bottom",
                "left"
            ]; r < n.length; r++){
                var i = n[r], o = t["padding-" + i];
                e[i] = ri(o);
            }
            return e;
        }(n), o = i.left + i.right, s = i.top + i.bottom, a = ri(n.width), c = ri(n.height);
        if ("border-box" === n.boxSizing && (Math.round(a + o) !== e && (a -= ni(n, "left", "right") + o), Math.round(c + s) !== r && (c -= ni(n, "top", "bottom") + s)), !function(t) {
            return t === ti(t).document.documentElement;
        }(t)) {
            var l = Math.round(a + o) - e, u = Math.round(c + s) - r;
            1 !== Math.abs(l) && (a -= l), 1 !== Math.abs(u) && (c -= u);
        }
        return ai(i.left, i.top, a, c);
    }
    var oi = "undefined" != typeof SVGGraphicsElement ? function(t) {
        return t instanceof ti(t).SVGGraphicsElement;
    } : function(t) {
        return t instanceof ti(t).SVGElement && "function" == typeof t.getBBox;
    };
    function si(t) {
        return $n ? oi(t) ? function(t) {
            var e = t.getBBox();
            return ai(0, 0, e.width, e.height);
        }(t) : ii(t) : ei;
    }
    function ai(t, e, r, n) {
        return {
            x: t,
            y: e,
            width: r,
            height: n
        };
    }
    var ci = function() {
        function t(t) {
            this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = ai(0, 0, 0, 0), this.target = t;
        }
        return t.prototype.isActive = function() {
            var t = si(this.target);
            return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
        }, t.prototype.broadcastRect = function() {
            var t = this.contentRect_;
            return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
        }, t;
    }(), li = function(t, e) {
        var r, n, i, o, s, a, c, l = (n = (r = e).x, i = r.y, o = r.width, s = r.height, a = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, c = Object.create(a.prototype), Zn(c, {
            x: n,
            y: i,
            width: o,
            height: s,
            top: i,
            right: n + o,
            bottom: s + i,
            left: n
        }), c);
        Zn(this, {
            target: t,
            contentRect: l
        });
    }, ui = function() {
        function t(t, e, r) {
            if (this.activeObservations_ = [], this.observations_ = new qn, "function" != typeof t) throw new TypeError("The callback provided as parameter 1 is not a function.");
            this.callback_ = t, this.controller_ = e, this.callbackCtx_ = r;
        }
        return t.prototype.observe = function(t) {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            if ("undefined" != typeof Element && Element instanceof Object) {
                if (!(t instanceof ti(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                var e = this.observations_;
                e.has(t) || (e.set(t, new ci(t)), this.controller_.addObserver(this), this.controller_.refresh());
            }
        }, t.prototype.unobserve = function(t) {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            if ("undefined" != typeof Element && Element instanceof Object) {
                if (!(t instanceof ti(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                var e = this.observations_;
                e.has(t) && (e.delete(t), e.size || this.controller_.removeObserver(this));
            }
        }, t.prototype.disconnect = function() {
            this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
        }, t.prototype.gatherActive = function() {
            var t = this;
            this.clearActive(), this.observations_.forEach(function(e) {
                e.isActive() && t.activeObservations_.push(e);
            });
        }, t.prototype.broadcastActive = function() {
            if (this.hasActive()) {
                var t = this.callbackCtx_, e = this.activeObservations_.map(function(t) {
                    return new li(t.target, t.broadcastRect());
                });
                this.callback_.call(t, e, t), this.clearActive();
            }
        }, t.prototype.clearActive = function() {
            this.activeObservations_.splice(0);
        }, t.prototype.hasActive = function() {
            return this.activeObservations_.length > 0;
        }, t;
    }(), fi = "undefined" != typeof WeakMap ? new WeakMap : new qn, hi = function t(e) {
        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var r = Jn.getInstance(), n = new ui(e, r, this);
        fi.set(this, n);
    };
    [
        "observe",
        "unobserve",
        "disconnect"
    ].forEach(function(t) {
        hi.prototype[t] = function() {
            var e;
            return (e = fi.get(this))[t].apply(e, arguments);
        };
    });
    var di = void 0 !== Xn.ResizeObserver ? Xn.ResizeObserver : hi, pi = null, vi = null;
    function gi() {
        if (null === pi) {
            if ("undefined" == typeof document) return pi = 0;
            var t = document.body, e = document.createElement("div");
            e.classList.add("simplebar-hide-scrollbar"), t.appendChild(e);
            var r = e.getBoundingClientRect().right;
            t.removeChild(e), pi = r;
        }
        return pi;
    }
    Yt && window.addEventListener("resize", function() {
        vi !== window.devicePixelRatio && (vi = window.devicePixelRatio, pi = null);
    });
    var yi = function() {
        function t(e, r) {
            var n = this;
            this.onScroll = function() {
                n.scrollXTicking || (window.requestAnimationFrame(n.scrollX), n.scrollXTicking = !0), n.scrollYTicking || (window.requestAnimationFrame(n.scrollY), n.scrollYTicking = !0);
            }, this.scrollX = function() {
                n.axis.x.isOverflowing && (n.showScrollbar("x"), n.positionScrollbar("x")), n.scrollXTicking = !1;
            }, this.scrollY = function() {
                n.axis.y.isOverflowing && (n.showScrollbar("y"), n.positionScrollbar("y")), n.scrollYTicking = !1;
            }, this.onMouseEnter = function() {
                n.showScrollbar("x"), n.showScrollbar("y");
            }, this.onMouseMove = function(t) {
                n.mouseX = t.clientX, n.mouseY = t.clientY, (n.axis.x.isOverflowing || n.axis.x.forceVisible) && n.onMouseMoveForAxis("x"), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && n.onMouseMoveForAxis("y");
            }, this.onMouseLeave = function() {
                n.onMouseMove.cancel(), (n.axis.x.isOverflowing || n.axis.x.forceVisible) && n.onMouseLeaveForAxis("x"), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && n.onMouseLeaveForAxis("y"), n.mouseX = -1, n.mouseY = -1;
            }, this.onWindowResize = function() {
                n.scrollbarWidth = n.getScrollbarWidth(), n.hideNativeScrollbar();
            }, this.hideScrollbars = function() {
                n.axis.x.track.rect = n.axis.x.track.el.getBoundingClientRect(), n.axis.y.track.rect = n.axis.y.track.el.getBoundingClientRect(), n.isWithinBounds(n.axis.y.track.rect) || (n.axis.y.scrollbar.el.classList.remove(n.classNames.visible), n.axis.y.isVisible = !1), n.isWithinBounds(n.axis.x.track.rect) || (n.axis.x.scrollbar.el.classList.remove(n.classNames.visible), n.axis.x.isVisible = !1);
            }, this.onPointerEvent = function(t) {
                var e, r;
                n.axis.x.track.rect = n.axis.x.track.el.getBoundingClientRect(), n.axis.y.track.rect = n.axis.y.track.el.getBoundingClientRect(), (n.axis.x.isOverflowing || n.axis.x.forceVisible) && (e = n.isWithinBounds(n.axis.x.track.rect)), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && (r = n.isWithinBounds(n.axis.y.track.rect)), (e || r) && (t.preventDefault(), t.stopPropagation(), "mousedown" === t.type && (e && (n.axis.x.scrollbar.rect = n.axis.x.scrollbar.el.getBoundingClientRect(), n.isWithinBounds(n.axis.x.scrollbar.rect) ? n.onDragStart(t, "x") : n.onTrackClick(t, "x")), r && (n.axis.y.scrollbar.rect = n.axis.y.scrollbar.el.getBoundingClientRect(), n.isWithinBounds(n.axis.y.scrollbar.rect) ? n.onDragStart(t, "y") : n.onTrackClick(t, "y"))));
            }, this.drag = function(e) {
                var r = n.axis[n.draggedAxis].track, i = r.rect[n.axis[n.draggedAxis].sizeAttr], o = n.axis[n.draggedAxis].scrollbar, s = n.contentWrapperEl[n.axis[n.draggedAxis].scrollSizeAttr], a = parseInt(n.elStyles[n.axis[n.draggedAxis].sizeAttr], 10);
                e.preventDefault(), e.stopPropagation();
                var c = (("y" === n.draggedAxis ? e.pageY : e.pageX) - r.rect[n.axis[n.draggedAxis].offsetAttr] - n.axis[n.draggedAxis].dragOffset) / (i - o.size) * (s - a);
                "x" === n.draggedAxis && (c = n.isRtl && t.getRtlHelpers().isRtlScrollbarInverted ? c - (i + o.size) : c, c = n.isRtl && t.getRtlHelpers().isRtlScrollingInverted ? -c : c), n.contentWrapperEl[n.axis[n.draggedAxis].scrollOffsetAttr] = c;
            }, this.onEndDrag = function(t) {
                t.preventDefault(), t.stopPropagation(), n.el.classList.remove(n.classNames.dragging), document.removeEventListener("mousemove", n.drag, !0), document.removeEventListener("mouseup", n.onEndDrag, !0), n.removePreventClickId = window.setTimeout(function() {
                    document.removeEventListener("click", n.preventClick, !0), document.removeEventListener("dblclick", n.preventClick, !0), n.removePreventClickId = null;
                });
            }, this.preventClick = function(t) {
                t.preventDefault(), t.stopPropagation();
            }, this.el = e, this.minScrollbarWidth = 20, this.options = Object.assign({}, t.defaultOptions, {}, r), this.classNames = Object.assign({}, t.defaultOptions.classNames, {}, this.options.classNames), this.axis = {
                x: {
                    scrollOffsetAttr: "scrollLeft",
                    sizeAttr: "width",
                    scrollSizeAttr: "scrollWidth",
                    offsetSizeAttr: "offsetWidth",
                    offsetAttr: "left",
                    overflowAttr: "overflowX",
                    dragOffset: 0,
                    isOverflowing: !0,
                    isVisible: !1,
                    forceVisible: !1,
                    track: {},
                    scrollbar: {}
                },
                y: {
                    scrollOffsetAttr: "scrollTop",
                    sizeAttr: "height",
                    scrollSizeAttr: "scrollHeight",
                    offsetSizeAttr: "offsetHeight",
                    offsetAttr: "top",
                    overflowAttr: "overflowY",
                    dragOffset: 0,
                    isOverflowing: !0,
                    isVisible: !1,
                    forceVisible: !1,
                    track: {},
                    scrollbar: {}
                }
            }, this.removePreventClickId = null, t.instances.has(this.el) || (this.recalculate = Gr(this.recalculate.bind(this), 64), this.onMouseMove = Gr(this.onMouseMove.bind(this), 64), this.hideScrollbars = dn(this.hideScrollbars.bind(this), this.options.timeout), this.onWindowResize = dn(this.onWindowResize.bind(this), 64, {
                leading: !0
            }), t.getRtlHelpers = Hn(t.getRtlHelpers), this.init());
        }
        t.getRtlHelpers = function() {
            var e = document.createElement("div");
            e.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
            var r = e.firstElementChild;
            document.body.appendChild(r);
            var n = r.firstElementChild;
            r.scrollLeft = 0;
            var i = t.getOffset(r), o = t.getOffset(n);
            r.scrollLeft = 999;
            var s = t.getOffset(n);
            return {
                isRtlScrollingInverted: i.left !== o.left && o.left - s.left != 0,
                isRtlScrollbarInverted: i.left !== o.left
            };
        }, t.getOffset = function(t) {
            var e = t.getBoundingClientRect();
            return {
                top: e.top + (window.pageYOffset || document.documentElement.scrollTop),
                left: e.left + (window.pageXOffset || document.documentElement.scrollLeft)
            };
        };
        var e = t.prototype;
        return e.init = function() {
            t.instances.set(this.el, this), Yt && (this.initDOM(), this.scrollbarWidth = this.getScrollbarWidth(), this.recalculate(), this.initListeners());
        }, e.initDOM = function() {
            var t = this;
            if (Array.prototype.filter.call(this.el.children, function(e) {
                return e.classList.contains(t.classNames.wrapper);
            }).length) this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper), this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper), this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl), this.offsetEl = this.el.querySelector("." + this.classNames.offset), this.maskEl = this.el.querySelector("." + this.classNames.mask), this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder), this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl), this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl), this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal), this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
            else {
                for(this.wrapperEl = document.createElement("div"), this.contentWrapperEl = document.createElement("div"), this.offsetEl = document.createElement("div"), this.maskEl = document.createElement("div"), this.contentEl = document.createElement("div"), this.placeholderEl = document.createElement("div"), this.heightAutoObserverWrapperEl = document.createElement("div"), this.heightAutoObserverEl = document.createElement("div"), this.wrapperEl.classList.add(this.classNames.wrapper), this.contentWrapperEl.classList.add(this.classNames.contentWrapper), this.offsetEl.classList.add(this.classNames.offset), this.maskEl.classList.add(this.classNames.mask), this.contentEl.classList.add(this.classNames.contentEl), this.placeholderEl.classList.add(this.classNames.placeholder), this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl), this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl); this.el.firstChild;)this.contentEl.appendChild(this.el.firstChild);
                this.contentWrapperEl.appendChild(this.contentEl), this.offsetEl.appendChild(this.contentWrapperEl), this.maskEl.appendChild(this.offsetEl), this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl), this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl), this.wrapperEl.appendChild(this.maskEl), this.wrapperEl.appendChild(this.placeholderEl), this.el.appendChild(this.wrapperEl);
            }
            if (!this.axis.x.track.el || !this.axis.y.track.el) {
                var e = document.createElement("div"), r = document.createElement("div");
                e.classList.add(this.classNames.track), r.classList.add(this.classNames.scrollbar), e.appendChild(r), this.axis.x.track.el = e.cloneNode(!0), this.axis.x.track.el.classList.add(this.classNames.horizontal), this.axis.y.track.el = e.cloneNode(!0), this.axis.y.track.el.classList.add(this.classNames.vertical), this.el.appendChild(this.axis.x.track.el), this.el.appendChild(this.axis.y.track.el);
            }
            this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar), this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar), this.options.autoHide || (this.axis.x.scrollbar.el.classList.add(this.classNames.visible), this.axis.y.scrollbar.el.classList.add(this.classNames.visible)), this.el.setAttribute("data-simplebar", "init");
        }, e.initListeners = function() {
            var t = this;
            this.options.autoHide && this.el.addEventListener("mouseenter", this.onMouseEnter), [
                "mousedown",
                "click",
                "dblclick"
            ].forEach(function(e) {
                t.el.addEventListener(e, t.onPointerEvent, !0);
            }), [
                "touchstart",
                "touchend",
                "touchmove"
            ].forEach(function(e) {
                t.el.addEventListener(e, t.onPointerEvent, {
                    capture: !0,
                    passive: !0
                });
            }), this.el.addEventListener("mousemove", this.onMouseMove), this.el.addEventListener("mouseleave", this.onMouseLeave), this.contentWrapperEl.addEventListener("scroll", this.onScroll), window.addEventListener("resize", this.onWindowResize);
            var e = !1;
            this.resizeObserver = new di(function() {
                e && t.recalculate();
            }), this.resizeObserver.observe(this.el), this.resizeObserver.observe(this.contentEl), window.requestAnimationFrame(function() {
                e = !0;
            }), this.mutationObserver = new MutationObserver(this.recalculate), this.mutationObserver.observe(this.contentEl, {
                childList: !0,
                subtree: !0,
                characterData: !0
            });
        }, e.recalculate = function() {
            this.elStyles = window.getComputedStyle(this.el), this.isRtl = "rtl" === this.elStyles.direction;
            var t = this.heightAutoObserverEl.offsetHeight <= 1, e = this.heightAutoObserverEl.offsetWidth <= 1, r = this.contentEl.offsetWidth, n = this.contentWrapperEl.offsetWidth, i = this.elStyles.overflowX, o = this.elStyles.overflowY;
            this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft, this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
            var s = this.contentEl.scrollHeight, a = this.contentEl.scrollWidth;
            this.contentWrapperEl.style.height = t ? "auto" : "100%", this.placeholderEl.style.width = e ? r + "px" : "auto", this.placeholderEl.style.height = s + "px";
            var c = this.contentWrapperEl.offsetHeight;
            this.axis.x.isOverflowing = a > r, this.axis.y.isOverflowing = s > c, this.axis.x.isOverflowing = "hidden" !== i && this.axis.x.isOverflowing, this.axis.y.isOverflowing = "hidden" !== o && this.axis.y.isOverflowing, this.axis.x.forceVisible = "x" === this.options.forceVisible || !0 === this.options.forceVisible, this.axis.y.forceVisible = "y" === this.options.forceVisible || !0 === this.options.forceVisible, this.hideNativeScrollbar();
            var l = this.axis.x.isOverflowing ? this.scrollbarWidth : 0, u = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
            this.axis.x.isOverflowing = this.axis.x.isOverflowing && a > n - u, this.axis.y.isOverflowing = this.axis.y.isOverflowing && s > c - l, this.axis.x.scrollbar.size = this.getScrollbarSize("x"), this.axis.y.scrollbar.size = this.getScrollbarSize("y"), this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px", this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px", this.positionScrollbar("x"), this.positionScrollbar("y"), this.toggleTrackVisibility("x"), this.toggleTrackVisibility("y");
        }, e.getScrollbarSize = function(t) {
            if (void 0 === t && (t = "y"), !this.axis[t].isOverflowing) return 0;
            var e, r = this.contentEl[this.axis[t].scrollSizeAttr], n = this.axis[t].track.el[this.axis[t].offsetSizeAttr], i = n / r;
            return e = Math.max(~~(i * n), this.options.scrollbarMinSize), this.options.scrollbarMaxSize && (e = Math.min(e, this.options.scrollbarMaxSize)), e;
        }, e.positionScrollbar = function(e) {
            if (void 0 === e && (e = "y"), this.axis[e].isOverflowing) {
                var r = this.contentWrapperEl[this.axis[e].scrollSizeAttr], n = this.axis[e].track.el[this.axis[e].offsetSizeAttr], i = parseInt(this.elStyles[this.axis[e].sizeAttr], 10), o = this.axis[e].scrollbar, s = this.contentWrapperEl[this.axis[e].scrollOffsetAttr], a = (s = "x" === e && this.isRtl && t.getRtlHelpers().isRtlScrollingInverted ? -s : s) / (r - i), c = ~~((n - o.size) * a);
                c = "x" === e && this.isRtl && t.getRtlHelpers().isRtlScrollbarInverted ? c + (n - o.size) : c, o.el.style.transform = "x" === e ? "translate3d(" + c + "px, 0, 0)" : "translate3d(0, " + c + "px, 0)";
            }
        }, e.toggleTrackVisibility = function(t) {
            void 0 === t && (t = "y");
            var e = this.axis[t].track.el, r = this.axis[t].scrollbar.el;
            this.axis[t].isOverflowing || this.axis[t].forceVisible ? (e.style.visibility = "visible", this.contentWrapperEl.style[this.axis[t].overflowAttr] = "scroll") : (e.style.visibility = "hidden", this.contentWrapperEl.style[this.axis[t].overflowAttr] = "hidden"), this.axis[t].isOverflowing ? r.style.display = "block" : r.style.display = "none";
        }, e.hideNativeScrollbar = function() {
            this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0, this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        }, e.onMouseMoveForAxis = function(t) {
            void 0 === t && (t = "y"), this.axis[t].track.rect = this.axis[t].track.el.getBoundingClientRect(), this.axis[t].scrollbar.rect = this.axis[t].scrollbar.el.getBoundingClientRect(), this.isWithinBounds(this.axis[t].scrollbar.rect) ? this.axis[t].scrollbar.el.classList.add(this.classNames.hover) : this.axis[t].scrollbar.el.classList.remove(this.classNames.hover), this.isWithinBounds(this.axis[t].track.rect) ? (this.showScrollbar(t), this.axis[t].track.el.classList.add(this.classNames.hover)) : this.axis[t].track.el.classList.remove(this.classNames.hover);
        }, e.onMouseLeaveForAxis = function(t) {
            void 0 === t && (t = "y"), this.axis[t].track.el.classList.remove(this.classNames.hover), this.axis[t].scrollbar.el.classList.remove(this.classNames.hover);
        }, e.showScrollbar = function(t) {
            void 0 === t && (t = "y");
            var e = this.axis[t].scrollbar.el;
            this.axis[t].isVisible || (e.classList.add(this.classNames.visible), this.axis[t].isVisible = !0), this.options.autoHide && this.hideScrollbars();
        }, e.onDragStart = function(t, e) {
            void 0 === e && (e = "y");
            var r = this.axis[e].scrollbar, n = "y" === e ? t.pageY : t.pageX;
            this.axis[e].dragOffset = n - r.rect[this.axis[e].offsetAttr], this.draggedAxis = e, this.el.classList.add(this.classNames.dragging), document.addEventListener("mousemove", this.drag, !0), document.addEventListener("mouseup", this.onEndDrag, !0), null === this.removePreventClickId ? (document.addEventListener("click", this.preventClick, !0), document.addEventListener("dblclick", this.preventClick, !0)) : (window.clearTimeout(this.removePreventClickId), this.removePreventClickId = null);
        }, e.onTrackClick = function(t, e) {
            var r = this;
            void 0 === e && (e = "y"), this.axis[e].scrollbar.rect = this.axis[e].scrollbar.el.getBoundingClientRect();
            var n = this.axis[e].scrollbar.rect[this.axis[e].offsetAttr], i = parseInt(this.elStyles[this.axis[e].sizeAttr], 10), o = this.contentWrapperEl[this.axis[e].scrollOffsetAttr], s = ("y" === e ? this.mouseY - n : this.mouseX - n) < 0 ? -1 : 1, a = -1 === s ? o - i : o + i;
            !function t() {
                var n, i;
                -1 === s ? o > a && (o -= 40, r.contentWrapperEl.scrollTo(((n = {})[r.axis[e].offsetAttr] = o, n)), window.requestAnimationFrame(t)) : o < a && (o += 40, r.contentWrapperEl.scrollTo(((i = {})[r.axis[e].offsetAttr] = o, i)), window.requestAnimationFrame(t));
            }();
        }, e.getContentElement = function() {
            return this.contentEl;
        }, e.getScrollElement = function() {
            return this.contentWrapperEl;
        }, e.getScrollbarWidth = function() {
            try {
                return "none" === getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display || "scrollbarWidth" in document.documentElement.style ? 0 : gi();
            } catch (t) {
                return gi();
            }
        }, e.removeListeners = function() {
            var t = this;
            this.options.autoHide && this.el.removeEventListener("mouseenter", this.onMouseEnter), [
                "mousedown",
                "click",
                "dblclick"
            ].forEach(function(e) {
                t.el.removeEventListener(e, t.onPointerEvent, !0);
            }), [
                "touchstart",
                "touchend",
                "touchmove"
            ].forEach(function(e) {
                t.el.removeEventListener(e, t.onPointerEvent, {
                    capture: !0,
                    passive: !0
                });
            }), this.el.removeEventListener("mousemove", this.onMouseMove), this.el.removeEventListener("mouseleave", this.onMouseLeave), this.contentWrapperEl.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onWindowResize), this.mutationObserver.disconnect(), this.resizeObserver.disconnect(), this.recalculate.cancel(), this.onMouseMove.cancel(), this.hideScrollbars.cancel(), this.onWindowResize.cancel();
        }, e.unMount = function() {
            this.removeListeners(), t.instances.delete(this.el);
        }, e.isWithinBounds = function(t) {
            return this.mouseX >= t.left && this.mouseX <= t.left + t.width && this.mouseY >= t.top && this.mouseY <= t.top + t.height;
        }, e.findChild = function(t, e) {
            var r = t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector;
            return Array.prototype.filter.call(t.children, function(t) {
                return r.call(t, e);
            })[0];
        }, t;
    }();
    yi.defaultOptions = {
        autoHide: !0,
        forceVisible: !1,
        classNames: {
            contentEl: "simplebar-content",
            contentWrapper: "simplebar-content-wrapper",
            offset: "simplebar-offset",
            mask: "simplebar-mask",
            wrapper: "simplebar-wrapper",
            placeholder: "simplebar-placeholder",
            scrollbar: "simplebar-scrollbar",
            track: "simplebar-track",
            heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
            heightAutoObserverEl: "simplebar-height-auto-observer",
            visible: "simplebar-visible",
            horizontal: "simplebar-horizontal",
            vertical: "simplebar-vertical",
            hover: "simplebar-hover",
            dragging: "simplebar-dragging"
        },
        scrollbarMinSize: 25,
        scrollbarMaxSize: 0,
        timeout: 1e3
    }, yi.instances = new WeakMap;
    var bi = function(t) {
        return function(e, r, n, i) {
            kt(r);
            var o = Mt(e), s = y(o), a = st(o.length), c = t ? a - 1 : 0, l = t ? -1 : 1;
            if (n < 2) for(;;){
                if (c in s) {
                    i = s[c], c += l;
                    break;
                }
                if (c += l, t ? c < 0 : a <= c) throw TypeError("Reduce of empty array with no initial value");
            }
            for(; t ? c >= 0 : a > c; c += l)c in s && (i = r(i, s[c], c, o));
            return i;
        };
    }, mi = {
        left: bi(!1),
        right: bi(!0)
    }.left;
    At({
        target: "Array",
        proto: !0,
        forced: Ft("reduce")
    }, {
        reduce: function(t) {
            return mi(this, t, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var xi = R.f, Ei = Function.prototype, wi = Ei.toString, Oi = /^\s*function ([^ (]*)/;
    !l || "name" in Ei || xi(Ei, "name", {
        configurable: !0,
        get: function() {
            try {
                return wi.call(this).match(Oi)[1];
            } catch (t) {
                return "";
            }
        }
    });
    var _i, Si, Ai = function() {
        var t = j(this), e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
    }, ki = RegExp.prototype.exec, Li = String.prototype.replace, Mi = ki, ji = (_i = /a/, Si = /b*/g, ki.call(_i, "a"), ki.call(Si, "a"), 0 !== _i.lastIndex || 0 !== Si.lastIndex), Ti = void 0 !== /()??/.exec("")[1];
    (ji || Ti) && (Mi = function(t) {
        var e, r, n, i, o = this;
        return Ti && (r = new RegExp("^" + o.source + "$(?!\\s)", Ai.call(o))), ji && (e = o.lastIndex), n = ki.call(o, t), ji && n && (o.lastIndex = o.global ? n.index + n[0].length : e), Ti && n && n.length > 1 && Li.call(n[0], r, function() {
            for(i = 1; i < arguments.length - 2; i++)void 0 === arguments[i] && (n[i] = void 0);
        }), n;
    });
    var Ri = Mi;
    At({
        target: "RegExp",
        proto: !0,
        forced: /./.exec !== Ri
    }, {
        exec: Ri
    });
    var Wi = zt("species"), zi = !c(function() {
        var t = /./;
        return t.exec = function() {
            var t = [];
            return t.groups = {
                a: "7"
            }, t;
        }, "7" !== "".replace(t, "$<a>");
    }), Ci = !c(function() {
        var t = /(?:)/, e = t.exec;
        t.exec = function() {
            return e.apply(this, arguments);
        };
        var r = "ab".split(t);
        return 2 !== r.length || "a" !== r[0] || "b" !== r[1];
    }), Ni = function(t, e, r, n) {
        var i = zt(t), o = !c(function() {
            var e = {};
            return e[i] = function() {
                return 7;
            }, 7 != ""[t](e);
        }), s = o && !c(function() {
            var e = !1, r = /a/;
            return r.exec = function() {
                return e = !0, null;
            }, "split" === t && (r.constructor = {}, r.constructor[Wi] = function() {
                return r;
            }), r[i](""), !e;
        });
        if (!o || !s || "replace" === t && !zi || "split" === t && !Ci) {
            var a = /./[i], l = r(i, ""[t], function(t, e, r, n, i) {
                return e.exec === Ri ? o && !i ? {
                    done: !0,
                    value: a.call(e, r, n)
                } : {
                    done: !0,
                    value: t.call(r, e, n)
                } : {
                    done: !1
                };
            }), u = l[0], f = l[1];
            J(String.prototype, t, u), J(RegExp.prototype, i, 2 == e ? function(t, e) {
                return f.call(t, this, e);
            } : function(t) {
                return f.call(t, this);
            }), n && W(RegExp.prototype[i], "sham", !0);
        }
    }, Ii = Ue.charAt, Di = function(t, e, r) {
        return e + (r ? Ii(t, e).length : 1);
    }, Pi = function(t, e) {
        var r = t.exec;
        if ("function" == typeof r) {
            var n = r.call(t, e);
            if ("object" != typeof n) throw TypeError("RegExp exec method returned something other than an Object or null");
            return n;
        }
        if ("RegExp" !== v(t)) throw TypeError("RegExp#exec called on incompatible receiver");
        return Ri.call(t, e);
    };
    Ni("match", 1, function(t, e, r) {
        return [
            function(e) {
                var r = b(this), n = null == e ? void 0 : e[t];
                return void 0 !== n ? n.call(e, r) : new RegExp(e)[t](String(r));
            },
            function(t) {
                var n = r(e, t, this);
                if (n.done) return n.value;
                var i = j(t), o = String(this);
                if (!i.global) return Pi(i, o);
                var s = i.unicode;
                i.lastIndex = 0;
                for(var a, c = [], l = 0; null !== (a = Pi(i, o));){
                    var u = String(a[0]);
                    c[l] = u, "" === u && (i.lastIndex = Di(o, st(i.lastIndex), s)), l++;
                }
                return 0 === l ? null : c;
            }
        ];
    });
    var Fi = Math.max, Vi = Math.min, Bi = Math.floor, Hi = /\$([$&'`]|\d\d?|<[^>]*>)/g, qi = /\$([$&'`]|\d\d?)/g;
    Ni("replace", 2, function(t, e, r) {
        return [
            function(r, n) {
                var i = b(this), o = null == r ? void 0 : r[t];
                return void 0 !== o ? o.call(r, i, n) : e.call(String(i), r, n);
            },
            function(t, i) {
                var o = r(e, t, this, i);
                if (o.done) return o.value;
                var s = j(t), a = String(this), c = "function" == typeof i;
                c || (i = String(i));
                var l = s.global;
                if (l) {
                    var u = s.unicode;
                    s.lastIndex = 0;
                }
                for(var f = [];;){
                    var h = Pi(s, a);
                    if (null === h) break;
                    if (f.push(h), !l) break;
                    "" === String(h[0]) && (s.lastIndex = Di(a, st(s.lastIndex), u));
                }
                for(var d, p = "", v = 0, g = 0; g < f.length; g++){
                    h = f[g];
                    for(var y = String(h[0]), b = Fi(Vi(it(h.index), a.length), 0), m = [], x = 1; x < h.length; x++)m.push(void 0 === (d = h[x]) ? d : String(d));
                    var E = h.groups;
                    if (c) {
                        var w = [
                            y
                        ].concat(m, b, a);
                        void 0 !== E && w.push(E);
                        var O = String(i.apply(void 0, w));
                    } else O = n(y, a, b, m, E, i);
                    b >= v && (p += a.slice(v, b) + O, v = b + y.length);
                }
                return p + a.slice(v);
            }
        ];
        function n(t, r, n, i, o, s) {
            var a = n + t.length, c = i.length, l = qi;
            return void 0 !== o && (o = Mt(o), l = Hi), e.call(s, l, function(e, s) {
                var l;
                switch(s.charAt(0)){
                    case "$":
                        return "$";
                    case "&":
                        return t;
                    case "`":
                        return r.slice(0, n);
                    case "'":
                        return r.slice(a);
                    case "<":
                        l = o[s.slice(1, -1)];
                        break;
                    default:
                        var u = +s;
                        if (0 === u) return e;
                        if (u > c) {
                            var f = Bi(u / 10);
                            return 0 === f ? e : f <= c ? void 0 === i[f - 1] ? s.charAt(1) : i[f - 1] + s.charAt(1) : e;
                        }
                        l = i[u - 1];
                }
                return void 0 === l ? "" : l;
            });
        }
    });
    var $i = function(t) {
        return Array.prototype.reduce.call(t, function(t, e) {
            var r = e.name.match(/data-simplebar-(.+)/);
            if (r) {
                var n = r[1].replace(/\W+(.)/g, function(t, e) {
                    return e.toUpperCase();
                });
                switch(e.value){
                    case "true":
                        t[n] = !0;
                        break;
                    case "false":
                        t[n] = !1;
                        break;
                    case void 0:
                        t[n] = !0;
                        break;
                    default:
                        t[n] = e.value;
                }
            }
            return t;
        }, {});
    };
    return yi.initDOMLoadedElements = function() {
        document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements), window.removeEventListener("load", this.initDOMLoadedElements), Array.prototype.forEach.call(document.querySelectorAll('[data-simplebar]:not([data-simplebar="init"])'), function(t) {
            yi.instances.has(t) || new yi(t, $i(t.attributes));
        });
    }, yi.removeObserver = function() {
        this.globalObserver.disconnect();
    }, yi.initHtmlApi = function() {
        this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this), "undefined" != typeof MutationObserver && (this.globalObserver = new MutationObserver(yi.handleMutations), this.globalObserver.observe(document, {
            childList: !0,
            subtree: !0
        })), "complete" === document.readyState || "loading" !== document.readyState && !document.documentElement.doScroll ? window.setTimeout(this.initDOMLoadedElements) : (document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements), window.addEventListener("load", this.initDOMLoadedElements));
    }, yi.handleMutations = function(t) {
        t.forEach(function(t) {
            Array.prototype.forEach.call(t.addedNodes, function(t) {
                1 === t.nodeType && (t.hasAttribute("data-simplebar") ? !yi.instances.has(t) && new yi(t, $i(t.attributes)) : Array.prototype.forEach.call(t.querySelectorAll('[data-simplebar]:not([data-simplebar="init"])'), function(t) {
                    !yi.instances.has(t) && new yi(t, $i(t.attributes));
                }));
            }), Array.prototype.forEach.call(t.removedNodes, function(t) {
                1 === t.nodeType && (t.hasAttribute('[data-simplebar="init"]') ? yi.instances.has(t) && yi.instances.get(t).unMount() : Array.prototype.forEach.call(t.querySelectorAll('[data-simplebar="init"]'), function(t) {
                    yi.instances.has(t) && yi.instances.get(t).unMount();
                }));
            });
        });
    }, yi.getOptions = $i, Yt && yi.initHtmlApi(), yi;
});


window.SimpleBar = (0, (/*@__PURE__*/$parcel$interopDefault($ff8e252796d15e90$exports)));


/** @module general */ /**
 * Allgemeine Funktionalität
 *
 */ class $4d6a4d6c23b55b04$export$495fdb200dc0cd20 {
    constructor(){}
    attachEventListener() {}
}


/** @module general */ /**
 *  Funktionalität zur Umschaltung der Sprachauswahl
 */ class $72506f89da967ee9$export$688fce325da0304b {
    constructor(){
        this.wrapperElement = document.querySelector('body');
        this.languageSelector = '.opc-language-selection[data-op-layout="list"]';
        this.languageElement = this.wrapperElement.querySelectorAll(this.languageSelector);
        this.attachEventListener();
    }
    /**
	 * Event Registrierung im DOM
	 */ attachEventListener() {
        if (this.languageElement.length > 0) this.wrapperElement.addEventListener('click', (e)=>{
            let currentLanguageElement = e.target.closest(this.languageSelector);
            if (currentLanguageElement) this.toggleLanguageElement(currentLanguageElement);
            else if (e.target.closest(this.languageSelector) === null) Array.from(this.languageElement).forEach((item)=>{
                if (item.classList.contains('is-open')) this.toggleLanguageElement(item);
            });
        });
    }
    /**
	 * Sichtbarkeit (offen oder geschlossen) der Sprachauswahl umschalten
	 *
	 * @param {HTMLElement} languageElement Element, welches Umgeschaltet (öffnen / schliessen) werden soll
	 */ toggleLanguageElement(languageElement) {
        languageElement.classList.toggle('is-open');
    }
}



class $1e2f9b09a0759e0d$export$be24cb6caf8e0169 {
    constructor(){}
    /**
	 * Fetch async data
	 *
	 * @param {*} reqUrl
	 * @param {*} init
	 * @param {*} returnFnc
	 * @param {*} errorFnc
	 * @param {boolean} [forceResponseAsJson=false]
	 */ fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson = false) {
        fetch(reqUrl, init).then(this.getRespContentType).then(forceResponseAsJson ? this.processJsonResponse.bind(this) : this.doNothing).then(returnFnc).catch((error)=>{
            errorFnc(error);
        });
    }
    /**
	 *
	 *
	 * @param {*} reqUrl
	 * @param {*} inputData
	 * @param {*} returnFnc
	 * @param {*} [errorFnc=this.getDefaultErrorFnc]
	 * @param {boolean} [forceResponseAsJson=false]
	 */ fetchAsynPostForm(reqUrl, inputData, returnFnc, errorFnc = this.getDefaultErrorFnc, forceResponseAsJson = false) {
        let headers = new Headers({
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'x-requested-with': 'XMLHttpRequest'
        });
        const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute('content') || '';
        if (csrfToken.length > 0) headers.append('XSRF-TOKEN', csrfToken);
        let init = this.getDefaultPostInitObj(headers, this.objectToQuerystring(inputData), forceResponseAsJson);
        this.fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson);
    }
    /**
	 *
	 *
	 * @param {*} reqUrl
	 * @param {*} inputData
	 * @param {*} returnFnc
	 * @param {*} [errorFnc=this.getDefaultErrorFnc]
	 * @param {boolean} [forceResponseAsJson=false]
	 */ fetchAsynPostJson(reqUrl, inputData, returnFnc, errorFnc = this.getDefaultErrorFnc, forceResponseAsJson = false) {
        let headers = new Headers({
            'content-type': 'application/json; charset=UTF-8',
            'x-requested-with': 'XMLHttpRequest'
        });
        const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute('content') || '';
        if (csrfToken.length > 0) headers.append('XSRF-TOKEN', csrfToken);
        let init = this.getDefaultPostInitObj(headers, inputData, forceResponseAsJson);
        this.fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson);
    }
    /**
	 *
	 *
	 * @param {*} reqUrl
	 * @param {*} returnFnc
	 * @param {*} [errorFnc=this.getDefaultErrorFnc]
	 * @param {boolean} [forceResponseAsJson=false]
	 */ fetchAsynGetForm(reqUrl, returnFnc, errorFnc = this.getDefaultErrorFnc, forceResponseAsJson = false) {
        let init = this.getDefaultGetInitObj(null, forceResponseAsJson);
        this.fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson);
    }
    /**
	 *
	 *
	 * @param {*} reqUrl
	 * @param {*} returnFnc
	 * @param {*} [errorFnc=this.getDefaultErrorFnc]
	 * @param {boolean} [forceResponseAsJson=false]
	 */ fetchAsynGetJson(reqUrl, returnFnc, errorFnc = this.getDefaultErrorFnc, forceResponseAsJson = false) {
        let init = this.getDefaultGetInitObj(null, forceResponseAsJson);
        this.fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson);
    }
    /**
	 *
	 *
	 * @param {*} resp
	 * @returns {*}
	 */ getRespContentType(resp) {
        let contentType = resp.headers.get('content-type');
        return contentType && contentType.includes('application/json') ? resp.json() : resp.text();
    }
    /**
	 *
	 *
	 * @param {*} error
	 */ getDefaultErrorFnc(error) {
        // eslint-disable-next-line no-console
        console.error('Request failed: ', error);
    }
    /**
	 *
	 *
	 * @param {*} [headers=null]
	 * @param {boolean} [forceResponseAsJson=false]
	 * @returns {*}
	 */ getDefaultGetInitObj(headers = null, forceResponseAsJson = false) {
        let init = {
            method: 'GET',
            credentials: 'include',
            headers: headers
        };
        if (headers === null) init.headers = new Headers({
            'x-requested-with': 'XMLHttpRequest'
        });
        if (forceResponseAsJson) init.headers.set('response-type', 'json');
        return init;
    }
    /**
	 *
	 *
	 * @param {*} [headers=null]
	 * @param {string} [body='']
	 * @param {boolean} [forceResponseAsJson=false]
	 * @returns {*}
	 */ getDefaultPostInitObj(headers = null, body = '', forceResponseAsJson = false) {
        let init = this.getDefaultGetInitObj(headers, forceResponseAsJson);
        init.method = 'POST';
        init['body'] = body;
        return init;
    }
    /**
	 *
	 *
	 * @param {*} [headers=null]
	 * @param {boolean} [forceResponseAsJson=false]
	 * @returns {*}
	 */ getDefaultGetInitObjExternal(headers = null, forceResponseAsJson = false) {
        let init = this.getDefaultGetInitObj(headers, forceResponseAsJson);
        delete init.credentials;
        return init;
    }
    /**
	 *
	 *
	 * @param {*} [headers=null]
	 * @param {string} [body='']
	 * @param {boolean} [forceResponseAsJson=false]
	 * @returns {*}
	 */ // eslint-disable-next-line no-unused-vars
    getDefaultPostInitObjExternal(headers = null, body = '', forceResponseAsJson = false) {
        let init = this.getDefaultPostInitObj(headers, body, forceResponseAsJson);
        delete init.credentials;
        return init;
    }
    /**
	 *
	 *
	 * @param {*} obj
	 * @returns {*}
	 */ objectToQuerystring(obj, encode = true, encodeUriComponent = true) {
        return Object.keys(obj).reduce(function(str, key, i) {
            let encodeKey = encodeUriComponent ? encodeURIComponent(key) : encodeURI(key);
            let encodeObjKey = encodeUriComponent ? encodeURIComponent(obj[key]) : encodeURI(obj[key]);
            let delimiter, val;
            delimiter = i > 0 ? '&' : '';
            key = encode ? encodeKey : key;
            val = encode ? encodeObjKey : obj[key];
            return [
                str,
                delimiter,
                key,
                '=',
                val
            ].join('');
        }, '');
    }
    /**
	 *
	 *
	 * @param {*} response
	 * @returns {*}
	 */ processJsonResponse(response) {
        // Daten Base64-dekodieren
        let data = this.base64DecodeUnicode(response.data);
        // Daten HTML-dekodieren
        let html = document.createElement('div');
        html.innerHTML = data;
        // JSON-Objekt erstellen
        let json = response.contentType == 'application/json' && html.innerText !== '' ? JSON.parse(html.innerText) : {};
        // Meldungen anzeigen
        (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessages(response.messages, json);
        return {
            // Informationen aus Response-Objekt
            status: response.status,
            messages: response.messages,
            dataAsBase64: response.data,
            contentType: response.contentType,
            // Aufbereitete Informationen
            success: response.status == 'ok',
            dataAsHtml: response.contentType == 'text/html' ? html.innerText : '',
            dataAsJson: json,
            data: data
        };
    }
    /**
     * Returns decoded Utf8 string
     * @param {string} encoded Utf8 encoded string
     * @returns string
     */ base64DecodeUnicode(encoded) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return window.decodeURIComponent(window.atob(encoded).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }
    /**
     *
     * @param {boolean} checkForReadOnlyContext Soll geprüft werden, ob die Daten nur lesend geladen werden sollen?
     * @returns URL für die asynchrone Abfrage
     */ setAsyncUrl(checkForReadOnlyContext = false) {
        let asyncUrl = '/WebPortal/async.aspx';
        if (!(window.opacc && window.opacc.systemUrls)) return asyncUrl;
        if (checkForReadOnlyContext) {
            if (window.opacc.systemUrls.asyncReadOnly) asyncUrl = window.opacc.systemUrls.asyncReadOnly;
            else if (window.opacc.systemUrls.async) asyncUrl = window.opacc.systemUrls.async;
        }
        return asyncUrl;
    }
    /**
	 *
	 *
	 * @param {*} response
	 * @returns {*}
	 */ doNothing(response) {
        return response;
    }
}


'use strict';
/**
     * Keys enum
     * @type {Object}
     */ var $b8a3ca3805add3a4$var$keys = {
    ENTER: 13,
    ESC: 27,
    F1: 112,
    F12: 123,
    LEFT: 37,
    RIGHT: 39
};
/**
     * Default options
     * @type {Object}
     */ var $b8a3ca3805add3a4$var$defaults = {
    autoReset: true,
    basic: false,
    closable: true,
    closableByDimmer: true,
    frameless: false,
    maintainFocus: true,
    maximizable: true,
    modal: true,
    movable: true,
    moveBounded: false,
    overflow: true,
    padding: true,
    pinnable: true,
    pinned: true,
    preventBodyShift: false,
    resizable: true,
    startMaximized: false,
    transition: 'pulse',
    type: 'modal',
    style: undefined,
    notifier: {
        delay: 3,
        position: 'bottom-right',
        closeButton: false
    },
    glossary: {
        title: '',
        ok: 'OK',
        cancel: 'Cancel',
        acccpt: 'Accept',
        deny: 'Deny',
        confirm: 'Confirm',
        decline: 'Decline',
        close: 'Close',
        maximize: 'Maximize',
        restore: 'Restore'
    },
    theme: {
        input: 'notifications-input',
        ok: 'notifications-ok',
        cancel: 'notifications-cancel'
    }
};
//holds open dialogs instances
var $b8a3ca3805add3a4$var$openDialogs = [];
function $b8a3ca3805add3a4$var$ucFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $b8a3ca3805add3a4$var$setDataAttr(element, instanceName, value) {
    let attrName = `op${$b8a3ca3805add3a4$var$ucFirst(instanceName)}`;
    if (value !== undefined) element.dataset[attrName] = value;
}
/**
     * [Helper]  Adds the specified class(es) to the element.
     *
     * @element {node}      The element
     * @className {string}  One or more space-separated classes to be added to the class attribute of the element.
     *
     * @return {undefined}
     */ function $b8a3ca3805add3a4$var$addClass(element, classNames) {
    element.className += ' ' + classNames;
}
/**
     * [Helper]  Removes the specified class(es) from the element.
     *
     * @element {node}      The element
     * @className {string}  One or more space-separated classes to be removed from the class attribute of the element.
     *
     * @return {undefined}
     */ function $b8a3ca3805add3a4$var$removeClass(element, classNames) {
    var original = element.className.split(' ');
    var toBeRemoved = classNames.split(' ');
    for(var x = 0; x < toBeRemoved.length; x += 1){
        var index = original.indexOf(toBeRemoved[x]);
        if (index > -1) original.splice(index, 1);
    }
    element.className = original.join(' ');
}
/**
     * [Helper]  Checks if the document is RTL
     *
     * @return {Boolean} True if the document is RTL, false otherwise.
     */ function $b8a3ca3805add3a4$var$isRightToLeft() {
    return window.getComputedStyle(document.body).direction === 'rtl';
}
/**
     * [Helper]  Get the document current scrollTop
     *
     * @return {Number} current document scrollTop value
     */ function $b8a3ca3805add3a4$var$getScrollTop() {
    return document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
}
/**
     * [Helper]  Get the document current scrollLeft
     *
     * @return {Number} current document scrollLeft value
     */ function $b8a3ca3805add3a4$var$getScrollLeft() {
    return document.documentElement && document.documentElement.scrollLeft || document.body.scrollLeft;
}
/**
    * Helper: clear contents
    *
    */ function $b8a3ca3805add3a4$var$clearContents(element) {
    while(element.lastChild)element.removeChild(element.lastChild);
}
/**
     * Extends a given prototype by merging properties from base into sub.
     *
     * @sub {Object} sub The prototype being overwritten.
     * @base {Object} base The prototype being written.
     *
     * @return {Object} The extended prototype.
     */ function $b8a3ca3805add3a4$var$copy(src) {
    if (null === src) return src;
    var cpy;
    if (Array.isArray(src)) {
        cpy = [];
        for(var x = 0; x < src.length; x += 1)cpy.push($b8a3ca3805add3a4$var$copy(src[x]));
        return cpy;
    }
    if (src instanceof Date) return new Date(src.getTime());
    if (src instanceof RegExp) {
        cpy = new RegExp(src.source);
        cpy.global = src.global;
        cpy.ignoreCase = src.ignoreCase;
        cpy.multiline = src.multiline;
        cpy.lastIndex = src.lastIndex;
        return cpy;
    }
    if (typeof src === 'object') {
        cpy = {};
        // copy dialog pototype over definition.
        for(var prop in src)if (src.hasOwnProperty(prop)) cpy[prop] = $b8a3ca3805add3a4$var$copy(src[prop]);
        return cpy;
    }
    return src;
}
/**
      * Helper: destruct the dialog
      *
      */ function $b8a3ca3805add3a4$var$destruct(instance, initialize) {
    if (instance.elements) {
        //delete the dom and it's references.
        var root = instance.elements.root;
        root.parentNode.removeChild(root);
        delete instance.elements;
        //copy back initial settings.
        instance.settings = $b8a3ca3805add3a4$var$copy(instance.__settings);
        //re-reference init function.
        instance.__init = initialize;
        //delete __internal variable to allow re-initialization.
        delete instance.__internal;
    }
}
/**
 * Test to check if passive event listeners are supported.
 */ var $b8a3ca3805add3a4$var$IsPassiveSupported = false;
try {
    var $b8a3ca3805add3a4$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $b8a3ca3805add3a4$var$IsPassiveSupported = true;
        }
    });
    window.addEventListener('test', $b8a3ca3805add3a4$var$options, $b8a3ca3805add3a4$var$options);
    window.removeEventListener('test', $b8a3ca3805add3a4$var$options, $b8a3ca3805add3a4$var$options);
} catch (e) {}
/**
 * Removes an event listener
 *
 * @param {HTMLElement} el The EventTarget to register the listenr on.
 * @param {string} event The event type to listen for.
 * @param {Function} handler The function to handle the event.
 * @param {boolean} useCapture Specifices if the event to be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
 * @param {boolean} passive A Boolean which, if true, indicates that the function specified by listener will never call preventDefault().
 */ var $b8a3ca3805add3a4$var$on = function(el, event, fn, useCapture, passive) {
    useCapture = useCapture === undefined ? false : useCapture;
    passive = passive === undefined ? false : passive;
    el.addEventListener(event, fn, $b8a3ca3805add3a4$var$IsPassiveSupported ? {
        capture: useCapture,
        passive: passive
    } : useCapture === true);
};
/**
 * Removes an event listener
 *
 * @param {HTMLElement} el The EventTarget to unregister the listenr from.
 * @param {string} event The event type to remove.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} useCapture Specifices if the event to be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
 * @param {boolean} passive A Boolean which, if true, indicates that the function specified by listener will never call preventDefault().
 */ var $b8a3ca3805add3a4$var$off = function(el, event, fn, useCapture, passive) {
    useCapture = useCapture === undefined ? false : useCapture;
    passive = passive === undefined ? false : passive;
    el.removeEventListener(event, fn, $b8a3ca3805add3a4$var$IsPassiveSupported ? {
        capture: useCapture,
        passive: passive
    } : useCapture === true);
};
/**
     * Prevent default event from firing
     *
     * @param  {Event} event Event object
     * @return {undefined}

    function prevent ( event ) {
        if ( event ) {
            if ( event.preventDefault ) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
        }
    }
    */ var $b8a3ca3805add3a4$var$transition = function() {
    var t, type;
    var supported = false;
    var transitions = {
        'animation': 'animationend',
        'OAnimation': 'oAnimationEnd oanimationend',
        'msAnimation': 'MSAnimationEnd',
        'MozAnimation': 'animationend',
        'WebkitAnimation': 'webkitAnimationEnd'
    };
    for(t in transitions)if (document.documentElement.style[t] !== undefined) {
        type = transitions[t];
        supported = true;
        break;
    }
    return {
        type: type,
        supported: supported
    };
}();
/**
    * Creates event handler delegate that sends the instance as last argument.
    *
    * @return {Function}    a function wrapper which sends the instance as last argument.
    */ function $b8a3ca3805add3a4$var$delegate(context, method) {
    return function() {
        if (arguments.length > 0) {
            var args = [];
            for(var x = 0; x < arguments.length; x += 1)args.push(arguments[x]);
            args.push(context);
            return method.apply(context, args);
        }
        return method.apply(context, [
            null,
            context
        ]);
    };
}
/**
    * Helper for creating a dialog close event.
    *
    * @return {object}
    */ function $b8a3ca3805add3a4$var$createCloseEvent(index, button) {
    return {
        index: index,
        button: button,
        cancel: false
    };
}
/**
    * Helper for dispatching events.
    *
    * @param  {string} evenType The type of the event to disptach.
    * @param  {object} instance The dialog instance disptaching the event.
    *
    * @return   {any}   The result of the invoked function.
    */ function $b8a3ca3805add3a4$var$dispatchEvent(eventType, instance) {
    if (typeof instance.get(eventType) === 'function') return instance.get(eventType).call(instance);
}
/**
     * Super class for all dialogs
     *
     * @return {Object}		base dialog prototype
     */ var $b8a3ca3805add3a4$var$dialog = function() {
    var usedKeys = [], //dummy variable, used to trigger dom reflow.
    reflow = null, //holds body tab index in case it has any.
    tabindex = false, //condition for detecting safari
    isSafari = window.navigator.userAgent.indexOf('Safari') > -1 && window.navigator.userAgent.indexOf('Chrome') < 0, //dialog building blocks
    templates = {
        dimmer: '<div class="notifications-dimmer"></div>',
        /*tab index required to fire click event before body focus*/ modal: '<div class="notifications-modal" tabindex="0"></div>',
        dialog: '<div class="notifications-dialog" tabindex="0"></div>',
        reset: '<button class="notifications-reset"></button>',
        commands: '<div class="notifications-commands"><button class="notifications-pin"></button><button class="notifications-maximize"></button><button class="notifications-close"></button></div>',
        header: '<div class="notifications-header"></div>',
        body: '<div class="notifications-body"></div>',
        content: '<div class="notifications-content"></div>',
        footer: '<div class="notifications-footer"></div>',
        buttons: {
            primary: '<div class="notifications-buttons" data-op-type="primary"></div>',
            auxiliary: '<div class="notifications-buttons" data-op-type="auxiliary"></div>'
        },
        button: '<button></button>',
        resizeHandle: '<div class="notifications-handle"></div>'
    }, //common class names
    classes = {
        animationIn: 'is-progress-in',
        animationOut: 'is-progress-out',
        base: 'opc-notifications',
        closable: 'is-closable',
        fixed: 'is-fixed',
        frameless: 'is-frameless',
        hidden: 'is-hidden',
        maximizable: 'is-maximizable',
        maximized: 'is-maximized',
        modeless: 'is-modeless',
        movable: 'is-movable',
        noOverflow: 'is-no-overflow',
        pinnable: 'is-pinnable',
        prefix: 'notifications-',
        resizable: 'is-resizable',
        unpinned: 'is-unpinned'
    }, // Opacc Data-Attributes
    dataAttributes = {
        basic: 'basic',
        capture: 'capture',
        noSelection: 'noSelection',
        noPadding: 'noPadding',
        shake: 'shake',
        // style: '',
        type: 'modal'
    };
    /**
         * Helper: initializes the dialog instance
         *
         * @return	{Number}	The total count of currently open modals.
         */ function initialize(instance) {
        if (!instance.__internal) {
            //no need to expose init after this.
            delete instance.__init;
            //keep a copy of initial dialog settings
            if (!instance.__settings) instance.__settings = $b8a3ca3805add3a4$var$copy(instance.settings);
            //get dialog buttons/focus setup
            var setup;
            if (typeof instance.setup === 'function') {
                setup = instance.setup();
                setup.options = setup.options || {};
                setup.focus = setup.focus || {};
            } else setup = {
                buttons: [],
                focus: {
                    element: null,
                    select: false
                },
                options: {}
            };
            //initialize hooks object.
            if (typeof instance.hooks !== 'object') instance.hooks = {};
            //copy buttons defintion
            var buttonsDefinition = [];
            if (Array.isArray(setup.buttons)) for(var b = 0; b < setup.buttons.length; b += 1){
                var ref = setup.buttons[b], cpy = {};
                for(var i in ref)if (ref.hasOwnProperty(i)) cpy[i] = ref[i];
                buttonsDefinition.push(cpy);
            }
            var internal = instance.__internal = {
                /**
                     * Flag holding the open state of the dialog
                     *
                     * @type {Boolean}
                     */ isOpen: false,
                /**
                     * Active element is the element that will receive focus after
                     * closing the dialog. It defaults as the body tag, but gets updated
                     * to the last focused element before the dialog was opened.
                     *
                     * @type {Node}
                     */ activeElement: document.body,
                timerIn: undefined,
                timerOut: undefined,
                buttons: buttonsDefinition,
                focus: setup.focus,
                options: {
                    style: undefined,
                    type: undefined,
                    title: undefined,
                    modal: undefined,
                    basic: undefined,
                    frameless: undefined,
                    pinned: undefined,
                    movable: undefined,
                    moveBounded: undefined,
                    resizable: undefined,
                    autoReset: undefined,
                    closable: undefined,
                    closableByDimmer: undefined,
                    maximizable: undefined,
                    startMaximized: undefined,
                    pinnable: undefined,
                    transition: undefined,
                    padding: undefined,
                    overflow: undefined,
                    onshow: undefined,
                    onclosing: undefined,
                    onclose: undefined,
                    onfocus: undefined,
                    onmove: undefined,
                    onmoved: undefined,
                    onresize: undefined,
                    onresized: undefined,
                    onmaximize: undefined,
                    onmaximized: undefined,
                    onrestore: undefined,
                    onrestored: undefined
                },
                resetHandler: undefined,
                beginMoveHandler: undefined,
                beginResizeHandler: undefined,
                bringToFrontHandler: undefined,
                modalClickHandler: undefined,
                buttonsClickHandler: undefined,
                commandsClickHandler: undefined,
                transitionInHandler: undefined,
                transitionOutHandler: undefined,
                destroy: undefined
            };
            var elements = {};
            //root node
            elements.root = document.createElement('div');
            elements.root.className = classes.base + ' ' + classes.hidden + ' ';
            elements.root.innerHTML = templates.dimmer + templates.modal;
            //dimmer
            elements.dimmer = elements.root.firstChild;
            //dialog
            elements.modal = elements.root.lastChild;
            elements.modal.innerHTML = templates.dialog;
            elements.dialog = elements.modal.firstChild;
            elements.dialog.innerHTML = templates.reset + templates.commands + templates.header + templates.body + templates.footer + templates.resizeHandle + templates.reset;
            //reset links
            elements.reset = [];
            elements.reset.push(elements.dialog.firstChild);
            elements.reset.push(elements.dialog.lastChild);
            //commands
            elements.commands = {};
            elements.commands.container = elements.reset[0].nextSibling;
            elements.commands.pin = elements.commands.container.firstChild;
            elements.commands.maximize = elements.commands.pin.nextSibling;
            elements.commands.close = elements.commands.maximize.nextSibling;
            //header
            elements.header = elements.commands.container.nextSibling;
            //body
            elements.body = elements.header.nextSibling;
            elements.body.innerHTML = templates.content;
            elements.content = elements.body.firstChild;
            //footer
            elements.footer = elements.body.nextSibling;
            elements.footer.innerHTML = templates.buttons.auxiliary + templates.buttons.primary;
            //resize handle
            elements.resizeHandle = elements.footer.nextSibling;
            //buttons
            elements.buttons = {};
            elements.buttons.auxiliary = elements.footer.firstChild;
            elements.buttons.primary = elements.buttons.auxiliary.nextSibling;
            elements.buttons.primary.innerHTML = templates.button;
            elements.buttonTemplate = elements.buttons.primary.firstChild;
            //remove button template
            elements.buttons.primary.removeChild(elements.buttonTemplate);
            for(var x = 0; x < instance.__internal.buttons.length; x += 1){
                var button = instance.__internal.buttons[x];
                // add to the list of used keys.
                if (usedKeys.indexOf(button.key) < 0) usedKeys.push(button.key);
                button.element = elements.buttonTemplate.cloneNode();
                button.element.innerHTML = button.text;
                if (typeof button.className === 'string' && button.className !== '') $b8a3ca3805add3a4$var$addClass(button.element, button.className);
                for(var key in button.attrs)if (key !== 'className' && button.attrs.hasOwnProperty(key)) button.element.setAttribute(key, button.attrs[key]);
                if (button.scope === 'auxiliary') elements.buttons.auxiliary.appendChild(button.element);
                else elements.buttons.primary.appendChild(button.element);
            }
            //make elements pubic
            instance.elements = elements;
            //save event handlers delegates
            internal.resetHandler = $b8a3ca3805add3a4$var$delegate(instance, onReset);
            internal.beginMoveHandler = $b8a3ca3805add3a4$var$delegate(instance, beginMove);
            internal.beginResizeHandler = $b8a3ca3805add3a4$var$delegate(instance, beginResize);
            internal.bringToFrontHandler = $b8a3ca3805add3a4$var$delegate(instance, bringToFront);
            internal.modalClickHandler = $b8a3ca3805add3a4$var$delegate(instance, modalClickHandler);
            internal.buttonsClickHandler = $b8a3ca3805add3a4$var$delegate(instance, buttonsClickHandler);
            internal.commandsClickHandler = $b8a3ca3805add3a4$var$delegate(instance, commandsClickHandler);
            internal.transitionInHandler = $b8a3ca3805add3a4$var$delegate(instance, handleTransitionInEvent);
            internal.transitionOutHandler = $b8a3ca3805add3a4$var$delegate(instance, handleTransitionOutEvent);
            //settings
            for(var opKey in internal.options){
                if (setup.options[opKey] !== undefined) // if found in user options
                instance.set(opKey, setup.options[opKey]);
                else if ($b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.hasOwnProperty(opKey)) // else if found in defaults options
                instance.set(opKey, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults[opKey]);
                else if (opKey === 'title') // else if title key, use opaccNotifications.defaults.glossary
                instance.set(opKey, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.glossary[opKey]);
            }
            // allow dom customization
            if (typeof instance.build === 'function') instance.build();
        }
        //add to the end of the DOM tree.
        document.body.appendChild(instance.elements.root);
    }
    /**
         * Helper: maintains scroll position
         *
         */ var scrollX, scrollY;
    function saveScrollPosition() {
        scrollX = $b8a3ca3805add3a4$var$getScrollLeft();
        scrollY = $b8a3ca3805add3a4$var$getScrollTop();
    }
    function restoreScrollPosition() {
        window.scrollTo(scrollX, scrollY);
    }
    /**
         * Helper: adds/removes no-overflow class from body
         *
         */ function ensureNoOverflow() {
        var requiresNoOverflow = 0;
        for(var x = 0; x < $b8a3ca3805add3a4$var$openDialogs.length; x += 1){
            var instance = $b8a3ca3805add3a4$var$openDialogs[x];
            if (instance.isModal() || instance.isMaximized()) requiresNoOverflow += 1;
        }
        if (requiresNoOverflow === 0 && document.body.className.indexOf(classes.noOverflow) >= 0) {
            //last open modal or last maximized one
            $b8a3ca3805add3a4$var$removeClass(document.body, classes.noOverflow);
            preventBodyShift(false);
        } else if (requiresNoOverflow > 0 && document.body.className.indexOf(classes.noOverflow) < 0) {
            //first open modal or first maximized one
            preventBodyShift(true);
            $b8a3ca3805add3a4$var$addClass(document.body, classes.noOverflow);
        }
    }
    var top = '', topScroll = 0;
    /**
         * Helper: prevents body shift.
         *
         */ function preventBodyShift(add) {
        if ($b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.preventBodyShift && document.documentElement.scrollHeight > document.documentElement.clientHeight) {
            if (add) {
                topScroll = scrollY;
                top = window.getComputedStyle(document.body).top;
                $b8a3ca3805add3a4$var$addClass(document.body, classes.fixed);
                document.body.style.top = -scrollY + 'px';
            } else {
                scrollY = topScroll;
                document.body.style.top = top;
                $b8a3ca3805add3a4$var$removeClass(document.body, classes.fixed);
                restoreScrollPosition();
            }
        }
    }
    /**
         * Sets the name of the transition used to show/hide the dialog
         *
         * @param {Object} instance The dilog instance.
         *
         */ function updateTransition(instance, value, oldValue) {
        if (typeof oldValue === 'string') $b8a3ca3805add3a4$var$setDataAttr(instance.elements.root, oldValue, 0);
        $b8a3ca3805add3a4$var$setDataAttr(instance.elements.root, value, 1);
        reflow = instance.elements.root.offsetWidth;
    }
    /**
         * Toggles the dialog display mode
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function updateDisplayMode(instance) {
        if (instance.get('modal')) {
            //make modal
            $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.modeless);
            //only if open
            if (instance.isOpen()) {
                unbindModelessEvents(instance);
                //in case a pinned modless dialog was made modal while open.
                updateAbsPositionFix(instance);
                ensureNoOverflow();
            }
        } else {
            //make modeless
            $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.modeless);
            //only if open
            if (instance.isOpen()) {
                bindModelessEvents(instance);
                //in case pin/unpin was called while a modal is open
                updateAbsPositionFix(instance);
                ensureNoOverflow();
            }
        }
    }
    /**
         * Toggles the dialog basic view mode
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function updateBasicMode(instance) {
        if (instance.get('basic')) $b8a3ca3805add3a4$var$setDataAttr(instance.elements.root, dataAttributes.basic, 1);
        else $b8a3ca3805add3a4$var$setDataAttr(instance.elements.root, dataAttributes.basic, 0);
    }
    /**
         * Toggles the dialog frameless view mode
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function updateFramelessMode(instance) {
        if (instance.get('frameless')) $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.frameless);
        else $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.frameless);
    }
    /**
         * Helper: Brings the modeless dialog to front, attached to modeless dialogs.
         *
         * @param {Event} event Focus event
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bringToFront(event, instance) {
        // Do not bring to front if preceeded by an open modal
        var index = $b8a3ca3805add3a4$var$openDialogs.indexOf(instance);
        for(var x = index + 1; x < $b8a3ca3805add3a4$var$openDialogs.length; x += 1){
            if ($b8a3ca3805add3a4$var$openDialogs[x].isModal()) return;
        }
        // Bring to front by making it the last child.
        if (document.body.lastChild !== instance.elements.root) {
            document.body.appendChild(instance.elements.root);
            //also make sure its at the end of the list
            $b8a3ca3805add3a4$var$openDialogs.splice($b8a3ca3805add3a4$var$openDialogs.indexOf(instance), 1);
            $b8a3ca3805add3a4$var$openDialogs.push(instance);
            setFocus(instance);
        }
        return false;
    }
    /**
         * Helper: reflects dialogs options updates
         *
         * @param {Object} instance The dilog instance.
         * @param {String} option The updated option name.
         *
         * @return	{undefined}
         */ function optionUpdated(instance, option, oldValue, newValue) {
        switch(option){
            case 'title':
                instance.setHeader(newValue);
                break;
            case 'modal':
                updateDisplayMode(instance);
                break;
            case 'basic':
                updateBasicMode(instance);
                break;
            case 'frameless':
                updateFramelessMode(instance);
                break;
            case 'pinned':
                updatePinned(instance);
                break;
            case 'closable':
                updateClosable(instance);
                break;
            case 'maximizable':
                updateMaximizable(instance);
                break;
            case 'pinnable':
                updatePinnable(instance);
                break;
            case 'movable':
                updateMovable(instance);
                break;
            case 'resizable':
                updateResizable(instance);
                break;
            case 'type':
                $b8a3ca3805add3a4$var$setDataAttr(instance.elements.root, 'type', newValue);
                break;
            case 'style':
                $b8a3ca3805add3a4$var$setDataAttr(instance.elements.root, 'style', newValue);
                break;
            case 'padding':
                if (newValue) $b8a3ca3805add3a4$var$setDataAttr(instance.elements.root, dataAttributes.noPadding, 0);
                else if (instance.elements.root.className.indexOf(classes.noPadding) < 0) $b8a3ca3805add3a4$var$setDataAttr(instance.elements.root, dataAttributes.noPadding, 1);
                break;
            case 'overflow':
                if (newValue) $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.noOverflow);
                else if (instance.elements.root.className.indexOf(classes.noOverflow) < 0) $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.noOverflow);
                break;
            case 'transition':
                updateTransition(instance, newValue, oldValue);
                break;
        }
        // internal on option updated event
        if (typeof instance.hooks.onupdate === 'function') instance.hooks.onupdate.call(instance, option, oldValue, newValue);
    }
    /**
         * Helper: reflects dialogs options updates
         *
         * @param {Object} instance The dilog instance.
         * @param {Object} obj The object to set/get a value on/from.
         * @param {Function} callback The callback function to call if the key was found.
         * @param {String|Object} key A string specifying a propery name or a collection of key value pairs.
         * @param {Object} value Optional, the value associated with the key (in case it was a string).
         * @param {String} option The updated option name.
         *
         * @return	{Object} result object
         *	The result objects has an 'op' property, indicating of this is a SET or GET operation.
         *		GET:
         *		- found: a flag indicating if the key was found or not.
         *		- value: the property value.
         *		SET:
         *		- items: a list of key value pairs of the properties being set.
         *				each contains:
         *					- found: a flag indicating if the key was found or not.
         *					- key: the property key.
         *					- value: the property value.
         */ function update(instance, obj, callback, key, value) {
        var result = {
            op: undefined,
            items: []
        };
        if (typeof value === 'undefined' && typeof key === 'string') {
            //get
            result.op = 'get';
            if (obj.hasOwnProperty(key)) {
                result.found = true;
                result.value = obj[key];
            } else {
                result.found = false;
                result.value = undefined;
            }
        } else {
            var old;
            //set
            result.op = 'set';
            if (typeof key === 'object') {
                //set multiple
                var args = key;
                for(var prop in args)if (obj.hasOwnProperty(prop)) {
                    if (obj[prop] !== args[prop]) {
                        old = obj[prop];
                        obj[prop] = args[prop];
                        callback.call(instance, prop, old, args[prop]);
                    }
                    result.items.push({
                        'key': prop,
                        'value': args[prop],
                        'found': true
                    });
                } else result.items.push({
                    'key': prop,
                    'value': args[prop],
                    'found': false
                });
            } else if (typeof key === 'string') {
                //set single
                if (obj.hasOwnProperty(key)) {
                    if (obj[key] !== value) {
                        old = obj[key];
                        obj[key] = value;
                        callback.call(instance, key, old, value);
                    }
                    result.items.push({
                        'key': key,
                        'value': value,
                        'found': true
                    });
                } else result.items.push({
                    'key': key,
                    'value': value,
                    'found': false
                });
            } else //invalid params
            throw new Error('args must be a string or object');
        }
        return result;
    }
    /**
         * Triggers a close event.
         *
         * @param {Object} instance	The dilog instance.
         *
         * @return {undefined}
         */ function triggerClose(instance) {
        var found;
        triggerCallback(instance, function(button) {
            return found = button.invokeOnClose === true;
        });
        //none of the buttons registered as onclose callback
        //close the dialog
        if (!found && instance.isOpen()) instance.close();
    }
    /**
         * Dialogs commands event handler, attached to the dialog commands element.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance	The dilog instance.
         *
         * @return {undefined}
         */ function commandsClickHandler(event, instance) {
        var target = event.srcElement || event.target;
        switch(target){
            case instance.elements.commands.pin:
                if (!instance.isPinned()) pin(instance);
                else unpin(instance);
                break;
            case instance.elements.commands.maximize:
                if (!instance.isMaximized()) maximize(instance);
                else restore(instance);
                break;
            case instance.elements.commands.close:
                triggerClose(instance);
                break;
        }
        return false;
    }
    /**
         * Helper: pins the modeless dialog.
         *
         * @param {Object} instance	The dialog instance.
         *
         * @return {undefined}
         */ function pin(instance) {
        //pin the dialog
        instance.set('pinned', true);
    }
    /**
         * Helper: unpins the modeless dialog.
         *
         * @param {Object} instance	The dilog instance.
         *
         * @return {undefined}
         */ function unpin(instance) {
        //unpin the dialog
        instance.set('pinned', false);
    }
    /**
         * Helper: enlarges the dialog to fill the entire screen.
         *
         * @param {Object} instance	The dilog instance.
         *
         * @return {undefined}
         */ function maximize(instance) {
        // allow custom `onmaximize` method
        $b8a3ca3805add3a4$var$dispatchEvent('onmaximize', instance);
        //maximize the dialog
        $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.maximized);
        if (instance.isOpen()) ensureNoOverflow();
        // allow custom `onmaximized` method
        $b8a3ca3805add3a4$var$dispatchEvent('onmaximized', instance);
    }
    /**
         * Helper: returns the dialog to its former size.
         *
         * @param {Object} instance	The dilog instance.
         *
         * @return {undefined}
         */ function restore(instance) {
        // allow custom `onrestore` method
        $b8a3ca3805add3a4$var$dispatchEvent('onrestore', instance);
        //maximize the dialog
        $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.maximized);
        if (instance.isOpen()) ensureNoOverflow();
        // allow custom `onrestored` method
        $b8a3ca3805add3a4$var$dispatchEvent('onrestored', instance);
    }
    /**
         * Show or hide the maximize box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updatePinnable(instance) {
        if (instance.get('pinnable')) $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.pinnable);
        else $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.pinnable);
    }
    /**
         * Helper: Fixes the absolutly positioned modal div position.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */ function addAbsPositionFix(instance) {
        var scrollLeft = $b8a3ca3805add3a4$var$getScrollLeft();
        instance.elements.modal.style.marginTop = $b8a3ca3805add3a4$var$getScrollTop() + 'px';
        instance.elements.modal.style.marginLeft = scrollLeft + 'px';
        instance.elements.modal.style.marginRight = -scrollLeft + 'px';
    }
    /**
         * Helper: Removes the absolutly positioned modal div position fix.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */ function removeAbsPositionFix(instance) {
        var marginTop = parseInt(instance.elements.modal.style.marginTop, 10);
        var marginLeft = parseInt(instance.elements.modal.style.marginLeft, 10);
        instance.elements.modal.style.marginTop = '';
        instance.elements.modal.style.marginLeft = '';
        instance.elements.modal.style.marginRight = '';
        if (instance.isOpen()) {
            var top = 0, left = 0;
            if (instance.elements.dialog.style.top !== '') top = parseInt(instance.elements.dialog.style.top, 10);
            instance.elements.dialog.style.top = top + (marginTop - $b8a3ca3805add3a4$var$getScrollTop()) + 'px';
            if (instance.elements.dialog.style.left !== '') left = parseInt(instance.elements.dialog.style.left, 10);
            instance.elements.dialog.style.left = left + (marginLeft - $b8a3ca3805add3a4$var$getScrollLeft()) + 'px';
        }
    }
    /**
         * Helper: Adds/Removes the absolutly positioned modal div position fix based on its pinned setting.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */ function updateAbsPositionFix(instance) {
        // if modeless and unpinned add fix
        if (!instance.get('modal') && !instance.get('pinned')) addAbsPositionFix(instance);
        else removeAbsPositionFix(instance);
    }
    /**
         * Toggles the dialog position lock | modeless only.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to make it modal, false otherwise.
         *
         * @return {undefined}
         */ function updatePinned(instance) {
        if (instance.get('pinned')) {
            $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.unpinned);
            if (instance.isOpen()) removeAbsPositionFix(instance);
        } else {
            $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.unpinned);
            if (instance.isOpen() && !instance.isModal()) addAbsPositionFix(instance);
        }
    }
    /**
         * Show or hide the maximize box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updateMaximizable(instance) {
        if (instance.get('maximizable')) $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.maximizable);
        else $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.maximizable);
    }
    /**
         * Show or hide the close box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updateClosable(instance) {
        if (instance.get('closable')) {
            $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.closable);
            bindClosableEvents(instance);
        } else {
            $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.closable);
            unbindClosableEvents(instance);
        }
    }
    var cancelClick = false, modalClickHandlerTS = 0 // stores last click timestamp to prevent executing the handler twice on double click.
    ;
    /**
         * Helper: closes the modal dialog when clicking the modal
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function modalClickHandler(event, instance) {
        if (event.timeStamp - modalClickHandlerTS > 200 && (modalClickHandlerTS = event.timeStamp) && !cancelClick) {
            var target = event.srcElement || event.target;
            if (instance.get('closableByDimmer') === true && target === instance.elements.modal) triggerClose(instance);
            cancelClick = false;
            return false;
        }
    }
    // stores last call timestamp to prevent triggering the callback twice.
    var callbackTS = 0;
    // flag to cancel keyup event if already handled by click event (pressing Enter on a focusted button).
    var cancelKeyup = false;
    /**
         * Helper: triggers a button callback
         *
         * @param {Object}		The dilog instance.
         * @param {Function}	Callback to check which button triggered the event.
         *
         * @return {undefined}
         */ function triggerCallback(instance, check) {
        if (Date.now() - callbackTS > 200 && (callbackTS = Date.now())) for(var idx = 0; idx < instance.__internal.buttons.length; idx += 1){
            var button = instance.__internal.buttons[idx];
            if (!button.element.disabled && check(button)) {
                var closeEvent = $b8a3ca3805add3a4$var$createCloseEvent(idx, button);
                if (typeof instance.callback === 'function') instance.callback.apply(instance, [
                    closeEvent
                ]);
                //close the dialog only if not canceled.
                if (closeEvent.cancel === false) instance.close();
                break;
            }
        }
    }
    /**
         * Clicks event handler, attached to the dialog footer.
         *
         * @param {Event}		DOM event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */ function buttonsClickHandler(event, instance) {
        var target = event.srcElement || event.target;
        triggerCallback(instance, function(button) {
            // if this button caused the click, cancel keyup event
            return button.element === target && (cancelKeyup = true);
        });
    }
    /**
         * Keyup event handler, attached to the document.body
         *
         * @param {Event}		DOM event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */ function keyupHandler(event) {
        //hitting enter while button has focus will trigger keyup too.
        //ignore if handled by clickHandler
        if (cancelKeyup) {
            cancelKeyup = false;
            return;
        }
        var instance = $b8a3ca3805add3a4$var$openDialogs[$b8a3ca3805add3a4$var$openDialogs.length - 1];
        var keyCode = event.keyCode;
        if (instance.__internal.buttons.length === 0 && keyCode === $b8a3ca3805add3a4$var$keys.ESC && instance.get('closable') === true) {
            triggerClose(instance);
            return false;
        } else if (usedKeys.indexOf(keyCode) > -1) {
            triggerCallback(instance, function(button) {
                return button.key === keyCode;
            });
            return false;
        }
    }
    /**
        * Keydown event handler, attached to the document.body
        *
        * @param {Event}		DOM event object.
        * @param {Object}		The dilog instance.
        *
        * @return {undefined}
        */ function keydownHandler(event) {
        var instance = $b8a3ca3805add3a4$var$openDialogs[$b8a3ca3805add3a4$var$openDialogs.length - 1];
        var keyCode = event.keyCode;
        if (keyCode === $b8a3ca3805add3a4$var$keys.LEFT || keyCode === $b8a3ca3805add3a4$var$keys.RIGHT) {
            var buttons = instance.__internal.buttons;
            for(var x = 0; x < buttons.length; x += 1)if (document.activeElement === buttons[x].element) switch(keyCode){
                case $b8a3ca3805add3a4$var$keys.LEFT:
                    buttons[(x || buttons.length) - 1].element.focus();
                    return;
                case $b8a3ca3805add3a4$var$keys.RIGHT:
                    buttons[(x + 1) % buttons.length].element.focus();
                    return;
            }
        } else if (keyCode < $b8a3ca3805add3a4$var$keys.F12 + 1 && keyCode > $b8a3ca3805add3a4$var$keys.F1 - 1 && usedKeys.indexOf(keyCode) > -1) {
            event.preventDefault();
            event.stopPropagation();
            triggerCallback(instance, function(button) {
                return button.key === keyCode;
            });
            return false;
        }
    }
    /**
         * Sets focus to proper dialog element
         *
         * @param {Object} instance The dilog instance.
         * @param {Node} [resetTarget=undefined] DOM element to reset focus to.
         *
         * @return {undefined}
         */ function setFocus(instance, resetTarget) {
        // reset target has already been determined.
        if (resetTarget) resetTarget.focus();
        else {
            // current instance focus settings
            var focus = instance.__internal.focus;
            // the focus element.
            var element = focus.element;
            switch(typeof focus.element){
                // a number means a button index
                case 'number':
                    if (instance.__internal.buttons.length > focus.element) {
                        //in basic view, skip focusing the buttons.
                        if (instance.get('basic') === true) element = instance.elements.reset[0];
                        else element = instance.__internal.buttons[focus.element].element;
                    }
                    break;
                // a string means querySelector to select from dialog body contents.
                case 'string':
                    element = instance.elements.body.querySelector(focus.element);
                    break;
                // a function should return the focus element.
                case 'function':
                    element = focus.element.call(instance);
                    break;
            }
            // if no focus element, default to first reset element.
            if ((typeof element === 'undefined' || element === null) && instance.__internal.buttons.length === 0) element = instance.elements.reset[0];
            // focus
            if (element && element.focus) {
                element.focus();
                // if selectable
                if (focus.select && element.select) element.select();
            }
        }
    }
    /**
         * Focus event handler, attached to document.body and dialogs own reset links.
         * handles the focus for modal dialogs only.
         *
         * @param {Event} event DOM focus event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function onReset(event, instance) {
        // should work on last modal if triggered from document.body
        if (!instance) {
            for(var x = $b8a3ca3805add3a4$var$openDialogs.length - 1; x > -1; x -= 1)if ($b8a3ca3805add3a4$var$openDialogs[x].isModal()) {
                instance = $b8a3ca3805add3a4$var$openDialogs[x];
                break;
            }
        }
        // if modal
        if (instance && instance.isModal()) {
            // determine reset target to enable forward/backward tab cycle.
            var resetTarget, target = event.srcElement || event.target;
            var lastResetElement = target === instance.elements.reset[1] || instance.__internal.buttons.length === 0 && target === document.body;
            // if last reset link, then go to maximize or close
            if (lastResetElement) {
                if (instance.get('maximizable')) resetTarget = instance.elements.commands.maximize;
                else if (instance.get('closable')) resetTarget = instance.elements.commands.close;
            }
            // if no reset target found, try finding the best button
            if (resetTarget === undefined) {
                if (typeof instance.__internal.focus.element === 'number') {
                    // button focus element, go to first available button
                    if (target === instance.elements.reset[0]) resetTarget = instance.elements.buttons.auxiliary.firstChild || instance.elements.buttons.primary.firstChild;
                    else if (lastResetElement) //restart the cycle by going to first reset link
                    resetTarget = instance.elements.reset[0];
                } else // will reach here when tapping backwards, so go to last child
                // The focus element SHOULD NOT be a button (logically!).
                if (target === instance.elements.reset[0]) resetTarget = instance.elements.buttons.primary.lastChild || instance.elements.buttons.auxiliary.lastChild;
            }
            // focus
            setFocus(instance, resetTarget);
        }
    }
    /**
         * Transition in transitionend event handler.
         *
         * @param {Event}		TransitionEnd event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */ function handleTransitionInEvent(event, instance) {
        // clear the timer
        clearTimeout(instance.__internal.timerIn);
        // once transition is complete, set focus
        setFocus(instance);
        //restore scroll to prevent document jump
        restoreScrollPosition();
        // allow handling key up after transition ended.
        cancelKeyup = false;
        // allow custom `onfocus` method
        $b8a3ca3805add3a4$var$dispatchEvent('onfocus', instance);
        // unbind the event
        $b8a3ca3805add3a4$var$off(instance.elements.dialog, $b8a3ca3805add3a4$var$transition.type, instance.__internal.transitionInHandler);
        $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.animationIn);
    }
    /**
         * Transition out transitionend event handler.
         *
         * @param {Event}		TransitionEnd event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */ function handleTransitionOutEvent(event, instance) {
        // clear the timer
        clearTimeout(instance.__internal.timerOut);
        // unbind the event
        $b8a3ca3805add3a4$var$off(instance.elements.dialog, $b8a3ca3805add3a4$var$transition.type, instance.__internal.transitionOutHandler);
        // reset move updates
        resetMove(instance);
        // reset resize updates
        resetResize(instance);
        // restore if maximized
        if (instance.isMaximized() && !instance.get('startMaximized')) restore(instance);
        // return focus to the last active element
        if ($b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.maintainFocus && instance.__internal.activeElement) {
            instance.__internal.activeElement.focus();
            instance.__internal.activeElement = null;
        }
        //destory the instance
        if (typeof instance.__internal.destroy === 'function') instance.__internal.destroy.apply(instance);
    }
    /* Controls moving a dialog around */ //holde the current moving instance
    var movable = null, //holds the current X offset when move starts
    offsetX = 0, //holds the current Y offset when move starts
    offsetY = 0, xProp = 'pageX', yProp = 'pageY', bounds = null, refreshTop = false, moveDelegate = null;
    /**
         * Helper: sets the element top/left coordinates
         *
         * @param {Event} event	DOM event object.
         * @param {Node} element The element being moved.
         *
         * @return {undefined}
         */ function moveElement(event, element) {
        var left = event[xProp] - offsetX, top = event[yProp] - offsetY;
        if (refreshTop) top -= document.body.scrollTop;
        element.style.left = left + 'px';
        element.style.top = top + 'px';
    }
    /**
         * Helper: sets the element top/left coordinates within screen bounds
         *
         * @param {Event} event	DOM event object.
         * @param {Node} element The element being moved.
         *
         * @return {undefined}
         */ function moveElementBounded(event, element) {
        var left = event[xProp] - offsetX, top = event[yProp] - offsetY;
        if (refreshTop) top -= document.body.scrollTop;
        element.style.left = Math.min(bounds.maxLeft, Math.max(bounds.minLeft, left)) + 'px';
        if (refreshTop) element.style.top = Math.min(bounds.maxTop, Math.max(bounds.minTop, top)) + 'px';
        else element.style.top = Math.max(bounds.minTop, top) + 'px';
    }
    /**
         * Triggers the start of a move event, attached to the header element mouse down event.
         * Adds no-selection class to the body, disabling selection while moving.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {Boolean} false
         */ function beginMove(event, instance) {
        if (resizable === null && !instance.isMaximized() && instance.get('movable')) {
            var eventSrc, left = 0, top = 0;
            if (event.type === 'touchstart') {
                event.preventDefault();
                eventSrc = event.targetTouches[0];
                xProp = 'clientX';
                yProp = 'clientY';
            } else if (event.button === 0) eventSrc = event;
            if (eventSrc) {
                var element = instance.elements.dialog;
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.capture, 1);
                if (element.style.left) left = parseInt(element.style.left, 10);
                if (element.style.top) top = parseInt(element.style.top, 10);
                offsetX = eventSrc[xProp] - left;
                offsetY = eventSrc[yProp] - top;
                if (instance.isModal()) offsetY += instance.elements.modal.scrollTop;
                else if (instance.isPinned()) offsetY -= document.body.scrollTop;
                if (instance.get('moveBounded')) {
                    var current = element, offsetLeft = -left, offsetTop = -top;
                    //calc offset
                    do {
                        offsetLeft += current.offsetLeft;
                        offsetTop += current.offsetTop;
                    }while (current = current.offsetParent);
                    bounds = {
                        maxLeft: offsetLeft,
                        minLeft: -offsetLeft,
                        maxTop: document.documentElement.clientHeight - element.clientHeight - offsetTop,
                        minTop: -offsetTop
                    };
                    moveDelegate = moveElementBounded;
                } else {
                    bounds = null;
                    moveDelegate = moveElement;
                }
                // allow custom `onmove` method
                $b8a3ca3805add3a4$var$dispatchEvent('onmove', instance);
                refreshTop = !instance.isModal() && instance.isPinned();
                movable = instance;
                moveDelegate(eventSrc, element);
                $b8a3ca3805add3a4$var$setDataAttr(document.body, dataAttributes.noSelection, 1);
                return false;
            }
        }
    }
    /**
         * The actual move handler,  attached to document.body mousemove event.
         *
         * @param {Event} event	DOM event object.
         *
         * @return {undefined}
         */ function move(event) {
        if (movable) {
            var eventSrc;
            if (event.type === 'touchmove') {
                event.preventDefault();
                eventSrc = event.targetTouches[0];
            } else if (event.button === 0) eventSrc = event;
            if (eventSrc) moveDelegate(eventSrc, movable.elements.dialog);
        }
    }
    /**
         * Triggers the end of a move event,  attached to document.body mouseup event.
         * Removes no-selection class from document.body, allowing selection.
         *
         * @return {undefined}
         */ function endMove() {
        if (movable) {
            var instance = movable;
            movable = bounds = null;
            $b8a3ca3805add3a4$var$setDataAttr(document.body, dataAttributes.noSelection, 0);
            $b8a3ca3805add3a4$var$setDataAttr(instance.elements.dialog, dataAttributes.capture, 0);
            // allow custom `onmoved` method
            $b8a3ca3805add3a4$var$dispatchEvent('onmoved', instance);
        }
    }
    /**
         * Resets any changes made by moving the element to its original state,
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function resetMove(instance) {
        movable = null;
        var element = instance.elements.dialog;
        element.style.left = element.style.top = '';
    }
    /**
         * Updates the dialog move behavior.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updateMovable(instance) {
        if (instance.get('movable')) {
            // add class
            $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.movable);
            if (instance.isOpen()) bindMovableEvents(instance);
        } else {
            //reset
            resetMove(instance);
            // remove class
            $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.movable);
            if (instance.isOpen()) unbindMovableEvents(instance);
        }
    }
    /* Controls moving a dialog around */ //holde the current instance being resized
    var resizable = null, //holds the staring left offset when resize starts.
    startingLeft = Number.Nan, //holds the staring width when resize starts.
    startingWidth = 0, //holds the initial width when resized for the first time.
    minWidth = 0, //holds the offset of the resize handle.
    handleOffset = 0;
    /**
         * Helper: sets the element width/height and updates left coordinate if neccessary.
         *
         * @param {Event} event	DOM mousemove event object.
         * @param {Node} element The element being moved.
         * @param {Boolean} pinned A flag indicating if the element being resized is pinned to the screen.
         *
         * @return {undefined}
         */ function resizeElement(event, element, pageRelative) {
        //calculate offsets from 0,0
        var current = element;
        var offsetLeft = 0;
        var offsetTop = 0;
        do {
            offsetLeft += current.offsetLeft;
            offsetTop += current.offsetTop;
        }while (current = current.offsetParent);
        // determine X,Y coordinates.
        var X, Y;
        if (pageRelative === true) {
            X = event.pageX;
            Y = event.pageY;
        } else {
            X = event.clientX;
            Y = event.clientY;
        }
        // rtl handling
        var isRTL = $b8a3ca3805add3a4$var$isRightToLeft();
        if (isRTL) {
            // reverse X
            X = document.body.offsetWidth - X;
            // if has a starting left, calculate offsetRight
            if (!isNaN(startingLeft)) offsetLeft = document.body.offsetWidth - offsetLeft - element.offsetWidth;
        }
        // set width/height
        element.style.height = Y - offsetTop + handleOffset + 'px';
        element.style.width = X - offsetLeft + handleOffset + 'px';
        // if the element being resized has a starting left, maintain it.
        // the dialog is centered, divide by half the offset to maintain the margins.
        if (!isNaN(startingLeft)) {
            var diff = Math.abs(element.offsetWidth - startingWidth) * 0.5;
            if (isRTL) //negate the diff, why?
            //when growing it should decrease left
            //when shrinking it should increase left
            diff *= -1;
            if (element.offsetWidth > startingWidth) //growing
            element.style.left = startingLeft + diff + 'px';
            else if (element.offsetWidth >= minWidth) //shrinking
            element.style.left = startingLeft - diff + 'px';
        }
    }
    /**
         * Triggers the start of a resize event, attached to the resize handle element mouse down event.
         * Adds no-selection class to the body, disabling selection while moving.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {Boolean} false
         */ function beginResize(event, instance) {
        if (!instance.isMaximized()) {
            var eventSrc;
            if (event.type === 'touchstart') {
                event.preventDefault();
                eventSrc = event.targetTouches[0];
            } else if (event.button === 0) eventSrc = event;
            if (eventSrc) {
                // allow custom `onresize` method
                $b8a3ca3805add3a4$var$dispatchEvent('onresize', instance);
                resizable = instance;
                handleOffset = instance.elements.resizeHandle.offsetHeight / 2;
                var element = instance.elements.dialog;
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.capture, 1);
                startingLeft = parseInt(element.style.left, 10);
                element.style.height = element.offsetHeight + 'px';
                element.style.minHeight = instance.elements.header.offsetHeight + instance.elements.footer.offsetHeight + 'px';
                element.style.width = (startingWidth = element.offsetWidth) + 'px';
                if (element.style.maxWidth !== 'none') element.style.minWidth = (minWidth = element.offsetWidth) + 'px';
                element.style.maxWidth = 'none';
                $b8a3ca3805add3a4$var$setDataAttr(document.body, dataAttributes.noSelection, 1);
                return false;
            }
        }
    }
    /**
         * The actual resize handler,  attached to document.body mousemove event.
         *
         * @param {Event} event	DOM event object.
         *
         * @return {undefined}
         */ function resize(event) {
        if (resizable) {
            var eventSrc;
            if (event.type === 'touchmove') {
                event.preventDefault();
                eventSrc = event.targetTouches[0];
            } else if (event.button === 0) eventSrc = event;
            if (eventSrc) resizeElement(eventSrc, resizable.elements.dialog, !resizable.get('modal') && !resizable.get('pinned'));
        }
    }
    /**
         * Triggers the end of a resize event,  attached to document.body mouseup event.
         * Removes no-selection class from document.body, allowing selection.
         *
         * @return {undefined}
         */ function endResize() {
        if (resizable) {
            var instance = resizable;
            resizable = null;
            $b8a3ca3805add3a4$var$setDataAttr(document.body, dataAttributes.noSelection, 0);
            $b8a3ca3805add3a4$var$setDataAttr(instance.elements.dialog, dataAttributes.capture, 0);
            cancelClick = true;
            // allow custom `onresized` method
            $b8a3ca3805add3a4$var$dispatchEvent('onresized', instance);
        }
    }
    /**
         * Resets any changes made by resizing the element to its original state.
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function resetResize(instance) {
        resizable = null;
        var element = instance.elements.dialog;
        if (element.style.maxWidth === 'none') {
            //clear inline styles.
            element.style.maxWidth = element.style.minWidth = element.style.width = element.style.height = element.style.minHeight = element.style.left = '';
            //reset variables.
            startingLeft = Number.Nan;
            startingWidth = minWidth = handleOffset = 0;
        }
    }
    /**
         * Updates the dialog move behavior.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updateResizable(instance) {
        if (instance.get('resizable')) {
            // add class
            $b8a3ca3805add3a4$var$addClass(instance.elements.root, classes.resizable);
            if (instance.isOpen()) bindResizableEvents(instance);
        } else {
            //reset
            resetResize(instance);
            // remove class
            $b8a3ca3805add3a4$var$removeClass(instance.elements.root, classes.resizable);
            if (instance.isOpen()) unbindResizableEvents(instance);
        }
    }
    /**
         * Reset move/resize on window resize.
         *
         * @param {Event} event	window resize event object.
         *
         * @return {undefined}
         */ function windowResize() {
        for(var x = 0; x < $b8a3ca3805add3a4$var$openDialogs.length; x += 1){
            var instance = $b8a3ca3805add3a4$var$openDialogs[x];
            if (instance.get('autoReset')) {
                resetMove(instance);
                resetResize(instance);
            }
        }
    }
    /**
         * Bind dialogs events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindEvents(instance) {
        // if first dialog, hook global handlers
        if ($b8a3ca3805add3a4$var$openDialogs.length === 1) {
            //global
            $b8a3ca3805add3a4$var$on(window, 'resize', windowResize);
            $b8a3ca3805add3a4$var$on(document.body, 'keyup', keyupHandler);
            $b8a3ca3805add3a4$var$on(document.body, 'keydown', keydownHandler);
            $b8a3ca3805add3a4$var$on(document.body, 'focus', onReset);
            //move
            $b8a3ca3805add3a4$var$on(document.documentElement, 'mousemove', move);
            $b8a3ca3805add3a4$var$on(document.documentElement, 'touchmove', move);
            $b8a3ca3805add3a4$var$on(document.documentElement, 'mouseup', endMove);
            $b8a3ca3805add3a4$var$on(document.documentElement, 'touchend', endMove);
            //resize
            $b8a3ca3805add3a4$var$on(document.documentElement, 'mousemove', resize);
            $b8a3ca3805add3a4$var$on(document.documentElement, 'touchmove', resize);
            $b8a3ca3805add3a4$var$on(document.documentElement, 'mouseup', endResize);
            $b8a3ca3805add3a4$var$on(document.documentElement, 'touchend', endResize);
        }
        // common events
        $b8a3ca3805add3a4$var$on(instance.elements.commands.container, 'click', instance.__internal.commandsClickHandler);
        $b8a3ca3805add3a4$var$on(instance.elements.footer, 'click', instance.__internal.buttonsClickHandler);
        $b8a3ca3805add3a4$var$on(instance.elements.reset[0], 'focus', instance.__internal.resetHandler);
        $b8a3ca3805add3a4$var$on(instance.elements.reset[1], 'focus', instance.__internal.resetHandler);
        //prevent handling key up when dialog is being opened by a key stroke.
        cancelKeyup = true;
        // hook in transition handler
        $b8a3ca3805add3a4$var$on(instance.elements.dialog, $b8a3ca3805add3a4$var$transition.type, instance.__internal.transitionInHandler);
        // modelss only events
        if (!instance.get('modal')) bindModelessEvents(instance);
        // resizable
        if (instance.get('resizable')) bindResizableEvents(instance);
        // movable
        if (instance.get('movable')) bindMovableEvents(instance);
    }
    /**
         * Unbind dialogs events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindEvents(instance) {
        // if last dialog, remove global handlers
        if ($b8a3ca3805add3a4$var$openDialogs.length === 1) {
            //global
            $b8a3ca3805add3a4$var$off(window, 'resize', windowResize);
            $b8a3ca3805add3a4$var$off(document.body, 'keyup', keyupHandler);
            $b8a3ca3805add3a4$var$off(document.body, 'keydown', keydownHandler);
            $b8a3ca3805add3a4$var$off(document.body, 'focus', onReset);
            //move
            $b8a3ca3805add3a4$var$off(document.documentElement, 'mousemove', move);
            $b8a3ca3805add3a4$var$off(document.documentElement, 'mouseup', endMove);
            //resize
            $b8a3ca3805add3a4$var$off(document.documentElement, 'mousemove', resize);
            $b8a3ca3805add3a4$var$off(document.documentElement, 'mouseup', endResize);
        }
        // common events
        $b8a3ca3805add3a4$var$off(instance.elements.commands.container, 'click', instance.__internal.commandsClickHandler);
        $b8a3ca3805add3a4$var$off(instance.elements.footer, 'click', instance.__internal.buttonsClickHandler);
        $b8a3ca3805add3a4$var$off(instance.elements.reset[0], 'focus', instance.__internal.resetHandler);
        $b8a3ca3805add3a4$var$off(instance.elements.reset[1], 'focus', instance.__internal.resetHandler);
        // hook out transition handler
        $b8a3ca3805add3a4$var$on(instance.elements.dialog, $b8a3ca3805add3a4$var$transition.type, instance.__internal.transitionOutHandler);
        // modelss only events
        if (!instance.get('modal')) unbindModelessEvents(instance);
        // movable
        if (instance.get('movable')) unbindMovableEvents(instance);
        // resizable
        if (instance.get('resizable')) unbindResizableEvents(instance);
    }
    /**
         * Bind modeless specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindModelessEvents(instance) {
        $b8a3ca3805add3a4$var$on(instance.elements.dialog, 'focus', instance.__internal.bringToFrontHandler, true);
    }
    /**
         * Unbind modeless specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindModelessEvents(instance) {
        $b8a3ca3805add3a4$var$off(instance.elements.dialog, 'focus', instance.__internal.bringToFrontHandler, true);
    }
    /**
         * Bind movable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindMovableEvents(instance) {
        $b8a3ca3805add3a4$var$on(instance.elements.header, 'mousedown', instance.__internal.beginMoveHandler);
        $b8a3ca3805add3a4$var$on(instance.elements.header, 'touchstart', instance.__internal.beginMoveHandler);
    }
    /**
         * Unbind movable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindMovableEvents(instance) {
        $b8a3ca3805add3a4$var$off(instance.elements.header, 'mousedown', instance.__internal.beginMoveHandler);
        $b8a3ca3805add3a4$var$off(instance.elements.header, 'touchstart', instance.__internal.beginMoveHandler);
    }
    /**
         * Bind resizable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindResizableEvents(instance) {
        $b8a3ca3805add3a4$var$on(instance.elements.resizeHandle, 'mousedown', instance.__internal.beginResizeHandler);
        $b8a3ca3805add3a4$var$on(instance.elements.resizeHandle, 'touchstart', instance.__internal.beginResizeHandler);
    }
    /**
         * Unbind resizable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindResizableEvents(instance) {
        $b8a3ca3805add3a4$var$off(instance.elements.resizeHandle, 'mousedown', instance.__internal.beginResizeHandler);
        $b8a3ca3805add3a4$var$off(instance.elements.resizeHandle, 'touchstart', instance.__internal.beginResizeHandler);
    }
    /**
         * Bind closable events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindClosableEvents(instance) {
        $b8a3ca3805add3a4$var$on(instance.elements.modal, 'click', instance.__internal.modalClickHandler);
    }
    /**
         * Unbind closable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindClosableEvents(instance) {
        $b8a3ca3805add3a4$var$off(instance.elements.modal, 'click', instance.__internal.modalClickHandler);
    }
    // dialog API
    return {
        __init: initialize,
        /**
             * Check if dialog is currently open
             *
             * @return {Boolean}
             */ isOpen: function() {
            return this.__internal.isOpen;
        },
        isModal: function() {
            return this.elements.root.className.indexOf(classes.modeless) < 0;
        },
        isMaximized: function() {
            return this.elements.root.className.indexOf(classes.maximized) > -1;
        },
        isPinned: function() {
            return this.elements.root.className.indexOf(classes.unpinned) < 0;
        },
        maximize: function() {
            if (!this.isMaximized()) maximize(this);
            return this;
        },
        restore: function() {
            if (this.isMaximized()) restore(this);
            return this;
        },
        pin: function() {
            if (!this.isPinned()) pin(this);
            return this;
        },
        unpin: function() {
            if (this.isPinned()) unpin(this);
            return this;
        },
        bringToFront: function() {
            bringToFront(null, this);
            return this;
        },
        /**
             * Move the dialog to a specific x/y coordinates
             *
             * @param {Number} x    The new dialog x coordinate in pixels.
             * @param {Number} y    The new dialog y coordinate in pixels.
             *
             * @return {Object} The dialog instance.
             */ moveTo: function(x, y) {
            if (!isNaN(x) && !isNaN(y)) {
                // allow custom `onmove` method
                $b8a3ca3805add3a4$var$dispatchEvent('onmove', this);
                var element = this.elements.dialog, current = element, offsetLeft = 0, offsetTop = 0;
                //subtract existing left,top
                if (element.style.left) offsetLeft -= parseInt(element.style.left, 10);
                if (element.style.top) offsetTop -= parseInt(element.style.top, 10);
                //calc offset
                do {
                    offsetLeft += current.offsetLeft;
                    offsetTop += current.offsetTop;
                }while (current = current.offsetParent);
                //calc left, top
                var left = x - offsetLeft;
                var top = y - offsetTop;
                //// rtl handling
                if ($b8a3ca3805add3a4$var$isRightToLeft()) left *= -1;
                element.style.left = left + 'px';
                element.style.top = top + 'px';
                // allow custom `onmoved` method
                $b8a3ca3805add3a4$var$dispatchEvent('onmoved', this);
            }
            return this;
        },
        /**
             * Resize the dialog to a specific width/height (the dialog must be 'resizable').
             * The dialog can be resized to:
             *  A minimum width equal to the initial display width
             *  A minimum height equal to the sum of header/footer heights.
             *
             *
             * @param {Number or String} width    The new dialog width in pixels or in percent.
             * @param {Number or String} height   The new dialog height in pixels or in percent.
             *
             * @return {Object} The dialog instance.
             */ resizeTo: function(width, height) {
            var w = parseFloat(width), h = parseFloat(height), regex = /(\d*\.\d+|\d+)%/;
            if (!isNaN(w) && !isNaN(h) && this.get('resizable') === true) {
                // allow custom `onresize` method
                $b8a3ca3805add3a4$var$dispatchEvent('onresize', this);
                if (('' + width).match(regex)) w = w / 100 * document.documentElement.clientWidth;
                if (('' + height).match(regex)) h = h / 100 * document.documentElement.clientHeight;
                var element = this.elements.dialog;
                if (element.style.maxWidth !== 'none') element.style.minWidth = (minWidth = element.offsetWidth) + 'px';
                element.style.maxWidth = 'none';
                element.style.minHeight = this.elements.header.offsetHeight + this.elements.footer.offsetHeight + 'px';
                element.style.width = w + 'px';
                element.style.height = h + 'px';
                // allow custom `onresized` method
                $b8a3ca3805add3a4$var$dispatchEvent('onresized', this);
            }
            return this;
        },
        /**
             * Gets or Sets dialog settings/options
             *
             * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
             * @param {Object} value Optional, the value associated with the key (in case it was a string).
             *
             * @return {undefined}
             */ setting: function(key, value) {
            var self = this;
            var result = update(this, this.__internal.options, function(k, o, n) {
                optionUpdated(self, k, o, n);
            }, key, value);
            if (result.op === 'get') {
                if (result.found) return result.value;
                else if (typeof this.settings !== 'undefined') return update(this, this.settings, this.settingUpdated || function() {}, key, value).value;
                else return undefined;
            } else if (result.op === 'set') {
                if (result.items.length > 0) {
                    var callback = this.settingUpdated || function() {};
                    for(var x = 0; x < result.items.length; x += 1){
                        var item = result.items[x];
                        if (!item.found && typeof this.settings !== 'undefined') update(this, this.settings, callback, item.key, item.value);
                    }
                }
                return this;
            }
        },
        /**
             * [Alias] Sets dialog settings/options
             */ set: function(key, value) {
            this.setting(key, value);
            return this;
        },
        /**
             * [Alias] Gets dialog settings/options
             */ get: function(key) {
            return this.setting(key);
        },
        /**
            * Sets dialog header
            * @content {string or element}
            *
            * @return {undefined}
            */ setHeader: function(content) {
            if (typeof content === 'string') {
                $b8a3ca3805add3a4$var$clearContents(this.elements.header);
                this.elements.header.innerHTML = content;
            } else if (content instanceof window.HTMLElement && this.elements.header.firstChild !== content) {
                $b8a3ca3805add3a4$var$clearContents(this.elements.header);
                this.elements.header.appendChild(content);
            }
            return this;
        },
        /**
            * Sets dialog contents
            * @content {string or element}
            *
            * @return {undefined}
            */ setContent: function(content) {
            if (typeof content === 'string') {
                $b8a3ca3805add3a4$var$clearContents(this.elements.content);
                this.elements.content.innerHTML = content;
            } else if (content instanceof window.HTMLElement && this.elements.content.firstChild !== content) {
                $b8a3ca3805add3a4$var$clearContents(this.elements.content);
                this.elements.content.appendChild(content);
            }
            return this;
        },
        /**
             * Show the dialog as modal
             *
             * @return {Object} the dialog instance.
             */ showModal: function(className) {
            return this.show(true, className);
        },
        /**
             * Show the dialog
             *
             * @return {Object} the dialog instance.
             */ show: function(modal, className) {
            // ensure initialization
            initialize(this);
            if (!this.__internal.isOpen) {
                // add to open dialogs
                this.__internal.isOpen = true;
                $b8a3ca3805add3a4$var$openDialogs.push(this);
                // save last focused element
                if ($b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.maintainFocus) this.__internal.activeElement = document.activeElement;
                // set tabindex attribute on body element this allows script to give it focusable
                if (!document.body.hasAttribute('tabindex')) document.body.setAttribute('tabindex', tabindex = '0');
                //allow custom dom manipulation updates before showing the dialog.
                if (typeof this.prepare === 'function') this.prepare();
                bindEvents(this);
                if (modal !== undefined) this.set('modal', modal);
                //save scroll to prevent document jump
                saveScrollPosition();
                ensureNoOverflow();
                // allow custom dialog class on show
                if (typeof className === 'string' && className !== '') {
                    this.__internal.className = className;
                    $b8a3ca3805add3a4$var$addClass(this.elements.root, className);
                }
                // maximize if start maximized
                if (this.get('startMaximized')) this.maximize();
                else if (this.isMaximized()) restore(this);
                updateAbsPositionFix(this);
                $b8a3ca3805add3a4$var$removeClass(this.elements.root, classes.animationOut);
                $b8a3ca3805add3a4$var$addClass(this.elements.root, classes.animationIn);
                // set 1s fallback in case transition event doesn't fire
                clearTimeout(this.__internal.timerIn);
                this.__internal.timerIn = setTimeout(this.__internal.transitionInHandler, $b8a3ca3805add3a4$var$transition.supported ? 1000 : 100);
                if (isSafari) {
                    // force desktop safari reflow
                    var root = this.elements.root;
                    root.style.display = 'none';
                    setTimeout(function() {
                        root.style.display = 'block';
                    }, 0);
                }
                //reflow
                reflow = this.elements.root.offsetWidth;
                // show dialog
                $b8a3ca3805add3a4$var$removeClass(this.elements.root, classes.hidden);
                // internal on show event
                if (typeof this.hooks.onshow === 'function') this.hooks.onshow.call(this);
                // allow custom `onshow` method
                $b8a3ca3805add3a4$var$dispatchEvent('onshow', this);
            } else {
                // reset move updates
                resetMove(this);
                // reset resize updates
                resetResize(this);
                // shake the dialog to indicate its already open
                $b8a3ca3805add3a4$var$addClass(this.elements.dialog, classes.shake);
                var self = this;
                setTimeout(function() {
                    $b8a3ca3805add3a4$var$removeClass(self.elements.dialog, classes.shake);
                }, 200);
            }
            return this;
        },
        /**
             * Close the dialog
             *
             * @return {Object} The dialog instance
             */ close: function() {
            if (this.__internal.isOpen) // custom `onclosing` event
            {
                if ($b8a3ca3805add3a4$var$dispatchEvent('onclosing', this) !== false) {
                    unbindEvents(this);
                    $b8a3ca3805add3a4$var$removeClass(this.elements.root, classes.animationIn);
                    $b8a3ca3805add3a4$var$addClass(this.elements.root, classes.animationOut);
                    // set 1s fallback in case transition event doesn't fire
                    clearTimeout(this.__internal.timerOut);
                    this.__internal.timerOut = setTimeout(this.__internal.transitionOutHandler, $b8a3ca3805add3a4$var$transition.supported ? 1000 : 100);
                    // hide dialog
                    $b8a3ca3805add3a4$var$addClass(this.elements.root, classes.hidden);
                    //reflow
                    reflow = this.elements.modal.offsetWidth;
                    // remove custom dialog class on hide
                    if (typeof this.__internal.className !== 'undefined' && this.__internal.className !== '') $b8a3ca3805add3a4$var$removeClass(this.elements.root, this.__internal.className);
                    // internal on close event
                    if (typeof this.hooks.onclose === 'function') this.hooks.onclose.call(this);
                    // allow custom `onclose` method
                    $b8a3ca3805add3a4$var$dispatchEvent('onclose', this);
                    //remove from open dialogs
                    $b8a3ca3805add3a4$var$openDialogs.splice($b8a3ca3805add3a4$var$openDialogs.indexOf(this), 1);
                    this.__internal.isOpen = false;
                    ensureNoOverflow();
                }
            }
            // last dialog and tab index was set by us, remove it.
            if (!$b8a3ca3805add3a4$var$openDialogs.length && tabindex === '0') document.body.removeAttribute('tabindex');
            return this;
        },
        /**
             * Close all open dialogs except this.
             *
             * @return {undefined}
             */ closeOthers: function() {
            $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.closeAll(this);
            return this;
        },
        /**
             * Destroys this dialog instance
             *
             * @return {undefined}
             */ destroy: function() {
            if (this.__internal) {
                if (this.__internal.isOpen) {
                    //mark dialog for destruction, this will be called on tranistionOut event.
                    this.__internal.destroy = function() {
                        $b8a3ca3805add3a4$var$destruct(this, initialize);
                    };
                    //close the dialog to unbind all events.
                    this.close();
                } else if (!this.__internal.destroy) $b8a3ca3805add3a4$var$destruct(this, initialize);
            }
            return this;
        }
    };
}();
var $b8a3ca3805add3a4$var$notifier = function() {
    var reflow, element, openInstances = [], classes = {
        base: 'opc-notifications-notifier',
        message: 'notifications-message',
        visible: 'is-visible',
        hidden: 'is-hidden',
        close: 'notifications-close'
    }, dataAttributes = {
        top: 'NotifierTop',
        right: 'NotifierRight',
        bottom: 'NotifierBottom',
        left: 'NotifierLeft',
        center: 'NotifierCenter'
    };
    /**
         * Helper: initializes the notifier instance
         *
         */ function initialize(instance) {
        if (!instance.__internal) {
            instance.__internal = {
                position: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.notifier.position,
                delay: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.notifier.delay
            };
            element = document.createElement('DIV');
            updatePosition(instance);
        }
        //add to DOM tree.
        if (element.parentNode !== document.body) document.body.appendChild(element);
    }
    function pushInstance(instance) {
        instance.__internal.pushed = true;
        openInstances.push(instance);
    }
    function popInstance(instance) {
        openInstances.splice(openInstances.indexOf(instance), 1);
        instance.__internal.pushed = false;
    }
    /**
         * Helper: update the notifier instance position
         *
         */ function updatePosition(instance) {
        element.className = classes.base;
        switch(instance.__internal.position){
            case 'top-right':
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.top, 1);
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.right, 1);
                break;
            case 'top-left':
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.top, 1);
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.left, 1);
                break;
            case 'top-center':
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.top, 1);
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.center, 1);
                break;
            case 'bottom-left':
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.bottom, 1);
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.left, 1);
                break;
            case 'bottom-center':
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.bottom, 1);
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.center, 1);
                break;
            default:
            case 'bottom-right':
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.bottom, 1);
                $b8a3ca3805add3a4$var$setDataAttr(element, dataAttributes.right, 1);
                break;
        }
    }
    /**
        * creates a new notification message
        *
        * @param  {DOMElement} message	The notifier message element
        * @param  {Number} wait   Time (in ms) to wait before the message is dismissed, a value of 0 means keep open till clicked.
        * @param  {Function} callback A callback function to be invoked when the message is dismissed.
        *
        * @return {undefined}
        */ function create(div, callback) {
        function clickDelegate(event, instance) {
            if (!instance.__internal.closeButton || event.target.getAttribute('data-close') === 'true') instance.dismiss(true);
        }
        function transitionDone(event, instance) {
            // unbind event
            $b8a3ca3805add3a4$var$off(instance.element, $b8a3ca3805add3a4$var$transition.type, transitionDone);
            // remove the message
            element.removeChild(instance.element);
        }
        function initialize(instance) {
            if (!instance.__internal) {
                instance.__internal = {
                    pushed: false,
                    delay: undefined,
                    timer: undefined,
                    clickHandler: undefined,
                    transitionEndHandler: undefined,
                    transitionTimeout: undefined
                };
                instance.__internal.clickHandler = $b8a3ca3805add3a4$var$delegate(instance, clickDelegate);
                instance.__internal.transitionEndHandler = $b8a3ca3805add3a4$var$delegate(instance, transitionDone);
            }
            return instance;
        }
        function clearTimers(instance) {
            clearTimeout(instance.__internal.timer);
            clearTimeout(instance.__internal.transitionTimeout);
        }
        return initialize({
            /* notification DOM element*/ element: div,
            /*
                 * Pushes a notification message
                 * @param {string or DOMElement} content The notification message content
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */ push: function(_content, _wait) {
                if (!this.__internal.pushed) {
                    pushInstance(this);
                    clearTimers(this);
                    var content, wait;
                    switch(arguments.length){
                        case 0:
                            wait = this.__internal.delay;
                            break;
                        case 1:
                            if (typeof _content === 'number') wait = _content;
                            else {
                                content = _content;
                                wait = this.__internal.delay;
                            }
                            break;
                        case 2:
                            content = _content;
                            wait = _wait;
                            break;
                    }
                    this.__internal.closeButton = $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.notifier.closeButton;
                    // set contents
                    if (typeof content !== 'undefined') this.setContent(content);
                    // append or insert
                    if ($b8a3ca3805add3a4$var$notifier.__internal.position.indexOf('top') < 0) element.appendChild(this.element);
                    else element.insertBefore(this.element, element.firstChild);
                    reflow = this.element.offsetWidth;
                    $b8a3ca3805add3a4$var$addClass(this.element, classes.visible);
                    // attach click event
                    $b8a3ca3805add3a4$var$on(this.element, 'click', this.__internal.clickHandler);
                    return this.delay(wait);
                }
                return this;
            },
            /*
                 * {Function} callback function to be invoked before dismissing the notification message.
                 * Remarks: A return value === 'false' will cancel the dismissal
                 *
                 */ ondismiss: function() {},
            /*
                 * {Function} callback function to be invoked when the message is dismissed.
                 *
                 */ callback: callback,
            /*
                 * Dismisses the notification message
                 * @param {Boolean} clicked A flag indicating if the dismissal was caused by a click.
                 *
                 */ dismiss: function(clicked) {
                if (this.__internal.pushed) {
                    clearTimers(this);
                    if (!(typeof this.ondismiss === 'function' && this.ondismiss.call(this) === false)) {
                        //detach click event
                        $b8a3ca3805add3a4$var$off(this.element, 'click', this.__internal.clickHandler);
                        // ensure element exists
                        if (typeof this.element !== 'undefined' && this.element.parentNode === element) {
                            //transition end or fallback
                            this.__internal.transitionTimeout = setTimeout(this.__internal.transitionEndHandler, $b8a3ca3805add3a4$var$transition.supported ? 1000 : 100);
                            $b8a3ca3805add3a4$var$removeClass(this.element, classes.visible);
                            // custom callback on dismiss
                            if (typeof this.callback === 'function') this.callback.call(this, clicked);
                        }
                        popInstance(this);
                    }
                }
                return this;
            },
            /*
                 * Delays the notification message dismissal
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */ delay: function(wait) {
                clearTimers(this);
                this.__internal.delay = typeof wait !== 'undefined' && !isNaN(+wait) ? +wait : $b8a3ca3805add3a4$var$notifier.__internal.delay;
                if (this.__internal.delay > 0) {
                    var self = this;
                    this.__internal.timer = setTimeout(function() {
                        self.dismiss();
                    }, this.__internal.delay * 1000);
                }
                return this;
            },
            /*
                 * Sets the notification message contents
                 * @param {string or DOMElement} content The notification message content
                 *
                 */ setContent: function(content) {
                if (typeof content === 'string') {
                    $b8a3ca3805add3a4$var$clearContents(this.element);
                    this.element.innerHTML = content;
                } else if (content instanceof window.HTMLElement && this.element.firstChild !== content) {
                    $b8a3ca3805add3a4$var$clearContents(this.element);
                    this.element.appendChild(content);
                }
                if (this.__internal.closeButton) {
                    var close = document.createElement('span');
                    $b8a3ca3805add3a4$var$addClass(close, classes.close);
                    close.setAttribute('data-close', true);
                    this.element.appendChild(close);
                }
                return this;
            },
            /*
                 * Dismisses all open notifications except this.
                 *
                 */ dismissOthers: function() {
                $b8a3ca3805add3a4$var$notifier.dismissAll(this);
                return this;
            }
        });
    }
    //notifier api
    return {
        /**
             * Gets or Sets notifier settings.
             *
             * @param {string} key The setting name
             * @param {Variant} value The setting value.
             *
             * @return {Object}	if the called as a setter, return the notifier instance.
             */ setting: function(key, value) {
            //ensure init
            initialize(this);
            if (typeof value === 'undefined') //get
            return this.__internal[key];
            else //set
            switch(key){
                case 'position':
                    this.__internal.position = value;
                    updatePosition(this);
                    break;
                case 'delay':
                    this.__internal.delay = value;
                    break;
            }
            return this;
        },
        /**
             * [Alias] Sets dialog settings/options
             */ set: function(key, value) {
            this.setting(key, value);
            return this;
        },
        /**
             * [Alias] Gets dialog settings/options
             */ get: function(key) {
            return this.setting(key);
        },
        /**
             * Creates a new notification message
             *
             * @param {string} type The type of notification message (simply a CSS class name 'ajs-{type}' to be added).
             * @param {Function} callback  A callback function to be invoked when the message is dismissed.
             *
             * @return {undefined}
             */ create: function(type, callback) {
            //ensure notifier init
            initialize(this);
            //create new notification message
            var div = document.createElement('div');
            // div.className = classes.message + ((typeof type === 'string' && type !== '') ? ' ajs-' + type : '');
            div.className = classes.message + (typeof type === 'string' && type !== '' ? ' is-' + type : '');
            return create(div, callback);
        },
        /**
             * Dismisses all open notifications.
             *
             * @param {Object} excpet [optional] The notification object to exclude from dismissal.
             *
             */ dismissAll: function(except) {
            var clone = openInstances.slice(0);
            for(var x = 0; x < clone.length; x += 1){
                var instance = clone[x];
                if (except === undefined || except !== instance) instance.dismiss();
            }
        }
    };
}();
/**
     * OpaccNotifications public API
     * This contains everything that is exposed through the opaccNotifications object.
     *
     * @return {Object}
     */ function $b8a3ca3805add3a4$var$OpaccNotifications() {
    // holds a references of created dialogs
    var dialogs = {};
    /**
         * Extends a given prototype by merging properties from base into sub.
         *
         * @sub {Object} sub The prototype being overwritten.
         * @base {Object} base The prototype being written.
         *
         * @return {Object} The extended prototype.
         */ function extend(sub, base) {
        // copy dialog pototype over definition.
        for(var prop in base)if (base.hasOwnProperty(prop)) sub[prop] = base[prop];
        return sub;
    }
    /**
        * Helper: returns a dialog instance from saved dialogs.
        * and initializes the dialog if its not already initialized.
        *
        * @name {String} name The dialog name.
        *
        * @return {Object} The dialog instance.
        */ function get_dialog(name) {
        var dialog = dialogs[name].dialog;
        //initialize the dialog if its not already initialized.
        if (dialog && typeof dialog.__init === 'function') dialog.__init(dialog);
        return dialog;
    }
    /**
         * Helper:  registers a new dialog definition.
         *
         * @name {String} name The dialog name.
         * @Factory {Function} Factory a function resposible for creating dialog prototype.
         * @transient {Boolean} transient True to create a new dialog instance each time the dialog is invoked, false otherwise.
         * @base {String} base the name of another dialog to inherit from.
         *
         * @return {Object} The dialog definition.
         */ function register(name, Factory, transient, base) {
        var definition = {
            dialog: null,
            factory: Factory
        };
        //if this is based on an existing dialog, create a new definition
        //by applying the new protoype over the existing one.
        if (base !== undefined) definition.factory = function() {
            return extend(new dialogs[base].factory(), new Factory());
        };
        if (!transient) //create a new definition based on dialog
        definition.dialog = extend(new definition.factory(), $b8a3ca3805add3a4$var$dialog);
        return dialogs[name] = definition;
    }
    return {
        /**
             * OpaccNotifications defaults
             *
             * @type {Object}
             */ defaults: $b8a3ca3805add3a4$var$defaults,
        /**
             * Dialogs factory
             *
             * @param {string}      Dialog name.
             * @param {Function}    A Dialog factory function.
             * @param {Boolean}     Indicates whether to create a singleton or transient dialog.
             * @param {String}      The name of the base type to inherit from.
             */ dialog: function(name, Factory, transient, base) {
            // get request, create a new instance and return it.
            if (typeof Factory !== 'function') return get_dialog(name);
            if (this.hasOwnProperty(name)) throw new Error('opaccNotifications.dialog: name already exists');
            // register the dialog
            var definition = register(name, Factory, transient, base);
            if (transient) // make it public
            this[name] = function() {
                //if passed with no params, consider it a get request
                if (arguments.length === 0) return definition.dialog;
                else {
                    var instance = extend(new definition.factory(), $b8a3ca3805add3a4$var$dialog);
                    //ensure init
                    if (instance && typeof instance.__init === 'function') instance.__init(instance);
                    instance['main'].apply(instance, arguments);
                    return instance['show'].apply(instance);
                }
            };
            else // make it public
            this[name] = function() {
                //ensure init
                if (definition.dialog && typeof definition.dialog.__init === 'function') definition.dialog.__init(definition.dialog);
                //if passed with no params, consider it a get request
                if (arguments.length === 0) return definition.dialog;
                else {
                    var dialog = definition.dialog;
                    dialog['main'].apply(definition.dialog, arguments);
                    return dialog['show'].apply(definition.dialog);
                }
            };
        },
        /**
             * Close all open dialogs.
             *
             * @param {Object} excpet [optional] The dialog object to exclude from closing.
             *
             * @return {undefined}
             */ closeAll: function(except) {
            var clone = $b8a3ca3805add3a4$var$openDialogs.slice(0);
            for(var x = 0; x < clone.length; x += 1){
                var instance = clone[x];
                if (except === undefined || except !== instance) instance.close();
            }
        },
        /**
             * Gets or Sets dialog settings/options. if the dialog is transient, this call does nothing.
             *
             * @param {string} name The dialog name.
             * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
             * @param {Variant} value Optional, the value associated with the key (in case it was a string).
             *
             * @return {undefined}
             */ setting: function(name, key, value) {
            if (name === 'notifier') return $b8a3ca3805add3a4$var$notifier.setting(key, value);
            var dialog = get_dialog(name);
            if (dialog) return dialog.setting(key, value);
        },
        /**
             * [Alias] Sets dialog settings/options
             */ set: function(name, key, value) {
            return this.setting(name, key, value);
        },
        /**
             * [Alias] Gets dialog settings/options
             */ get: function(name, key) {
            return this.setting(name, key);
        },
        /**
             * Creates a new notification message.
             * If a type is passed, a class name "ajs-{type}" will be added.
             * This allows for custom look and feel for various types of notifications.
             *
             * @param  {String | DOMElement}    [message=undefined]		Message text
             * @param  {String}                 [type='']				Type of log message
             * @param  {String}                 [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}               [callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ notify: function(message, type, wait, callback) {
            return $b8a3ca3805add3a4$var$notifier.create(type, callback).push(message, wait);
        },
        /**
             * Creates a new notification message.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ message: function(message, wait, callback) {
            return $b8a3ca3805add3a4$var$notifier.create(null, callback).push(message, wait);
        },
        /**
             * Creates a new notification message of type 'success'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ success: function(message, wait, callback) {
            return $b8a3ca3805add3a4$var$notifier.create('success', callback).push(message, wait);
        },
        /**
             * Creates a new notification message of type 'error'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ error: function(message, wait, callback) {
            return $b8a3ca3805add3a4$var$notifier.create('error', callback).push(message, wait);
        },
        /**
             * Creates a new notification message of type 'warning'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ warning: function(message, wait, callback) {
            return $b8a3ca3805add3a4$var$notifier.create('warning', callback).push(message, wait);
        },
        /**
             * Dismisses all open notifications
             *
             * @return {undefined}
             */ dismissAll: function() {
            $b8a3ca3805add3a4$var$notifier.dismissAll();
        }
    };
}
const $b8a3ca3805add3a4$export$dddc4bb1e90c7b26 = new $b8a3ca3805add3a4$var$OpaccNotifications();
/**
    * Alert dialog definition
    *
    * invoked by:
    *	opaccNotifications.alert(message);
    *	opaccNotifications.alert(title, message);
    *	opaccNotifications.alert(message, onok);
    *	opaccNotifications.alert(title, message, onok);
     */ $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.dialog('alert', function() {
    return {
        main: function(_title, _message, _onok) {
            var title, message, onok;
            switch(arguments.length){
                case 1:
                    message = _title;
                    break;
                case 2:
                    if (typeof _message === 'function') {
                        message = _title;
                        onok = _message;
                    } else {
                        title = _title;
                        message = _message;
                    }
                    break;
                case 3:
                    title = _title;
                    message = _message;
                    onok = _onok;
                    break;
            }
            this.set('title', title);
            this.set('message', message);
            this.set('onok', onok);
            return this;
        },
        setup: function() {
            return {
                buttons: [
                    {
                        text: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.glossary.ok,
                        key: $b8a3ca3805add3a4$var$keys.ESC,
                        invokeOnClose: true,
                        className: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.theme.ok
                    }
                ],
                focus: {
                    element: 0,
                    select: false
                },
                options: {
                    maximizable: false,
                    resizable: false,
                    type: 'alert'
                }
            };
        },
        build: function() {
        // nothing
        },
        prepare: function() {
        //nothing
        },
        setMessage: function(message) {
            this.setContent(message);
        },
        settings: {
            message: undefined,
            onok: undefined,
            label: undefined
        },
        settingUpdated: function(key, oldValue, newValue) {
            switch(key){
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'label':
                    if (this.__internal.buttons[0].element) this.__internal.buttons[0].element.innerHTML = newValue;
                    break;
            }
        },
        callback: function(closeEvent) {
            if (typeof this.get('onok') === 'function') {
                var returnValue = this.get('onok').call(this, closeEvent);
                if (typeof returnValue !== 'undefined') closeEvent.cancel = !returnValue;
            }
        }
    };
});
/**
     * Confirm dialog object
     *
     *	opaccNotifications.confirm(message);
     *	opaccNotifications.confirm(message, onok);
     *	opaccNotifications.confirm(message, onok, oncancel);
     *	opaccNotifications.confirm(title, message, onok, oncancel);
     */ $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.dialog('confirm', function() {
    var autoConfirm = {
        timer: null,
        index: null,
        text: null,
        duration: null,
        task: function(event, self) {
            if (self.isOpen()) {
                self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text + ' (&#8207;' + autoConfirm.duration + '&#8207;) ';
                autoConfirm.duration -= 1;
                if (autoConfirm.duration === -1) {
                    clearAutoConfirm(self);
                    var button = self.__internal.buttons[autoConfirm.index];
                    var closeEvent = $b8a3ca3805add3a4$var$createCloseEvent(autoConfirm.index, button);
                    if (typeof self.callback === 'function') self.callback.apply(self, [
                        closeEvent
                    ]);
                    //close the dialog.
                    if (closeEvent.close !== false) self.close();
                }
            } else clearAutoConfirm(self);
        }
    };
    function clearAutoConfirm(self) {
        if (autoConfirm.timer !== null) {
            clearInterval(autoConfirm.timer);
            autoConfirm.timer = null;
            self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text;
        }
    }
    function startAutoConfirm(self, index, duration) {
        clearAutoConfirm(self);
        autoConfirm.duration = duration;
        autoConfirm.index = index;
        autoConfirm.text = self.__internal.buttons[index].element.innerHTML;
        autoConfirm.timer = setInterval($b8a3ca3805add3a4$var$delegate(self, autoConfirm.task), 1000);
        autoConfirm.task(null, self);
    }
    return {
        main: function(_title, _message, _onok, _oncancel) {
            var title, message, onok, oncancel;
            switch(arguments.length){
                case 1:
                    message = _title;
                    break;
                case 2:
                    message = _title;
                    onok = _message;
                    break;
                case 3:
                    message = _title;
                    onok = _message;
                    oncancel = _onok;
                    break;
                case 4:
                    title = _title;
                    message = _message;
                    onok = _onok;
                    oncancel = _oncancel;
                    break;
            }
            this.set('title', title);
            this.set('message', message);
            this.set('onok', onok);
            this.set('oncancel', oncancel);
            return this;
        },
        setup: function() {
            return {
                buttons: [
                    {
                        text: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.glossary.ok,
                        key: $b8a3ca3805add3a4$var$keys.ENTER,
                        className: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.theme.ok
                    },
                    {
                        text: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.glossary.cancel,
                        key: $b8a3ca3805add3a4$var$keys.ESC,
                        invokeOnClose: true,
                        className: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.theme.cancel
                    }
                ],
                focus: {
                    element: 0,
                    select: false
                },
                options: {
                    maximizable: false,
                    resizable: false,
                    type: 'confirm'
                }
            };
        },
        build: function() {
        //nothing
        },
        prepare: function() {
        //nothing
        },
        setMessage: function(message) {
            this.setContent(message);
        },
        settings: {
            message: null,
            labels: null,
            onok: null,
            oncancel: null,
            defaultFocus: null,
            reverseButtons: null
        },
        settingUpdated: function(key, oldValue, newValue) {
            switch(key){
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'labels':
                    if ('ok' in newValue && this.__internal.buttons[0].element) {
                        this.__internal.buttons[0].text = newValue.ok;
                        this.__internal.buttons[0].element.innerHTML = newValue.ok;
                    }
                    if ('cancel' in newValue && this.__internal.buttons[1].element) {
                        this.__internal.buttons[1].text = newValue.cancel;
                        this.__internal.buttons[1].element.innerHTML = newValue.cancel;
                    }
                    break;
                case 'reverseButtons':
                    if (newValue === true) this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
                    else this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                    break;
                case 'defaultFocus':
                    this.__internal.focus.element = newValue === 'ok' ? 0 : 1;
                    break;
            }
        },
        callback: function(closeEvent) {
            clearAutoConfirm(this);
            var returnValue;
            switch(closeEvent.index){
                case 0:
                    if (typeof this.get('onok') === 'function') {
                        returnValue = this.get('onok').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') closeEvent.cancel = !returnValue;
                    }
                    break;
                case 1:
                    if (typeof this.get('oncancel') === 'function') {
                        returnValue = this.get('oncancel').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') closeEvent.cancel = !returnValue;
                    }
                    break;
            }
        },
        autoOk: function(duration) {
            startAutoConfirm(this, 0, duration);
            return this;
        },
        autoCancel: function(duration) {
            startAutoConfirm(this, 1, duration);
            return this;
        }
    };
});
/**
     * Prompt dialog object
     *
     * invoked by:
     *	opaccNotifications.prompt(message);
     *	opaccNotifications.prompt(message, value);
     *	opaccNotifications.prompt(message, value, onok);
     *	opaccNotifications.prompt(message, value, onok, oncancel);
     *	opaccNotifications.prompt(title, message, value, onok, oncancel);
     */ $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.dialog('prompt', function() {
    var input = document.createElement('INPUT');
    var p = document.createElement('P');
    return {
        main: function(_title, _message, _value, _onok, _oncancel) {
            var title, message, value, onok, oncancel;
            switch(arguments.length){
                case 1:
                    message = _title;
                    break;
                case 2:
                    message = _title;
                    value = _message;
                    break;
                case 3:
                    message = _title;
                    value = _message;
                    onok = _value;
                    break;
                case 4:
                    message = _title;
                    value = _message;
                    onok = _value;
                    oncancel = _onok;
                    break;
                case 5:
                    title = _title;
                    message = _message;
                    value = _value;
                    onok = _onok;
                    oncancel = _oncancel;
                    break;
            }
            this.set('title', title);
            this.set('message', message);
            this.set('value', value);
            this.set('onok', onok);
            this.set('oncancel', oncancel);
            return this;
        },
        setup: function() {
            return {
                buttons: [
                    {
                        text: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.glossary.ok,
                        key: $b8a3ca3805add3a4$var$keys.ENTER,
                        className: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.theme.ok
                    },
                    {
                        text: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.glossary.cancel,
                        key: $b8a3ca3805add3a4$var$keys.ESC,
                        invokeOnClose: true,
                        className: $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.theme.cancel
                    }
                ],
                focus: {
                    element: input,
                    select: true
                },
                options: {
                    maximizable: false,
                    resizable: false,
                    type: 'prompt'
                }
            };
        },
        build: function() {
            input.className = $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.defaults.theme.input;
            input.setAttribute('type', 'text');
            input.value = this.get('value');
            this.elements.content.appendChild(p);
            this.elements.content.appendChild(input);
        },
        prepare: function() {
        //nothing
        },
        setMessage: function(message) {
            if (typeof message === 'string') {
                $b8a3ca3805add3a4$var$clearContents(p);
                p.innerHTML = message;
            } else if (message instanceof window.HTMLElement && p.firstChild !== message) {
                $b8a3ca3805add3a4$var$clearContents(p);
                p.appendChild(message);
            }
        },
        settings: {
            message: undefined,
            labels: undefined,
            onok: undefined,
            oncancel: undefined,
            value: '',
            type: 'text',
            reverseButtons: undefined
        },
        settingUpdated: function(key, oldValue, newValue) {
            switch(key){
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'value':
                    input.value = newValue;
                    break;
                case 'type':
                    switch(newValue){
                        case 'text':
                        case 'color':
                        case 'date':
                        case 'datetime-local':
                        case 'email':
                        case 'month':
                        case 'number':
                        case 'password':
                        case 'search':
                        case 'tel':
                        case 'time':
                        case 'week':
                            input.type = newValue;
                            break;
                        default:
                            input.type = 'text';
                            break;
                    }
                    break;
                case 'labels':
                    if (newValue.ok && this.__internal.buttons[0].element) this.__internal.buttons[0].element.innerHTML = newValue.ok;
                    if (newValue.cancel && this.__internal.buttons[1].element) this.__internal.buttons[1].element.innerHTML = newValue.cancel;
                    break;
                case 'reverseButtons':
                    if (newValue === true) this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
                    else this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                    break;
            }
        },
        callback: function(closeEvent) {
            var returnValue;
            switch(closeEvent.index){
                case 0:
                    this.settings.value = input.value;
                    if (typeof this.get('onok') === 'function') {
                        returnValue = this.get('onok').call(this, closeEvent, this.settings.value);
                        if (typeof returnValue !== 'undefined') closeEvent.cancel = !returnValue;
                    }
                    break;
                case 1:
                    if (typeof this.get('oncancel') === 'function') {
                        returnValue = this.get('oncancel').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') closeEvent.cancel = !returnValue;
                    }
                    if (!closeEvent.cancel) input.value = this.settings.value;
                    break;
            }
        }
    };
});
$b8a3ca3805add3a4$export$dddc4bb1e90c7b26.modal || $b8a3ca3805add3a4$export$dddc4bb1e90c7b26.dialog('modal', function() {
    return {
        main: function(_title, _message, _onok) {
            var title, message, onok;
            switch(arguments.length){
                case 1:
                    message = _title;
                    break;
                case 2:
                    if (typeof _message === 'function') {
                        message = _title;
                        onok = _message;
                    } else {
                        title = _title;
                        message = _message;
                    }
                    break;
                case 3:
                    title = _title;
                    message = _message;
                    onok = _onok;
                    break;
            }
            this.set('title', title);
            this.set('message', message);
            this.set('onok', onok);
            return this;
        },
        setup: function() {
            return {
                options: {
                    maximizable: false,
                    resizable: false,
                    type: 'modal'
                }
            };
        },
        build: function() {},
        prepare: function() {
            this.set('basic', true);
            this.set('title', this.elements.content.querySelector(this.get('head')));
            this.elements.header.style.opacity = 1;
            //this.elements.resizeHandle.remove();
            this.elements.footer.remove();
        },
        setMessage: function(message) {
            this.setContent(message);
        },
        settings: {
            message: undefined,
            onok: undefined,
            label: undefined,
            head: '.favorite-modal-head'
        },
        settingUpdated: function(key, oldValue, newValue) {
            this.close();
            switch(key){
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'label':
                    if (this.__internal.buttons[0].element) this.__internal.buttons[0].element.innerHTML = newValue;
                    break;
            }
        },
        callback: function(closeEvent) {
            if (typeof this.get('onok') === 'function') {
                var returnValue = this.get('onok').call(this, closeEvent);
                if (typeof returnValue !== 'undefined') closeEvent.cancel = !returnValue;
            }
        }
    };
});


const $6a5d168af5ede3cd$var$globalFormErrorMessages = {
    messageValueMissing: {
        code: '3-6-6360',
        text: 'Please fill out this field.'
    },
    messageValueMissingSelect: {
        code: '3-6-6360',
        text: 'Please select a value.'
    },
    messageValueMissingSelectMulti: {
        code: '3-6-6360',
        text: 'Please select at least one value.'
    },
    messageTypeMismatchEmail: {
        code: '3-6-6360',
        text: 'Please enter an email address.'
    },
    messageTypeMismatchURL: {
        code: '3-6-6360',
        text: 'Please enter a URL.'
    },
    messageTooShort: {
        code: '3-6-6360',
        text: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.'
    },
    messageTooLong: {
        code: '3-6-6360',
        text: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.'
    },
    messagePatternMismatch: {
        code: '3-6-6360',
        text: 'Please match the requested format.'
    },
    messageBadInput: {
        code: '3-6-6360',
        text: 'Please enter a number.'
    },
    messageStepMismatch: {
        code: '3-6-6360',
        text: 'Please select a value that is a multiple from {step}.'
    },
    messageToMuchDec: {
        code: '3-6-6360',
        text: 'Invalid value indicated. Your input has been changed to {newValue}.'
    },
    messageStepAdjust: {
        code: '3-6-6360',
        text: 'The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}'
    },
    messageRangeOverflow: {
        code: '3-6-6360',
        text: 'Please select a value that is no more than {max}.'
    },
    messageRangeUnderflow: {
        code: '3-6-6360',
        text: 'Please select a value that is no less than {min}.'
    },
    messageGeneric: {
        code: '3-6-6360',
        text: 'The value you entered for this field is invalid.'
    },
    messageUnequal: {
        code: '3-6-6360',
        text: 'The indicated values do not match.'
    }
};
const $6a5d168af5ede3cd$var$globalBasketMessages = {
    messageEmptyBasket: {
        code: '1-6-6220',
        text: 'Shopping cart is empty'
    },
    messageAddedToBasket: {
        code: '1-6-6221',
        text: 'added to the shopping cart'
    },
    quickOrderMessageTooShort: {
        code: '1-6-6222',
        text: 'At least %1 characters are required for a search.'
    }
};
const $6a5d168af5ede3cd$var$globalDeliveryMessages = {
    messageDeliveryTypeGeneral: {
        code: '1-6-6226',
        text: 'Delivery method changed'
    }
};
const $6a5d168af5ede3cd$var$globalPaymentMessages = {
    messagePaymentTypeCreditCard: {
        code: '1-6-6227',
        text: 'Payment type credit card'
    },
    messagePaymentTypeInvoice: {
        code: '1-6-6227',
        text: 'Payment type invoice'
    },
    messagePaymentTypeInAdvance: {
        code: '1-6-6227',
        text: 'Payment type advance payment'
    },
    messagePaymentTypeOnDelivery: {
        code: '1-6-6227',
        text: 'Payment type cash on delivery'
    },
    messagePaymentTypeGeneral: {
        code: '1-6-6227',
        text: 'Payment type changed'
    }
};
const $6a5d168af5ede3cd$var$globalCompareMessages = {
    messageHint: {
        code: '1-6-6240',
        text: ''
    }
};
const $6a5d168af5ede3cd$var$globalFavoriteMessages = {
    messageInvalidName: {
        code: '2-6-6270',
        text: 'Unable to create the wish list; the name is invalid.'
    },
    messageMaxLists: {
        code: '2-6-6277',
        text: 'Max. number of wish lists reached!'
    },
    messageMaxPositions: {
        code: '2-6-6278',
        text: 'Max. number of positions reached!'
    },
    messageDeleteConfirmation: {
        code: '2-6-6273',
        text: 'Do you really want to delete the wish list?'
    }
};
const $6a5d168af5ede3cd$var$globalAutocompleteMessages = {
    messageNoValueFound: {
        code: '1-6-6290',
        text: 'No match found!'
    }
};
const $6a5d168af5ede3cd$var$globalArticleMessages = {
    messageEmpty: {
        code: '1-6-6210',
        text: 'No items found!'
    }
};
const $6a5d168af5ede3cd$var$globalAccountMessages = {
    messageDelete: {
        code: '1-6-6200',
        text: 'Do you really want to delete this address?'
    },
    messageChangeSuccess: {
        code: '1-6-6200',
        text: 'Address successfully modified.'
    }
};
const $6a5d168af5ede3cd$var$globalGeneralMessages = {
    messageEmptyText: {
        code: '1-6-6290',
        text: 'The output was suppressed due to an empty text.'
    },
    messageOk: {
        code: '1-6-6290',
        text: 'Yes'
    },
    messageCancel: {
        code: '1-6-6290',
        text: 'No'
    },
    messageChange: {
        code: '1-6-6290',
        text: 'The selection was changed'
    },
    messageDefault: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultInfo: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultWarning: {
        code: '2-6-0000',
        text: ''
    },
    messageDefaultError: {
        code: '3-6-0000',
        text: ''
    },
    messageDefaultDebug: {
        code: '4-6-0000',
        text: ''
    }
};
const $6a5d168af5ede3cd$var$globalDirectSearchSuggestMessages = {
    messageTooShort: {
        code: '1-6-6260',
        text: 'At least 3 characters!'
    },
    messageResultEmpty: {
        code: '1-6-6260',
        text: 'No items found!'
    }
};
const $6a5d168af5ede3cd$var$globalFileuploadAreaMessages = {
    defaultMessage: {
        code: '1-6-2002',
        text: 'Store the files here to upload them'
    },
    fallbackMessage: {
        code: '2-6-2002',
        text: 'Your browser does not support drag&drop file uploads'
    },
    fallbackText: {
        code: '2-6-2002',
        text: 'Use the form to upload your files'
    },
    fileTooBig: {
        code: '2-6-2002',
        text: 'The file is too large. The maximum file size is {{maxFileSize}} MB'
    },
    invalidFileType: {
        code: '2-6-2002',
        text: 'Unable to upload files of this type'
    },
    responseError: {
        code: '3-6-2002',
        text: 'The server rejected your request with status {{statusCode}}'
    },
    cancelUpload: {
        code: '1-6-2002',
        text: 'Cancel upload'
    },
    cancelUploadConfirmation: {
        code: '1-6-2002',
        text: 'Cancel upload?'
    },
    removeFile: {
        code: '1-6-2002',
        text: 'Remove file'
    },
    maxFilesExceeded: {
        code: '2-6-2002',
        text: 'You are not allowed to upload any more files'
    },
    buttonBrowse: {
        code: '1-6-2002',
        text: 'Select files to upload'
    },
    uploadHint: {
        code: '1-6-2002',
        text: 'Drag files and folders here'
    }
};
const $6a5d168af5ede3cd$var$globalCheckoutMessages = {
    missingTerms: {
        code: '3-6-6230',
        text: 'Please accept the General terms and conditions.'
    },
    loadingCheckoutTitle: {
        code: '1-6-6260',
        text: 'Almost done!'
    },
    loadingCheckoutText: {
        code: '1-6-6261',
        text: 'The order is carried out. This can take a moment!'
    }
};
const $6a5d168af5ede3cd$var$globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: {
        code: '3-6-6000',
        text: 'Something has gone wrong!'
    },
    htmlError401: {
        code: '3-6-6000',
        text: 'A valid authentication is required to process the request.'
    },
    htmlError403: {
        code: '3-6-6000',
        text: 'The request could not be processed due to missing authorization of the client.'
    },
    htmlError404: {
        code: '3-6-6000',
        text: 'The requested site does not exist.'
    },
    htmlError413: {
        code: '3-6-6000',
        text: 'The file is too large.'
    },
    htmlError415: {
        code: '3-6-6000',
        text: 'This media type is not supported.'
    },
    htmlError422: {
        code: '3-6-6000',
        text: 'Unable to display the requested site correctly.'
    },
    htmlError500: {
        code: '3-6-6000',
        text: 'Internal server error'
    },
    htmlError503: {
        code: '3-6-6000',
        text: 'The server is temporarily unavailable.'
    }
};
if (!window.opacc) window.opacc = {};
const $6a5d168af5ede3cd$export$7ea287b8bcd34b91 = Object.assign({}, $6a5d168af5ede3cd$var$globalFormErrorMessages, window.opacc.systemFormErrorMessages, window.projectFormErrorMessages, window.opacc.projectFormErrorMessages, window.opacc.tkFormErrorMessages);
const $6a5d168af5ede3cd$export$287bafa924522a4d = Object.assign({}, $6a5d168af5ede3cd$var$globalBasketMessages, window.opacc.systemBasketMessages, window.projectBasketMessages, window.opacc.projectBasketMessages, window.opacc.tkBasketMessages);
const $6a5d168af5ede3cd$export$ad480231e1cfb49 = Object.assign({}, $6a5d168af5ede3cd$var$globalCompareMessages, window.opacc.systemCompareMessages, window.projectCompareMessages, window.opacc.projectCompareMessages, window.opacc.tkCompareMessages);
const $6a5d168af5ede3cd$export$329e838a9ba51357 = Object.assign({}, $6a5d168af5ede3cd$var$globalFavoriteMessages, window.opacc.systemFavoriteMessages, window.projectFavoriteMessages, window.opacc.projectFavoriteMessages, window.opacc.tkFavoriteMessages);
const $6a5d168af5ede3cd$export$31629176936765c5 = Object.assign({}, $6a5d168af5ede3cd$var$globalArticleMessages, window.opacc.systemArticleMessages, window.projectArticleMessages, window.opacc.projectArticleMessages, window.opacc.tkArticleMessages);
const $6a5d168af5ede3cd$export$39227038979f1988 = Object.assign({}, $6a5d168af5ede3cd$var$globalGeneralMessages, window.opacc.systemGeneralMessages, window.projectGeneralMessages, window.opacc.projectGeneralMessages, window.opacc.tkGeneralMessages);
const $6a5d168af5ede3cd$export$f625b980042672da = Object.assign({}, $6a5d168af5ede3cd$var$globalDirectSearchSuggestMessages, window.opacc.systemDirectSearchSuggestMessages, window.projectDirectSearchSuggestMessages, window.opacc.projectDirectSearchSuggestMessages, window.opacc.tkDirectSearchSuggestMessages);
const $6a5d168af5ede3cd$export$fe24ead06f0313ff = Object.assign({}, $6a5d168af5ede3cd$var$globalFileuploadAreaMessages, window.opacc.systemFileuploadAreaMessages, window.projectFileuploadAreaMessages, window.opacc.projectFileuploadAreaMessages, window.opacc.tkFileuploadAreaMessages);
const $6a5d168af5ede3cd$export$fbedd73e1269236f = Object.assign({}, $6a5d168af5ede3cd$var$globalAutocompleteMessages, window.opacc.systemAutocompleteMessages, window.projectAutocompleteMessages, window.opacc.projectAutocompleteMessages, window.opacc.tkAutocompleteMessages);
const $6a5d168af5ede3cd$export$389a1ce21906c656 = Object.assign({}, $6a5d168af5ede3cd$var$globalPaymentMessages, window.opacc.systemPaymentMessages, window.projectPaymentMessages, window.opacc.projectPaymentMessages, window.opacc.tkPaymentMessages);
const $6a5d168af5ede3cd$export$36d5448025feaaa9 = Object.assign({}, $6a5d168af5ede3cd$var$globalDeliveryMessages, window.opacc.systemDeliveryMessages, window.projectDeliveryMessages, window.opacc.projectDeliveryMessages, window.opacc.tkDeliveryMessages);
const $6a5d168af5ede3cd$export$efd88ea7bc399322 = Object.assign({}, $6a5d168af5ede3cd$var$globalAccountMessages, window.opacc.systemAccountMessages, window.projectAccountMessages, window.opacc.tkAccountMessages);
const $6a5d168af5ede3cd$export$4705307fe5270e12 = Object.assign({}, $6a5d168af5ede3cd$var$globalCheckoutMessages, window.opacc.systemCheckoutMessages, window.projectCheckoutMessages, window.opacc.projectCheckoutMessages, window.opacc.tkCheckoutMessages);
const $6a5d168af5ede3cd$export$6e7e78d2cde281b0 = Object.assign({}, $6a5d168af5ede3cd$var$globalHtmlErrorCodeMessages, window.opacc.systemHtmlErrorCodeMessages, window.projectHtmlErrorCodeMessages, window.opacc.projectHtmlErrorCodeMessages, window.opacc.tkHtmlErrorCodeMessages);


class $9a3c23dc87c23435$export$b3c221c7106f5e79 {
    constructor(){
        this.msgType = {
            info: 'info',
            warn: 'warning',
            debug: 'debug',
            error: 'error',
            log: 'success'
        };
        this.mapMessages = Object.assign({}, (0, $6a5d168af5ede3cd$export$39227038979f1988), (0, $6a5d168af5ede3cd$export$efd88ea7bc399322), (0, $6a5d168af5ede3cd$export$389a1ce21906c656), (0, $6a5d168af5ede3cd$export$36d5448025feaaa9));
        this.moveMessages();
    }
    /**
	 *
	 *
	 * @param {*} type
	 * @returns {*}
	 */ setColoredOutput(type) {
        if (type === 'success') return [
            'background: green',
            'color: white',
            'display: block'
        ].join(';');
        else if (type === 'error') return [
            'background: red',
            'color: white',
            'display: block'
        ].join(';');
        else if (type === 'warning') return [
            'background: yellow',
            'color: black',
            'display: block'
        ].join(';');
        else if (type === 'debug') return [
            'background: blue',
            'color: white',
            'display: block'
        ].join(';');
        return true;
    }
    /**
	 *
	 *
	 * @param {*} [msg=null]
	 * @param {*} type
	 */ logToConsole(msg = null, type) {
        let consoleColor = null;
        switch(type){
            case this.msgType.info:
                consoleColor = [
                    'background: green',
                    'color: white',
                    'display: block'
                ].join(';');
                // eslint-disable-next-line no-console
                console.info(`%c ${msg}`, consoleColor);
                break;
            case this.msgType.warn:
                consoleColor = [
                    'background: yellow',
                    'color: black',
                    'display: block'
                ].join(';');
                // eslint-disable-next-line no-console
                console.warn(`%c ${msg}`, consoleColor);
                break;
            case this.msgType.error:
                consoleColor = [
                    'background: red',
                    'color: white',
                    'display: block'
                ].join(';');
                // eslint-disable-next-line no-console
                console.log(`%c ${msg}`, consoleColor, this.getSourceScriptNameFromCallStack());
                break;
            case this.msgType.debug:
                consoleColor = [
                    'background: blue',
                    'color: white',
                    'display: block'
                ].join(';');
                // eslint-disable-next-line no-console
                console.debug(`%c ${msg}`, consoleColor, this.getSourceScriptNameFromCallStack());
                break;
            default:
                // eslint-disable-next-line no-console
                console.log(msg);
        }
    }
    /**
	 *
	 *
	 * @param {*} msgObj
	 * @param {*} msgOverride
	 */ showMessage(msgObj, msgOverride) {
        if (msgObj) {
            let msgCode = msgObj.code;
            let msgText = msgObj.text;
            let msgDisplay = msgOverride ? msgOverride : msgText;
            let msgAddition = msgObj.addition;
            let options = {
                'wait': msgObj.wait,
                'link': msgObj.link,
                'title': msgObj.title
            };
            if (!msgCode) msgCode = this.mapMessages.messageDefault.code;
            if (msgCode && msgDisplay) {
                let msgType = msgCode.substr(0, 1);
                let msgConsole = `${msgCode}: ${msgText}`;
                if (msgAddition) msgConsole = `${msgConsole} (${msgAddition})`;
                switch(msgType){
                    case '1':
                        this.showInfo(msgDisplay, msgConsole, options);
                        break;
                    case '2':
                        this.showWarning(msgDisplay, msgConsole, options);
                        break;
                    case '3':
                        this.showError(msgDisplay, msgConsole, options);
                        break;
                    case '4':
                        this.showDebug(msgDisplay, msgConsole, options);
                        break;
                    default:
                        break;
                }
            }
        }
    }
    /**
	 *
	 *
	 * @param {*} messages
	 * @param {*} response
	 */ showMessages(messages, response) {
        Array.from(messages).forEach((message)=>{
            this.showMessage(message, this.mapMessageCodeToText(response, this.mapMessages));
        });
    }
    /**
	 *
	 *
	 * @param {*} frontMessage
	 * @param {*} [consoleMessage=null]
	 * @param {*} [options={}]
	 */ showInfo(frontMessage, consoleMessage = null, options = {
        wait: (0, $6a5d168af5ede3cd$export$39227038979f1988).messageDefaultInfo.wait
    }) {
        if (!consoleMessage) consoleMessage = frontMessage;
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).defaults.notifier.closeButton = true;
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).success(this.extendMessage(frontMessage, options), options.wait);
        this.logToConsole(consoleMessage, 'info');
    }
    /**
	 *
	 *
	 * @param {*} frontMessage
	 * @param {*} [consoleMessage=null]
	 * @param {*} [options={}]
	 */ showWarning(frontMessage, consoleMessage = null, options = {
        wait: (0, $6a5d168af5ede3cd$export$39227038979f1988).messageDefaultWarning.wait
    }) {
        if (!consoleMessage) consoleMessage = frontMessage;
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).defaults.notifier.closeButton = true;
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).warning(this.extendMessage(frontMessage, options), options.wait);
        this.logToConsole(consoleMessage, 'warning');
    }
    /**
	 *
	 *
	 * @param {*} frontMessage
	 * @param {*} [consoleMessage=null]
	 * @param {*} [options={}]
	 */ showError(frontMessage, consoleMessage = null, options = {
        wait: (0, $6a5d168af5ede3cd$export$39227038979f1988).messageDefaultError.wait
    }) {
        if (!consoleMessage) consoleMessage = frontMessage;
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).defaults.notifier.closeButton = true;
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).error(this.extendMessage(frontMessage, options), options.wait);
        this.logToConsole(consoleMessage, 'error');
    }
    /**
	 *
	 *
	 * @param {*} [frontMessage=null]
	 * @param {*} [consoleMessage=null]
	 * @param {*} [options={}]
	 * @returns {*}
	 */ showDebug(frontMessage = null, consoleMessage = null, options = {
        wait: (0, $6a5d168af5ede3cd$export$39227038979f1988).messageDefaultDebug.wait
    }) {
        if (!frontMessage && !consoleMessage) return;
        if (frontMessage) {
            if (!consoleMessage) consoleMessage = frontMessage;
            (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).defaults.notifier.closeButton = true;
            (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).message(this.extendMessage(frontMessage, options), options.wait);
        }
        this.logToConsole(consoleMessage, 'debug');
    }
    /**
	 *
	 *
	 * @param {string} content Anzuzeigender HTML-Inhalt im Modal als String
	 * @param {HTMLElement} [headSelector=undefined] HTML Selektor, welcher als Head angezeigt werden soll aus dem übergebenen content
	 * @param {boolean} [startInFullScreen=false] Modal maximiert zu Beginn anzeigen
	 * @param {object} [additionalSettings=undefined] Optionen Objekt für das Modal-Fenster
	 * @param {boolean} [additionalSettings.closable=true] Kann das Modal über den "Schliessen"-Button geschlossen werden? (bei "false" muss das Modal projektseitig geschlossen werden.)
	 * @param {boolean} [additionalSettings.closableByDimmer=true] Klick im Dimmbereich schliesst das Modal?
	 * @param {boolean} [additionalSettings.maximizable=false] Modal maximieren
	 * @param {boolean} [additionalSettings.modal=true] Modal mit Dimmer anzeigen (Interaktion mit Seite wird somit unterbunden)
	 * @param {boolean} [additionalSettings.movable=true] Modal bewegen
	 * @param {boolean} [additionalSettings.moveBounded=false] Verschiebbares Modal aus dem Bildschirm nur innerhalb der Seitenkoordinaten bewegen oder aus dem Bildschirm verschwinden lassen
	 * @param {boolean} [additionalSettings.overflow=true] Modal Inhalt bei unzureichendem Platz mit Scrollbalken darstellen
	 * @param {boolean} [additionalSettings.padding=true] Inhalt vom Modalrand einrücken
	 * @param {boolean} [additionalSettings.resizable=false] Modalgrösse verändern
	 * @param {boolean} [additionalSettings.startMaximized=false] Modal maximiert bei Öffnen darstellen
	 * @param {"slide"|"zoom"|"flipx"|"flipy"|"fade"|"pulse"} [additionalSettings.transition=pulse] - Animationseffekt des Modals
	 * @returns {*}
	 */ showModal(content, headSelector, startInFullScreen, additionalSettings) {
        let fullScreenOption = false;
        if (startInFullScreen === true) fullScreenOption = true;
        let defaultSettings = {
            'message': content,
            'head': headSelector,
            'maximizable': false,
            'startMaximized': fullScreenOption
        };
        let modalSettings = Object.assign({}, defaultSettings, additionalSettings);
        let isModalOpen = (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).modal().isOpen();
        if (!isModalOpen) (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).modal().destroy();
        let opaccModal = (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).modal().set(modalSettings).show();
        let returnObj = {
            content: opaccModal.elements.content,
            header: opaccModal.elements.header,
            footer: opaccModal.elements.footer
        };
        return returnObj;
    }
    /**
	 *
	 *
	 */ hideModal() {
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).modal().destroy();
    }
    /**
	 *
	 *
	 */ hideConfirm() {
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).confirm().destroy();
    }
    /**
	 *
	 *
	 * @param {*} content
	 * @param {*} trueLabel
	 * @param {*} falseLabel
	 * @param {*} trueFunction
	 * @param {*} falseFunction
	 * @param {*} [title=undefined]
	 * @param {*} [style=undefined]
	 * @returns {*}
	 */ showConfirm(content, trueLabel, falseLabel, trueFunction, falseFunction, title, style) {
        (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).confirm().destroy();
        let opaccConfirm = (0, $b8a3ca3805add3a4$export$dddc4bb1e90c7b26).confirm(content, trueFunction, falseFunction).set({
            'labels': {
                ok: trueLabel,
                cancel: falseLabel
            },
            'title': title,
            'style': style
        });
        let returnObj = {
            content: opaccConfirm.elements.content,
            header: opaccConfirm.elements.header,
            footer: opaccConfirm.elements.footer
        };
        return returnObj;
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ getSourceScriptNameFromCallStack() {
        const error = new Error();
        // Browserkompatibilität (prüfen ob stack unterstützt wird)
        if (error.stack != undefined) {
            const lines = error.stack.split('\n').slice(1);
            const lastStack = [
                ...lines
            ].pop();
            let lineMatch = lastStack.match(/at (?:(.+)\s+\()?(?:(.+?):(\d+)(?::(\d+))?|([^)]+))\)?/);
            if (!lineMatch) return;
            let object = null;
            let method = null;
            let functionName = null;
            let typeName = null;
            let methodName = null;
            let isNative = lineMatch[5] === 'native';
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] == '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.substr(0, methodStart);
                    method = functionName.substr(methodStart + 1);
                    let objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.substr(objectEnd + 1);
                        object = object.substr(0, objectEnd);
                    }
                }
                typeName = null;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = null;
                functionName = null;
            }
            let properties = {
                fileName: lineMatch[2] || null,
                lineNumber: parseInt(lineMatch[3], 10) || null,
                functionName: functionName,
                typeName: typeName,
                methodName: methodName,
                columnNumber: parseInt(lineMatch[4], 10) || null,
                native: isNative
            };
            return properties;
        } else if (error.fileName != undefined) return error.fileName;
        return false;
    }
    /**
	 *
	 *
	 * @param {*} [source=document]
	 * @param {*} [defaultMsg=undefined]
	 */ moveMessages(source = document, defaultMsg) {
        let showDefaultMsg = true;
        const portalMessageContainer = source.querySelector('[id^="wp_messages_container_"]');
        if (portalMessageContainer && portalMessageContainer.hasChildNodes()) {
            let infoMessage = portalMessageContainer.querySelectorAll('.Info');
            let errorMessage = portalMessageContainer.querySelectorAll('.Error');
            let warningMessage = portalMessageContainer.querySelectorAll('.Warning');
            let debugMessage = portalMessageContainer.querySelectorAll('.Debug');
            Array.from([
                ...infoMessage,
                ...errorMessage,
                ...warningMessage,
                ...debugMessage
            ], (item)=>{
                let messageType = item.className;
                let messageCode = item.querySelector('.was-message-code');
                let messageAddition = item.querySelector('.was-message-addition');
                let messageWait = item.querySelector('.was-message-wait');
                let frontMessage = item.cloneNode(true);
                let code = '?-?-????';
                let addition = '';
                let options = {
                    wait: ''
                };
                if (messageCode) {
                    frontMessage.querySelector('.was-message-code').remove();
                    code = messageCode.innerText;
                }
                if (messageAddition) {
                    frontMessage.querySelector('.was-message-addition').remove();
                    addition = ` addtion: ${messageAddition.innerText}`;
                }
                if (messageWait) {
                    frontMessage.querySelector('.was-message-wait').remove();
                    options.wait = messageWait.innerText;
                }
                let consoleMessage = `${code}: ${frontMessage.innerText} (wait: ${options.wait} sec.${addition})`;
                switch(messageType){
                    case 'Error':
                        this.showError(frontMessage.innerText, consoleMessage, options);
                        showDefaultMsg = false;
                        break;
                    case 'Info':
                        this.showInfo(frontMessage.innerText, consoleMessage, options);
                        showDefaultMsg = false;
                        break;
                    case 'Warning':
                        this.showWarning(frontMessage.innerText, consoleMessage, options);
                        showDefaultMsg = false;
                        break;
                    case 'Debug':
                        this.showDebug(frontMessage.innerText, consoleMessage, options);
                        showDefaultMsg = false;
                        break;
                    default:
                        break;
                }
            });
            portalMessageContainer.remove();
        }
        if (typeof defaultMsg === 'string' && showDefaultMsg) this.showMessage(this.mapMessages.messageDefault, defaultMsg);
        else if (typeof defaultMsg === 'object' && showDefaultMsg) {
            let consoleOutput = defaultMsg.consoleOnlyOutput;
            if (consoleOutput && consoleOutput.length > 0) this.showDebug('', consoleOutput);
        }
    }
    /**
	 *
	 *
	 * @param {*} response
	 * @param {*} mappedMessages
	 * @returns {*}
	 */ mapMessageCodeToText(response, mappedMessages) {
        let textMessage = null;
        if (response.pluginId) {
            if (response.pluginId === 'paymentType') switch(+response.paymentType){
                case 1:
                    textMessage = mappedMessages.messagePaymentTypeCreditCard.text;
                    break;
                case 2:
                    textMessage = mappedMessages.messagePaymentTypeInvoice.text;
                    break;
                case 5:
                    textMessage = mappedMessages.messagePaymentTypeInAdvance.text;
                    break;
                case 6:
                    textMessage = mappedMessages.messagePaymentTypeOnDelivery.text;
                    break;
                default:
                    textMessage = mappedMessages.messagePaymentTypeGeneral.text;
                    break;
            }
            else if (response.pluginId === 'deliveryType') textMessage = mappedMessages.messageDeliveryTypeGeneral.text;
            else if (response.pluginId === 'checkoutAdressChange') textMessage = mappedMessages.messageChangeSuccess.text;
            else if (response.pluginId.length > 0) textMessage = {
                consoleOnlyOutput: mappedMessages.messageEmptyText.text
            };
        }
        return textMessage;
    }
    /**
	 *
	 *
	 * @param {*} message
	 * @param {*} option
	 * @returns {*}
	 */ extendMessage(message, option) {
        if (option.link) message = `<a class="notifications-link" href="${option.link}" title="${option.title}">${message}</a>`;
        return message;
    }
}



class $e36614d26c6ab87f$export$5e9b9dfacd86d260 {
    /**
	 *
	 *
	 * @returns {*}
	 */ getCurrentURI() {
        return `${window.location.pathname}${window.location.search}`;
    }
    /**
	 *
	 *
	 * @param {*} url
	 * @param {boolean} [replaceSelectors=true]
	 * @returns {*}
	 */ getPersistentView(url, replaceSelectors = true) {
        let data = JSON.parse(this.getSessionStorage(url));
        if (replaceSelectors) for(let selector in data)document.querySelector(selector).outerHTML = (0, $aaf3d0fad38bd1f9$export$f6b455058877db44).sanitizeContent(data[selector]);
        return data;
    }
    /**
	 *
	 *
	 * @param {*} url
	 * @param {*} selectors
	 * @returns {*}
	 */ setPersistentView(url, ...selectors) {
        let data = {};
        selectors.forEach((selector)=>{
            data[selector] = document.querySelector(selector).outerHTML;
        });
        return this.setSessionStorage(url, JSON.stringify(data));
    }
    /**
	 *
	 *
	 * @param {*} url
	 * @returns {*}
	 */ removeAllPersistentViews(url) {
        Object.keys(window.sessionStorage).forEach((item)=>{
            if (item !== url && item.indexOf('take=async') != -1) this.removeSessionStorage(item);
        });
        return;
    }
    /**
	 *
	 *
	 * @param {*} url
	 * @returns {*}
	 */ removePersistentView(url) {
        return this.removeSessionStorage(url);
    }
    /**
	 *
	 *
	 * @param {*} key
	 * @returns {*}
	 */ removeSessionStorage(key) {
        window.sessionStorage.removeItem(key);
        return true;
    }
    /**
	 *
	 *
	 * @param {*} key
	 * @param {*} data
	 * @returns {*}
	 */ setSessionStorage(key, data) {
        window.sessionStorage.setItem(key, data);
        return true;
    }
    /**
	 *
	 *
	 * @param {*} key
	 * @returns {*}
	 */ getSessionStorage(key) {
        return window.sessionStorage.getItem(key);
    }
}



let $5f3fb7942e9a9720$var$e, $5f3fb7942e9a9720$var$t;
const $5f3fb7942e9a9720$var$n = new WeakMap, $5f3fb7942e9a9720$var$r = new WeakMap, $5f3fb7942e9a9720$var$o = new WeakMap, $5f3fb7942e9a9720$var$s = new WeakMap, $5f3fb7942e9a9720$var$a = new WeakMap;
let $5f3fb7942e9a9720$var$i = {
    get (e, t, n) {
        if (e instanceof IDBTransaction) {
            if ("done" === t) return $5f3fb7942e9a9720$var$r.get(e);
            if ("objectStoreNames" === t) return e.objectStoreNames || $5f3fb7942e9a9720$var$o.get(e);
            if ("store" === t) return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
        }
        return $5f3fb7942e9a9720$export$4997ffc0176396a6(e[t]);
    },
    set: (e, t, n)=>(e[t] = n, !0),
    has: (e, t)=>e instanceof IDBTransaction && ("done" === t || "store" === t) || t in e
};
function $5f3fb7942e9a9720$var$c(e) {
    return e !== IDBDatabase.prototype.transaction || "objectStoreNames" in IDBTransaction.prototype ? ($5f3fb7942e9a9720$var$t || ($5f3fb7942e9a9720$var$t = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ])).includes(e) ? function(...t) {
        return e.apply($5f3fb7942e9a9720$export$debb760848ca95a(this), t), $5f3fb7942e9a9720$export$4997ffc0176396a6($5f3fb7942e9a9720$var$n.get(this));
    } : function(...t) {
        return $5f3fb7942e9a9720$export$4997ffc0176396a6(e.apply($5f3fb7942e9a9720$export$debb760848ca95a(this), t));
    } : function(t, ...n) {
        const r = e.call($5f3fb7942e9a9720$export$debb760848ca95a(this), t, ...n);
        return $5f3fb7942e9a9720$var$o.set(r, t.sort ? t.sort() : [
            t
        ]), $5f3fb7942e9a9720$export$4997ffc0176396a6(r);
    };
}
function $5f3fb7942e9a9720$var$u(t) {
    var n;
    return "function" == typeof t ? $5f3fb7942e9a9720$var$c(t) : (t instanceof IDBTransaction && function(e) {
        if ($5f3fb7942e9a9720$var$r.has(e)) return;
        const t = new Promise((t, n)=>{
            const r = ()=>{
                e.removeEventListener("complete", o), e.removeEventListener("error", s), e.removeEventListener("abort", s);
            }, o = ()=>{
                t(), r();
            }, s = ()=>{
                n(e.error || new DOMException("AbortError", "AbortError")), r();
            };
            e.addEventListener("complete", o), e.addEventListener("error", s), e.addEventListener("abort", s);
        });
        $5f3fb7942e9a9720$var$r.set(e, t);
    }(t), n = t, ($5f3fb7942e9a9720$var$e || ($5f3fb7942e9a9720$var$e = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ])).some((e)=>n instanceof e) ? new Proxy(t, $5f3fb7942e9a9720$var$i) : t);
}
function $5f3fb7942e9a9720$export$4997ffc0176396a6(e) {
    if (e instanceof IDBRequest) return function(e) {
        const t = new Promise((t, n)=>{
            const r = ()=>{
                e.removeEventListener("success", o), e.removeEventListener("error", s);
            }, o = ()=>{
                t($5f3fb7942e9a9720$export$4997ffc0176396a6(e.result)), r();
            }, s = ()=>{
                n(e.error), r();
            };
            e.addEventListener("success", o), e.addEventListener("error", s);
        });
        return t.then((t)=>{
            t instanceof IDBCursor && $5f3fb7942e9a9720$var$n.set(t, e);
        }).catch(()=>{}), $5f3fb7942e9a9720$var$a.set(t, e), t;
    }(e);
    if ($5f3fb7942e9a9720$var$s.has(e)) return $5f3fb7942e9a9720$var$s.get(e);
    const t = $5f3fb7942e9a9720$var$u(e);
    return t !== e && ($5f3fb7942e9a9720$var$s.set(e, t), $5f3fb7942e9a9720$var$a.set(t, e)), t;
}
const $5f3fb7942e9a9720$export$debb760848ca95a = (e)=>$5f3fb7942e9a9720$var$a.get(e);
function $5f3fb7942e9a9720$export$ca0ed41b1a2af7e(e, t, { blocked: n, upgrade: r, blocking: o, terminated: s } = {}) {
    const a = indexedDB.open(e, t), i = $5f3fb7942e9a9720$export$4997ffc0176396a6(a);
    return r && a.addEventListener("upgradeneeded", (e)=>{
        r($5f3fb7942e9a9720$export$4997ffc0176396a6(a.result), e.oldVersion, e.newVersion, $5f3fb7942e9a9720$export$4997ffc0176396a6(a.transaction));
    }), n && a.addEventListener("blocked", ()=>n()), i.then((e)=>{
        s && e.addEventListener("close", ()=>s()), o && e.addEventListener("versionchange", ()=>o());
    }).catch(()=>{}), i;
}
function $5f3fb7942e9a9720$export$9d6df0ac66a98bb2(e, { blocked: t } = {}) {
    const n = indexedDB.deleteDatabase(e);
    return t && n.addEventListener("blocked", ()=>t()), $5f3fb7942e9a9720$export$4997ffc0176396a6(n).then(()=>{});
}
const $5f3fb7942e9a9720$var$D = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
], $5f3fb7942e9a9720$var$v = [
    "put",
    "add",
    "delete",
    "clear"
], $5f3fb7942e9a9720$var$b = new Map;
function $5f3fb7942e9a9720$var$I(e, t) {
    if (!(e instanceof IDBDatabase) || t in e || "string" != typeof t) return;
    if ($5f3fb7942e9a9720$var$b.get(t)) return $5f3fb7942e9a9720$var$b.get(t);
    const n = t.replace(/FromIndex$/, ""), r = t !== n, o = $5f3fb7942e9a9720$var$v.includes(n);
    if (!(n in (r ? IDBIndex : IDBObjectStore).prototype) || !o && !$5f3fb7942e9a9720$var$D.includes(n)) return;
    const s = async function(e, ...t) {
        const s = this.transaction(e, o ? "readwrite" : "readonly");
        let a = s.store;
        return r && (a = a.index(t.shift())), (await Promise.all([
            a[n](...t),
            o && s.done
        ]))[0];
    };
    return $5f3fb7942e9a9720$var$b.set(t, s), s;
}
$5f3fb7942e9a9720$var$i = ((e)=>({
        ...e,
        get: (t, n, r)=>$5f3fb7942e9a9720$var$I(t, n) || e.get(t, n, r),
        has: (t, n)=>!!$5f3fb7942e9a9720$var$I(t, n) || e.has(t, n)
    }))($5f3fb7942e9a9720$var$i);
var $5f3fb7942e9a9720$export$2e2bcd8739ae039 = null;


class $aea624f63deaf910$export$2683fc345df9a89e {
    constructor(){
        this.dbPromise = null;
        // !!! WICHTIG: Versionsnummer bei Änderungen erhöhen !!!
        this.versionNumber = 2;
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ getCurrentURI() {
        return `${window.location.pathname}${window.location.search}`;
    }
    init(storeName) {
        this.dbPromise = (0, $5f3fb7942e9a9720$export$ca0ed41b1a2af7e)('opaccStore', this.versionNumber, {
            upgrade (db) {
                if (db.objectStoreNames.length > 0) [
                    db.objectStoreNames
                ].forEach((store)=>{
                    db.deleteObjectStore(store[0]);
                });
                db.createObjectStore(storeName);
            }
        });
    }
    async get(storeName, key, replaceSelectors = true) {
        let data = await (await this.dbPromise).get(storeName, key);
        data = data ? JSON.parse(data) : data;
        if (replaceSelectors) for(let selector in data)document.querySelector(selector).outerHTML = (0, $aaf3d0fad38bd1f9$export$f6b455058877db44).sanitizeContent(data[selector]);
        return;
    }
    async set(storeName, key, ...selectors) {
        let data = {};
        selectors.forEach((selector)=>{
            data[selector] = document.querySelector(selector).outerHTML;
        });
        let val = JSON.stringify(data);
        return (await this.dbPromise).put(storeName, val, key);
    }
    async del(storeName, key) {
        return (await this.dbPromise).delete(storeName, key);
    }
    async clear(storeName) {
        return (await this.dbPromise).clear(storeName);
    }
    async keys(storeName) {
        return (await this.dbPromise).getAllKeys(storeName);
    }
}


/*! @license DOMPurify 3.1.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.5/LICENSE */ const { entries: $e8cccf5e02dec050$var$entries, setPrototypeOf: $e8cccf5e02dec050$var$setPrototypeOf, isFrozen: $e8cccf5e02dec050$var$isFrozen, getPrototypeOf: $e8cccf5e02dec050$var$getPrototypeOf, getOwnPropertyDescriptor: $e8cccf5e02dec050$var$getOwnPropertyDescriptor } = Object;
let { freeze: $e8cccf5e02dec050$var$freeze, seal: $e8cccf5e02dec050$var$seal, create: $e8cccf5e02dec050$var$create } = Object; // eslint-disable-line import/no-mutable-exports
let { apply: $e8cccf5e02dec050$var$apply, construct: $e8cccf5e02dec050$var$construct } = typeof Reflect !== 'undefined' && Reflect;
if (!$e8cccf5e02dec050$var$freeze) $e8cccf5e02dec050$var$freeze = function freeze(x) {
    return x;
};
if (!$e8cccf5e02dec050$var$seal) $e8cccf5e02dec050$var$seal = function seal(x) {
    return x;
};
if (!$e8cccf5e02dec050$var$apply) $e8cccf5e02dec050$var$apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
};
if (!$e8cccf5e02dec050$var$construct) $e8cccf5e02dec050$var$construct = function construct(Func, args) {
    return new Func(...args);
};
const $e8cccf5e02dec050$var$arrayForEach = $e8cccf5e02dec050$var$unapply(Array.prototype.forEach);
const $e8cccf5e02dec050$var$arrayPop = $e8cccf5e02dec050$var$unapply(Array.prototype.pop);
const $e8cccf5e02dec050$var$arrayPush = $e8cccf5e02dec050$var$unapply(Array.prototype.push);
const $e8cccf5e02dec050$var$stringToLowerCase = $e8cccf5e02dec050$var$unapply(String.prototype.toLowerCase);
const $e8cccf5e02dec050$var$stringToString = $e8cccf5e02dec050$var$unapply(String.prototype.toString);
const $e8cccf5e02dec050$var$stringMatch = $e8cccf5e02dec050$var$unapply(String.prototype.match);
const $e8cccf5e02dec050$var$stringReplace = $e8cccf5e02dec050$var$unapply(String.prototype.replace);
const $e8cccf5e02dec050$var$stringIndexOf = $e8cccf5e02dec050$var$unapply(String.prototype.indexOf);
const $e8cccf5e02dec050$var$stringTrim = $e8cccf5e02dec050$var$unapply(String.prototype.trim);
const $e8cccf5e02dec050$var$objectHasOwnProperty = $e8cccf5e02dec050$var$unapply(Object.prototype.hasOwnProperty);
const $e8cccf5e02dec050$var$regExpTest = $e8cccf5e02dec050$var$unapply(RegExp.prototype.test);
const $e8cccf5e02dec050$var$typeErrorCreate = $e8cccf5e02dec050$var$unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param {Function} func - The function to be wrapped and called.
 * @returns {Function} A new function that calls the given function with a specified thisArg and arguments.
 */ function $e8cccf5e02dec050$var$unapply(func) {
    return function(thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return $e8cccf5e02dec050$var$apply(func, thisArg, args);
    };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param {Function} func - The constructor function to be wrapped and called.
 * @returns {Function} A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function $e8cccf5e02dec050$var$unconstruct(func) {
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e8cccf5e02dec050$var$construct(func, args);
    };
}
/**
 * Add properties to a lookup table
 *
 * @param {Object} set - The set to which elements will be added.
 * @param {Array} array - The array containing elements to be added to the set.
 * @param {Function} transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns {Object} The modified set with added elements.
 */ function $e8cccf5e02dec050$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e8cccf5e02dec050$var$stringToLowerCase;
    if ($e8cccf5e02dec050$var$setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    $e8cccf5e02dec050$var$setPrototypeOf(set, null);
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!$e8cccf5e02dec050$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param {Array} array - The array to be cleaned.
 * @returns {Array} The cleaned version of the array
 */ function $e8cccf5e02dec050$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++){
        const isPropertyExist = $e8cccf5e02dec050$var$objectHasOwnProperty(array, index);
        if (!isPropertyExist) array[index] = null;
    }
    return array;
}
/**
 * Shallow clone an object
 *
 * @param {Object} object - The object to be cloned.
 * @returns {Object} A new object that copies the original.
 */ function $e8cccf5e02dec050$var$clone(object) {
    const newObject = $e8cccf5e02dec050$var$create(null);
    for (const [property, value] of $e8cccf5e02dec050$var$entries(object)){
        const isPropertyExist = $e8cccf5e02dec050$var$objectHasOwnProperty(object, property);
        if (isPropertyExist) {
            if (Array.isArray(value)) newObject[property] = $e8cccf5e02dec050$var$cleanArray(value);
            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = $e8cccf5e02dec050$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param {Object} object - The object to look up the getter function in its prototype chain.
 * @param {String} prop - The property name for which to find the getter function.
 * @returns {Function} The getter function found in the prototype chain or a fallback function.
 */ function $e8cccf5e02dec050$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $e8cccf5e02dec050$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $e8cccf5e02dec050$var$unapply(desc.get);
            if (typeof desc.value === 'function') return $e8cccf5e02dec050$var$unapply(desc.value);
        }
        object = $e8cccf5e02dec050$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
const $e8cccf5e02dec050$var$html$1 = $e8cccf5e02dec050$var$freeze([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'section',
    'select',
    'shadow',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr'
]);
// SVG
const $e8cccf5e02dec050$var$svg$1 = $e8cccf5e02dec050$var$freeze([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern'
]);
const $e8cccf5e02dec050$var$svgFilters = $e8cccf5e02dec050$var$freeze([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence'
]);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const $e8cccf5e02dec050$var$svgDisallowed = $e8cccf5e02dec050$var$freeze([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use'
]);
const $e8cccf5e02dec050$var$mathMl$1 = $e8cccf5e02dec050$var$freeze([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts'
]);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const $e8cccf5e02dec050$var$mathMlDisallowed = $e8cccf5e02dec050$var$freeze([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none'
]);
const $e8cccf5e02dec050$var$text = $e8cccf5e02dec050$var$freeze([
    '#text'
]);
const $e8cccf5e02dec050$var$html = $e8cccf5e02dec050$var$freeze([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns',
    'slot'
]);
const $e8cccf5e02dec050$var$svg = $e8cccf5e02dec050$var$freeze([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan'
]);
const $e8cccf5e02dec050$var$mathMl = $e8cccf5e02dec050$var$freeze([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnsalign',
    'columnlines',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lspace',
    'lquote',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns'
]);
const $e8cccf5e02dec050$var$xml = $e8cccf5e02dec050$var$freeze([
    'xlink:href',
    'xml:id',
    'xlink:title',
    'xml:space',
    'xmlns:xlink'
]);
// eslint-disable-next-line unicorn/better-regex
const $e8cccf5e02dec050$var$MUSTACHE_EXPR = $e8cccf5e02dec050$var$seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const $e8cccf5e02dec050$var$ERB_EXPR = $e8cccf5e02dec050$var$seal(/<%[\w\W]*|[\w\W]*%>/gm);
const $e8cccf5e02dec050$var$TMPLIT_EXPR = $e8cccf5e02dec050$var$seal(/\${[\w\W]*}/gm);
const $e8cccf5e02dec050$var$DATA_ATTR = $e8cccf5e02dec050$var$seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
const $e8cccf5e02dec050$var$ARIA_ATTR = $e8cccf5e02dec050$var$seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const $e8cccf5e02dec050$var$IS_ALLOWED_URI = $e8cccf5e02dec050$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const $e8cccf5e02dec050$var$IS_SCRIPT_OR_DATA = $e8cccf5e02dec050$var$seal(/^(?:\w+script|data):/i);
const $e8cccf5e02dec050$var$ATTR_WHITESPACE = $e8cccf5e02dec050$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const $e8cccf5e02dec050$var$DOCTYPE_NAME = $e8cccf5e02dec050$var$seal(/^html$/i);
const $e8cccf5e02dec050$var$CUSTOM_ELEMENT = $e8cccf5e02dec050$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var $e8cccf5e02dec050$var$EXPRESSIONS = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MUSTACHE_EXPR: $e8cccf5e02dec050$var$MUSTACHE_EXPR,
    ERB_EXPR: $e8cccf5e02dec050$var$ERB_EXPR,
    TMPLIT_EXPR: $e8cccf5e02dec050$var$TMPLIT_EXPR,
    DATA_ATTR: $e8cccf5e02dec050$var$DATA_ATTR,
    ARIA_ATTR: $e8cccf5e02dec050$var$ARIA_ATTR,
    IS_ALLOWED_URI: $e8cccf5e02dec050$var$IS_ALLOWED_URI,
    IS_SCRIPT_OR_DATA: $e8cccf5e02dec050$var$IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE: $e8cccf5e02dec050$var$ATTR_WHITESPACE,
    DOCTYPE_NAME: $e8cccf5e02dec050$var$DOCTYPE_NAME,
    CUSTOM_ELEMENT: $e8cccf5e02dec050$var$CUSTOM_ELEMENT
});
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const $e8cccf5e02dec050$var$NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    progressingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12 // Deprecated
};
const $e8cccf5e02dec050$var$getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param {TrustedTypePolicyFactory} trustedTypes The policy factory.
 * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return {TrustedTypePolicy} The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const $e8cccf5e02dec050$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
    }
};
function $e8cccf5e02dec050$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e8cccf5e02dec050$var$getGlobal();
    const DOMPurify = (root)=>$e8cccf5e02dec050$var$createDOMPurify(root);
    /**
   * Version label, exposed for easier checks
   * if DOMPurify is up to date or not
   */ DOMPurify.version = '3.1.5';
    /**
   * Array of elements that DOMPurify removed during sanitation.
   * Empty if nothing was removed.
   */ DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $e8cccf5e02dec050$var$NODE_TYPE.document) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let { document: document } = window1;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
    const ElementPrototype = Element.prototype;
    const cloneNode = $e8cccf5e02dec050$var$lookupGetter(ElementPrototype, 'cloneNode');
    const getNextSibling = $e8cccf5e02dec050$var$lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = $e8cccf5e02dec050$var$lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = $e8cccf5e02dec050$var$lookupGetter(ElementPrototype, 'parentNode');
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
    const { importNode: importNode } = originalDocument;
    let hooks = {};
    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof $e8cccf5e02dec050$var$entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = $e8cccf5e02dec050$var$EXPRESSIONS;
    let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = $e8cccf5e02dec050$var$EXPRESSIONS;
    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $e8cccf5e02dec050$var$addToSet({}, [
        ...$e8cccf5e02dec050$var$html$1,
        ...$e8cccf5e02dec050$var$svg$1,
        ...$e8cccf5e02dec050$var$svgFilters,
        ...$e8cccf5e02dec050$var$mathMl$1,
        ...$e8cccf5e02dec050$var$text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $e8cccf5e02dec050$var$addToSet({}, [
        ...$e8cccf5e02dec050$var$html,
        ...$e8cccf5e02dec050$var$svg,
        ...$e8cccf5e02dec050$var$mathMl,
        ...$e8cccf5e02dec050$var$xml
    ]);
    /*
   * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal($e8cccf5e02dec050$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $e8cccf5e02dec050$var$addToSet({}, [
        'annotation-xml',
        'audio',
        'colgroup',
        'desc',
        'foreignobject',
        'head',
        'iframe',
        'math',
        'mi',
        'mn',
        'mo',
        'ms',
        'mtext',
        'noembed',
        'noframes',
        'noscript',
        'plaintext',
        'script',
        'style',
        'svg',
        'template',
        'thead',
        'title',
        'video',
        'xmp'
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $e8cccf5e02dec050$var$addToSet({}, [
        'audio',
        'video',
        'img',
        'source',
        'image',
        'track'
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $e8cccf5e02dec050$var$addToSet({}, [
        'alt',
        'class',
        'for',
        'id',
        'label',
        'name',
        'pattern',
        'placeholder',
        'role',
        'summary',
        'title',
        'value',
        'style',
        'xmlns'
    ]);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $e8cccf5e02dec050$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $e8cccf5e02dec050$var$stringToString);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        'application/xhtml+xml',
        'text/html'
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
   * _parseConfig
   *
   * @param  {Object} cfg optional config literal
   */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = $e8cccf5e02dec050$var$clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? $e8cccf5e02dec050$var$stringToString : $e8cccf5e02dec050$var$stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? $e8cccf5e02dec050$var$addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? $e8cccf5e02dec050$var$addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? $e8cccf5e02dec050$var$addToSet({}, cfg.ALLOWED_NAMESPACES, $e8cccf5e02dec050$var$stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? $e8cccf5e02dec050$var$addToSet($e8cccf5e02dec050$var$clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
        cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
        transformCaseFunc // eslint-disable-line indent
        ) // eslint-disable-line indent
         : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? $e8cccf5e02dec050$var$addToSet($e8cccf5e02dec050$var$clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
        cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
        transformCaseFunc // eslint-disable-line indent
        ) // eslint-disable-line indent
         : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? $e8cccf5e02dec050$var$addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'FORBID_TAGS') ? $e8cccf5e02dec050$var$addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
        FORBID_ATTR = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'FORBID_ATTR') ? $e8cccf5e02dec050$var$addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
        USE_PROFILES = $e8cccf5e02dec050$var$objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || $e8cccf5e02dec050$var$IS_ALLOWED_URI;
        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = $e8cccf5e02dec050$var$addToSet({}, $e8cccf5e02dec050$var$text);
            ALLOWED_ATTR = [];
            if (USE_PROFILES.html === true) {
                $e8cccf5e02dec050$var$addToSet(ALLOWED_TAGS, $e8cccf5e02dec050$var$html$1);
                $e8cccf5e02dec050$var$addToSet(ALLOWED_ATTR, $e8cccf5e02dec050$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $e8cccf5e02dec050$var$addToSet(ALLOWED_TAGS, $e8cccf5e02dec050$var$svg$1);
                $e8cccf5e02dec050$var$addToSet(ALLOWED_ATTR, $e8cccf5e02dec050$var$svg);
                $e8cccf5e02dec050$var$addToSet(ALLOWED_ATTR, $e8cccf5e02dec050$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $e8cccf5e02dec050$var$addToSet(ALLOWED_TAGS, $e8cccf5e02dec050$var$svgFilters);
                $e8cccf5e02dec050$var$addToSet(ALLOWED_ATTR, $e8cccf5e02dec050$var$svg);
                $e8cccf5e02dec050$var$addToSet(ALLOWED_ATTR, $e8cccf5e02dec050$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $e8cccf5e02dec050$var$addToSet(ALLOWED_TAGS, $e8cccf5e02dec050$var$mathMl$1);
                $e8cccf5e02dec050$var$addToSet(ALLOWED_ATTR, $e8cccf5e02dec050$var$mathMl);
                $e8cccf5e02dec050$var$addToSet(ALLOWED_ATTR, $e8cccf5e02dec050$var$xml);
            }
        }
        /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $e8cccf5e02dec050$var$clone(ALLOWED_TAGS);
            $e8cccf5e02dec050$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
        }
        if (cfg.ADD_ATTR) {
            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $e8cccf5e02dec050$var$clone(ALLOWED_ATTR);
            $e8cccf5e02dec050$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
        }
        if (cfg.ADD_URI_SAFE_ATTR) $e8cccf5e02dec050$var$addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        if (cfg.FORBID_CONTENTS) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $e8cccf5e02dec050$var$clone(FORBID_CONTENTS);
            $e8cccf5e02dec050$var$addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) $e8cccf5e02dec050$var$addToSet(ALLOWED_TAGS, [
            'html',
            'head',
            'body'
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            $e8cccf5e02dec050$var$addToSet(ALLOWED_TAGS, [
                'tbody'
            ]);
            delete FORBID_TAGS.tbody;
        }
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw $e8cccf5e02dec050$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw $e8cccf5e02dec050$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            // Overwrite existing TrustedTypes policy.
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            // Sign local variables required by `sanitize`.
            emptyHTML = trustedTypesPolicy.createHTML('');
        } else {
            // Uninitialized policy, attempt to initialize the internal dompurify policy.
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = $e8cccf5e02dec050$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            // If creating the internal policy succeeded sign internal variables.
            if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
        }
        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if ($e8cccf5e02dec050$var$freeze) $e8cccf5e02dec050$var$freeze(cfg);
        CONFIG = cfg;
    };
    const MATHML_TEXT_INTEGRATION_POINTS = $e8cccf5e02dec050$var$addToSet({}, [
        'mi',
        'mo',
        'mn',
        'ms',
        'mtext'
    ]);
    const HTML_INTEGRATION_POINTS = $e8cccf5e02dec050$var$addToSet({}, [
        'foreignobject',
        'annotation-xml'
    ]);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = $e8cccf5e02dec050$var$addToSet({}, [
        'title',
        'style',
        'font',
        'a',
        'script'
    ]);
    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = $e8cccf5e02dec050$var$addToSet({}, [
        ...$e8cccf5e02dec050$var$svg$1,
        ...$e8cccf5e02dec050$var$svgFilters,
        ...$e8cccf5e02dec050$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $e8cccf5e02dec050$var$addToSet({}, [
        ...$e8cccf5e02dec050$var$mathMl$1,
        ...$e8cccf5e02dec050$var$mathMlDisallowed
    ]);
    /**
   * @param  {Element} element a DOM element whose namespace is being checked
   * @returns {boolean} Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element);
        // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
        };
        const tagName = $e8cccf5e02dec050$var$stringToLowerCase(element.tagName);
        const parentTagName = $e8cccf5e02dec050$var$stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) {
            // The only way to switch from HTML namespace to SVG
            // is via <svg>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
            // The only way to switch from MathML to SVG is via`
            // svg if parent is either <annotation-xml> or MathML
            // text integration points.
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            // We only allow elements that are defined in SVG
            // spec. All others are disallowed in SVG namespace.
            return Boolean(ALL_SVG_TAGS[tagName]);
        }
        if (element.namespaceURI === MATHML_NAMESPACE) {
            // The only way to switch from HTML namespace to MathML
            // is via <math>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
            // The only way to switch from SVG to MathML is via
            // <math> and HTML integration points
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
            // We only allow elements that are defined in MathML
            // spec. All others are disallowed in MathML namespace.
            return Boolean(ALL_MATHML_TAGS[tagName]);
        }
        if (element.namespaceURI === HTML_NAMESPACE) {
            // The only way to switch from SVG to HTML is via
            // HTML integration points, and from MathML to HTML
            // is via MathML text integration points
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            // We disallow tags that are specific for MathML
            // or SVG and should never appear in HTML namespace
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        }
        // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
        // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
   * _forceRemove
   *
   * @param  {Node} node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
        $e8cccf5e02dec050$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            node.parentNode.removeChild(node);
        } catch (_) {
            node.remove();
        }
    };
    /**
   * _removeAttribute
   *
   * @param  {String} name an Attribute name
   * @param  {Node} node a DOM node
   */ const _removeAttribute = function _removeAttribute(name, node) {
        try {
            $e8cccf5e02dec050$var$arrayPush(DOMPurify.removed, {
                attribute: node.getAttributeNode(name),
                from: node
            });
        } catch (_) {
            $e8cccf5e02dec050$var$arrayPush(DOMPurify.removed, {
                attribute: null,
                from: node
            });
        }
        node.removeAttribute(name);
        // We void attribute values for unremovable "is"" attributes
        if (name === 'is' && !ALLOWED_ATTR[name]) {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(node);
            } catch (_) {}
            else try {
                node.setAttribute(name, '');
            } catch (_) {}
        }
    };
    /**
   * _initDocument
   *
   * @param  {String} dirty a string of dirty markup
   * @return {Document} a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = $e8cccf5e02dec050$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {
            // Syntax error if dirtyPayload is invalid xml
            }
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param  {Node} root The root element or node to start traversing on.
   * @return {NodeIterator} The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
   * _isClobbered
   *
   * @param  {Node} elm element to check for clobbering attacks
   * @return {Boolean} true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(elm) {
        return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
   * Checks whether the given object is a DOM node.
   *
   * @param  {Node} object object to check whether it's a DOM node
   * @return {Boolean} true is object is a DOM node
   */ const _isNode = function _isNode(object) {
        return typeof Node === 'function' && object instanceof Node;
    };
    /**
   * _executeHook
   * Execute user configurable hooks
   *
   * @param  {String} entryPoint  Name of the hook's entry point
   * @param  {Node} currentNode node to work on with the hook
   * @param  {Object} data additional hook parameters
   */ const _executeHook = function _executeHook(entryPoint, currentNode, data) {
        if (!hooks[entryPoint]) return;
        $e8cccf5e02dec050$var$arrayForEach(hooks[entryPoint], (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    };
    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   *
   * @param   {Node} currentNode to check for permission to exist
   * @return  {Boolean} true if node was killed, false if left alive
   */ const _sanitizeElements = function _sanitizeElements(currentNode) {
        let content = null;
        /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
        /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $e8cccf5e02dec050$var$regExpTest(/<[/\w]/g, currentNode.innerHTML) && $e8cccf5e02dec050$var$regExpTest(/<[/\w]/g, currentNode.textContent)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === $e8cccf5e02dec050$var$NODE_TYPE.progressingInstruction) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === $e8cccf5e02dec050$var$NODE_TYPE.comment && $e8cccf5e02dec050$var$regExpTest(/<[/\w]/g, currentNode.data)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $e8cccf5e02dec050$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
            }
            /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    for(let i = childCount - 1; i >= 0; --i){
                        const childClone = cloneNode(childNodes[i], true);
                        childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                        parentNode.insertBefore(childClone, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        }
        /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && $e8cccf5e02dec050$var$regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $e8cccf5e02dec050$var$NODE_TYPE.text) {
            /* Get the element's text content */ content = currentNode.textContent;
            $e8cccf5e02dec050$var$arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                content = $e8cccf5e02dec050$var$stringReplace(content, expr, ' ');
            });
            if (currentNode.textContent !== content) {
                $e8cccf5e02dec050$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
        return false;
    };
    /**
   * _isValidAttribute
   *
   * @param  {string} lcTag Lowercase tag name of containing element.
   * @param  {string} lcName Lowercase attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && $e8cccf5e02dec050$var$regExpTest(DATA_ATTR, lcName)) ;
        else if (ALLOW_ARIA_ATTR && $e8cccf5e02dec050$var$regExpTest(ARIA_ATTR, lcName)) ;
        else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
            if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $e8cccf5e02dec050$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && $e8cccf5e02dec050$var$regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $e8cccf5e02dec050$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
            else return false;
        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
        else if ($e8cccf5e02dec050$var$regExpTest(IS_ALLOWED_URI$1, $e8cccf5e02dec050$var$stringReplace(value, ATTR_WHITESPACE, ''))) ;
        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && $e8cccf5e02dec050$var$stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
        else if (ALLOW_UNKNOWN_PROTOCOLS && !$e8cccf5e02dec050$var$regExpTest(IS_SCRIPT_OR_DATA, $e8cccf5e02dec050$var$stringReplace(value, ATTR_WHITESPACE, ''))) ;
        else if (value) return false;
        return true;
    };
    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param {string} tagName name of the tag of the node to sanitize
   * @returns {boolean} Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return tagName !== 'annotation-xml' && $e8cccf5e02dec050$var$stringMatch(tagName, CUSTOM_ELEMENT);
    };
    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param  {Node} currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
        const { attributes: attributes } = currentNode;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
        const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR
        };
        let l = attributes.length;
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            const attr = attributes[l];
            const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
            const lcName = transformCaseFunc(name);
            let value = name === 'value' ? attrValue : $e8cccf5e02dec050$var$stringTrim(attrValue);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Remove attribute */ _removeAttribute(name, currentNode);
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && $e8cccf5e02dec050$var$regExpTest(/\/>/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && $e8cccf5e02dec050$var$regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) $e8cccf5e02dec050$var$arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                value = $e8cccf5e02dec050$var$stringReplace(value, expr, ' ');
            });
            /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
            if (!_isValidAttribute(lcTag, lcName, value)) continue;
            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode);
                // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                if (namespaceURI) ;
                else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                    case 'TrustedHTML':
                        value = trustedTypesPolicy.createHTML(value);
                        break;
                    case 'TrustedScriptURL':
                        value = trustedTypesPolicy.createScriptURL(value);
                        break;
                }
            }
            /* Handle invalid data-* attribute set by try-catching it */ try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) _forceRemove(currentNode);
                else $e8cccf5e02dec050$var$arrayPop(DOMPurify.removed);
            } catch (_) {}
        }
        /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
   * _sanitizeShadowDOM
   *
   * @param  {DocumentFragment} fragment to iterate over recursively
   */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
            /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
            /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
        }
        /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
   * Sanitize
   * Public method providing core sanitation functionality
   *
   * @param {String|Node} dirty string or DOM node
   * @param {Object} cfg object
   */ // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = '<!-->';
        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
            if (typeof dirty.toString === 'function') {
                dirty = dirty.toString();
                if (typeof dirty !== 'string') throw $e8cccf5e02dec050$var$typeErrorCreate('dirty is not a string, aborting');
            } else throw $e8cccf5e02dec050$var$typeErrorCreate('toString is not a function');
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
        if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
            if (dirty.nodeName) {
                const tagName = transformCaseFunc(dirty.nodeName);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw $e8cccf5e02dec050$var$typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
            }
        } else if (dirty instanceof Node) {
            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $e8cccf5e02dec050$var$NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === 'HTML') body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
        /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
            /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
            /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
        }
        /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $e8cccf5e02dec050$var$regExpTest($e8cccf5e02dec050$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) $e8cccf5e02dec050$var$arrayForEach([
            MUSTACHE_EXPR,
            ERB_EXPR,
            TMPLIT_EXPR
        ], (expr)=>{
            serializedHTML = $e8cccf5e02dec050$var$stringReplace(serializedHTML, expr, ' ');
        });
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
   * Public method to set the configuration once
   * setConfig
   *
   * @param {Object} cfg configuration object
   */ DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
    };
    /**
   * Public method to remove the configuration
   * clearConfig
   *
   */ DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
    };
    /**
   * Public method to check if an attribute value is valid.
   * Uses last set config, if any. Otherwise, uses config defaults.
   * isValidAttribute
   *
   * @param  {String} tag Tag name of containing element.
   * @param  {String} attr Attribute name.
   * @param  {String} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
   */ DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    /**
   * AddHook
   * Public method to add DOMPurify hooks
   *
   * @param {String} entryPoint entry point for the hook to add
   * @param {Function} hookFunction function to execute
   */ DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') return;
        hooks[entryPoint] = hooks[entryPoint] || [];
        $e8cccf5e02dec050$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
   * RemoveHook
   * Public method to remove a DOMPurify hook at a given entryPoint
   * (pops it from the stack of hooks if more are present)
   *
   * @param {String} entryPoint entry point for the hook to remove
   * @return {Function} removed(popped) hook
   */ DOMPurify.removeHook = function(entryPoint) {
        if (hooks[entryPoint]) return $e8cccf5e02dec050$var$arrayPop(hooks[entryPoint]);
    };
    /**
   * RemoveHooks
   * Public method to remove all DOMPurify hooks at a given entryPoint
   *
   * @param  {String} entryPoint entry point for the hooks to remove
   */ DOMPurify.removeHooks = function(entryPoint) {
        if (hooks[entryPoint]) hooks[entryPoint] = [];
    };
    /**
   * RemoveAllHooks
   * Public method to remove all DOMPurify hooks
   */ DOMPurify.removeAllHooks = function() {
        hooks = {};
    };
    return DOMPurify;
}
var $e8cccf5e02dec050$export$2e2bcd8739ae039 = $e8cccf5e02dec050$var$createDOMPurify();
 //# sourceMappingURL=purify.es.mjs.map


class $90a6182283f7a7f7$export$3c26c8bc6ab74d3 {
    constructor(){
        this.defaultOpaccConfig = {
            USE_PROFILES: {
                html: true,
                svg: true,
                svgFilters: true
            },
            ADD_TAGS: [
                'use'
            ]
        };
    }
    /**
	 *
	 *
	 * @param {*} dirty Zu bereinigender Input
	 * @param {*} config Zusätzliches Konfigurationsobjekt für die Bereinigung
	 * @returns {string} Bereinigter Input
	 */ sanitizeContent(dirty, config = null) {
        return (0, $e8cccf5e02dec050$export$2e2bcd8739ae039).sanitize(dirty, Object.assign(this.defaultOpaccConfig, config));
    }
    /**
	 *
	 *
	 * @returns {Array} Alle entfernte Elemente und Attribute (Nur zu DEBUG zwecken)
	 */ removedContent() {
        return (0, $e8cccf5e02dec050$export$2e2bcd8739ae039).removed;
    }
}


const $aaf3d0fad38bd1f9$export$404e5c179052a7f8 = new (0, $1e2f9b09a0759e0d$export$be24cb6caf8e0169)();
const $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb = new (0, $9a3c23dc87c23435$export$b3c221c7106f5e79)();
const $aaf3d0fad38bd1f9$export$aa474826216683 = new (0, $e36614d26c6ab87f$export$5e9b9dfacd86d260)();
const $aaf3d0fad38bd1f9$export$9cb8825bd162cc38 = new (0, $aea624f63deaf910$export$2683fc345df9a89e)();
const $aaf3d0fad38bd1f9$export$f6b455058877db44 = new (0, $90a6182283f7a7f7$export$3c26c8bc6ab74d3)();


class $e5931a5b99ee1cd6$export$402a94333c65a191 {
    constructor(){
        this.attachEventListener();
    }
    /**
	 *
	 *
	 * @param {*} pubId
	 * @param {*} customJs
	 * @param {*} cnf
	 * @param {*} containerId
	 * @param {boolean} addthisFnc
	 */ successFnc(pubId, customJs, cnf, containerId, addthisFnc) {
        let scriptRunner = new Function(addthisFnc);
        scriptRunner.apply();
        // eslint-disable-next-line no-undef
        addthis.toolbox(`#${containerId}`);
        // eslint-disable-next-line no-undef
        addthis.addEventListener('addthis.menu.share', (evt)=>{
            document.dispatchEvent(new CustomEvent('opaccSocialInteractionEvent', {
                'detail': {
                    'action': 'shared',
                    'tracker': 'send',
                    'hitType': 'social',
                    'socialNetwork': evt.data.service,
                    'socialAction': 'share',
                    'socialTarget': location.href
                }
            }));
        });
    }
    /**
	 *
	 *
	 * @param {*} error
	 */ errorFnc(error) {
        // eslint-disable-next-line no-console
        console.error('Socialmedia failed: ', error);
    }
    /**
	 *
	 *
	 */ attachEventListener() {
        document.addEventListener('DOMContentLoaded', ()=>{
            let elemList = document.querySelectorAll('.opc-social-media-buttons');
            Array.from(elemList).forEach((item)=>{
                if (item.dataset.opType == 'addthis') {
                    let pubId = item.dataset.opPubid;
                    let customJs = item.dataset.opCustomjs;
                    let cnf = item.dataset.opConfig;
                    let containerId = item.firstElementChild.id;
                    let fncArg = [
                        pubId,
                        customJs,
                        cnf,
                        containerId
                    ];
                    let initGet = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).getDefaultGetInitObj();
                    initGet['dataType'] = 'script';
                    initGet['cache'] = true;
                    delete initGet.credentials;
                    (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsync(`//s7.addthis.com/js/300/addthis_widget.js#pubid=${pubId}`, initGet, this.successFnc.bind(this, ...fncArg), this.errorFnc);
                }
            });
        });
    }
}


var $b0539aab807e643c$exports = {};
/**
 * @popperjs/core v2.11.8 - MIT License
 */ (function(global, factory) {
    factory($b0539aab807e643c$exports);
})($b0539aab807e643c$exports, function(exports1) {
    'use strict';
    function getWindow(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
    function isElement(node) {
        var OwnElement = getWindow(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function isHTMLElement(node) {
        var OwnElement = getWindow(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function isShadowRoot(node) {
        // IE 11 has no ShadowRoot
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = getWindow(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
    var max = Math.max;
    var min = Math.min;
    var round = Math.round;
    function getUAString() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
    function isLayoutViewport() {
        return !/^((?!chrome|android).)*safari/i.test(getUAString());
    }
    function getBoundingClientRect(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && isHTMLElement(element)) {
            scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
    function getWindowScroll(node) {
        var win = getWindow(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
    function getHTMLElementScroll(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
    function getNodeScroll(node) {
        if (node === getWindow(node) || !isHTMLElement(node)) return getWindowScroll(node);
        else return getHTMLElementScroll(node);
    }
    function getNodeName(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
    function getDocumentElement(element) {
        // $FlowFixMe[incompatible-return]: assume body is always available
        return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
    function getWindowScrollBarX(element) {
        // If <html> has a CSS width greater than the viewport, then this will be
        // incorrect for RTL.
        // Popper 1 is broken in this case and never had a bug report so let's assume
        // it's not an issue. I don't think anyone ever specifies width on <html>
        // anyway.
        // Browsers where the left scrollbar doesn't cause an issue report `0` for
        // this (e.g. Edge 2019, IE11, Safari)
        return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
    }
    function getComputedStyle(element) {
        return getWindow(element).getComputedStyle(element);
    }
    function isScrollParent(element) {
        // Firefox wants us to check `-x` and `-y` variations as well
        var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
    function isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = round(rect.width) / element.offsetWidth || 1;
        var scaleY = round(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    } // Returns the composite rect of an element relative to its offsetParent.
    // Composite means it takes into account transforms as well as layout.
    function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = isHTMLElement(offsetParent);
        var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
        var documentElement = getDocumentElement(offsetParent);
        var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
            isScrollParent(documentElement)) scroll = getNodeScroll(offsetParent);
            if (isHTMLElement(offsetParent)) {
                offsets = getBoundingClientRect(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
    // means it doesn't take into account transforms.
    function getLayoutRect(element) {
        var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
        // Fixes https://github.com/popperjs/popper-core/issues/1223
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
    function getParentNode(element) {
        if (getNodeName(element) === 'html') return element;
        return(// $FlowFixMe[incompatible-return]
        // $FlowFixMe[prop-missing]
        element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
        element.parentNode || (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
        // $FlowFixMe[incompatible-call]: HTMLElement is a Node
        getDocumentElement(element) // fallback
        );
    }
    function getScrollParent(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf(getNodeName(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
        return node.ownerDocument.body;
        if (isHTMLElement(node) && isScrollParent(node)) return node;
        return getScrollParent(getParentNode(node));
    }
    /*
    given a DOM element, return the list of all scroll parents, up the list of ancesors
    until we get to the top window object. This list is what we attach scroll listeners
    to, because if any of these parent elements scroll, we'll need to re-calculate the
    reference element's position.
    */ function listScrollParents(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = getScrollParent(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = getWindow(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
    }
    function isTableElement(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf(getNodeName(element)) >= 0;
    }
    function getTrueOffsetParent(element) {
        if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
        getComputedStyle(element).position === 'fixed') return null;
        return element.offsetParent;
    } // `.offsetParent` reports `null` for fixed elements, while absolute elements
    // return the containing block
    function getContainingBlock(element) {
        var isFirefox = /firefox/i.test(getUAString());
        var isIE = /Trident/i.test(getUAString());
        if (isIE && isHTMLElement(element)) {
            // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
            var elementCss = getComputedStyle(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = getParentNode(element);
        if (isShadowRoot(currentNode)) currentNode = currentNode.host;
        while(isHTMLElement(currentNode) && [
            'html',
            'body'
        ].indexOf(getNodeName(currentNode)) < 0){
            var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
            // create a containing block.
            // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    } // Gets the closest ancestor positioned element. Handles some edge cases,
    // such as table ancestors and cross browser bugs.
    function getOffsetParent(element) {
        var window1 = getWindow(element);
        var offsetParent = getTrueOffsetParent(element);
        while(offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
        if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) return window1;
        return offsetParent || getContainingBlock(element) || window1;
    }
    var top = 'top';
    var bottom = 'bottom';
    var right = 'right';
    var left = 'left';
    var auto = 'auto';
    var basePlacements = [
        top,
        bottom,
        right,
        left
    ];
    var start = 'start';
    var end = 'end';
    var clippingParents = 'clippingParents';
    var viewport = 'viewport';
    var popper = 'popper';
    var reference = 'reference';
    var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + start,
            placement + "-" + end
        ]);
    }, []);
    var placements = /*#__PURE__*/ [].concat(basePlacements, [
        auto
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + start,
            placement + "-" + end
        ]);
    }, []); // modifiers that need to read the DOM
    var beforeRead = 'beforeRead';
    var read = 'read';
    var afterRead = 'afterRead'; // pure-logic modifiers
    var beforeMain = 'beforeMain';
    var main = 'main';
    var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
    var beforeWrite = 'beforeWrite';
    var write = 'write';
    var afterWrite = 'afterWrite';
    var modifierPhases = [
        beforeRead,
        read,
        afterRead,
        beforeMain,
        main,
        afterMain,
        beforeWrite,
        write,
        afterWrite
    ];
    function order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        }); // On visiting object, check for its dependencies and visit them recursively
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) // check for visited object
            sort(modifier);
        });
        return result;
    }
    function orderModifiers(modifiers) {
        // order based on dependencies
        var orderedModifiers = order(modifiers); // order based on phase
        return modifierPhases.reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
    function debounce(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
    function mergeByName(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {}); // IE11 does not support Object.values
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
    function getViewportRect(element, strategy) {
        var win = getWindow(element);
        var html = getDocumentElement(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = isLayoutViewport();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + getWindowScrollBarX(element),
            y: y
        };
    }
    // of the `<html>` and `<body>` rect bounds if horizontally scrollable
    function getDocumentRect(element) {
        var _element$ownerDocumen;
        var html = getDocumentElement(element);
        var winScroll = getWindowScroll(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
        var y = -winScroll.scrollTop;
        if (getComputedStyle(body || html).direction === 'rtl') x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function contains(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
        if (parent.contains(child)) return true;
        else if (rootNode && isShadowRoot(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                 // $FlowFixMe[prop-missing]: need a better way to handle this...
                next = next.parentNode || next.host;
            }while (next);
        } // Give up, the result is false
        return false;
    }
    function rectToClientRect(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
    function getInnerBoundingClientRect(element, strategy) {
        var rect = getBoundingClientRect(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
    } // A "clipping parent" is an overflowable container with the characteristic of
    // clipping (or hiding) overflowing elements with a position different from
    // `initial`
    function getClippingParents(element) {
        var clippingParents = listScrollParents(getParentNode(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf(getComputedStyle(element).position) >= 0;
        var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
        if (!isElement(clipperElement)) return [];
         // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
        return clippingParents.filter(function(clippingParent) {
            return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
        });
    } // Gets the maximum area that the element is visible in due to any number of
    // clipping parents
    function getClippingRect(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = max(rect.top, accRect.top);
            accRect.right = min(rect.right, accRect.right);
            accRect.bottom = min(rect.bottom, accRect.bottom);
            accRect.left = max(rect.left, accRect.left);
            return accRect;
        }, getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
    function getBasePlacement(placement) {
        return placement.split('-')[0];
    }
    function getVariation(placement) {
        return placement.split('-')[1];
    }
    function getMainAxisFromPlacement(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
    function computeOffsets(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? getBasePlacement(placement) : null;
        var variation = placement ? getVariation(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
            }
        }
        return offsets;
    }
    function getFreshSideObject() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
    function mergePaddingObject(paddingObject) {
        return Object.assign({}, getFreshSideObject(), paddingObject);
    }
    function expandToHashMap(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
    function detectOverflow(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
        var altContext = elementContext === popper ? reference : popper;
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = getBoundingClientRect(state.elements.reference);
        var popperOffsets = computeOffsets({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
        // 0 or negative = within the clipping rect
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
        if (elementContext === popper && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    right,
                    bottom
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    top,
                    bottom
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
    var DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function popperGenerator(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
                        popper: listScrollParents(popper)
                    }; // Orders the modifiers based on their dependencies and `phase`
                    // properties
                    var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                // Sync update – it will always be executed, even if not necessary. This
                // is useful for low frequency updates where sync behavior simplifies the
                // logic.
                // For high frequency updates (e.g. `resize` and `scroll` events), always
                // prefer the async Popper#update method
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                    // anymore
                    if (!areValidElements(reference, popper)) return;
                     // Store the reference and popper rects to be read by modifiers
                    state.rects = {
                        reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
                        popper: getLayoutRect(popper)
                    }; // Modifiers have the ability to reset the current update cycle. The
                    // most common use case for this is the `flip` modifier changing the
                    // placement, which then needs to re-run all the modifiers, because the
                    // logic was previously ran for the previous placement and is therefore
                    // stale/incorrect
                    state.reset = false;
                    state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                    // is filled with the initial data specified by the modifier. This means
                    // it doesn't persist and is fresh on each update.
                    // To ensure persistent data, use `${name}#persistent`
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                // Async and optimistically optimized update – it will not be executed if
                // not necessary (debounced to run at most once-per-tick)
                update: debounce(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            }); // Modifiers have the ability to execute arbitrary code before the first
            // update cycle runs. They will be executed in the same order as the update
            // cycle. This is useful when a modifier adds some persistent data that
            // other modifiers need to use, but the modifier is run after the dependent
            // one.
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var passive = {
        passive: true
    };
    function effect$2(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window1 = getWindow(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, passive);
        });
        if (resize) window1.addEventListener('resize', instance.update, passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, passive);
            });
            if (resize) window1.removeEventListener('resize', instance.update, passive);
        };
    } // eslint-disable-next-line import/no-unused-modules
    var eventListeners = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: effect$2,
        data: {}
    };
    function popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        // Offsets are the actual position the popper needs to have to be
        // properly positioned near its reference element
        // This is the most basic placement, and will be adjusted by
        // the modifiers in the next step
        state.modifiersData[name] = computeOffsets({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    } // eslint-disable-next-line import/no-unused-modules
    var popperOffsets$1 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: popperOffsets,
        data: {}
    };
    var unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    }; // Round the offsets to the nearest suitable subpixel based on the DPR.
    // Zooming can change the DPR, but it seems to report a value that will
    // cleanly divide the values into the appropriate subpixels.
    function roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: round(x * dpr) / dpr || 0,
            y: round(y * dpr) / dpr || 0
        };
    }
    function mapToStyles(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = left;
        var sideY = top;
        var win = window;
        if (adaptive) {
            var offsetParent = getOffsetParent(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === getWindow(popper)) {
                offsetParent = getDocumentElement(popper);
                if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
            offsetParent;
            if (placement === top || (placement === left || placement === right) && variation === end) {
                sideY = bottom;
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === left || (placement === top || placement === bottom) && variation === end) {
                sideX = right;
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && unsetSides);
        var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
            x: x,
            y: y
        }, getWindow(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: getBasePlacement(state.placement),
            variation: getVariation(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    } // eslint-disable-next-line import/no-unused-modules
    var computeStyles$1 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: computeStyles,
        data: {}
    };
    // and applies them to the HTMLElements such as popper and arrow
    function applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name]; // arrow is optional + virtual elements
            if (!isHTMLElement(element) || !getNodeName(element)) return;
             // Flow doesn't support to extend this property, but it's the most
            // effective way to apply styles to an HTMLElement
            // $FlowFixMe[cannot-write]
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function effect$1(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {}); // arrow is optional + virtual elements
                if (!isHTMLElement(element) || !getNodeName(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    } // eslint-disable-next-line import/no-unused-modules
    var applyStyles$1 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: applyStyles,
        effect: effect$1,
        requires: [
            'computeStyles'
        ]
    };
    function distanceAndSkiddingToXY(placement, rects, offset) {
        var basePlacement = getBasePlacement(placement);
        var invertDistance = [
            left,
            top
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            left,
            right
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = placements.reduce(function(acc, placement) {
            acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules
    var offset$1 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: offset
    };
    var hash$1 = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function getOppositePlacement(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return hash$1[matched];
        });
    }
    var hash = {
        start: 'end',
        end: 'start'
    };
    function getOppositeVariationPlacement(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return hash[matched];
        });
    }
    function computeAutoPlacement(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
        var variation = getVariation(placement);
        var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement) {
            return getVariation(placement) === variation;
        }) : basePlacements;
        var allowedPlacements = placements$1.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements$1;
         // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = detectOverflow(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[getBasePlacement(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
    function getExpandedFallbackPlacements(placement) {
        if (getBasePlacement(placement) === auto) return [];
        var oppositePlacement = getOppositePlacement(placement);
        return [
            getOppositeVariationPlacement(placement),
            oppositePlacement,
            getOppositeVariationPlacement(oppositePlacement)
        ];
    }
    function flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = getBasePlacement(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            getOppositePlacement(preferredPlacement)
        ] : getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = getBasePlacement(placement);
            var isStartVariation = getVariation(placement) === start;
            var isVertical = [
                top,
                bottom
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = detectOverflow(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
            if (referenceRect[len] > popperRect[len]) mainVariationSide = getOppositePlacement(mainVariationSide);
            var altVariationSide = getOppositePlacement(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            // `2` may be desired in some cases – research later
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    } // eslint-disable-next-line import/no-unused-modules
    var flip$1 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
    function getAltAxis(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function within(min$1, value, max$1) {
        return max(min$1, min(value, max$1));
    }
    function withinMaxClamp(min, value, max) {
        var v = within(min, value, max);
        return v > max ? max : v;
    }
    function preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = detectOverflow(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = getBasePlacement(state.placement);
        var variation = getVariation(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = getMainAxisFromPlacement(basePlacement);
        var altAxis = getAltAxis(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? top : left;
            var altSide = mainAxis === 'y' ? bottom : right;
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min$1 = offset + overflow[mainSide];
            var max$1 = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === start ? referenceRect[len] : popperRect[len];
            var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
            // outside the reference bounds
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
            // to include its full size in the calculation. If the reference is small
            // and near the edge of a boundary, the popper can overflow even if the
            // reference is not overflowing as well (e.g. virtual elements with no
            // width or height)
            var arrowLen = within(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? top : left;
            var _altSide = mainAxis === 'x' ? bottom : right;
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                top,
                left
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules
    var preventOverflow$1 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
    var toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    };
    function arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = getBasePlacement(state.placement);
        var axis = getMainAxisFromPlacement(basePlacement);
        var isVertical = [
            left,
            right
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = toPaddingObject(options.padding, state);
        var arrowRect = getLayoutRect(arrowElement);
        var minProp = axis === 'y' ? top : left;
        var maxProp = axis === 'y' ? bottom : right;
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = getOffsetParent(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
        // outside of the popper bounds
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = within(min, center, max); // Prevents breaking syntax highlighting...
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
         // CSS selector
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!contains(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    } // eslint-disable-next-line import/no-unused-modules
    var arrow$1 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: arrow,
        effect: effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
    function getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function isAnySideFullyClipped(overflow) {
        return [
            top,
            right,
            bottom,
            left
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = detectOverflow(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = detectOverflow(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    } // eslint-disable-next-line import/no-unused-modules
    var hide$1 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: hide
    };
    var defaultModifiers$1 = [
        eventListeners,
        popperOffsets$1,
        computeStyles$1,
        applyStyles$1
    ];
    var createPopper$1 = /*#__PURE__*/ popperGenerator({
        defaultModifiers: defaultModifiers$1
    }); // eslint-disable-next-line import/no-unused-modules
    var defaultModifiers = [
        eventListeners,
        popperOffsets$1,
        computeStyles$1,
        applyStyles$1,
        offset$1,
        flip$1,
        preventOverflow$1,
        arrow$1,
        hide$1
    ];
    var createPopper = /*#__PURE__*/ popperGenerator({
        defaultModifiers: defaultModifiers
    }); // eslint-disable-next-line import/no-unused-modules
    exports1.applyStyles = applyStyles$1;
    exports1.arrow = arrow$1;
    exports1.computeStyles = computeStyles$1;
    exports1.createPopper = createPopper;
    exports1.createPopperLite = createPopper$1;
    exports1.defaultModifiers = defaultModifiers;
    exports1.detectOverflow = detectOverflow;
    exports1.eventListeners = eventListeners;
    exports1.flip = flip$1;
    exports1.hide = hide$1;
    exports1.offset = offset$1;
    exports1.popperGenerator = popperGenerator;
    exports1.popperOffsets = popperOffsets$1;
    exports1.preventOverflow = preventOverflow$1;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
}); //# sourceMappingURL=popper.js.map


var $d7b475bad30c107b$exports = {};

/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ (function(global, factory) {
    $d7b475bad30c107b$exports = factory((parcelRequire("2AvH9")));
})($d7b475bad30c107b$exports, function(core) {
    'use strict';
    var css = ".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;white-space:normal;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}";
    function injectCSS(css) {
        var style = document.createElement('style');
        style.textContent = css;
        style.setAttribute('data-tippy-stylesheet', '');
        var head = document.head;
        var firstStyleOrLinkTag = document.querySelector('head>style,head>link');
        if (firstStyleOrLinkTag) head.insertBefore(style, firstStyleOrLinkTag);
        else head.appendChild(style);
    }
    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
    var isIE11 = isBrowser ? !!window.msCrypto : false;
    var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
    var BOX_CLASS = "tippy-box";
    var CONTENT_CLASS = "tippy-content";
    var BACKDROP_CLASS = "tippy-backdrop";
    var ARROW_CLASS = "tippy-arrow";
    var SVG_ARROW_CLASS = "tippy-svg-arrow";
    var TOUCH_OPTIONS = {
        passive: true,
        capture: true
    };
    var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
        return document.body;
    };
    function hasOwnProperty(obj, key) {
        return ({}).hasOwnProperty.call(obj, key);
    }
    function getValueAtIndexOrReturn(value, index, defaultValue) {
        if (Array.isArray(value)) {
            var v = value[index];
            return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
        }
        return value;
    }
    function isType(value, type) {
        var str = ({}).toString.call(value);
        return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
    }
    function invokeWithArgsOrReturn(value, args) {
        return typeof value === 'function' ? value.apply(void 0, args) : value;
    }
    function debounce(fn, ms) {
        // Avoid wrapping in `setTimeout` if ms is 0 anyway
        if (ms === 0) return fn;
        var timeout;
        return function(arg) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                fn(arg);
            }, ms);
        };
    }
    function removeProperties(obj, keys) {
        var clone = Object.assign({}, obj);
        keys.forEach(function(key) {
            delete clone[key];
        });
        return clone;
    }
    function splitBySpaces(value) {
        return value.split(/\s+/).filter(Boolean);
    }
    function normalizeToArray(value) {
        return [].concat(value);
    }
    function pushIfUnique(arr, value) {
        if (arr.indexOf(value) === -1) arr.push(value);
    }
    function unique(arr) {
        return arr.filter(function(item, index) {
            return arr.indexOf(item) === index;
        });
    }
    function getBasePlacement(placement) {
        return placement.split('-')[0];
    }
    function arrayFrom(value) {
        return [].slice.call(value);
    }
    function removeUndefinedProps(obj) {
        return Object.keys(obj).reduce(function(acc, key) {
            if (obj[key] !== undefined) acc[key] = obj[key];
            return acc;
        }, {});
    }
    function div() {
        return document.createElement('div');
    }
    function isElement(value) {
        return [
            'Element',
            'Fragment'
        ].some(function(type) {
            return isType(value, type);
        });
    }
    function isNodeList(value) {
        return isType(value, 'NodeList');
    }
    function isMouseEvent(value) {
        return isType(value, 'MouseEvent');
    }
    function isReferenceElement(value) {
        return !!(value && value._tippy && value._tippy.reference === value);
    }
    function getArrayOfElements(value) {
        if (isElement(value)) return [
            value
        ];
        if (isNodeList(value)) return arrayFrom(value);
        if (Array.isArray(value)) return value;
        return arrayFrom(document.querySelectorAll(value));
    }
    function setTransitionDuration(els, value) {
        els.forEach(function(el) {
            if (el) el.style.transitionDuration = value + "ms";
        });
    }
    function setVisibilityState(els, state) {
        els.forEach(function(el) {
            if (el) el.setAttribute('data-state', state);
        });
    }
    function getOwnerDocument(elementOrElements) {
        var _element$ownerDocumen;
        var _normalizeToArray = normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
        return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
    }
    function isCursorOutsideInteractiveBorder(popperTreeData, event) {
        var clientX = event.clientX, clientY = event.clientY;
        return popperTreeData.every(function(_ref) {
            var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
            var interactiveBorder = props.interactiveBorder;
            var basePlacement = getBasePlacement(popperState.placement);
            var offsetData = popperState.modifiersData.offset;
            if (!offsetData) return true;
            var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
            var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
            var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
            var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
            var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
            var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
            var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
            var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
            return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
        });
    }
    function updateTransitionEndListener(box, action, listener) {
        var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
        // `webkitTransitionEnd`...
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            box[method](event, listener);
        });
    }
    /**
     * Compared to xxx.contains, this function works for dom structures with shadow
     * dom
     */ function actualContains(parent, child) {
        var target = child;
        while(target){
            var _target$getRootNode;
            if (parent.contains(target)) return true;
            target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
        }
        return false;
    }
    var currentInput = {
        isTouch: false
    };
    var lastMouseMoveTime = 0;
    /**
     * When a `touchstart` event is fired, it's assumed the user is using touch
     * input. We'll bind a `mousemove` event listener to listen for mouse input in
     * the future. This way, the `isTouch` property is fully dynamic and will handle
     * hybrid devices that use a mix of touch + mouse input.
     */ function onDocumentTouchStart() {
        if (currentInput.isTouch) return;
        currentInput.isTouch = true;
        if (window.performance) document.addEventListener('mousemove', onDocumentMouseMove);
    }
    /**
     * When two `mousemove` event are fired consecutively within 20ms, it's assumed
     * the user is using mouse input again. `mousemove` can fire on touch devices as
     * well, but very rarely that quickly.
     */ function onDocumentMouseMove() {
        var now = performance.now();
        if (now - lastMouseMoveTime < 20) {
            currentInput.isTouch = false;
            document.removeEventListener('mousemove', onDocumentMouseMove);
        }
        lastMouseMoveTime = now;
    }
    /**
     * When an element is in focus and has a tippy, leaving the tab/window and
     * returning causes it to show again. For mouse users this is unexpected, but
     * for keyboard use it makes sense.
     * TODO: find a better technique to solve this problem
     */ function onWindowBlur() {
        var activeElement = document.activeElement;
        if (isReferenceElement(activeElement)) {
            var instance = activeElement._tippy;
            if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
        }
    }
    function bindGlobalEventListeners() {
        document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
        window.addEventListener('blur', onWindowBlur);
    }
    function createMemoryLeakWarning(method) {
        var txt = method === 'destroy' ? 'n already-' : ' ';
        return [
            method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
            'indicates a potential memory leak.'
        ].join(' ');
    }
    function clean(value) {
        var spacesAndTabs = /[ \t]{2,}/g;
        var lineStartWithSpaces = /^[ \t]*/gm;
        return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
    }
    function getDevMessage(message) {
        return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
    }
    function getFormattedMessage(message) {
        return [
            getDevMessage(message),
            'color: #00C584; font-size: 1.3em; font-weight: bold;',
            'line-height: 1.5',
            'color: #a6a095;'
        ];
    } // Assume warnings and errors never have the same message
    var visitedMessages;
    resetVisitedMessages();
    function resetVisitedMessages() {
        visitedMessages = new Set();
    }
    function warnWhen(condition, message) {
        if (condition && !visitedMessages.has(message)) {
            var _console;
            visitedMessages.add(message);
            (_console = console).warn.apply(_console, getFormattedMessage(message));
        }
    }
    function errorWhen(condition, message) {
        if (condition && !visitedMessages.has(message)) {
            var _console2;
            visitedMessages.add(message);
            (_console2 = console).error.apply(_console2, getFormattedMessage(message));
        }
    }
    function validateTargets(targets) {
        var didPassFalsyValue = !targets;
        var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
        errorWhen(didPassFalsyValue, [
            'tippy() was passed',
            '`' + String(targets) + '`',
            'as its targets (first) argument. Valid types are: String, Element,',
            'Element[], or NodeList.'
        ].join(' '));
        errorWhen(didPassPlainObject, [
            'tippy() was passed a plain object which is not supported as an argument',
            'for virtual positioning. Use props.getReferenceClientRect instead.'
        ].join(' '));
    }
    var pluginProps = {
        animateFill: false,
        followCursor: false,
        inlinePositioning: false,
        sticky: false
    };
    var renderProps = {
        allowHTML: false,
        animation: 'fade',
        arrow: true,
        content: '',
        inertia: false,
        maxWidth: 350,
        role: 'tooltip',
        theme: '',
        zIndex: 9999
    };
    var defaultProps = Object.assign({
        appendTo: TIPPY_DEFAULT_APPEND_TO,
        aria: {
            content: 'auto',
            expanded: 'auto'
        },
        delay: 0,
        duration: [
            300,
            250
        ],
        getReferenceClientRect: null,
        hideOnClick: true,
        ignoreAttributes: false,
        interactive: false,
        interactiveBorder: 2,
        interactiveDebounce: 0,
        moveTransition: '',
        offset: [
            0,
            10
        ],
        onAfterUpdate: function onAfterUpdate() {},
        onBeforeUpdate: function onBeforeUpdate() {},
        onCreate: function onCreate() {},
        onDestroy: function onDestroy() {},
        onHidden: function onHidden() {},
        onHide: function onHide() {},
        onMount: function onMount() {},
        onShow: function onShow() {},
        onShown: function onShown() {},
        onTrigger: function onTrigger() {},
        onUntrigger: function onUntrigger() {},
        onClickOutside: function onClickOutside() {},
        placement: 'top',
        plugins: [],
        popperOptions: {},
        render: null,
        showOnCreate: false,
        touch: true,
        trigger: 'mouseenter focus',
        triggerTarget: null
    }, pluginProps, renderProps);
    var defaultKeys = Object.keys(defaultProps);
    var setDefaultProps = function setDefaultProps(partialProps) {
        validateProps(partialProps, []);
        var keys = Object.keys(partialProps);
        keys.forEach(function(key) {
            defaultProps[key] = partialProps[key];
        });
    };
    function getExtendedPassedProps(passedProps) {
        var plugins = passedProps.plugins || [];
        var pluginProps = plugins.reduce(function(acc, plugin) {
            var name = plugin.name, defaultValue = plugin.defaultValue;
            if (name) {
                var _name;
                acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
            }
            return acc;
        }, {});
        return Object.assign({}, passedProps, pluginProps);
    }
    function getDataAttributeProps(reference, plugins) {
        var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
            plugins: plugins
        }))) : defaultKeys;
        var props = propKeys.reduce(function(acc, key) {
            var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
            if (!valueAsString) return acc;
            if (key === 'content') acc[key] = valueAsString;
            else try {
                acc[key] = JSON.parse(valueAsString);
            } catch (e) {
                acc[key] = valueAsString;
            }
            return acc;
        }, {});
        return props;
    }
    function evaluateProps(reference, props) {
        var out = Object.assign({}, props, {
            content: invokeWithArgsOrReturn(props.content, [
                reference
            ])
        }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
        out.aria = Object.assign({}, defaultProps.aria, out.aria);
        out.aria = {
            expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
            content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
        };
        return out;
    }
    function validateProps(partialProps, plugins) {
        if (partialProps === void 0) partialProps = {};
        if (plugins === void 0) plugins = [];
        var keys = Object.keys(partialProps);
        keys.forEach(function(prop) {
            var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
            var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
            if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
                return plugin.name === prop;
            }).length === 0;
            warnWhen(didPassUnknownProp, [
                "`" + prop + "`",
                "is not a valid prop. You may have spelled it incorrectly, or if it's",
                'a plugin, forgot to pass it in an array as props.plugins.',
                '\n\n',
                'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
                'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
            ].join(' '));
        });
    }
    var innerHTML = function innerHTML() {
        return 'innerHTML';
    };
    function dangerouslySetInnerHTML(element, html) {
        element[innerHTML()] = html;
    }
    function createArrowElement(value) {
        var arrow = div();
        if (value === true) arrow.className = ARROW_CLASS;
        else {
            arrow.className = SVG_ARROW_CLASS;
            if (isElement(value)) arrow.appendChild(value);
            else dangerouslySetInnerHTML(arrow, value);
        }
        return arrow;
    }
    function setContent(content, props) {
        if (isElement(props.content)) {
            dangerouslySetInnerHTML(content, '');
            content.appendChild(props.content);
        } else if (typeof props.content !== 'function') {
            if (props.allowHTML) dangerouslySetInnerHTML(content, props.content);
            else content.textContent = props.content;
        }
    }
    function getChildren(popper) {
        var box = popper.firstElementChild;
        var boxChildren = arrayFrom(box.children);
        return {
            box: box,
            content: boxChildren.find(function(node) {
                return node.classList.contains(CONTENT_CLASS);
            }),
            arrow: boxChildren.find(function(node) {
                return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
            }),
            backdrop: boxChildren.find(function(node) {
                return node.classList.contains(BACKDROP_CLASS);
            })
        };
    }
    function render(instance) {
        var popper = div();
        var box = div();
        box.className = BOX_CLASS;
        box.setAttribute('data-state', 'hidden');
        box.setAttribute('tabindex', '-1');
        var content = div();
        content.className = CONTENT_CLASS;
        content.setAttribute('data-state', 'hidden');
        setContent(content, instance.props);
        popper.appendChild(box);
        box.appendChild(content);
        onUpdate(instance.props, instance.props);
        function onUpdate(prevProps, nextProps) {
            var _getChildren = getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
            if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
            else box.removeAttribute('data-theme');
            if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
            else box.removeAttribute('data-animation');
            if (nextProps.inertia) box.setAttribute('data-inertia', '');
            else box.removeAttribute('data-inertia');
            box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
            if (nextProps.role) box.setAttribute('role', nextProps.role);
            else box.removeAttribute('role');
            if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) setContent(content, instance.props);
            if (nextProps.arrow) {
                if (!arrow) box.appendChild(createArrowElement(nextProps.arrow));
                else if (prevProps.arrow !== nextProps.arrow) {
                    box.removeChild(arrow);
                    box.appendChild(createArrowElement(nextProps.arrow));
                }
            } else if (arrow) box.removeChild(arrow);
        }
        return {
            popper: popper,
            onUpdate: onUpdate
        };
    } // Runtime check to identify if the render function is the default one; this
    // way we can apply default CSS transitions logic and it can be tree-shaken away
    render.$$tippy = true;
    var idCounter = 1;
    var mouseMoveListeners = []; // Used by `hideAll()`
    var mountedInstances = [];
    function createTippy(reference, passedProps) {
        var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
        // 🔒 Private members
        // ===========================================================================
        var showTimeout;
        var hideTimeout;
        var scheduleHideAnimationFrame;
        var isVisibleFromClick = false;
        var didHideDueToDocumentMouseDown = false;
        var didTouchMove = false;
        var ignoreOnFirstUpdate = false;
        var lastTriggerEvent;
        var currentTransitionEndListener;
        var onFirstUpdate;
        var listeners = [];
        var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
        var currentTarget; // ===========================================================================
        // 🔑 Public members
        // ===========================================================================
        var id = idCounter++;
        var popperInstance = null;
        var plugins = unique(props.plugins);
        var state = {
            // Is the instance currently enabled?
            isEnabled: true,
            // Is the tippy currently showing and not transitioning out?
            isVisible: false,
            // Has the instance been destroyed?
            isDestroyed: false,
            // Is the tippy currently mounted to the DOM?
            isMounted: false,
            // Has the tippy finished transitioning in?
            isShown: false
        };
        var instance = {
            // properties
            id: id,
            reference: reference,
            popper: div(),
            popperInstance: popperInstance,
            props: props,
            state: state,
            plugins: plugins,
            // methods
            clearDelayTimeouts: clearDelayTimeouts,
            setProps: setProps,
            setContent: setContent,
            show: show,
            hide: hide,
            hideWithInteractivity: hideWithInteractivity,
            enable: enable,
            disable: disable,
            unmount: unmount,
            destroy: destroy
        }; // TODO: Investigate why this early return causes a TDZ error in the tests —
        // it doesn't seem to happen in the browser
        /* istanbul ignore if */ if (!props.render) {
            errorWhen(true, 'render() function has not been supplied.');
            return instance;
        } // ===========================================================================
        // Initial mutations
        // ===========================================================================
        var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
        popper.setAttribute('data-tippy-root', '');
        popper.id = "tippy-" + instance.id;
        instance.popper = popper;
        reference._tippy = instance;
        popper._tippy = instance;
        var pluginsHooks = plugins.map(function(plugin) {
            return plugin.fn(instance);
        });
        var hasAriaExpanded = reference.hasAttribute('aria-expanded');
        addListeners();
        handleAriaExpandedAttribute();
        handleStyles();
        invokeHook('onCreate', [
            instance
        ]);
        if (props.showOnCreate) scheduleShow();
         // Prevent a tippy with a delay from hiding if the cursor left then returned
        // before it started hiding
        popper.addEventListener('mouseenter', function() {
            if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
        });
        popper.addEventListener('mouseleave', function() {
            if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        });
        return instance; // ===========================================================================
        // 🔒 Private methods
        // ===========================================================================
        function getNormalizedTouchSettings() {
            var touch = instance.props.touch;
            return Array.isArray(touch) ? touch : [
                touch,
                0
            ];
        }
        function getIsCustomTouchBehavior() {
            return getNormalizedTouchSettings()[0] === 'hold';
        }
        function getIsDefaultRenderFn() {
            var _instance$props$rende;
            // @ts-ignore
            return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
        }
        function getCurrentTarget() {
            return currentTarget || reference;
        }
        function getDocument() {
            var parent = getCurrentTarget().parentNode;
            return parent ? getOwnerDocument(parent) : document;
        }
        function getDefaultTemplateChildren() {
            return getChildren(popper);
        }
        function getDelay(isShow) {
            // For touch or keyboard input, force `0` delay for UX reasons
            // Also if the instance is mounted but not visible (transitioning out),
            // ignore delay
            if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
            return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
        }
        function handleStyles(fromHide) {
            if (fromHide === void 0) fromHide = false;
            popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
            popper.style.zIndex = "" + instance.props.zIndex;
        }
        function invokeHook(hook, args, shouldInvokePropsHook) {
            if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
            pluginsHooks.forEach(function(pluginHooks) {
                if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
            });
            if (shouldInvokePropsHook) {
                var _instance$props;
                (_instance$props = instance.props)[hook].apply(_instance$props, args);
            }
        }
        function handleAriaContentAttribute() {
            var aria = instance.props.aria;
            if (!aria.content) return;
            var attr = "aria-" + aria.content;
            var id = popper.id;
            var nodes = normalizeToArray(instance.props.triggerTarget || reference);
            nodes.forEach(function(node) {
                var currentValue = node.getAttribute(attr);
                if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
                else {
                    var nextValue = currentValue && currentValue.replace(id, '').trim();
                    if (nextValue) node.setAttribute(attr, nextValue);
                    else node.removeAttribute(attr);
                }
            });
        }
        function handleAriaExpandedAttribute() {
            if (hasAriaExpanded || !instance.props.aria.expanded) return;
            var nodes = normalizeToArray(instance.props.triggerTarget || reference);
            nodes.forEach(function(node) {
                if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
                else node.removeAttribute('aria-expanded');
            });
        }
        function cleanupInteractiveMouseListeners() {
            getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
            mouseMoveListeners = mouseMoveListeners.filter(function(listener) {
                return listener !== debouncedOnMouseMove;
            });
        }
        function onDocumentPress(event) {
            // Moved finger to scroll instead of an intentional tap outside
            if (currentInput.isTouch) {
                if (didTouchMove || event.type === 'mousedown') return;
            }
            var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
            if (instance.props.interactive && actualContains(popper, actualTarget)) return;
             // Clicked on the event listeners target
            if (normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
                return actualContains(el, actualTarget);
            })) {
                if (currentInput.isTouch) return;
                if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
            } else invokeHook('onClickOutside', [
                instance,
                event
            ]);
            if (instance.props.hideOnClick === true) {
                instance.clearDelayTimeouts();
                instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
                // currentTarget. This lets a tippy with `focus` trigger know that it
                // should not show
                didHideDueToDocumentMouseDown = true;
                setTimeout(function() {
                    didHideDueToDocumentMouseDown = false;
                }); // The listener gets added in `scheduleShow()`, but this may be hiding it
                // before it shows, and hide()'s early bail-out behavior can prevent it
                // from being cleaned up
                if (!instance.state.isMounted) removeDocumentPress();
            }
        }
        function onTouchMove() {
            didTouchMove = true;
        }
        function onTouchStart() {
            didTouchMove = false;
        }
        function addDocumentPress() {
            var doc = getDocument();
            doc.addEventListener('mousedown', onDocumentPress, true);
            doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
            doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
            doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
        }
        function removeDocumentPress() {
            var doc = getDocument();
            doc.removeEventListener('mousedown', onDocumentPress, true);
            doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
            doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
            doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
        }
        function onTransitionedOut(duration, callback) {
            onTransitionEnd(duration, function() {
                if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
            });
        }
        function onTransitionedIn(duration, callback) {
            onTransitionEnd(duration, callback);
        }
        function onTransitionEnd(duration, callback) {
            var box = getDefaultTemplateChildren().box;
            function listener(event) {
                if (event.target === box) {
                    updateTransitionEndListener(box, 'remove', listener);
                    callback();
                }
            } // Make callback synchronous if duration is 0
            // `transitionend` won't fire otherwise
            if (duration === 0) return callback();
            updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
            updateTransitionEndListener(box, 'add', listener);
            currentTransitionEndListener = listener;
        }
        function on(eventType, handler, options) {
            if (options === void 0) options = false;
            var nodes = normalizeToArray(instance.props.triggerTarget || reference);
            nodes.forEach(function(node) {
                node.addEventListener(eventType, handler, options);
                listeners.push({
                    node: node,
                    eventType: eventType,
                    handler: handler,
                    options: options
                });
            });
        }
        function addListeners() {
            if (getIsCustomTouchBehavior()) {
                on('touchstart', onTrigger, {
                    passive: true
                });
                on('touchend', onMouseLeave, {
                    passive: true
                });
            }
            splitBySpaces(instance.props.trigger).forEach(function(eventType) {
                if (eventType === 'manual') return;
                on(eventType, onTrigger);
                switch(eventType){
                    case 'mouseenter':
                        on('mouseleave', onMouseLeave);
                        break;
                    case 'focus':
                        on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                        break;
                    case 'focusin':
                        on('focusout', onBlurOrFocusOut);
                        break;
                }
            });
        }
        function removeListeners() {
            listeners.forEach(function(_ref) {
                var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
                node.removeEventListener(eventType, handler, options);
            });
            listeners = [];
        }
        function onTrigger(event) {
            var _lastTriggerEvent;
            var shouldScheduleClickHide = false;
            if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
            var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
            lastTriggerEvent = event;
            currentTarget = event.currentTarget;
            handleAriaExpandedAttribute();
            if (!instance.state.isVisible && isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
            // over a new target, but `mousemove` events don't get fired. This
            // causes interactive tooltips to get stuck open until the cursor is
            // moved
            mouseMoveListeners.forEach(function(listener) {
                return listener(event);
            });
             // Toggle show/hide when clicking click-triggered tooltips
            if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
            else scheduleShow(event);
            if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
            if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
        }
        function onMouseMove(event) {
            var target = event.target;
            var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
            if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
            var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
                var _instance$popperInsta;
                var instance = popper._tippy;
                var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
                if (state) return {
                    popperRect: popper.getBoundingClientRect(),
                    popperState: state,
                    props: props
                };
                return null;
            }).filter(Boolean);
            if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
                cleanupInteractiveMouseListeners();
                scheduleHide(event);
            }
        }
        function onMouseLeave(event) {
            var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
            if (shouldBail) return;
            if (instance.props.interactive) {
                instance.hideWithInteractivity(event);
                return;
            }
            scheduleHide(event);
        }
        function onBlurOrFocusOut(event) {
            if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
             // If focus was moved to within the popper
            if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
            scheduleHide(event);
        }
        function isEventListenerStopped(event) {
            return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
        }
        function createPopperInstance() {
            destroyPopperInstance();
            var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
            var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
            var computedReference = getReferenceClientRect ? {
                getBoundingClientRect: getReferenceClientRect,
                contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
            } : reference;
            var tippyModifier = {
                name: '$$tippy',
                enabled: true,
                phase: 'beforeWrite',
                requires: [
                    'computeStyles'
                ],
                fn: function fn(_ref2) {
                    var state = _ref2.state;
                    if (getIsDefaultRenderFn()) {
                        var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                        [
                            'placement',
                            'reference-hidden',
                            'escaped'
                        ].forEach(function(attr) {
                            if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                            else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                            else box.removeAttribute("data-" + attr);
                        });
                        state.attributes.popper = {};
                    }
                }
            };
            var modifiers = [
                {
                    name: 'offset',
                    options: {
                        offset: offset
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: {
                            top: 2,
                            bottom: 2,
                            left: 5,
                            right: 5
                        }
                    }
                },
                {
                    name: 'flip',
                    options: {
                        padding: 5
                    }
                },
                {
                    name: 'computeStyles',
                    options: {
                        adaptive: !moveTransition
                    }
                },
                tippyModifier
            ];
            if (getIsDefaultRenderFn() && arrow) modifiers.push({
                name: 'arrow',
                options: {
                    element: arrow,
                    padding: 3
                }
            });
            modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
            instance.popperInstance = core.createPopper(computedReference, popper, Object.assign({}, popperOptions, {
                placement: placement,
                onFirstUpdate: onFirstUpdate,
                modifiers: modifiers
            }));
        }
        function destroyPopperInstance() {
            if (instance.popperInstance) {
                instance.popperInstance.destroy();
                instance.popperInstance = null;
            }
        }
        function mount() {
            var appendTo = instance.props.appendTo;
            var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
            // it's directly after the reference element so the elements inside the
            // tippy can be tabbed to
            // If there are clipping issues, the user can specify a different appendTo
            // and ensure focus management is handled correctly manually
            var node = getCurrentTarget();
            if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
            else parentNode = invokeWithArgsOrReturn(appendTo, [
                node
            ]);
             // The popper element needs to exist on the DOM before its position can be
            // updated as Popper needs to read its dimensions
            if (!parentNode.contains(popper)) parentNode.appendChild(popper);
            instance.state.isMounted = true;
            createPopperInstance();
            // Accessibility check
            warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, [
                'Interactive tippy element may not be accessible via keyboard',
                'navigation because it is not directly after the reference element',
                'in the DOM source order.',
                '\n\n',
                'Using a wrapper <div> or <span> tag around the reference element',
                'solves this by creating a new parentNode context.',
                '\n\n',
                'Specifying `appendTo: document.body` silences this warning, but it',
                'assumes you are using a focus management solution to handle',
                'keyboard navigation.',
                '\n\n',
                'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'
            ].join(' '));
        }
        function getNestedPopperTree() {
            return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
        }
        function scheduleShow(event) {
            instance.clearDelayTimeouts();
            if (event) invokeHook('onTrigger', [
                instance,
                event
            ]);
            addDocumentPress();
            var delay = getDelay(true);
            var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
            if (currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
            if (delay) showTimeout = setTimeout(function() {
                instance.show();
            }, delay);
            else instance.show();
        }
        function scheduleHide(event) {
            instance.clearDelayTimeouts();
            invokeHook('onUntrigger', [
                instance,
                event
            ]);
            if (!instance.state.isVisible) {
                removeDocumentPress();
                return;
            } // For interactive tippies, scheduleHide is added to a document.body handler
            // from onMouseLeave so must intercept scheduled hides from mousemove/leave
            // events when trigger contains mouseenter and click, and the tip is
            // currently shown as a result of a click.
            if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
                'mouseleave',
                'mousemove'
            ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
            var delay = getDelay(false);
            if (delay) hideTimeout = setTimeout(function() {
                if (instance.state.isVisible) instance.hide();
            }, delay);
            else // Fixes a `transitionend` problem when it fires 1 frame too
            // late sometimes, we don't want hide() to be called.
            scheduleHideAnimationFrame = requestAnimationFrame(function() {
                instance.hide();
            });
        } // ===========================================================================
        // 🔑 Public methods
        // ===========================================================================
        function enable() {
            instance.state.isEnabled = true;
        }
        function disable() {
            // Disabling the instance should also hide it
            // https://github.com/atomiks/tippy.js-react/issues/106
            instance.hide();
            instance.state.isEnabled = false;
        }
        function clearDelayTimeouts() {
            clearTimeout(showTimeout);
            clearTimeout(hideTimeout);
            cancelAnimationFrame(scheduleHideAnimationFrame);
        }
        function setProps(partialProps) {
            warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
            if (instance.state.isDestroyed) return;
            invokeHook('onBeforeUpdate', [
                instance,
                partialProps
            ]);
            removeListeners();
            var prevProps = instance.props;
            var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
                ignoreAttributes: true
            }));
            instance.props = nextProps;
            addListeners();
            if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
                cleanupInteractiveMouseListeners();
                debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
            } // Ensure stale aria-expanded attributes are removed
            if (prevProps.triggerTarget && !nextProps.triggerTarget) normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
                node.removeAttribute('aria-expanded');
            });
            else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
            handleAriaExpandedAttribute();
            handleStyles();
            if (onUpdate) onUpdate(prevProps, nextProps);
            if (instance.popperInstance) {
                createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
                // and the nested ones get re-rendered first.
                // https://github.com/atomiks/tippyjs-react/issues/177
                // TODO: find a cleaner / more efficient solution(!)
                getNestedPopperTree().forEach(function(nestedPopper) {
                    // React (and other UI libs likely) requires a rAF wrapper as it flushes
                    // its work in one
                    requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
                });
            }
            invokeHook('onAfterUpdate', [
                instance,
                partialProps
            ]);
        }
        function setContent(content) {
            instance.setProps({
                content: content
            });
        }
        function show() {
            warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
            var isAlreadyVisible = instance.state.isVisible;
            var isDestroyed = instance.state.isDestroyed;
            var isDisabled = !instance.state.isEnabled;
            var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
            var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
            if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
             // Normalize `disabled` behavior across browsers.
            // Firefox allows events on disabled elements, but Chrome doesn't.
            // Using a wrapper element (i.e. <span>) is recommended.
            if (getCurrentTarget().hasAttribute('disabled')) return;
            invokeHook('onShow', [
                instance
            ], false);
            if (instance.props.onShow(instance) === false) return;
            instance.state.isVisible = true;
            if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
            handleStyles();
            addDocumentPress();
            if (!instance.state.isMounted) popper.style.transition = 'none';
             // If flipping to the opposite side after hiding at least once, the
            // animation will use the wrong placement without resetting the duration
            if (getIsDefaultRenderFn()) {
                var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
                setTransitionDuration([
                    box,
                    content
                ], 0);
            }
            onFirstUpdate = function onFirstUpdate() {
                var _instance$popperInsta2;
                if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
                ignoreOnFirstUpdate = true; // reflow
                popper.offsetHeight;
                popper.style.transition = instance.props.moveTransition;
                if (getIsDefaultRenderFn() && instance.props.animation) {
                    var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                    setTransitionDuration([
                        _box,
                        _content
                    ], duration);
                    setVisibilityState([
                        _box,
                        _content
                    ], 'visible');
                }
                handleAriaContentAttribute();
                handleAriaExpandedAttribute();
                pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
                // popper has been positioned for the first time
                (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
                invokeHook('onMount', [
                    instance
                ]);
                if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                    instance.state.isShown = true;
                    invokeHook('onShown', [
                        instance
                    ]);
                });
            };
            mount();
        }
        function hide() {
            warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
            var isAlreadyHidden = !instance.state.isVisible;
            var isDestroyed = instance.state.isDestroyed;
            var isDisabled = !instance.state.isEnabled;
            var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
            if (isAlreadyHidden || isDestroyed || isDisabled) return;
            invokeHook('onHide', [
                instance
            ], false);
            if (instance.props.onHide(instance) === false) return;
            instance.state.isVisible = false;
            instance.state.isShown = false;
            ignoreOnFirstUpdate = false;
            isVisibleFromClick = false;
            if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
            cleanupInteractiveMouseListeners();
            removeDocumentPress();
            handleStyles(true);
            if (getIsDefaultRenderFn()) {
                var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
                if (instance.props.animation) {
                    setTransitionDuration([
                        box,
                        content
                    ], duration);
                    setVisibilityState([
                        box,
                        content
                    ], 'hidden');
                }
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            if (instance.props.animation) {
                if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
            } else instance.unmount();
        }
        function hideWithInteractivity(event) {
            warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
            getDocument().addEventListener('mousemove', debouncedOnMouseMove);
            pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
            debouncedOnMouseMove(event);
        }
        function unmount() {
            warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
            if (instance.state.isVisible) instance.hide();
            if (!instance.state.isMounted) return;
            destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
            // tree by default. This seems mainly for interactive tippies, but we should
            // find a workaround if possible
            getNestedPopperTree().forEach(function(nestedPopper) {
                nestedPopper._tippy.unmount();
            });
            if (popper.parentNode) popper.parentNode.removeChild(popper);
            mountedInstances = mountedInstances.filter(function(i) {
                return i !== instance;
            });
            instance.state.isMounted = false;
            invokeHook('onHidden', [
                instance
            ]);
        }
        function destroy() {
            warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
            if (instance.state.isDestroyed) return;
            instance.clearDelayTimeouts();
            instance.unmount();
            removeListeners();
            delete reference._tippy;
            instance.state.isDestroyed = true;
            invokeHook('onDestroy', [
                instance
            ]);
        }
    }
    function tippy(targets, optionalProps) {
        if (optionalProps === void 0) optionalProps = {};
        var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
        validateTargets(targets);
        validateProps(optionalProps, plugins);
        bindGlobalEventListeners();
        var passedProps = Object.assign({}, optionalProps, {
            plugins: plugins
        });
        var elements = getArrayOfElements(targets);
        var isSingleContentElement = isElement(passedProps.content);
        var isMoreThanOneReferenceElement = elements.length > 1;
        warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, [
            'tippy() was passed an Element as the `content` prop, but more than',
            'one tippy instance was created by this invocation. This means the',
            'content element will only be appended to the last tippy instance.',
            '\n\n',
            'Instead, pass the .innerHTML of the element, or use a function that',
            'returns a cloned version of the element instead.',
            '\n\n',
            '1) content: element.innerHTML\n',
            '2) content: () => element.cloneNode(true)'
        ].join(' '));
        var instances = elements.reduce(function(acc, reference) {
            var instance = reference && createTippy(reference, passedProps);
            if (instance) acc.push(instance);
            return acc;
        }, []);
        return isElement(targets) ? instances[0] : instances;
    }
    tippy.defaultProps = defaultProps;
    tippy.setDefaultProps = setDefaultProps;
    tippy.currentInput = currentInput;
    var hideAll = function hideAll(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
        mountedInstances.forEach(function(instance) {
            var isExcluded = false;
            if (excludedReferenceOrInstance) isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
            if (!isExcluded) {
                var originalDuration = instance.props.duration;
                instance.setProps({
                    duration: duration
                });
                instance.hide();
                if (!instance.state.isDestroyed) instance.setProps({
                    duration: originalDuration
                });
            }
        });
    };
    // every time the popper is destroyed (i.e. a new target), removing the styles
    // and causing transitions to break for singletons when the console is open, but
    // most notably for non-transform styles being used, `gpuAcceleration: false`.
    var applyStylesModifier = Object.assign({}, core.applyStyles, {
        effect: function effect(_ref) {
            var state = _ref.state;
            var initialStyles = {
                popper: {
                    position: state.options.strategy,
                    left: '0',
                    top: '0',
                    margin: '0'
                },
                arrow: {
                    position: 'absolute'
                },
                reference: {}
            };
            Object.assign(state.elements.popper.style, initialStyles.popper);
            state.styles = initialStyles;
            if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
             // intentionally return no cleanup function
        // return () => { ... }
        }
    });
    var createSingleton = function createSingleton(tippyInstances, optionalProps) {
        var _optionalProps$popper;
        if (optionalProps === void 0) optionalProps = {};
        errorWhen(!Array.isArray(tippyInstances), [
            'The first argument passed to createSingleton() must be an array of',
            'tippy instances. The passed value was',
            String(tippyInstances)
        ].join(' '));
        var individualInstances = tippyInstances;
        var references = [];
        var triggerTargets = [];
        var currentTarget;
        var overrides = optionalProps.overrides;
        var interceptSetPropsCleanups = [];
        var shownOnCreate = false;
        function setTriggerTargets() {
            triggerTargets = individualInstances.map(function(instance) {
                return normalizeToArray(instance.props.triggerTarget || instance.reference);
            }).reduce(function(acc, item) {
                return acc.concat(item);
            }, []);
        }
        function setReferences() {
            references = individualInstances.map(function(instance) {
                return instance.reference;
            });
        }
        function enableInstances(isEnabled) {
            individualInstances.forEach(function(instance) {
                if (isEnabled) instance.enable();
                else instance.disable();
            });
        }
        function interceptSetProps(singleton) {
            return individualInstances.map(function(instance) {
                var originalSetProps = instance.setProps;
                instance.setProps = function(props) {
                    originalSetProps(props);
                    if (instance.reference === currentTarget) singleton.setProps(props);
                };
                return function() {
                    instance.setProps = originalSetProps;
                };
            });
        } // have to pass singleton, as it maybe undefined on first call
        function prepareInstance(singleton, target) {
            var index = triggerTargets.indexOf(target); // bail-out
            if (target === currentTarget) return;
            currentTarget = target;
            var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
                acc[prop] = individualInstances[index].props[prop];
                return acc;
            }, {});
            singleton.setProps(Object.assign({}, overrideProps, {
                getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                    var _references$index;
                    return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
                }
            }));
        }
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        var plugin = {
            fn: function fn() {
                return {
                    onDestroy: function onDestroy() {
                        enableInstances(true);
                    },
                    onHidden: function onHidden() {
                        currentTarget = null;
                    },
                    onClickOutside: function onClickOutside(instance) {
                        if (instance.props.showOnCreate && !shownOnCreate) {
                            shownOnCreate = true;
                            currentTarget = null;
                        }
                    },
                    onShow: function onShow(instance) {
                        if (instance.props.showOnCreate && !shownOnCreate) {
                            shownOnCreate = true;
                            prepareInstance(instance, references[0]);
                        }
                    },
                    onTrigger: function onTrigger(instance, event) {
                        prepareInstance(instance, event.currentTarget);
                    }
                };
            }
        };
        var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, [
            'overrides'
        ]), {
            plugins: [
                plugin
            ].concat(optionalProps.plugins || []),
            triggerTarget: triggerTargets,
            popperOptions: Object.assign({}, optionalProps.popperOptions, {
                modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                    applyStylesModifier
                ])
            })
        }));
        var originalShow = singleton.show;
        singleton.show = function(target) {
            originalShow(); // first time, showOnCreate or programmatic call with no params
            // default to showing first instance
            if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
             // triggered from event (do nothing as prepareInstance already called by onTrigger)
            // programmatic call with no params when already visible (do nothing again)
            if (currentTarget && target == null) return;
             // target is index of instance
            if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
             // target is a child tippy instance
            if (individualInstances.indexOf(target) >= 0) {
                var ref = target.reference;
                return prepareInstance(singleton, ref);
            } // target is a ReferenceElement
            if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
        };
        singleton.showNext = function() {
            var first = references[0];
            if (!currentTarget) return singleton.show(0);
            var index = references.indexOf(currentTarget);
            singleton.show(references[index + 1] || first);
        };
        singleton.showPrevious = function() {
            var last = references[references.length - 1];
            if (!currentTarget) return singleton.show(last);
            var index = references.indexOf(currentTarget);
            var target = references[index - 1] || last;
            singleton.show(target);
        };
        var originalSetProps = singleton.setProps;
        singleton.setProps = function(props) {
            overrides = props.overrides || overrides;
            originalSetProps(props);
        };
        singleton.setInstances = function(nextInstances) {
            enableInstances(true);
            interceptSetPropsCleanups.forEach(function(fn) {
                return fn();
            });
            individualInstances = nextInstances;
            enableInstances(false);
            setReferences();
            setTriggerTargets();
            interceptSetPropsCleanups = interceptSetProps(singleton);
            singleton.setProps({
                triggerTarget: triggerTargets
            });
        };
        interceptSetPropsCleanups = interceptSetProps(singleton);
        return singleton;
    };
    var BUBBLING_EVENTS_MAP = {
        mouseover: 'mouseenter',
        focusin: 'focus',
        click: 'click'
    };
    /**
     * Creates a delegate instance that controls the creation of tippy instances
     * for child elements (`target` CSS selector).
     */ function delegate(targets, props) {
        errorWhen(!(props && props.target), [
            'You must specity a `target` prop indicating a CSS selector string matching',
            'the target elements that should receive a tippy.'
        ].join(' '));
        var listeners = [];
        var childTippyInstances = [];
        var disabled = false;
        var target = props.target;
        var nativeProps = removeProperties(props, [
            'target'
        ]);
        var parentProps = Object.assign({}, nativeProps, {
            trigger: 'manual',
            touch: false
        });
        var childProps = Object.assign({
            touch: defaultProps.touch
        }, nativeProps, {
            showOnCreate: true
        });
        var returnValue = tippy(targets, parentProps);
        var normalizedReturnValue = normalizeToArray(returnValue);
        function onTrigger(event) {
            if (!event.target || disabled) return;
            var targetNode = event.target.closest(target);
            if (!targetNode) return;
             // Get relevant trigger with fallbacks:
            // 1. Check `data-tippy-trigger` attribute on target node
            // 2. Fallback to `trigger` passed to `delegate()`
            // 3. Fallback to `defaultProps.trigger`
            var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore
            if (targetNode._tippy) return;
            if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
            if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) return;
            var instance = tippy(targetNode, childProps);
            if (instance) childTippyInstances = childTippyInstances.concat(instance);
        }
        function on(node, eventType, handler, options) {
            if (options === void 0) options = false;
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        }
        function addEventListeners(instance) {
            var reference = instance.reference;
            on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
            on(reference, 'mouseover', onTrigger);
            on(reference, 'focusin', onTrigger);
            on(reference, 'click', onTrigger);
        }
        function removeEventListeners() {
            listeners.forEach(function(_ref) {
                var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
                node.removeEventListener(eventType, handler, options);
            });
            listeners = [];
        }
        function applyMutations(instance) {
            var originalDestroy = instance.destroy;
            var originalEnable = instance.enable;
            var originalDisable = instance.disable;
            instance.destroy = function(shouldDestroyChildInstances) {
                if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
                if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                    instance.destroy();
                });
                childTippyInstances = [];
                removeEventListeners();
                originalDestroy();
            };
            instance.enable = function() {
                originalEnable();
                childTippyInstances.forEach(function(instance) {
                    return instance.enable();
                });
                disabled = false;
            };
            instance.disable = function() {
                originalDisable();
                childTippyInstances.forEach(function(instance) {
                    return instance.disable();
                });
                disabled = true;
            };
            addEventListeners(instance);
        }
        normalizedReturnValue.forEach(applyMutations);
        return returnValue;
    }
    var animateFill = {
        name: 'animateFill',
        defaultValue: false,
        fn: function fn(instance) {
            var _instance$props$rende;
            // @ts-ignore
            if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
                errorWhen(instance.props.animateFill, 'The `animateFill` plugin requires the default render function.');
                return {};
            }
            var _getChildren = getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
            var backdrop = instance.props.animateFill ? createBackdropElement() : null;
            return {
                onCreate: function onCreate() {
                    if (backdrop) {
                        box.insertBefore(backdrop, box.firstElementChild);
                        box.setAttribute('data-animatefill', '');
                        box.style.overflow = 'hidden';
                        instance.setProps({
                            arrow: false,
                            animation: 'shift-away'
                        });
                    }
                },
                onMount: function onMount() {
                    if (backdrop) {
                        var transitionDuration = box.style.transitionDuration;
                        var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                        // tooltip element. `clip-path` is the other alternative but is not
                        // well-supported and is buggy on some devices.
                        content.style.transitionDelay = Math.round(duration / 10) + "ms";
                        backdrop.style.transitionDuration = transitionDuration;
                        setVisibilityState([
                            backdrop
                        ], 'visible');
                    }
                },
                onShow: function onShow() {
                    if (backdrop) backdrop.style.transitionDuration = '0ms';
                },
                onHide: function onHide() {
                    if (backdrop) setVisibilityState([
                        backdrop
                    ], 'hidden');
                }
            };
        }
    };
    function createBackdropElement() {
        var backdrop = div();
        backdrop.className = BACKDROP_CLASS;
        setVisibilityState([
            backdrop
        ], 'hidden');
        return backdrop;
    }
    var mouseCoords = {
        clientX: 0,
        clientY: 0
    };
    var activeInstances = [];
    function storeMouseCoords(_ref) {
        var clientX = _ref.clientX, clientY = _ref.clientY;
        mouseCoords = {
            clientX: clientX,
            clientY: clientY
        };
    }
    function addMouseCoordsListener(doc) {
        doc.addEventListener('mousemove', storeMouseCoords);
    }
    function removeMouseCoordsListener(doc) {
        doc.removeEventListener('mousemove', storeMouseCoords);
    }
    var followCursor = {
        name: 'followCursor',
        defaultValue: false,
        fn: function fn(instance) {
            var reference = instance.reference;
            var doc = getOwnerDocument(instance.props.triggerTarget || reference);
            var isInternalUpdate = false;
            var wasFocusEvent = false;
            var isUnmounted = true;
            var prevProps = instance.props;
            function getIsInitialBehavior() {
                return instance.props.followCursor === 'initial' && instance.state.isVisible;
            }
            function addListener() {
                doc.addEventListener('mousemove', onMouseMove);
            }
            function removeListener() {
                doc.removeEventListener('mousemove', onMouseMove);
            }
            function unsetGetReferenceClientRect() {
                isInternalUpdate = true;
                instance.setProps({
                    getReferenceClientRect: null
                });
                isInternalUpdate = false;
            }
            function onMouseMove(event) {
                // If the instance is interactive, avoid updating the position unless it's
                // over the reference element
                var isCursorOverReference = event.target ? reference.contains(event.target) : true;
                var followCursor = instance.props.followCursor;
                var clientX = event.clientX, clientY = event.clientY;
                var rect = reference.getBoundingClientRect();
                var relativeX = clientX - rect.left;
                var relativeY = clientY - rect.top;
                if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                    // @ts-ignore - unneeded DOMRect properties
                    getReferenceClientRect: function getReferenceClientRect() {
                        var rect = reference.getBoundingClientRect();
                        var x = clientX;
                        var y = clientY;
                        if (followCursor === 'initial') {
                            x = rect.left + relativeX;
                            y = rect.top + relativeY;
                        }
                        var top = followCursor === 'horizontal' ? rect.top : y;
                        var right = followCursor === 'vertical' ? rect.right : x;
                        var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                        var left = followCursor === 'vertical' ? rect.left : x;
                        return {
                            width: right - left,
                            height: bottom - top,
                            top: top,
                            right: right,
                            bottom: bottom,
                            left: left
                        };
                    }
                });
            }
            function create() {
                if (instance.props.followCursor) {
                    activeInstances.push({
                        instance: instance,
                        doc: doc
                    });
                    addMouseCoordsListener(doc);
                }
            }
            function destroy() {
                activeInstances = activeInstances.filter(function(data) {
                    return data.instance !== instance;
                });
                if (activeInstances.filter(function(data) {
                    return data.doc === doc;
                }).length === 0) removeMouseCoordsListener(doc);
            }
            return {
                onCreate: create,
                onDestroy: destroy,
                onBeforeUpdate: function onBeforeUpdate() {
                    prevProps = instance.props;
                },
                onAfterUpdate: function onAfterUpdate(_, _ref2) {
                    var followCursor = _ref2.followCursor;
                    if (isInternalUpdate) return;
                    if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                        destroy();
                        if (followCursor) {
                            create();
                            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                        } else {
                            removeListener();
                            unsetGetReferenceClientRect();
                        }
                    }
                },
                onMount: function onMount() {
                    if (instance.props.followCursor && !wasFocusEvent) {
                        if (isUnmounted) {
                            onMouseMove(mouseCoords);
                            isUnmounted = false;
                        }
                        if (!getIsInitialBehavior()) addListener();
                    }
                },
                onTrigger: function onTrigger(_, event) {
                    if (isMouseEvent(event)) mouseCoords = {
                        clientX: event.clientX,
                        clientY: event.clientY
                    };
                    wasFocusEvent = event.type === 'focus';
                },
                onHidden: function onHidden() {
                    if (instance.props.followCursor) {
                        unsetGetReferenceClientRect();
                        removeListener();
                        isUnmounted = true;
                    }
                }
            };
        }
    };
    function getProps(props, modifier) {
        var _props$popperOptions;
        return {
            popperOptions: Object.assign({}, props.popperOptions, {
                modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                    var name = _ref.name;
                    return name !== modifier.name;
                }), [
                    modifier
                ])
            })
        };
    }
    var inlinePositioning = {
        name: 'inlinePositioning',
        defaultValue: false,
        fn: function fn(instance) {
            var reference = instance.reference;
            function isEnabled() {
                return !!instance.props.inlinePositioning;
            }
            var placement;
            var cursorRectIndex = -1;
            var isInternalUpdate = false;
            var triedPlacements = [];
            var modifier = {
                name: 'tippyInlinePositioning',
                enabled: true,
                phase: 'afterWrite',
                fn: function fn(_ref2) {
                    var state = _ref2.state;
                    if (isEnabled()) {
                        if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                        if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                            triedPlacements.push(state.placement);
                            instance.setProps({
                                // @ts-ignore - unneeded DOMRect properties
                                getReferenceClientRect: function getReferenceClientRect() {
                                    return _getReferenceClientRect(state.placement);
                                }
                            });
                        }
                        placement = state.placement;
                    }
                }
            };
            function _getReferenceClientRect(placement) {
                return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
            }
            function setInternalProps(partialProps) {
                isInternalUpdate = true;
                instance.setProps(partialProps);
                isInternalUpdate = false;
            }
            function addModifier() {
                if (!isInternalUpdate) setInternalProps(getProps(instance.props, modifier));
            }
            return {
                onCreate: addModifier,
                onAfterUpdate: addModifier,
                onTrigger: function onTrigger(_, event) {
                    if (isMouseEvent(event)) {
                        var rects = arrayFrom(instance.reference.getClientRects());
                        var cursorRect = rects.find(function(rect) {
                            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                        });
                        var index = rects.indexOf(cursorRect);
                        cursorRectIndex = index > -1 ? index : cursorRectIndex;
                    }
                },
                onHidden: function onHidden() {
                    cursorRectIndex = -1;
                }
            };
        }
    };
    function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
        // Not an inline element, or placement is not yet known
        if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
         // There are two rects and they are disjoined
        if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
        switch(currentBasePlacement){
            case 'top':
            case 'bottom':
                var firstRect = clientRects[0];
                var lastRect = clientRects[clientRects.length - 1];
                var isTop = currentBasePlacement === 'top';
                var top = firstRect.top;
                var bottom = lastRect.bottom;
                var left = isTop ? firstRect.left : lastRect.left;
                var right = isTop ? firstRect.right : lastRect.right;
                var width = right - left;
                var height = bottom - top;
                return {
                    top: top,
                    bottom: bottom,
                    left: left,
                    right: right,
                    width: width,
                    height: height
                };
            case 'left':
            case 'right':
                var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                    return rects.left;
                }));
                var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                    return rects.right;
                }));
                var measureRects = clientRects.filter(function(rect) {
                    return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
                });
                var _top = measureRects[0].top;
                var _bottom = measureRects[measureRects.length - 1].bottom;
                var _left = minLeft;
                var _right = maxRight;
                var _width = _right - _left;
                var _height = _bottom - _top;
                return {
                    top: _top,
                    bottom: _bottom,
                    left: _left,
                    right: _right,
                    width: _width,
                    height: _height
                };
            default:
                return boundingRect;
        }
    }
    var sticky = {
        name: 'sticky',
        defaultValue: false,
        fn: function fn(instance) {
            var reference = instance.reference, popper = instance.popper;
            function getReference() {
                return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
            }
            function shouldCheck(value) {
                return instance.props.sticky === true || instance.props.sticky === value;
            }
            var prevRefRect = null;
            var prevPopRect = null;
            function updatePosition() {
                var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
                var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
                if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
                    if (instance.popperInstance) instance.popperInstance.update();
                }
                prevRefRect = currentRefRect;
                prevPopRect = currentPopRect;
                if (instance.state.isMounted) requestAnimationFrame(updatePosition);
            }
            return {
                onMount: function onMount() {
                    if (instance.props.sticky) updatePosition();
                }
            };
        }
    };
    function areRectsDifferent(rectA, rectB) {
        if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
        return true;
    }
    if (isBrowser) injectCSS(css);
    tippy.setDefaultProps({
        plugins: [
            animateFill,
            followCursor,
            inlinePositioning,
            sticky
        ],
        render: render
    });
    tippy.createSingleton = createSingleton;
    tippy.delegate = delegate;
    tippy.hideAll = hideAll;
    tippy.roundArrow = ROUND_ARROW;
    return tippy;
}); //# sourceMappingURL=tippy-bundle.umd.js.map


const $92f7906bf0da4162$var$OpaccPopperTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($d7b475bad30c107b$exports)));
var $92f7906bf0da4162$export$2e2bcd8739ae039 = $92f7906bf0da4162$var$OpaccPopperTooltip;


class $c3685846905adb5e$export$1e6549682565ecb5 {
    constructor(){
        this.initAll();
    }
    initAll() {
        let tooltips = document.querySelectorAll('[data-op-tooltip]');
        this.init(tooltips);
    }
    initSpecified(parentElem) {
        let tooltips = parentElem.querySelectorAll('[data-op-tooltip]');
        this.init(tooltips);
    }
    init(tooltips) {
        if (tooltips.length > 0) Array.from(tooltips).forEach((item)=>{
            (0, $92f7906bf0da4162$export$2e2bcd8739ae039)(item, {
                content: this.fixTitle(item).getAttribute('data-op-original-title'),
                allowHTML: item.dataset.opTooltipHtml && item.dataset.opTooltipHtml == '1' ? true : false,
                placement: item.dataset.opTooltipPlacement ? item.dataset.opTooltipPlacement : 'top',
                delay: item.dataset.opTooltipDelay ? this.JsonStringToObj(item.dataset.opTooltipDelay) : 0
            });
        });
    }
    /**
	 *
	 *
	 * @param {*} string
	 * @returns {*}
	 */ JsonStringToObj(string) {
        let fixedJSON = string.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2": ');
        return JSON.parse(fixedJSON);
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */ fixTitle(item) {
        const titleType = typeof item.getAttribute('data-op-original-title');
        const itemTitle = item.getAttribute('title');
        if (itemTitle || titleType !== 'string') {
            if (itemTitle.trim().length > 0) {
                item.setAttribute('data-op-original-title', itemTitle || '');
                item.setAttribute('title', '');
            }
        }
        return item;
    }
    /**
	 * Initialisierung der Tooltips
	 *
	 * @param {HTMLElement} item HTML-Element, auf dem das Tooltip angezeigt werden soll
	 * @param {Object} options Objekt um die Tooltips individuell zu platzieren / formatieren
	 */ initializeTooltips(item, options) {
        new (0, $92f7906bf0da4162$export$2e2bcd8739ae039)(item, options);
    }
}


const $677dd339ba58b734$export$15f64486a5ca2f4f = new (0, $4d6a4d6c23b55b04$export$495fdb200dc0cd20)();
const $677dd339ba58b734$export$bf510be1d005fffb = new (0, $72506f89da967ee9$export$688fce325da0304b)();
const $677dd339ba58b734$export$e9c2ea70f59f909b = new (0, $e5931a5b99ee1cd6$export$402a94333c65a191)();
const $677dd339ba58b734$export$b128b15d50b9bc9e = new (0, $c3685846905adb5e$export$1e6549682565ecb5)();



class $9d66158e28ec0cad$export$e2fadb1945b7ba3a {
    constructor(){
        this.wrapperElement = document.querySelector('.content');
        this.parentElem = '.opc-navigation';
        this.qrySelector = 'data-op-navtype';
        this.SidebarNavDataSetSelector = 'progressive-descloser-sidebar';
        this.navLevelElement = 'li';
        this.qrySelectorValue = 'click';
        this.templateName = 'opc-navigation-burgerlist';
        this.navSelector = document.querySelectorAll(`${this.parentElem}[${this.qrySelector}]`);
        this.offCanvasWrapper = document.querySelector('.offcanvas-menu-wrapper');
        this.segmentNavigationWrapper = this.wrapperElement.querySelector('.opc-segment-navigation');
        this.offCanvasNaviElement = document.querySelectorAll('.offcanvas-menu-trigger');
        this.showAllCategoriesButtons = this.wrapperElement.querySelectorAll('.opc-category-navigation .show-all-categories');
        this.sideBarNavigation = document.querySelector(`${this.parentElem}[${this.qrySelector}="${this.SidebarNavDataSetSelector}"]`);
        this.buttonElementSelector = '.opc-segment-navigation .opc-button[data-op-href]';
        this.isMobile = document.querySelector('html.is-mobile');
        this.mainWrapper = document.querySelector('.main-wrapper');
        this.asyncRequestIsRunning = false;
        // Sticky header
        this.allStickyElems = document.querySelectorAll('[data-op-sticky="true"]');
        // evaluate current Nav-Id
        this.currentSidebarNavElem = document.querySelector('#is-active-sidebar-nav');
        this.attachEventListener();
    }
    /**
     * Event Registrierungen im DOM
     */ attachEventListener() {
        if (this.allStickyElems.length > 0) this.stickyElementNavigation();
        if (this.segmentNavigationWrapper) {
            (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).init('persistentView');
            // check if view must be loaded from SessionStorage
            if (window.location.search.indexOf('take=') > 0) (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).get('persistentView', (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).getCurrentURI());
            this.firePseudoChangeEvent();
            this.segmentNavigationLoader();
        }
        if ([
            ...this.offCanvasNaviElement,
            ...this.showAllCategoriesButtons
        ].length > 0) this.offCanvasNavigationListener();
        if (this.navSelector.length > 0) this.addBinding();
    }
    addBinding() {
        document.addEventListener('click', (e)=>{
            let elem = e.target;
            if (!elem.closest(`${this.parentElem}[${this.qrySelector}]`)) return;
            if (this.offCanvasWrapper && elem.closest(`.${this.offCanvasWrapper.className}`)) {
                if (elem.closest('.navigation-toggler')) {
                    let liNaviElement = elem.closest(this.navLevelElement);
                    if (liNaviElement.classList.contains('is-open')) this.toggleIsOpenCssClass(liNaviElement);
                    else this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
                }
            } else if (this.sideBarNavigation && this.isMobile) this.getSidebarNavElems(e);
            else {
                let liNaviElement = elem.closest(this.navLevelElement);
                if (liNaviElement) {
                    if (liNaviElement.classList.contains('is-open')) this.toggleIsOpenCssClass(liNaviElement);
                    else {
                        let navLayout = elem.closest('[data-op-layout]');
                        if (navLayout && navLayout.dataset.opLayout === 'arrow') {
                            if (elem.closest('.navigation-toggler')) this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
                            else this.closeSubNavigation(liNaviElement.parentElement.children);
                        } else this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
                    }
                }
            }
        }, false);
    }
    /**
     *
     *
     */ offCanvasNavigationListener() {
        [
            ...this.offCanvasNaviElement,
            ...this.showAllCategoriesButtons
        ].forEach((navElem)=>{
            navElem.addEventListener('click', ()=>{
                this.toggleOffCanvasNavigation();
            });
        });
        if (this.offCanvasWrapper) this.offCanvasWrapper.addEventListener('click', (e)=>{
            let closeOffCanvasButton = e.target.closest('.offcanvas-menu-close');
            if (closeOffCanvasButton) this.toggleOffCanvasNavigation();
        });
    }
    /**
     *
     *
     */ toggleOffCanvasNavigation() {
        let rootElement = document.querySelector('html');
        let setCssClass = 'offcanvas-menu-open';
        if (this.sideBarNavigation && this.isMobile) setCssClass = 'sidebar-menu-open';
        rootElement.classList.toggle(setCssClass);
        // nur ausführen beim öffnen der Navigation
        if (!rootElement.classList.contains(setCssClass) && this.currentSidebarNavElem) {
            let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
            let data = {
                type: 'navigation',
                navigationid: this.currentSidebarNavElem.dataset.opNavId,
                template: this.templateName
            };
            let currNav = document.querySelector(`${this.parentElem}[${this.qrySelector}="${this.SidebarNavDataSetSelector}"]`);
            if (!this.asyncRequestIsRunning) {
                (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, data, this.getNextNavLevel.bind(this, document.querySelector('#is-active-sidebar-nav') || currNav), this.getDefaultErrorFnc, true);
                this.asyncRequestIsRunning = true;
            }
        }
        [
            ...this.offCanvasNaviElement
        ].forEach((elem)=>elem.classList.toggle('is-active'));
    }
    /**
     *
     *
     */ stickyElementNavigation() {
        [
            ...this.allStickyElems
        ].forEach((item)=>{
            const optionsobj = {
                lastScrollTop: 0,
                delta: 5,
                height: item.offsetHeight
            };
            if (item.dataset.opStickyDirection) optionsobj.stickyDirection = item.dataset.opStickyDirection || 'all';
            this.stickyElementListener(item, optionsobj);
        });
    }
    /**
     *
     *
     * @param {*} elem
     * @param {*} options
     */ stickyElementListener(elem, options) {
        let didScroll;
        window.addEventListener('scroll', ()=>{
            didScroll = true;
            // run hasScrolled() and reset didScroll status
            setInterval(()=>{
                if (didScroll) {
                    this.hasScrolled(elem, options);
                    didScroll = false;
                }
            }, 250);
        });
    }
    /**
     *
     *
     * @param {*} elem
     * @param {*} options
     * @returns {boolean}
     */ hasScrolled(elem, options) {
        let pageOffset = window.pageYOffset;
        // Make sure they scroll more than delta
        if (Math.abs(options.lastScrollTop - pageOffset) <= options.delta) return;
        if (options.stickyDirection === 'all') this.scrollToActiveState(elem);
        else if (options.stickyDirection === 'down') {
            if (pageOffset + window.innerHeight < document.body.offsetHeight) // Scroll down
            this.scrollToActiveState(elem);
            else if (pageOffset > options.lastScrollTop && pageOffset > options.height) // Scroll up
            this.scrollToInactiveState(elem);
        } else if (options.stickyDirection === 'up') {
            if (pageOffset > options.lastScrollTop && pageOffset > options.height) // Scroll down
            this.scrollToInactiveState(elem);
            else if (pageOffset + window.innerHeight < document.body.offsetHeight) this.scrollToActiveState(elem);
        }
        options.lastScrollTop = pageOffset;
    }
    /**
     *
     *
     * @param {*} elem
     */ scrollToActiveState(elem) {
        elem.classList.remove('sticky-inactive');
        elem.classList.add('sticky-active');
    }
    /**
     *
     *
     * @param {*} elem
     */ scrollToInactiveState(elem) {
        let isNav = elem.querySelector(this.parentElem);
        if (isNav) this.closeSubNavigation(isNav.querySelector(this.navLevelElement).parentElement.children);
        elem.classList.remove('sticky-active');
        elem.classList.add('sticky-inactive');
    }
    /**
     *
     *
     * @param {*} navList
     * @param {*} [elem=null]
     */ closeSubNavigation(navList, elem = null) {
        for (let item of [
            ...navList
        ])item.classList.remove('is-open');
        if (elem) elem.classList.add('is-open');
    }
    /**
     *
     *
     * @param {*} elem
     */ toggleIsOpenCssClass(elem) {
        elem.classList.toggle('is-open');
    }
    /**
     *
     *
     */ segmentNavigationLoader() {
        this.wrapperElement.addEventListener('click', (e)=>{
            let buttonElement = e.target.closest(this.buttonElementSelector);
            if (!buttonElement) return;
            (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).clear('persistentView');
            buttonElement.classList.add('is-progress');
            (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynGetForm(buttonElement.dataset.opHref, this.appendDataToResultList.bind(this, buttonElement), this.getDefaultErrorFnc, true);
        });
    }
    /**
     *
     *
     * @param {*} e
     */ getSidebarNavElems(e) {
        let navCrumbs = e.target.closest('.crumbs');
        let navLevelBackBtn = null;
        if (navCrumbs) navLevelBackBtn = navCrumbs.lastElementChild.querySelector('.is-active-crumb');
        if (!e.target.closest('li.has-children') && !navLevelBackBtn) return;
        e.preventDefault();
        let navHref = e.target.href;
        if (!navHref) return;
        let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
        let data = {
            type: 'navigation',
            navigationid: e.target.dataset.opNavId,
            template: this.templateName
        };
        this.mainWrapper.style.pointerEvents = 'none';
        if (!this.asyncRequestIsRunning) {
            (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, data, this.getNextNavLevel.bind(this, e.target), this.getDefaultErrorFnc, true);
            this.asyncRequestIsRunning = true;
        }
    }
    /**
     *
     *
     * @param {*} response
     */ async getNextNavLevel(targetElem, response) {
        this.asyncRequestIsRunning = false;
        this.mainWrapper.style.pointerEvents = 'auto';
        let navElem = await targetElem.closest(`${this.parentElem}[data-op-asynctemplate="${this.templateName}"]`);
        if (!navElem) return;
        navElem.outerHTML = await response.dataAsJson.showItems;
        navElem.addEventListener('click', (e)=>{
            this.getSidebarNavElems(e);
        });
    }
    /**
     *
     *
     * @param {*} buttonElement
     * @param {*} response
     */ appendDataToResultList(buttonElement, response) {
        let targetSelector = buttonElement.parentElement.dataset.opTarget || '#result-list';
        buttonElement.classList.remove('is-progress');
        let htmlObj = document.createElement('div');
        let listChildren = document.createDocumentFragment();
        htmlObj.innerHTML = response.dataAsHtml;
        Array.from(htmlObj.querySelector(targetSelector).children).forEach((item)=>{
            listChildren.append(item);
        });
        let buttonElementSelector = `.opc-segment-navigation[data-op-target="${targetSelector}"] .opc-button[data-op-href]`;
        let moreButton = htmlObj.querySelector(buttonElementSelector);
        if (moreButton) buttonElement.dataset.opHref = moreButton.dataset.opHref;
        if (buttonElement.dataset.opHref === 'javascript:void(0);') buttonElement.classList.add('is-hidden');
        document.querySelector(targetSelector).appendChild(listChildren);
        this.firePseudoChangeEvent();
        let resultWrapperSelector = '.result-view-wrapper';
        const resultWrapperElem = this.getParentElement(buttonElement, resultWrapperSelector);
        resultWrapperSelector = resultWrapperElem && resultWrapperElem.hasAttribute('id') ? `#${resultWrapperElem.id}` : resultWrapperSelector;
        if (document.querySelector(resultWrapperSelector)) {
            this.modifyHistory(targetSelector);
            (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).set('persistentView', (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).getCurrentURI(), resultWrapperSelector, buttonElementSelector);
        }
    }
    getParentElement(element, targetSelector) {
        if (!element.parentElement) return null;
        const parent = element.parentElement.querySelector(targetSelector);
        if (!parent) return this.getParentElement(element.parentElement, targetSelector);
        return parent;
    }
    /**
     * Change-Event triggern, um asynchrone Change-Operationen auszuführen
     * @private
     * @ignore
     */ firePseudoChangeEvent() {
        let triggerEvent = new Event('change');
        document.querySelector('.content').dispatchEvent(triggerEvent);
    }
    /**
     *
     *
     * @param {*} selector
     */ modifyHistory(selector) {
        let stateData = document.querySelector(selector).childElementCount;
        let urlParams = window.location.search.substring(1);
        if (urlParams.length === 0) urlParams = 'take=async';
        else if (urlParams.indexOf('take=') == -1) urlParams += '&take=async';
        history.replaceState({
            itemCount: stateData
        }, 'newResult', `${window.location.pathname}?${urlParams}`);
    }
}


const $770afa34674dfea4$export$640aece78df7de67 = new (0, $9d66158e28ec0cad$export$e2fadb1945b7ba3a)();



var $965620ceadb636fe$import_meta = Object.assign(Object.create(null), {
    url: "file:///webportal/config/layout/themes/project/js/src/vendor/script/classes/opacc.class.staticcontent.js"
});

class $965620ceadb636fe$export$4b7bf84774185018 {
    constructor(){
        this.viewportContainer = document.querySelector('.viewport');
        this.requestData = {};
        this.attachEventListener();
    }
    /**
	 *
	 *
	 */ attachEventListener() {
        if (this.viewportContainer) this.viewportContainer.addEventListener('click', (event)=>{
            let button = event.target.closest('button.opc-button[data-op-target="#opc-static-content-editor"]');
            if (button) this.sendAjaxRequest(button);
        });
    }
    /**
	 *
	 *
	 * @param {*} item
	 */ sendAjaxRequest(item) {
        this.requestData = {
            type: 'staticcontent',
            boid: item.dataset.opBoid,
            bonumber: item.dataset.opBonumber,
            arttextno: item.dataset.opArttextno,
            langno: item.dataset.opLangno,
            per: item.dataset.opPer,
            template: item.dataset.opAsynctemplate,
            modalid: item.dataset.opTarget
        };
        if (item.dataset.opBo !== undefined) this.requestData.bo = item.dataset.opBo;
        if (item.dataset.opAttr !== undefined) this.requestData.attr = item.dataset.opAttr;
        if (item.dataset.opId !== undefined) this.requestData.id = item.dataset.opId;
        let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl(true);
        (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, this.requestData, this.showContentInEditMode.bind(this), this.getDefaultErrorFnc, true);
    }
    /**
	 *
	 *
	 * @param {*} response
	 */ async showContentInEditMode(response) {
        if (response.success) {
            (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showModal('<img style="display:block;margin:auto" src="data:image/gif;base64,R0lGODlhIAAZALMAAKyqrNTS1Ly6vOzq7LSytOTi5MTCxKyurNTW1Ly+vPT29LS2tP///wAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQJCQAMACwAAAAAIAAZAAAExJDJSau9OOvNu/9geB0AeRjSUK6IhJjlICUwmQh3kh45EUiBBU5wkDFuQwAAudAxBjzc4scI4mhG5E2Z6OJ2Par1RjAKmjilYOiEDqdA4a04Y3NvTTDOFx/Sj2gJalp6CXBVcgkEBXVJS1JtUYpickRZa1uPOYV8iH6Xjjl5T5KHY4pmgVxsnJSfdTmrhpFhfXNZqppfpKKuXYuNmQcEBDwpAMTFYsPEAFnJJAjS0owMCtPSRgPYCAoSBdwi4uPk5ebnHREAIfkECQkAFAAsAAAAACAAGQCEBAIErKqs1NLUNDY0vLq8DA4M7OrstLK0DAoM5OLkREZExMLEBAYErK6s1NbUPD48vL68FBIU9Pb0tLa0////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABesgEBXjQ51oqq4qo7yPyc40hbxKXO/qDcs8nusXDPpyMkMjsGw4Tg6m1HCCNJqBY+6kJEAIE8FJMPESGlTK1xwYIrkHc3hchljTa3sWp6MYAl8QB2IUZGYHaWCBe0R+cV5zhXVneGYQjG9+gF6DdGZoVROLbn0Gj4KEhnYHCVUEbEelmxCRqpSusHxJp52Sn5W5jX+BvaqCiaJebbpwr7Spk6BqlpiyxNC/oYuxu87FdYKt08GZfwfnDakN5wcBeOxLpDISAg72DmkG9/YSJwn7DrgV4SFwYI2CBmcwiKFgAJCEKwBIlPgQYooQACH5BAkJAB8ALAAAAAAgABkAhAQCBHx+fDw6PLy+vFxeXBwaHKyqrOTi5BQSFGxqbLS2tERGRNTS1AwKDGRmZCQmJLSytPT29AQGBISGhDw+PMTCxGRiZKyurOzq7BQWFGxubLy6vExKTNTW1CwuLP///wX+YCWKzPcNEqI2gem+sCtw9OKYVbHsXhv/LopmmLiddDwf8CccOhKmAZLTWwKbmmIUuahaY1jtccFZPHydi0F9wUTZBkPYWMnsuj6GYjPYtKMbfANyQ1lGUndeeoIQB4B8G4REdFyKe31/J4F9koYmG5V5lxsQbh8bCn2DYVBjSSaLmKaqfJ1iiK8fDIF8pVGptayfobAQqpl9kLaHxLqjyMCrhQmtoImikL6aynNb17DPprycwqfNsaSz0cveububyJuR5dbuFxD4BrP3EGrdrnhMYOhAkGAEEwcKEqTX7MuLf7gCOnxILYEFOhnKSJxogoAFAiAnDBNAwYwSjkAIBgBYufLkxBAAIfkECQkAIQAsAAAAACAAGQCFBAIEhIKEREJExMLEpKKkbGpsJCYk5OLkVFZUtLK0FBIUzM7MDAoMnJqcTEpMrKqsfH58PD48/Pr8XF5cvLq8BAYEhIaEREZEzMrMbG5sLCos7O7sXFpcHBoc1NbUrK6svL68////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABv7AkHAo3AyOx4MQwlA4KyAiUUKtChcRh/bSWGou4E5UKgxYzBaCEOPIuBHdEOQbHpMtD0JeHVq03RxxcxcOF2JkQngPe2t/GYFeYIZ2Unh6BHx+bo+CX4WHIQMPH6MPipiZF5uQcnQOoCAUFLGmi4x9jqyDDgKwsiAgtZeZuZ2SvrMUtXvEq8afY7HJy6hXqoDGdULStKeYV8WR0Nu/wYq3mtiR2iHcypbo4a2Fr9G/74vVfdec673207w1U9eK0CRys8zl+4bL2bqD7e4ti+dwHjt3wigSHEQI1ocECUgJtFZx1z8hBzyoVDmy4UY6EO80mNlgYD+LMaWUo4DBWiGBn7pcgUKEyMOEoxM4fFhiQECECEOJSpUSAIBVq5SIBAEAIfkECQkAIgAsAAAAACAAGQCFBAIEhIaExMbEPD48rKqsXFpc7O7snJqcTE5MNDY01NbUvLq8DA4MjI6MREZEbGpstLK0/Pr83N7cDAoMjIqMzM7MREJErK6sXF5cnJ6cVFZUxMLEFBIUlJKUTEpMbG5s/P785OLk////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABv5AkXBILApDm2TSIBxwGBwOwCgERa5Y4WGA8DgGlebAQZ5QRZKAWr0QZjSfOCIssgwsXjM11CD4OxtacHJ0A3dlZxIdBBkEB4EiB4Mfc2J4FhMNmpoEQhJ9fo+CcR8ehXd5HRCrF51oi4wZbSIZBaSVIoaXEx0XEBetnrCOkJKkppapv7+un4zEo4TJmL2szcMHs2/Hp3gOvMvBaH2NopGTuLoe1L7Mwn4EgNGl3cq+4s4ZF+bG0rmo7H7hw1YMXb1vqqx5Igft3K16AYFdgyfPoT91CNvhI3dBlhuD08AJnBiq4MNk3xpkWNlo4TN+IP/tqiCAZgUFR0DFM3kR1Ti3RATnpQOox4gECgcOdKjYj9LBokUMLJg6VYKgB1iRyVwH9UyRCxjChsVZJ4GdAV29qm0CoG3bIAAh+QQJCQAfACwAAAAAIAAZAIQ8OjycnpzU0tRsbmy8urxcXlzs7uyEhoSsqqyUkpRERkTc3tzEwsRkZmT8+vy0srScmpw8PjykpqTU1tS8vrxkYmT08vSMjoysrqyUlpRMSkzk4uTExsRsamz8/vz///8F/uAnjmRplgKjqmcrOo4FW57YKJqmRG5LHUDgQtRpDI68nokBQUgQieGneBwklSQK5CmJ2jrVCAYxxjBEm4tazRExMk7EZWMzIhEUQp6Chjz+Em0fTFxeU3ZWeASLfB8bGQ8YD4EiWoVSDR1giRR5en2SGJSDW06GHRVVCgh6jCILAZGTgpammJsDAIp7oICChLZEiBG7D40bEKGjtV23m8R7n46Qvm6lzUSpR6vRxwHKtNeGmVW6e8a9s9aXwmG70o9/ouHsH5nP796S6qT1qKrFjiWLtEzcrXJk5B3LEEBCAAi/DLZDMmHBhIp0PhjgwJFjRmbjNCHBUuJNnFPaJQYoIJklAYSHFw4eAcByxIJFOA3YqKCpA82aPQ4UGFqgAlCgIQAAIfkECQkAGAAsAAAAACAAGQCEhIKExMLEpKKk5OLklJaUtLK01NLU9PL0jIqMvLq8zMrMrKqsnJ6c/Pr8hIaExMbE7OrsnJqctLa01NbU9Pb0jI6MvL68rK6s////AAAAAAAAAAAAAAAAAAAAAAAAAAAABf4gJo5kaZ5oqo4N1bZrPApOXcuyICy8g8eM3c5xWRQvARHEyJyIHpVodCDS8QSIhSWxtSgv3YLhKSiYI1RMcCG4OLSJhMSLgYC5kjHmUb4U0FUMPAtvFoZcX2F6fGYXDGlrQwtxXV9ccottZ2lWbBVaW3OJXGJkEn6PIpFuk1uIdXcWeWSNqWpCrF2isIpkfo6cO2yFl3R2vXsCEpuquMSyxrGzyb+2QRdtz6/HpJkFfoAYnYRw0KMWpcnLwM1s5F3b0pl+f5Bt2UaNxgtm34sRDAISCMbGzYSDB9McQHgQgogBDxREfHCgnacfK6xkw6iCAQGBPjiiUABtl8iTKANLhAAAIfkECQkAEAAsAAAAACAAGQCEjI6MxMbErKqsvLq85OLktLK0nJ6c1NLUxMLE9Pb0lJKUrK6svL687OrstLa01NbU////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABdsgJI5kaZ5oqq5s675wfC4CvSBiU++P+Ni1hkgAKBYFjEGSkVssCwfRwaEcLIQQgaDAVSAHAwcT0nAqHVHIVMm4DmuFhZdBVzaf6XWygK0tugJgS01VaFJUSW5ZcHJISWJ3SlCHVYp+DgUAgUl2ZGYMhmqIDAUEQ39/c2djZXiUiX2MqoOerqKVfQsLmLOQtWd5o3xvqLOdrZLBuKd/mV+grJ+Tt7DEccbRS6F6pKZZurxwcaxbXAt5zQUCfQbtBgoP8fHeCfLxWA32Dwk+Af7+MgIKHEiwoMEWIQAAOw=="/>');
            await (parcelRequire("aJdSK"));
            const settings = {
                closable: false,
                closableByDimmer: false
            };
            (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showModal(response.dataAsHtml, null, true, settings);
            this.initEditor(`${this.requestData.modalid} .edit`);
            // Attach Event-Listener to Save- and Cancel-Button
            let modal = document.querySelector(this.requestData.modalid);
            if (modal) modal.addEventListener('click', (event)=>{
                let btnSave = event.target.closest('button.opc-button[data-op-action="save"]');
                let btnCancel = event.target.closest('button.opc-button[data-op-action="cancel"]');
                if (btnSave) {
                    let htmlEncoded = this.htmlEncode(this.getContentFromEditMode());
                    this.requestData = {
                        type: 'staticcontent',
                        boid: btnSave.dataset.opBoid,
                        bonumber: btnSave.dataset.opBonumber,
                        arttextno: btnSave.dataset.opArttextno,
                        langno: btnSave.dataset.opLangno,
                        html: htmlEncoded
                    };
                    if (btnSave.dataset.opBo !== undefined) this.requestData.bo = btnSave.dataset.opBo;
                    if (btnSave.dataset.opAttr !== undefined) this.requestData.attr = btnSave.dataset.opAttr;
                    if (btnSave.dataset.opId !== undefined) this.requestData.id = btnSave.dataset.opId;
                    // Save WYSIWYG content
                    let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
                    (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, this.requestData, this.refreshContent.bind(this), this.getDefaultErrorFnc, true);
                }
                if (btnSave || btnCancel) (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).hideModal();
            });
        }
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ getContentFromEditMode() {
        // eslint-disable-next-line no-undef
        return opaccEditor.activeEditor.getContent({
            format: 'raw'
        });
    }
    /**
	 *
	 *
	 * @param {*} response
	 */ refreshContent(response) {
        if (response.success) {
            let contentContainer = document.getElementById(`staticcontent-${this.requestData.boid}-${this.requestData.arttextno}`);
            if (!contentContainer) contentContainer = document.getElementById(this.requestData.id);
            if (contentContainer) contentContainer.innerHTML = response.dataAsHtml;
        }
    }
    /**
	 *
	 *
	 * @param {*} selector
	 */ async initEditor(selector) {
        // Editor must be removed before initialisation
        opaccEditor.remove(selector);
        const opaccEditorUrl = this.getEditorFileUrl();
        const fileTypes = {
            image: 1,
            file: 2,
            media: 3
        };
        opaccEditor.init({
            selector: selector,
            language: this.getLanguage(),
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'pagebreak',
                'searchreplace',
                'wordcount',
                'visualblocks',
                'visualchars',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'nonbreaking',
                'save',
                'table',
                'directionality',
                'emoticons',
                'quickbars'
            ],
            insertdatetime_formats: [
                '%d.%m.%Y',
                '%H:%M'
            ],
            contextmenu: false,
            tools: 'inserttable',
            toolbar: "undo redo | styleselect | bold italic | forecolor backcolor | alignleft aligncenteralignright alignjustify | bullist numlist outdent indent | link image media |preview print | removeformat | code",
            width: '100%',
            base_url: `//${opaccEditorUrl.host}${opaccEditorUrl.pathname}/lib/editor/`,
            language_url: `//${opaccEditorUrl.host}${opaccEditorUrl.pathname}/lib/editor/translations/${this.getLanguage()}.js`,
            promotion: false,
            extended_valid_elements: 'i[*]',
            license_key: 'gpl',
            setup: (editor)=>{
                editor.on('SaveContent', (ed)=>{
                    // Augrund des HTML Encodings durch Aktivieren des application.cnf Parameters 'NoXSSValidation' => htmlEncodeFields()
                    // und dem standartmässig eingeschaltetem forced_root_block: <p> beim initialisieren wird der folgende content zuerst
                    // nochmals decodiert ( &lt;p&gt; => <p>) und anschliessend encodiert ( <p> => &lt;p&gt; ).
                    ed.content = this.htmlEncode(this.htmlDecode(ed.content));
                });
            },
            file_picker_callback: (callback, value, meta)=>{
                let type = fileTypes[meta.filetype];
                window.tinymce.activeEditor.windowManager.openUrl({
                    title: 'Fileupload Area',
                    url: this.getFileManagerURL(window.tinymce.activeEditor, type),
                    width: 800,
                    height: 600
                });
            }
        });
    }
    getFileManagerURL(editor, type) {
        return `/webportal/filemanager.aspx?editor=${editor.id}&type=${type}&lang=${this.getLanguage()}`;
    }
    /**
	 *
	 *
	 * @param {*} content
	 * @returns {*}
	 */ htmlEncode(content) {
        return content.toString().replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    /**
     *
     *
     * @param {*} content
     * @returns {*}
     */ htmlDecode(content) {
        return content.toString().replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ getLanguage() {
        if (location.href.indexOf('/en/') !== -1) return 'en_GB';
        else if (location.href.indexOf('/fr/') !== -1) return 'fr_FR';
        else if (location.href.indexOf('/it/') !== -1) return 'it';
        else return 'de';
    }
    /**
	 *
	 *
	 * @returns {*} URLObject
	 */ getEditorFileUrl() {
        const editorUrl = $965620ceadb636fe$import_meta !== undefined ? new URL("file:///webportal/config/layout/themes/project/js/src/vendor/script/classes/opacc.class.staticcontent.js") : {};
        if ('pathname' in editorUrl) for(let x = 0; x < 3; x++)editorUrl.pathname = editorUrl.pathname.substring(0, editorUrl.pathname.lastIndexOf("/"));
        else {
            editorUrl.host = 'cdn.was.local';
            editorUrl.pathname = '/was/dev/src'; //Versionsnummer wird beim Deployment des CDN aus Bamboo-Variable übernommen
        }
        return editorUrl;
    }
}


const $7fdcda72ba19d5d1$export$ebec86bb3cbdafe1 = new (0, $965620ceadb636fe$export$4b7bf84774185018)();


'use strict';
// keys
if (!Object.keys) Object.keys = function(object) {
    var keys = [];
    for(var name in object)if (Object.prototype.hasOwnProperty.call(object, name)) keys.push(name);
    return keys;
};
// ChildNode.remove
(function() {
    if (!("remove" in Element.prototype)) Element.prototype.remove = function() {
        if (this.parentNode) this.parentNode.removeChild(this);
    };
})();
function $4ec0aceb0167f552$var$extend() {
    var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length;
    for(; i < length; i++){
        if ((obj = arguments[i]) !== null) for(name in obj){
            copy = obj[name];
            if (target === copy) continue;
            else if (copy !== undefined) target[name] = copy;
        }
    }
    return target;
}
function $4ec0aceb0167f552$var$checkStorageValue(value) {
    return [
        'true',
        'false'
    ].indexOf(value) >= 0 ? JSON.parse(value) : value;
}
function $4ec0aceb0167f552$var$setLocalStorage(key, value, access) {
    if (access) localStorage.setItem(key, value);
    return value;
}
function $4ec0aceb0167f552$var$getSlideId() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return 'tns' + window.tnsId;
}
function $4ec0aceb0167f552$var$getBody() {
    var doc = document, body = doc.body;
    if (!body) {
        body = doc.createElement('body');
        body.fake = true;
    }
    return body;
}
var $4ec0aceb0167f552$var$docElement = document.documentElement;
function $4ec0aceb0167f552$var$setFakeBody(body) {
    var docOverflow = '';
    if (body.fake) {
        docOverflow = $4ec0aceb0167f552$var$docElement.style.overflow;
        //avoid crashing IE8, if background image is used
        body.style.background = '';
        //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = $4ec0aceb0167f552$var$docElement.style.overflow = 'hidden';
        $4ec0aceb0167f552$var$docElement.appendChild(body);
    }
    return docOverflow;
}
function $4ec0aceb0167f552$var$resetFakeBody(body, docOverflow) {
    if (body.fake) {
        body.remove();
        $4ec0aceb0167f552$var$docElement.style.overflow = docOverflow;
        // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        // eslint-disable-next-line
        $4ec0aceb0167f552$var$docElement.offsetHeight;
    }
}
// get css-calc
function $4ec0aceb0167f552$var$calc() {
    var doc = document, body = $4ec0aceb0167f552$var$getBody(), docOverflow = $4ec0aceb0167f552$var$setFakeBody(body), div = doc.createElement('div'), result = false;
    body.appendChild(div);
    try {
        var vals = [
            'calc(10px)',
            '-moz-calc(10px)',
            '-webkit-calc(10px)'
        ], val;
        for(var i = 0; i < 3; i++){
            val = vals[i];
            div.style.width = val;
            if (div.offsetWidth === 10) {
                result = val.replace('(10px)', '');
                break;
            }
        }
    } catch (e) {}
    body.fake ? $4ec0aceb0167f552$var$resetFakeBody(body, docOverflow) : div.remove();
    return result;
}
// get subpixel support value
function $4ec0aceb0167f552$var$subpixelLayout() {
    var doc = document, body = $4ec0aceb0167f552$var$getBody(), docOverflow = $4ec0aceb0167f552$var$setFakeBody(body), parent = doc.createElement('div'), child1 = doc.createElement('div'), child2, supported;
    parent.style.cssText = 'width: 10px';
    child1.style.cssText = 'float: left; width: 5.5px; height: 10px;';
    child2 = child1.cloneNode(true);
    parent.appendChild(child1);
    parent.appendChild(child2);
    body.appendChild(parent);
    supported = child1.offsetTop !== child2.offsetTop;
    body.fake ? $4ec0aceb0167f552$var$resetFakeBody(body, docOverflow) : parent.remove();
    return supported;
}
function $4ec0aceb0167f552$var$mediaquerySupport() {
    var doc = document, body = $4ec0aceb0167f552$var$getBody(), docOverflow = $4ec0aceb0167f552$var$setFakeBody(body), div = doc.createElement('div'), style = doc.createElement('style'), rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}', position;
    style.type = 'text/css';
    div.className = 'tns-mq-test';
    body.appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) style.styleSheet.cssText = rule;
    else style.appendChild(doc.createTextNode(rule));
    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];
    body.fake ? $4ec0aceb0167f552$var$resetFakeBody(body, docOverflow) : div.remove();
    return position === "absolute";
}
// create and append style sheet
function $4ec0aceb0167f552$var$createStyleSheet(media) {
    // Create the <style> tag
    var style = document.createElement("style");
    // style.setAttribute("type", "text/css");
    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")
    if (media) style.setAttribute("media", media);
    // WebKit hack :(
    // style.appendChild(document.createTextNode(""));
    // Add the <style> element to the page
    document.querySelector('head').appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
}
// cross browsers addRule method
function $4ec0aceb0167f552$var$addCSSRule(sheet, selector, rules, index) {
    'insertRule' in sheet ? sheet.insertRule(selector + '{' + rules + '}', index) : sheet.addRule(selector, rules, index);
}
function $4ec0aceb0167f552$var$getCssRulesLength(sheet) {
    var rule = 'insertRule' in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
}
function $4ec0aceb0167f552$var$toDegree(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
}
function $4ec0aceb0167f552$var$getTouchDirection(angle, range) {
    var direction = false, gap = Math.abs(90 - Math.abs(angle));
    if (gap >= 90 - range) direction = 'horizontal';
    else if (gap <= range) direction = 'vertical';
    return direction;
}
function $4ec0aceb0167f552$var$hasClass(el, str) {
    return el.className.indexOf(str) >= 0;
}
function $4ec0aceb0167f552$var$addClass(el, str) {
    if (!$4ec0aceb0167f552$var$hasClass(el, str)) el.className += ' ' + str;
}
function $4ec0aceb0167f552$var$removeClass(el, str) {
    if ($4ec0aceb0167f552$var$hasClass(el, str)) el.className = el.className.replace(str, '');
}
function $4ec0aceb0167f552$var$hasAttr(el, attr) {
    return el.hasAttribute(attr);
}
function $4ec0aceb0167f552$var$getAttr(el, attr) {
    return el.getAttribute(attr);
}
function $4ec0aceb0167f552$var$isNodeList(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
}
function $4ec0aceb0167f552$var$setAttrs(els, attrs) {
    els = $4ec0aceb0167f552$var$isNodeList(els) || els instanceof Array ? els : [
        els
    ];
    if (Object.prototype.toString.call(attrs) !== '[object Object]') return;
    for(var i = els.length; i--;)for(var key in attrs)els[i].setAttribute(key, attrs[key]);
}
function $4ec0aceb0167f552$var$removeAttrs(els, attrs) {
    els = $4ec0aceb0167f552$var$isNodeList(els) || els instanceof Array ? els : [
        els
    ];
    attrs = attrs instanceof Array ? attrs : [
        attrs
    ];
    var attrLength = attrs.length;
    for(var i = els.length; i--;)for(var j = attrLength; j--;)els[i].removeAttribute(attrs[j]);
}
function $4ec0aceb0167f552$var$hideElement(el) {
    if (!$4ec0aceb0167f552$var$hasAttr(el, 'hidden')) $4ec0aceb0167f552$var$setAttrs(el, {
        'hidden': ''
    });
}
function $4ec0aceb0167f552$var$showElement(el) {
    if ($4ec0aceb0167f552$var$hasAttr(el, 'hidden')) $4ec0aceb0167f552$var$removeAttrs(el, 'hidden');
}
function $4ec0aceb0167f552$var$isVisible(el) {
    return el.offsetWidth > 0 && el.offsetHeight > 0;
}
// check if an image is loaded
// 1. See if "naturalWidth" and "naturalHeight" properties are available.
// 2. See if "complete" property is available.
function $4ec0aceb0167f552$var$imageLoaded(img) {
    if (typeof img.complete === 'boolean') return img.complete;
    else if (typeof img.naturalWidth === 'number') return img.naturalWidth !== 0;
}
function $4ec0aceb0167f552$var$whichProperty(props) {
    var el = document.createElement('fakeelement'), len = props.length;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (el.style[prop] !== undefined) return prop;
    }
    return false; // explicit for ie9-
}
// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function $4ec0aceb0167f552$var$getEndProperty(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) endProp = 'webkit' + propOut + 'End';
    else if (/^O/.test(propIn)) endProp = 'o' + propOut + 'End';
    else if (propIn) endProp = propOut.toLowerCase() + 'end';
    return endProp;
}
// Test via a getter in the options object to see if the passive property is accessed
var $4ec0aceb0167f552$var$supportsPassive = false;
try {
    var $4ec0aceb0167f552$var$opts = Object.defineProperty({}, 'passive', {
        get: function() {
            $4ec0aceb0167f552$var$supportsPassive = true;
        }
    });
    window.addEventListener("test", null, $4ec0aceb0167f552$var$opts);
} catch (e) {}
var $4ec0aceb0167f552$var$passiveOption = $4ec0aceb0167f552$var$supportsPassive ? {
    passive: true
} : false;
function $4ec0aceb0167f552$var$addEvents(el, obj) {
    for(var prop in obj){
        var option = prop === 'touchstart' || prop === 'touchmove' ? $4ec0aceb0167f552$var$passiveOption : false;
        el.addEventListener(prop, obj[prop], option);
    }
}
function $4ec0aceb0167f552$var$removeEvents(el, obj) {
    for(var prop in obj){
        var option = [
            'touchstart',
            'touchmove'
        ].indexOf(prop) >= 0 ? $4ec0aceb0167f552$var$passiveOption : false;
        el.removeEventListener(prop, obj[prop], option);
    }
}
function $4ec0aceb0167f552$var$Events() {
    return {
        topics: {},
        on: function(eventName, fn) {
            this.topics[eventName] = this.topics[eventName] || [];
            this.topics[eventName].push(fn);
        },
        off: function(eventName, fn) {
            if (this.topics[eventName]) {
                for(var i = 0; i < this.topics[eventName].length; i++)if (this.topics[eventName][i] === fn) {
                    this.topics[eventName].splice(i, 1);
                    break;
                }
            }
        },
        emit: function(eventName, data) {
            if (this.topics[eventName]) this.topics[eventName].forEach(function(fn) {
                fn(data);
            });
        }
    };
}
function $4ec0aceb0167f552$var$jsTransform(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10), unit = to.indexOf('%') >= 0 ? '%' : 'px', to = to.replace(unit, ''), from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')), positionTick = (to - from) / duration * tick;
    setTimeout(moveElement, tick);
    function moveElement() {
        duration -= tick;
        from += positionTick;
        element.style[attr] = prefix + from + unit + postfix;
        if (duration > 0) setTimeout(moveElement, tick);
        else callback();
    }
}
// Format: ES MODULE
// check browser version and local storage
// if browser upgraded,
// 1. delete browser ralated data from local storage and
// 2. recheck these options and save them to local storage
var $4ec0aceb0167f552$var$browserInfo = navigator.userAgent, $4ec0aceb0167f552$var$localStorageAccess = true, $4ec0aceb0167f552$var$tnsStorage = {};
try {
    $4ec0aceb0167f552$var$tnsStorage = localStorage;
    if (!$4ec0aceb0167f552$var$tnsStorage['tnsApp']) $4ec0aceb0167f552$var$tnsStorage['tnsApp'] = $4ec0aceb0167f552$var$browserInfo;
    else if ($4ec0aceb0167f552$var$tnsStorage['tnsApp'] !== $4ec0aceb0167f552$var$browserInfo) {
        $4ec0aceb0167f552$var$tnsStorage['tnsApp'] = $4ec0aceb0167f552$var$browserInfo;
        // tC => calc
        // tSP => subpixel
        // tMQ => mediaquery
        // tTf => transform
        // tTDu => transitionDuration
        // tTDe => transitionDelay
        // tADu => animationDuration
        // tADe => animationDelay
        // tTE => transitionEnd
        // tAE => animationEnd
        [
            'tC',
            'tSP',
            'tMQ',
            'tTf',
            'tTDu',
            'tTDe',
            'tADu',
            'tADe',
            'tTE',
            'tAE'
        ].forEach(function(item) {
            $4ec0aceb0167f552$var$tnsStorage.removeItem(item);
        });
    }
} catch (e) {
    $4ec0aceb0167f552$var$localStorageAccess = false;
}
// get browser related data from local storage if they exist
// otherwise, run the functions again and save these data to local storage
// checkStorageValue() convert non-string value to its original value: 'true' > true
var $4ec0aceb0167f552$var$doc = document, $4ec0aceb0167f552$var$win = window, $4ec0aceb0167f552$var$KEYS = {
    ENTER: 13,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
}, $4ec0aceb0167f552$var$CALC = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tC']) || $4ec0aceb0167f552$var$setLocalStorage('tC', $4ec0aceb0167f552$var$calc(), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$SUBPIXEL = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tSP']) || $4ec0aceb0167f552$var$setLocalStorage('tSP', $4ec0aceb0167f552$var$subpixelLayout(), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$CSSMQ = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tMQ']) || $4ec0aceb0167f552$var$setLocalStorage('tMQ', $4ec0aceb0167f552$var$mediaquerySupport(), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$TRANSFORM = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tTf']) || $4ec0aceb0167f552$var$setLocalStorage('tTf', $4ec0aceb0167f552$var$whichProperty([
    'transform',
    'WebkitTransform',
    'MozTransform',
    'msTransform',
    'OTransform'
]), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$TRANSITIONDURATION = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tTDu']) || $4ec0aceb0167f552$var$setLocalStorage('tTDu', $4ec0aceb0167f552$var$whichProperty([
    'transitionDuration',
    'WebkitTransitionDuration',
    'MozTransitionDuration',
    'OTransitionDuration'
]), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$TRANSITIONDELAY = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tTDe']) || $4ec0aceb0167f552$var$setLocalStorage('tTDe', $4ec0aceb0167f552$var$whichProperty([
    'transitionDelay',
    'WebkitTransitionDelay',
    'MozTransitionDelay',
    'OTransitionDelay'
]), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$ANIMATIONDURATION = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tADu']) || $4ec0aceb0167f552$var$setLocalStorage('tADu', $4ec0aceb0167f552$var$whichProperty([
    'animationDuration',
    'WebkitAnimationDuration',
    'MozAnimationDuration',
    'OAnimationDuration'
]), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$ANIMATIONDELAY = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tADe']) || $4ec0aceb0167f552$var$setLocalStorage('tADe', $4ec0aceb0167f552$var$whichProperty([
    'animationDelay',
    'WebkitAnimationDelay',
    'MozAnimationDelay',
    'OAnimationDelay'
]), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$TRANSITIONEND = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tTE']) || $4ec0aceb0167f552$var$setLocalStorage('tTE', $4ec0aceb0167f552$var$getEndProperty($4ec0aceb0167f552$var$TRANSITIONDURATION, 'Transition'), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$ANIMATIONEND = $4ec0aceb0167f552$var$checkStorageValue($4ec0aceb0167f552$var$tnsStorage['tAE']) || $4ec0aceb0167f552$var$setLocalStorage('tAE', $4ec0aceb0167f552$var$getEndProperty($4ec0aceb0167f552$var$ANIMATIONDURATION, 'Animation'), $4ec0aceb0167f552$var$localStorageAccess), $4ec0aceb0167f552$var$tnsCssPrefix = 'op-mediaslider';
var $4ec0aceb0167f552$export$1ce7868306ce1597 = function(options) {
    options = $4ec0aceb0167f552$var$extend({
        container: $4ec0aceb0167f552$var$doc.querySelector('.slider'),
        mode: 'carousel',
        axis: 'horizontal',
        items: 1,
        gutter: 0,
        edgePadding: 0,
        fixedWidth: false,
        slideBy: 1,
        controls: true,
        controlsText: [
            'prev',
            'next'
        ],
        controlsContainer: false,
        nav: true,
        navContainer: false,
        navAsThumbnails: false,
        arrowKeys: false,
        speed: 300,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayDirection: 'forward',
        autoplayText: [
            'start',
            'stop'
        ],
        autoplayHoverPause: false,
        autoplayButton: false,
        autoplayButtonOutput: true,
        autoplayResetOnVisibility: true,
        // animateIn: `${tnsCssPrefix}-fadeIn`,
        // animateOut: `${tnsCssPrefix}-fadeOut`,
        // animateNormal: `${tnsCssPrefix}-normal`,
        // animateDelay: false,
        loop: true,
        rewind: false,
        autoHeight: false,
        responsive: false,
        lazyload: false,
        touch: true,
        mouseDrag: false,
        nested: false,
        freezable: true,
        // startIndex: 0,
        onInit: false
    }, options || {});
    // get element nodes from selectors
    [
        'container',
        'controlsContainer',
        'navContainer',
        'autoplayButton'
    ].forEach(function(item) {
        if (typeof options[item] === 'string') options[item] = $4ec0aceb0167f552$var$doc.querySelector(options[item]);
    });
    // make sure slide container exists
    var supportConsoleWarn = $4ec0aceb0167f552$var$win.console && typeof $4ec0aceb0167f552$var$win.console.warn === 'function';
    if (!options.container || !options.container.nodeName) {
        if (supportConsoleWarn) console.warn('Can\'t find container element.');
        return;
    }
    // make sure slides are more than 2
    if (options.container.children.length < 2) {
        if (supportConsoleWarn) console.warn('Slides less than 2.');
        return;
    }
    // update responsive
    // from: {
    //    300: 2,
    //    800: {
    //      loop: false
    //    }
    // }
    // to: {
    //    300: {
    //      items: 2
    //    },
    //    800: {
    //      loop: false
    //    }
    // }
    if (options.responsive) {
        var resTem = {}, res = options.responsive;
        for(var key in res){
            var val = res[key];
            resTem[key] = typeof val === 'number' ? {
                items: val
            } : val;
        }
        options.responsive = resTem;
        resTem = null;
        // apply responsive[0] to options and remove it
        if (0 in options.responsive) {
            options = $4ec0aceb0167f552$var$extend(options, options.responsive[0]);
            delete options.responsive[0];
        }
    }
    // === define and set variables ===
    var carousel = options.mode === 'carousel' ? true : false;
    if (!carousel) {
        options.axis = 'horizontal';
        options.rewind = false;
        options.loop = true;
        options.edgePadding = false;
        var animateIn = `${$4ec0aceb0167f552$var$tnsCssPrefix}-fadeIn`, animateOut = `${$4ec0aceb0167f552$var$tnsCssPrefix}-fadeOut`, animateDelay = false, animateNormal = options.animateNormal || `${$4ec0aceb0167f552$var$tnsCssPrefix}-normal`;
        if ($4ec0aceb0167f552$var$TRANSITIONEND && $4ec0aceb0167f552$var$ANIMATIONEND) {
            animateIn = options.animateIn || animateIn;
            animateOut = options.animateOut || animateOut;
            animateDelay = options.animateDelay || animateDelay;
        }
    }
    var horizontal = options.axis === 'horizontal' ? true : false, outerWrapper = $4ec0aceb0167f552$var$doc.createElement('div'), innerWrapper = $4ec0aceb0167f552$var$doc.createElement('div'), container = options.container, containerParent = container.parentNode, slideItems = container.children, slideCount = slideItems.length, vpOuter = containerParent.clientWidth, vpInner, responsive = options.responsive, responsiveItems = [], breakpoints = false, breakpointZone = 0, windowWidth = getWindowWidth();
    if (responsive) {
        breakpoints = Object.keys(responsive).map(function(x) {
            return parseInt(x);
        }).sort(function(a, b) {
            return a - b;
        });
        // get all responsive items
        breakpoints.forEach(function(bp) {
            responsiveItems = responsiveItems.concat(Object.keys(responsive[bp]));
        });
        // remove duplicated items
        var arr = [];
        responsiveItems.forEach(function(item) {
            if (arr.indexOf(item) < 0) arr.push(item);
        });
        responsiveItems = arr;
        setBreakpointZone();
    }
    var items = getOption('items'), slideBy = getOption('slideBy') === 'page' ? items : getOption('slideBy'), nested = options.nested, gutter = getOption('gutter'), edgePadding = getOption('edgePadding'), fixedWidth = getOption('fixedWidth'), arrowKeys = getOption('arrowKeys'), speed = getOption('speed'), rewind = options.rewind, loop = rewind ? false : options.loop, autoHeight = getOption('autoHeight'), sheet = $4ec0aceb0167f552$var$createStyleSheet(), lazyload = options.lazyload, slideOffsetTops, slideItemsOut = [], cloneCount = loop ? slideCount * 2 : 0, slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2, hasRightDeadZone = fixedWidth && !loop && !edgePadding ? true : false, updateIndexBeforeTransform = !carousel || !loop ? true : false, // transform
    transformAttr = horizontal ? 'left' : 'top', transformPrefix = '', transformPostfix = '', // index
    startIndex = getOption('startIndex'), index = startIndex ? updateStartIndex(startIndex) : !carousel ? 0 : cloneCount, indexCached = index, indexMin = 0, indexMax = slideCountNew - items, // resize
    resizeTimer, touchedOrDraged, running = false, onInit = options.onInit, events = new $4ec0aceb0167f552$var$Events(), // id, class
    containerIdCached = container.id, classContainer = ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-slider ${$4ec0aceb0167f552$var$tnsCssPrefix}-${options.mode}`, slideId = container.id || $4ec0aceb0167f552$var$getSlideId(), disable = getOption('disable'), freezable = options.freezable, freeze = disable ? true : freezable ? slideCount <= items : false, frozen, importantStr = nested === 'inner' ? ' !important' : '', controlsEvents = {
        'click': onControlsClick,
        'keydown': onControlsKeydown
    }, navEvents = {
        'click': onNavClick,
        'keydown': onNavKeydown
    }, hoverEvents = {
        'mouseover': mouseoverPause,
        'mouseout': mouseoutRestart
    }, visibilityEvent = {
        'visibilitychange': onVisibilityChange
    }, docmentKeydownEvent = {
        'keydown': onDocumentKeydown
    }, touchEvents = {
        'touchstart': onTouchOrMouseStart,
        'touchmove': onTouchOrMouseMove,
        'touchend': onTouchOrMouseEnd,
        'touchcancel': onTouchOrMouseEnd
    }, dragEvents = {
        'mousedown': onTouchOrMouseStart,
        'mousemove': onTouchOrMouseMove,
        'mouseup': onTouchOrMouseEnd,
        'mouseleave': onTouchOrMouseEnd
    }, hasControls = checkOption('controls'), hasNav = checkOption('nav'), navAsThumbnails = options.navAsThumbnails, hasAutoplay = checkOption('autoplay'), hasTouch = checkOption('touch'), hasMouseDrag = checkOption('mouseDrag'), slideActiveClass = `${$4ec0aceb0167f552$var$tnsCssPrefix}-slide-active`;
    // check startIndex
    function updateStartIndex(indexTem) {
        indexTem = indexTem % slideCount;
        if (indexTem < 0) indexTem += slideCount;
        indexTem = Math.min(indexTem, slideCountNew - items);
        return indexTem;
    }
    // controls
    if (hasControls) var controls = getOption('controls'), controlsText = getOption('controlsText'), controlsContainer = options.controlsContainer, prevButton, nextButton, prevIsButton, nextIsButton;
    // nav
    if (hasNav) var nav = getOption('nav'), navContainer = options.navContainer, navItems, visibleNavIndexes = [], visibleNavIndexesCached = visibleNavIndexes, navClicked = -1, navCurrentIndex = index % slideCount, navCurrentIndexCached = navCurrentIndex, navActiveClass = `${$4ec0aceb0167f552$var$tnsCssPrefix}-nav-active`;
    // autoplay
    if (hasAutoplay) var autoplay = getOption('autoplay'), autoplayTimeout = getOption('autoplayTimeout'), autoplayDirection = options.autoplayDirection === 'forward' ? 1 : -1, autoplayText = getOption('autoplayText'), autoplayHoverPause = getOption('autoplayHoverPause'), autoplayButton = options.autoplayButton, autoplayResetOnVisibility = getOption('autoplayResetOnVisibility'), autoplayHtmlStrings = [
        `<span class="${$4ec0aceb0167f552$var$tnsCssPrefix}-visually-hidden">', ' animation</span>`
    ], autoplayTimer, animating, autoplayHoverPaused, autoplayVisibilityPaused;
    // touch
    if (hasTouch) var touch = getOption('touch'), startX = null, startY = null, translateInit, moveDirectionExpected = 0, disX, disY;
    // mouse drag
    if (hasMouseDrag) var mouseDrag = getOption('mouseDrag'), isDragEvent = false;
    // disable slider when slidecount <= items
    if (freeze) controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    if ($4ec0aceb0167f552$var$TRANSFORM) {
        transformAttr = $4ec0aceb0167f552$var$TRANSFORM;
        transformPrefix = 'translate';
        transformPrefix += horizontal ? 'X(' : 'Y(';
        transformPostfix = ')';
    }
    // === COMMON FUNCTIONS === //
    function getWindowWidth() {
        return $4ec0aceb0167f552$var$win.innerWidth || $4ec0aceb0167f552$var$doc.documentElement.clientWidth || $4ec0aceb0167f552$var$doc.body.clientWidth;
    }
    function checkOption(item) {
        var result = options[item];
        if (!result && breakpoints && responsiveItems.indexOf(item) >= 0) breakpoints.forEach(function(bp) {
            if (responsive[bp][item]) result = true;
        });
        return result;
    }
    function getOption(item, viewport) {
        viewport = viewport ? viewport : windowWidth;
        var obj = {
            slideBy: 'page',
            edgePadding: false,
            autoHeight: true
        }, result;
        if (!carousel && item in obj) result = obj[item];
        else {
            if (item === 'items' && getOption('fixedWidth')) result = Math.floor(vpOuter / (getOption('fixedWidth') + getOption('gutter')));
            else if (item === 'autoHeight' && nested === 'outer') result = true;
            else {
                result = options[item];
                if (breakpoints && responsiveItems.indexOf(item) >= 0) for(var i = 0, len = breakpoints.length; i < len; i++){
                    var bp = breakpoints[i];
                    if (viewport >= bp) {
                        if (item in responsive[bp]) result = responsive[bp][item];
                    } else break;
                }
            }
        }
        if (item === 'slideBy' && result === 'page') result = getOption('items');
        return result;
    }
    function getSlideMarginLeft(i) {
        var str = $4ec0aceb0167f552$var$CALC ? $4ec0aceb0167f552$var$CALC + '(' + i * 100 + '% / ' + slideCountNew + ')' : i * 100 / slideCountNew + '%';
        return str;
    }
    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem) {
        var str = '';
        if (edgePaddingTem) {
            var gap = edgePaddingTem;
            if (gutterTem) gap += gutterTem;
            if (fixedWidthTem) str = 'margin: 0px ' + (vpOuter % (fixedWidthTem + gutterTem) + gutterTem) / 2 + 'px';
            else str = horizontal ? 'margin: 0 ' + edgePaddingTem + 'px 0 ' + gap + 'px;' : 'padding: ' + gap + 'px 0 ' + edgePaddingTem + 'px 0;';
        } else if (gutterTem && !fixedWidthTem) {
            var gutterTemUnit = '-' + gutterTem + 'px', dir = horizontal ? gutterTemUnit + ' 0 0' : '0 ' + gutterTemUnit + ' 0';
            str = 'margin: 0 ' + dir + ';';
        }
        return str;
    }
    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
        var str;
        if (fixedWidthTem) str = (fixedWidthTem + gutterTem) * slideCountNew + 'px';
        else str = $4ec0aceb0167f552$var$CALC ? $4ec0aceb0167f552$var$CALC + '(' + slideCountNew * 100 + '% / ' + itemsTem + ')' : slideCountNew * 100 / itemsTem + '%';
        return str;
    }
    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
        var str = '';
        if (horizontal) {
            str = 'width:';
            if (fixedWidthTem) str += fixedWidthTem + gutterTem + 'px';
            else {
                var dividend = carousel ? slideCountNew : itemsTem;
                str += $4ec0aceb0167f552$var$CALC ? $4ec0aceb0167f552$var$CALC + '(100% / ' + dividend + ')' : 100 / dividend + '%';
            }
            str += importantStr + ';';
        }
        return str;
    }
    function getSlideGutterStyle(gutterTem) {
        var str = '';
        // gutter maybe interger || 0
        // so can't use 'if (gutter)'
        if (gutterTem !== false) {
            var prop = horizontal ? 'padding-' : 'margin-', dir = horizontal ? 'right' : 'bottom';
            str = prop + dir + ': ' + gutterTem + 'px;';
        }
        return str;
    }
    (function sliderInit() {
        // First thing first, wrap container with 'outerWrapper > innerWrapper',
        // to get the correct view width
        outerWrapper.appendChild(innerWrapper);
        containerParent.insertBefore(outerWrapper, container);
        innerWrapper.appendChild(container);
        vpInner = innerWrapper.clientWidth;
        var classOuter = `${$4ec0aceb0167f552$var$tnsCssPrefix}-outer`, classInner = `${$4ec0aceb0167f552$var$tnsCssPrefix}-inner`, hasGutter = checkOption('gutter');
        if (carousel) {
            if (horizontal) {
                if (checkOption('edgePadding') || hasGutter && !options.fixedWidth) classOuter += ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-ovh`;
                else classInner += ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-ovh`;
            } else classInner += ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-ovh`;
        } else if (hasGutter) classOuter += ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-ovh`;
        outerWrapper.className = classOuter;
        innerWrapper.className = classInner;
        innerWrapper.id = slideId + '-iw';
        if (autoHeight) {
            innerWrapper.className += ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-ah`;
            innerWrapper.style[$4ec0aceb0167f552$var$TRANSITIONDURATION] = speed / 1000 + 's';
        }
        // set container properties
        if (container.id === '') container.id = slideId;
        classContainer += $4ec0aceb0167f552$var$SUBPIXEL ? ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-subpixel` : ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-no-subpixel`;
        classContainer += $4ec0aceb0167f552$var$CALC ? ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-calc` : ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-no-calc`;
        if (carousel) classContainer += ` ${$4ec0aceb0167f552$var$tnsCssPrefix}-` + options.axis;
        container.className += classContainer;
        // add event
        if (carousel && $4ec0aceb0167f552$var$TRANSITIONEND) {
            var eve = {};
            eve[$4ec0aceb0167f552$var$TRANSITIONEND] = onTransitionEnd;
            $4ec0aceb0167f552$var$addEvents(container, eve);
        }
        // delete datas after init
        classOuter = classInner = null;
        // add id, class, aria attributes
        // before clone slides
        for(var x = 0; x < slideCount; x++){
            var item = slideItems[x];
            if (!item.id) item.id = slideId + '-item' + x;
            $4ec0aceb0167f552$var$addClass(item, `${$4ec0aceb0167f552$var$tnsCssPrefix}-item`);
            if (!carousel && animateNormal) $4ec0aceb0167f552$var$addClass(item, animateNormal);
            $4ec0aceb0167f552$var$setAttrs(item, {
                'aria-hidden': 'true',
                'tabindex': '-1'
            });
        }
        // clone slides
        if (loop || edgePadding) {
            var fragmentBefore = $4ec0aceb0167f552$var$doc.createDocumentFragment(), fragmentAfter = $4ec0aceb0167f552$var$doc.createDocumentFragment();
            for(var j = cloneCount; j--;){
                var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(true);
                $4ec0aceb0167f552$var$removeAttrs(cloneFirst, 'id');
                fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
                if (carousel) {
                    var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
                    $4ec0aceb0167f552$var$removeAttrs(cloneLast, 'id');
                    fragmentBefore.appendChild(cloneLast);
                }
            }
            container.insertBefore(fragmentBefore, container.firstChild);
            container.appendChild(fragmentAfter);
            slideItems = container.children;
        }
        // activate visible slides
        // add aria attrs
        // set animation classes and left value for gallery slider
        // use slide count when slides are fewer than items
        for(var i = index; i < index + Math.min(slideCount, items); i++){
            var item = slideItems[i];
            $4ec0aceb0167f552$var$setAttrs(item, {
                'aria-hidden': 'false'
            });
            $4ec0aceb0167f552$var$removeAttrs(item, [
                'tabindex'
            ]);
            $4ec0aceb0167f552$var$addClass(item, slideActiveClass);
            if (!carousel) {
                item.style.left = (i - index) * 100 / items + '%';
                $4ec0aceb0167f552$var$addClass(item, animateIn);
                $4ec0aceb0167f552$var$removeClass(item, animateNormal);
            }
        }
        if (carousel && horizontal) {
            // set font-size rules
            // for modern browsers
            if ($4ec0aceb0167f552$var$SUBPIXEL) {
                // set slides font-size first
                $4ec0aceb0167f552$var$addCSSRule(sheet, '#' + slideId + ` > .${$4ec0aceb0167f552$var$tnsCssPrefix}-item`, 'font-size:' + $4ec0aceb0167f552$var$win.getComputedStyle(slideItems[0]).fontSize + ';', $4ec0aceb0167f552$var$getCssRulesLength(sheet));
                $4ec0aceb0167f552$var$addCSSRule(sheet, '#' + slideId, 'font-size:0;', $4ec0aceb0167f552$var$getCssRulesLength(sheet));
            // slide left margin
            // for IE8 & webkit browsers (no subpixel)
            } else [].forEach.call(slideItems, function(slide, i) {
                slide.style.marginLeft = getSlideMarginLeft(i);
            });
        }
        if ($4ec0aceb0167f552$var$CSSMQ) {
            // inner wrapper styles
            var str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth);
            $4ec0aceb0167f552$var$addCSSRule(sheet, '#' + slideId + '-iw', str, $4ec0aceb0167f552$var$getCssRulesLength(sheet));
            // container styles
            if (carousel && horizontal) {
                str = 'width:' + getContainerWidth(options.fixedWidth, options.gutter, options.items);
                $4ec0aceb0167f552$var$addCSSRule(sheet, '#' + slideId, str, $4ec0aceb0167f552$var$getCssRulesLength(sheet));
            }
            // slide styles
            if (horizontal || options.gutter) {
                str = getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) + getSlideGutterStyle(options.gutter);
                $4ec0aceb0167f552$var$addCSSRule(sheet, '#' + slideId + ` > .${$4ec0aceb0167f552$var$tnsCssPrefix}-item`, str, $4ec0aceb0167f552$var$getCssRulesLength(sheet));
            }
        // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)
        } else {
            // inner wrapper styles
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth);
            // container styles
            if (carousel && horizontal) container.style.width = getContainerWidth(fixedWidth, gutter, items);
            // slide styles
            if (horizontal || gutter) {
                var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
                // append to the last line
                $4ec0aceb0167f552$var$addCSSRule(sheet, '#' + slideId + ` > .${$4ec0aceb0167f552$var$tnsCssPrefix}-item`, str, $4ec0aceb0167f552$var$getCssRulesLength(sheet));
            }
        }
        if (!horizontal && !disable) {
            getSlideOffsetTops();
            updateContentWrapperHeight();
        }
        // media queries
        if (responsive && $4ec0aceb0167f552$var$CSSMQ) breakpoints.forEach(function(bp) {
            var opts = responsive[bp], str = '', innerWrapperStr = '', containerStr = '', slideStr = '', itemsBP = getOption('items', bp), fixedWidthBP = getOption('fixedWidth', bp), edgePaddingBP = getOption('edgePadding', bp), gutterBP = getOption('gutter', bp);
            // inner wrapper string
            if ('edgePadding' in opts || 'gutter' in opts) innerWrapperStr = '#' + slideId + '-iw{' + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP) + '}';
            // container string
            if (carousel && horizontal && ('fixedWidth' in opts || 'gutter' in opts || 'items' in opts)) containerStr = '#' + slideId + '{' + 'width:' + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + '}';
            // slide string
            if ('fixedWidth' in opts || checkOption('fixedWidth') && 'gutter' in opts || !carousel && 'items' in opts) slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
            if ('gutter' in opts) slideStr += getSlideGutterStyle(gutterBP);
            if (slideStr.length > 0) slideStr = `#${slideId} > .${$4ec0aceb0167f552$var$tnsCssPrefix}-item{${slideStr}}`;
            // if (slideStr.length > 0) { slideStr = '#' + slideId + ' > .tns-item{' + slideStr + '}'; }
            str = innerWrapperStr + containerStr + slideStr;
            if (str.length > 0) sheet.insertRule('@media (min-width: ' + bp / 16 + 'em) {' + str + '}', sheet.cssRules.length);
        });
        // set container transform property
        if (carousel && !disable) doContainerTransform();
        // == msInit ==
        // for IE10
        if (navigator.msMaxTouchPoints) {
            $4ec0aceb0167f552$var$addClass(outerWrapper, 'ms-touch');
            $4ec0aceb0167f552$var$addEvents(outerWrapper, {
                'scroll': ie10Scroll
            });
            setSnapInterval();
        }
        // == navInit ==
        if (hasNav) {
            var initIndex = !carousel ? 0 : cloneCount;
            // customized nav
            // will not hide the navs in case they're thumbnails
            if (navContainer) {
                $4ec0aceb0167f552$var$setAttrs(navContainer, {
                    'aria-label': 'Carousel Pagination'
                });
                navItems = navContainer.children;
                [].forEach.call(navItems, function(item, i) {
                    $4ec0aceb0167f552$var$setAttrs(item, {
                        'data-nav': i,
                        'tabindex': '-1',
                        'aria-selected': 'false',
                        'aria-controls': slideItems[initIndex + i].id
                    });
                });
            // generated nav
            } else {
                var navHtml = '';
                for(var i = 0; i < slideCount; i++)// hide nav items by default
                navHtml += '<button data-nav="' + i + '" tabindex="-1" aria-selected="false" aria-controls="' + slideItems[initIndex + i].id + '" hidden type="button"></button>';
                navHtml = `<div class="${$4ec0aceb0167f552$var$tnsCssPrefix}-nav" aria-label="Carousel Pagination">${navHtml}</div>`;
                outerWrapper.insertAdjacentHTML('afterbegin', navHtml);
                navContainer = outerWrapper.querySelector(`.${$4ec0aceb0167f552$var$tnsCssPrefix}-nav`);
                navItems = navContainer.children;
            }
            updateNavVisibility();
            // add transition
            if ($4ec0aceb0167f552$var$TRANSITIONDURATION) {
                var prefix = $4ec0aceb0167f552$var$TRANSITIONDURATION.substring(0, $4ec0aceb0167f552$var$TRANSITIONDURATION.length - 18).toLowerCase(), str = 'transition: all ' + speed / 1000 + 's';
                if (prefix) str = '-' + prefix + '-' + str;
                $4ec0aceb0167f552$var$addCSSRule(sheet, '[aria-controls^=' + slideId + '-item]', str, $4ec0aceb0167f552$var$getCssRulesLength(sheet));
            }
            $4ec0aceb0167f552$var$setAttrs(navItems[navCurrentIndex], {
                'tabindex': '0',
                'aria-selected': 'true'
            });
            $4ec0aceb0167f552$var$addClass(navItems[navCurrentIndex], navActiveClass);
            // add events
            $4ec0aceb0167f552$var$addEvents(navContainer, navEvents);
            if (!nav) $4ec0aceb0167f552$var$hideElement(navContainer);
        }
        // == autoplayInit ==
        if (hasAutoplay) {
            var txt = autoplay ? 'stop' : 'start';
            if (autoplayButton) $4ec0aceb0167f552$var$setAttrs(autoplayButton, {
                'data-action': txt
            });
            else if (options.autoplayButtonOutput) {
                innerWrapper.insertAdjacentHTML('beforebegin', '<button data-action="' + txt + '" type="button">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + '</button>');
                autoplayButton = outerWrapper.querySelector('[data-action]');
            }
            // add event
            if (autoplayButton) $4ec0aceb0167f552$var$addEvents(autoplayButton, {
                'click': toggleAnimation
            });
            if (!autoplay) {
                if (autoplayButton) $4ec0aceb0167f552$var$hideElement(autoplayButton);
            } else {
                startAutoplay();
                if (autoplayHoverPause) $4ec0aceb0167f552$var$addEvents(container, hoverEvents);
                if (autoplayResetOnVisibility) $4ec0aceb0167f552$var$addEvents(container, visibilityEvent);
            }
        }
        // == controlsInit ==
        if (hasControls) {
            if (controlsContainer) {
                prevButton = controlsContainer.children[0];
                nextButton = controlsContainer.children[1];
                $4ec0aceb0167f552$var$setAttrs(controlsContainer, {
                    'aria-label': 'Carousel Navigation',
                    'tabindex': '0'
                });
                $4ec0aceb0167f552$var$setAttrs(prevButton, {
                    'data-controls': 'prev'
                });
                $4ec0aceb0167f552$var$setAttrs(nextButton, {
                    'data-controls': 'next'
                });
                $4ec0aceb0167f552$var$setAttrs(controlsContainer.children, {
                    'aria-controls': slideId,
                    'tabindex': '-1'
                });
            } else {
                outerWrapper.insertAdjacentHTML('afterbegin', '<div class=' + `"${$4ec0aceb0167f552$var$tnsCssPrefix}-controls"` + ' aria-label="Carousel Navigation" tabindex="0"><button data-controls="prev" tabindex="-1" aria-controls="' + slideId + '" type="button">' + controlsText[0] + '</button><button data-controls="next" tabindex="-1" aria-controls="' + slideId + '" type="button">' + controlsText[1] + '</button></div>');
                controlsContainer = outerWrapper.querySelector(`.${$4ec0aceb0167f552$var$tnsCssPrefix}-controls`);
                prevButton = controlsContainer.children[0];
                nextButton = controlsContainer.children[1];
            }
            prevIsButton = isButton(prevButton);
            nextIsButton = isButton(nextButton);
            updateControlsStatus();
            // add events
            $4ec0aceb0167f552$var$addEvents(controlsContainer, controlsEvents);
            if (!controls) $4ec0aceb0167f552$var$hideElement(controlsContainer);
        }
        if (touch) $4ec0aceb0167f552$var$addEvents(container, touchEvents);
        if (mouseDrag) $4ec0aceb0167f552$var$addEvents(container, dragEvents);
        if (arrowKeys) $4ec0aceb0167f552$var$addEvents($4ec0aceb0167f552$var$doc, docmentKeydownEvent);
        if (nested === 'inner') events.on('outerResized', function() {
            resizeTasks();
            events.emit('innerLoaded', info());
        });
        else {
            $4ec0aceb0167f552$var$addEvents($4ec0aceb0167f552$var$win, {
                'resize': onResize
            });
            if (nested === 'outer') events.on('innerLoaded', runAutoHeight);
        }
        lazyLoad();
        runAutoHeight();
        toggleSlideDisplayAndEdgePadding();
        updateFixedWidthInnerWrapperStyle();
        events.on('indexChanged', additionalUpdates);
        if (typeof onInit === 'function') onInit(info());
        if (nested === 'inner') events.emit('innerLoaded', info());
        if (disable) disableSlider(true);
    })();
    // === ON RESIZE ===
    function onResize(e) {
        e = e || $4ec0aceb0167f552$var$win.event;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            var newWW = getWindowWidth();
            if (windowWidth !== newWW) {
                windowWidth = newWW;
                resizeTasks();
                if (nested === 'outer') events.emit('outerResized', info(e));
            }
        }, 100); // update after stop resizing for 100 ms
    }
    function resizeTasks() {
        var breakpointZoneTem = breakpointZone, indexTem = index, itemsTem = items, freezeTem = freeze;
        vpOuter = outerWrapper.clientWidth;
        vpInner = innerWrapper.clientWidth;
        if (breakpoints) setBreakpointZone();
        // things do when breakpoint zone change
        if (breakpointZoneTem !== breakpointZone || fixedWidth) {
            var arrowKeysTem = arrowKeys, autoHeightTem = autoHeight, fixedWidthTem = fixedWidth, edgePaddingTem = edgePadding, gutterTem = gutter, disableTem = disable;
            // update variables
            items = getOption('items');
            slideBy = getOption('slideBy');
            disable = getOption('disable');
            freeze = disable ? true : freezable ? slideCount <= items : false;
            if (items !== itemsTem) {
                indexMax = slideCountNew - items;
                // check index before transform in case
                // slider reach the right edge then items become bigger
                updateIndex();
            }
            if (disable !== disableTem) disableSlider(disable);
            if (freeze !== freezeTem) {
                // reset index to initial status
                if (freeze) index = !carousel ? 0 : cloneCount;
                toggleSlideDisplayAndEdgePadding();
            }
            if (breakpointZoneTem !== breakpointZone) {
                speed = getOption('speed');
                edgePadding = getOption('edgePadding');
                gutter = getOption('gutter');
                fixedWidth = getOption('fixedWidth');
                if (!disable && fixedWidth !== fixedWidthTem) doContainerTransform();
                autoHeight = getOption('autoHeight');
                if (autoHeight !== autoHeightTem) {
                    if (!autoHeight) innerWrapper.style.height = '';
                }
            }
            arrowKeys = freeze ? false : getOption('arrowKeys');
            if (arrowKeys !== arrowKeysTem) arrowKeys ? $4ec0aceb0167f552$var$addEvents($4ec0aceb0167f552$var$doc, docmentKeydownEvent) : $4ec0aceb0167f552$var$removeEvents($4ec0aceb0167f552$var$doc, docmentKeydownEvent);
            if (hasControls) {
                var controlsTem = controls, controlsTextTem = controlsText;
                controls = freeze ? false : getOption('controls');
                controlsText = getOption('controlsText');
                if (controls !== controlsTem) controls ? $4ec0aceb0167f552$var$showElement(controlsContainer) : $4ec0aceb0167f552$var$hideElement(controlsContainer);
                if (controlsText !== controlsTextTem) {
                    prevButton.innerHTML = controlsText[0];
                    nextButton.innerHTML = controlsText[1];
                }
            }
            if (hasNav) {
                var navTem = nav;
                nav = freeze ? false : getOption('nav');
                if (nav !== navTem) {
                    if (nav) {
                        $4ec0aceb0167f552$var$showElement(navContainer);
                        updateNavVisibility();
                    } else $4ec0aceb0167f552$var$hideElement(navContainer);
                }
            }
            if (hasTouch) {
                var touchTem = touch;
                touch = freeze ? false : getOption('touch');
                if (touch !== touchTem && carousel) touch ? $4ec0aceb0167f552$var$addEvents(container, touchEvents) : $4ec0aceb0167f552$var$removeEvents(container, touchEvents);
            }
            if (hasMouseDrag) {
                var mouseDragTem = mouseDrag;
                mouseDrag = freeze ? false : getOption('mouseDrag');
                if (mouseDrag !== mouseDragTem && carousel) mouseDrag ? $4ec0aceb0167f552$var$addEvents(container, dragEvents) : $4ec0aceb0167f552$var$removeEvents(container, dragEvents);
            }
            if (hasAutoplay) {
                var autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, autoplayTextTem = autoplayText;
                if (freeze) autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
                else {
                    autoplay = getOption('autoplay');
                    if (autoplay) {
                        autoplayHoverPause = getOption('autoplayHoverPause');
                        autoplayResetOnVisibility = getOption('autoplayResetOnVisibility');
                    } else autoplayHoverPause = autoplayResetOnVisibility = false;
                }
                autoplayText = getOption('autoplayText');
                autoplayTimeout = getOption('autoplayTimeout');
                if (autoplay !== autoplayTem) {
                    if (autoplay) {
                        if (autoplayButton) $4ec0aceb0167f552$var$showElement(autoplayButton);
                        if (!animating) startAutoplay();
                    } else {
                        if (autoplayButton) $4ec0aceb0167f552$var$hideElement(autoplayButton);
                        if (animating) stopAutoplay();
                    }
                }
                if (autoplayHoverPause !== autoplayHoverPauseTem) autoplayHoverPause ? $4ec0aceb0167f552$var$addEvents(container, hoverEvents) : $4ec0aceb0167f552$var$removeEvents(container, hoverEvents);
                if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) autoplayResetOnVisibility ? $4ec0aceb0167f552$var$addEvents($4ec0aceb0167f552$var$doc, visibilityEvent) : $4ec0aceb0167f552$var$removeEvents($4ec0aceb0167f552$var$doc, visibilityEvent);
                if (autoplayButton && autoplayText !== autoplayTextTem) {
                    var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
                    if (html.substring(len) === autoplayTextTem[i]) autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
                }
            }
            // IE8
            // ## update inner wrapper, container, slides if needed
            // set inline styles for inner wrapper & container
            // insert stylesheet (one line) for slides only (since slides are many)
            if (!$4ec0aceb0167f552$var$CSSMQ) {
                // inner wrapper styles
                if (!freeze && (edgePadding !== edgePaddingTem || gutter !== gutterTem)) innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth);
                // container styles
                if (carousel && horizontal && (fixedWidth !== fixedWidthTem || gutter !== gutterTem || items !== itemsTem)) container.style.width = getContainerWidth(fixedWidth, gutter, items);
                // slide styles
                if (horizontal && (items !== itemsTem || gutter !== gutterTem || fixedWidth != fixedWidthTem)) {
                    var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
                    // remove the last line and
                    // add new styles
                    sheet.removeRule($4ec0aceb0167f552$var$getCssRulesLength(sheet) - 1);
                    $4ec0aceb0167f552$var$addCSSRule(sheet, '#' + slideId + ` > .${$4ec0aceb0167f552$var$tnsCssPrefix}-item`, str, $4ec0aceb0167f552$var$getCssRulesLength(sheet));
                }
                // will do transform later if index !== indexTem
                // make sure doTransform will only run once
                if (!fixedWidth && index === indexTem) doTransform(0);
            }
            if (index !== indexTem) {
                events.emit('indexChanged', info());
                doTransform(0);
                indexCached = index;
            }
            if (items !== itemsTem) {
                additionalUpdates();
                updateSlidePosition();
                runAutoHeight();
                if (navigator.msMaxTouchPoints) setSnapInterval();
            }
        }
        // things always do regardless of breakpoint zone changing
        if (!horizontal && !disable) {
            getSlideOffsetTops();
            updateContentWrapperHeight();
            doContainerTransform();
        }
        updateFixedWidthInnerWrapperStyle(true);
        // auto height
        runAutoHeight();
    }
    // === INITIALIZATION FUNCTIONS === //
    function setBreakpointZone() {
        breakpointZone = 0;
        breakpoints.forEach(function(bp, i) {
            if (windowWidth >= bp) breakpointZone = i + 1;
        });
    }
    // (slideBy, indexMin, indexMax) => index
    var updateIndex = function() {
        return loop ? function() {
            var leftEdge = indexMin, rightEdge = indexMax;
            if (carousel) {
                leftEdge += slideBy;
                rightEdge -= slideBy;
                // adjust edges when edge padding is true
                // or fixed-width slider with extra space on the right side
                if (edgePadding) {
                    leftEdge += 1;
                    rightEdge -= 1;
                } else if (fixedWidth) {
                    var gt = gutter ? gutter : 0;
                    if (vpOuter % (fixedWidth + gt) > gt) rightEdge -= 1;
                }
            }
            if (index > rightEdge) while(index >= leftEdge + slideCount)index -= slideCount;
            else if (index < leftEdge) while(index <= rightEdge - slideCount)index += slideCount;
        } : function() {
            index = Math.max(indexMin, Math.min(indexMax, index));
        };
    }();
    function toggleSlideDisplayAndEdgePadding() {
        // if (cloneCount) {
        // if (fixedWidth && cloneCount) {
        var str = `${$4ec0aceb0167f552$var$tnsCssPrefix}-transparent`;
        if (freeze) {
            if (!frozen) {
                // remove edge padding from inner wrapper
                if (edgePadding) innerWrapper.style.margin = '0px';
                // add class ${tnsCssPrefix}-transparent to cloned slides
                if (cloneCount) for(var i = cloneCount; i--;){
                    if (carousel) $4ec0aceb0167f552$var$addClass(slideItems[i], str);
                    $4ec0aceb0167f552$var$addClass(slideItems[slideCountNew - i - 1], str);
                }
                frozen = true;
            }
        } else if (frozen) {
            // restore edge padding for inner wrapper
            // for mordern browsers
            if (edgePadding && !fixedWidth && $4ec0aceb0167f552$var$CSSMQ) innerWrapper.style.margin = '';
            // remove class ${tnsCssPrefix}-transparent to cloned slides
            if (cloneCount) for(var i = cloneCount; i--;){
                if (carousel) $4ec0aceb0167f552$var$removeClass(slideItems[i], str);
                $4ec0aceb0167f552$var$removeClass(slideItems[slideCountNew - i - 1], str);
            }
            frozen = false;
        }
    // }
    }
    function updateFixedWidthInnerWrapperStyle(resize) {
        if (fixedWidth && edgePadding) {
            // remove edge padding when freeze or viewport narrower than one slide
            if (freeze || vpOuter <= fixedWidth + gutter) {
                if (innerWrapper.style.margin !== '0px') innerWrapper.style.margin = '0px';
            } else if (resize) innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth);
        }
    }
    function disableSlider(disable) {
        var len = slideItems.length;
        if (disable) {
            sheet.disabled = true;
            container.className = container.className.replace(classContainer.substring(1), '');
            container.style = '';
            if (loop) for(var j = cloneCount; j--;){
                if (carousel) $4ec0aceb0167f552$var$hideElement(slideItems[j]);
                $4ec0aceb0167f552$var$hideElement(slideItems[len - j - 1]);
            }
            // vertical slider
            if (!horizontal || !carousel) innerWrapper.style = '';
            // gallery
            if (!carousel) for(var i = index; i < index + slideCount; i++){
                var item = slideItems[i];
                item.style = '';
                $4ec0aceb0167f552$var$removeClass(item, animateIn);
                $4ec0aceb0167f552$var$removeClass(item, animateNormal);
            }
        } else {
            sheet.disabled = false;
            container.className += classContainer;
            // vertical slider: get offsetTops before container transform
            if (!horizontal) getSlideOffsetTops();
            doContainerTransform();
            if (loop) for(var j = cloneCount; j--;){
                if (carousel) $4ec0aceb0167f552$var$showElement(slideItems[j]);
                $4ec0aceb0167f552$var$showElement(slideItems[len - j - 1]);
            }
            // gallery
            if (!carousel) for(var i = index; i < index + slideCount; i++){
                var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
                item.style.left = (i - index) * 100 / items + '%';
                $4ec0aceb0167f552$var$addClass(item, classN);
            }
        }
    }
    // lazyload
    function lazyLoad() {
        if (lazyload && !disable) {
            var i = index, len = index + items;
            if (edgePadding) {
                i -= 1;
                len += 1;
            }
            for(; i < len; i++)[].forEach.call(slideItems[i].querySelectorAll(`.${$4ec0aceb0167f552$var$tnsCssPrefix}-lazy-img`), function(img) {
                // stop propagationl transitionend event to container
                var eve = {};
                eve[$4ec0aceb0167f552$var$TRANSITIONEND] = function(e) {
                    e.stopPropagation();
                };
                $4ec0aceb0167f552$var$addEvents(img, eve);
                if (!$4ec0aceb0167f552$var$hasClass(img, 'loaded')) {
                    img.src = $4ec0aceb0167f552$var$getAttr(img, 'data-src');
                    $4ec0aceb0167f552$var$addClass(img, 'loaded');
                }
            });
        }
    }
    // check if all visible images are loaded
    // and update container height if it's done
    function runAutoHeight() {
        if (autoHeight && !disable) {
            // get all images inside visible slide items
            var images = [];
            for(var i = index; i < index + items; i++)[].forEach.call(slideItems[i].querySelectorAll('img'), function(img) {
                images.push(img);
            });
            if (images.length === 0) updateInnerWrapperHeight();
            else checkImagesLoaded(images);
        }
    }
    function checkImagesLoaded(images) {
        images.forEach(function(img, index) {
            if ($4ec0aceb0167f552$var$imageLoaded(img)) images.splice(index, 1);
        });
        if (images.length === 0) updateInnerWrapperHeight();
        else setTimeout(function() {
            checkImagesLoaded(images);
        }, 16);
    }
    function additionalUpdates() {
        lazyLoad();
        updateSlideStatus();
        updateControlsStatus();
        updateNavVisibility();
        updateNavStatus();
    }
    // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done
    function updateInnerWrapperHeight() {
        var heights = [], maxHeight;
        for(var i = index; i < index + items; i++)heights.push(slideItems[i].offsetHeight);
        maxHeight = Math.max.apply(null, heights);
        if (innerWrapper.style.height !== maxHeight) {
            if ($4ec0aceb0167f552$var$TRANSITIONDURATION) setDurations(speed);
            innerWrapper.style.height = maxHeight + 'px';
        }
    }
    // get the distance from the top edge of the first slide to each slide
    // (init) => slideOffsetTops
    function getSlideOffsetTops() {
        slideOffsetTops = [
            0
        ];
        var topFirst = slideItems[0].getBoundingClientRect().top, attr;
        for(var i = 1; i < slideCountNew; i++){
            attr = slideItems[i].getBoundingClientRect().top;
            slideOffsetTops.push(attr - topFirst);
        }
    }
    // set snapInterval (for IE10)
    function setSnapInterval() {
        outerWrapper.style.msScrollSnapPointsX = 'snapInterval(0%, ' + 100 / items + '%)';
    }
    // update slide
    function updateSlideStatus() {
        var l = index + Math.min(slideCount, items);
        for(var i = slideCountNew; i--;){
            var item = slideItems[i];
            // visible slides
            if (i >= index && i < l) {
                if ($4ec0aceb0167f552$var$hasAttr(item, 'tabindex')) {
                    $4ec0aceb0167f552$var$setAttrs(item, {
                        'aria-hidden': 'false'
                    });
                    $4ec0aceb0167f552$var$removeAttrs(item, [
                        'tabindex'
                    ]);
                    $4ec0aceb0167f552$var$addClass(item, slideActiveClass);
                }
            } else {
                if (!$4ec0aceb0167f552$var$hasAttr(item, 'tabindex')) $4ec0aceb0167f552$var$setAttrs(item, {
                    'aria-hidden': 'true',
                    'tabindex': '-1'
                });
                if ($4ec0aceb0167f552$var$hasClass(item, slideActiveClass)) $4ec0aceb0167f552$var$removeClass(item, slideActiveClass);
            }
        }
    }
    // gallery: update slide position
    function updateSlidePosition() {
        if (!carousel) {
            var l = index + Math.min(slideCount, items);
            for(var i = slideCountNew; i--;){
                var item = slideItems[i];
                if (i >= index && i < l) {
                    // add transitions to visible slides when adjusting their positions
                    $4ec0aceb0167f552$var$addClass(item, `${$4ec0aceb0167f552$var$tnsCssPrefix}-moving`);
                    item.style.left = (i - index) * 100 / items + '%';
                    $4ec0aceb0167f552$var$addClass(item, animateIn);
                    $4ec0aceb0167f552$var$removeClass(item, animateNormal);
                } else if (item.style.left) {
                    item.style.left = '';
                    $4ec0aceb0167f552$var$addClass(item, animateNormal);
                    $4ec0aceb0167f552$var$removeClass(item, animateIn);
                }
                // remove outlet animation
                $4ec0aceb0167f552$var$removeClass(item, animateOut);
            }
            // removing '.${tnsCssPrefix}-moving'
            setTimeout(function() {
                [].forEach.call(slideItems, function(el) {
                    $4ec0aceb0167f552$var$removeClass(el, `${$4ec0aceb0167f552$var$tnsCssPrefix}-moving`);
                });
            }, 300);
        }
    }
    // set tabindex & aria-selected on Nav
    function updateNavStatus() {
        // get current nav
        if (nav) {
            navCurrentIndex = navClicked !== -1 ? navClicked : index % slideCount;
            navClicked = -1;
            if (navCurrentIndex !== navCurrentIndexCached) {
                var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
                $4ec0aceb0167f552$var$setAttrs(navPrev, {
                    'tabindex': '-1',
                    'aria-selected': 'false'
                });
                $4ec0aceb0167f552$var$setAttrs(navCurrent, {
                    'tabindex': '0',
                    'aria-selected': 'true'
                });
                $4ec0aceb0167f552$var$removeClass(navPrev, navActiveClass);
                $4ec0aceb0167f552$var$addClass(navCurrent, navActiveClass);
            }
        }
    }
    function isButton(el) {
        return el.nodeName.toLowerCase() === 'button';
    }
    function isAriaDisabled(el) {
        return el.getAttribute('aria-disabled') === 'true';
    }
    function disEnableElement(isButton, el, val) {
        if (isButton) el.disabled = val;
        else el.setAttribute('aria-disabled', val.toString());
    }
    // set 'disabled' to true on controls when reach the edges
    function updateControlsStatus() {
        if (!controls || rewind || loop) return;
        var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index === indexMin ? true : false, disableNext = !rewind && index === indexMax ? true : false;
        if (disablePrev && !prevDisabled) disEnableElement(prevIsButton, prevButton, true);
        if (!disablePrev && prevDisabled) disEnableElement(prevIsButton, prevButton, false);
        if (disableNext && !nextDisabled) disEnableElement(nextIsButton, nextButton, true);
        if (!disableNext && nextDisabled) disEnableElement(nextIsButton, nextButton, false);
    }
    // set duration
    function setDurations(duration, target) {
        duration = !duration ? '' : duration / 1000 + 's';
        target = target || container;
        target.style[$4ec0aceb0167f552$var$TRANSITIONDURATION] = duration;
        if (!carousel) target.style[$4ec0aceb0167f552$var$ANIMATIONDURATION] = duration;
        if (!horizontal) innerWrapper.style[$4ec0aceb0167f552$var$TRANSITIONDURATION] = duration;
    }
    function getContainerTransformValue() {
        var val;
        if (horizontal) {
            if (fixedWidth) val = -(fixedWidth + gutter) * index + 'px';
            else {
                var denominator = $4ec0aceb0167f552$var$TRANSFORM ? slideCountNew : items;
                val = -index * 100 / denominator + '%';
            }
        } else val = -slideOffsetTops[index] + 'px';
        return val;
    }
    function doContainerTransform(val) {
        if (!val) val = getContainerTransformValue();
        container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }
    function animateSlide(number, classOut, classIn, isOut) {
        for(var i = number, l = number + items; i < l; i++){
            var item = slideItems[i];
            // set item positions
            if (!isOut) item.style.left = (i - index) * 100 / items + '%';
            if ($4ec0aceb0167f552$var$TRANSITIONDURATION) setDurations(speed, item);
            if (animateDelay && $4ec0aceb0167f552$var$TRANSITIONDELAY) item.style[$4ec0aceb0167f552$var$TRANSITIONDELAY] = item.style[$4ec0aceb0167f552$var$ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + 's';
            $4ec0aceb0167f552$var$removeClass(item, classOut);
            $4ec0aceb0167f552$var$addClass(item, classIn);
            if (isOut) slideItemsOut.push(item);
        }
    }
    // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers
    var transformCore = function() {
        return carousel ? function(duration, distance) {
            if (!distance) distance = getContainerTransformValue();
            // constrain the distance when non-loop no-edgePadding fixedWidth reaches the right edge
            if (hasRightDeadZone && index === indexMax) distance = -((fixedWidth + gutter) * slideCountNew - vpInner) + 'px';
            if ($4ec0aceb0167f552$var$TRANSITIONDURATION || !duration) {
                // for morden browsers with non-zero duration or
                // zero duration for all browsers
                doContainerTransform(distance);
                // run fallback function manually
                // when duration is 0 / container is hidden
                if (!duration || !$4ec0aceb0167f552$var$isVisible(container)) onTransitionEnd();
            } else // for old browser with non-zero duration
            $4ec0aceb0167f552$var$jsTransform(container, transformAttr, transformPrefix, transformPostfix, distance, speed, onTransitionEnd);
            if (!horizontal) updateContentWrapperHeight();
        } : function(duration) {
            slideItemsOut = [];
            var eve = {};
            eve[$4ec0aceb0167f552$var$TRANSITIONEND] = eve[$4ec0aceb0167f552$var$ANIMATIONEND] = onTransitionEnd;
            $4ec0aceb0167f552$var$removeEvents(slideItems[indexCached], eve);
            $4ec0aceb0167f552$var$addEvents(slideItems[index], eve);
            animateSlide(indexCached, animateIn, animateOut, true);
            animateSlide(index, animateNormal, animateIn);
            // run fallback function manually
            // when transition or animation not supported / duration is 0
            if (!$4ec0aceb0167f552$var$TRANSITIONEND || !$4ec0aceb0167f552$var$ANIMATIONEND || !duration) onTransitionEnd();
        };
    }();
    function doTransform(duration, distance) {
        // check duration is defined and is a number
        if (isNaN(duration)) duration = speed;
        // if container is hidden, set duration to 0
        // to fix an issue where browser doesn't fire ontransitionend on hidden element
        if (animating && !$4ec0aceb0167f552$var$isVisible(container)) duration = 0;
        if ($4ec0aceb0167f552$var$TRANSITIONDURATION) setDurations(duration);
        transformCore(duration, distance);
    }
    function render(e, sliderMoved) {
        if (updateIndexBeforeTransform) updateIndex();
        // render when slider was moved (touch or drag) even though index may not change
        if (index !== indexCached || sliderMoved) {
            // events
            events.emit('indexChanged', info());
            events.emit('transitionStart', info());
            // pause autoplay when click or keydown from user
            if (animating && e && [
                'click',
                'keydown'
            ].indexOf(e.type) >= 0) stopAutoplay();
            running = true;
            doTransform();
        }
    }
    /*
       * Transfer prefixed properties to the same format
       * CSS: -Webkit-Transform => webkittransform
       * JS: WebkitTransform => webkittransform
       * @param {string} str - property
       *
       */ function strTrans(str) {
        return str.toLowerCase().replace(/-/g, '');
    }
    // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height
    function onTransitionEnd(event) {
        // check running on gallery mode
        // make sure trantionend/animationend events run only once
        if (carousel || running) {
            events.emit('transitionEnd', info(event));
            if (!carousel && slideItemsOut.length > 0) for(var i = 0; i < items; i++){
                var item = slideItemsOut[i];
                // set item positions
                item.style.left = '';
                if ($4ec0aceb0167f552$var$TRANSITIONDURATION) setDurations(0, item);
                if (animateDelay && $4ec0aceb0167f552$var$TRANSITIONDELAY) item.style[$4ec0aceb0167f552$var$TRANSITIONDELAY] = item.style[$4ec0aceb0167f552$var$ANIMATIONDELAY] = '';
                $4ec0aceb0167f552$var$removeClass(item, animateOut);
                $4ec0aceb0167f552$var$addClass(item, animateNormal);
            }
            /* update slides, nav, controls after checking ...
           * => legacy browsers who don't support 'event'
           *    have to check event first, otherwise event.target will cause an error
           * => or 'gallery' mode:
           *   + event target is slide item
           * => or 'carousel' mode:
           *   + event target is container,
           *   + event.property is the same with transform attribute
           */ if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
                if (!updateIndexBeforeTransform) {
                    var indexTem = index;
                    updateIndex();
                    if (index !== indexTem) {
                        events.emit('indexChanged', info());
                        if ($4ec0aceb0167f552$var$TRANSITIONDURATION) setDurations(0);
                        doContainerTransform();
                    }
                }
                runAutoHeight();
                if (nested === 'inner') events.emit('innerLoaded', info());
                running = false;
                navCurrentIndexCached = navCurrentIndex;
                indexCached = index;
            }
        }
    }
    // # ACTIONS
    function goTo(targetIndex, e) {
        if (freeze) return;
        // prev slideBy
        if (targetIndex === 'prev') onControlsClick(e, -1);
        else if (targetIndex === 'next') onControlsClick(e, 1);
        else if (!running) {
            var absIndex = index % slideCount, indexGap = 0;
            if (absIndex < 0) absIndex += slideCount;
            if (targetIndex === 'first') indexGap = -absIndex;
            else if (targetIndex === 'last') indexGap = slideCount - items - absIndex;
            else {
                if (typeof targetIndex !== 'number') targetIndex = parseInt(targetIndex);
                if (!isNaN(targetIndex)) {
                    var absTargetIndex = targetIndex % slideCount;
                    if (absTargetIndex < 0) absTargetIndex += slideCount;
                    indexGap = absTargetIndex - absIndex;
                }
            }
            index += indexGap;
            // if index is changed, start rendering
            if (index % slideCount !== indexCached % slideCount) render(e);
        }
    }
    // on controls click
    function onControlsClick(e, dir) {
        if (!running) {
            var passEventObject;
            if (!dir) {
                e = e || $4ec0aceb0167f552$var$win.event;
                var target = e.target || e.srcElement;
                while(target !== controlsContainer && [
                    prevButton,
                    nextButton
                ].indexOf(target) < 0)target = target.parentNode;
                var targetIn = [
                    prevButton,
                    nextButton
                ].indexOf(target);
                if (targetIn >= 0) {
                    passEventObject = true;
                    dir = targetIn === 0 ? -1 : 1;
                }
            }
            if (rewind) {
                if (index === indexMin && dir === -1) {
                    goTo('last', e);
                    return;
                } else if (index === indexMax && dir === 1) {
                    goTo(0, e);
                    return;
                }
            }
            if (dir) {
                index += slideBy * dir;
                // pass e when click control buttons or keydown
                render(passEventObject || e && e.type === 'keydown' ? e : null);
            }
        }
    }
    // on nav click
    function onNavClick(e) {
        if (!running) {
            e = e || $4ec0aceb0167f552$var$win.event;
            var target = e.target || e.srcElement, navIndex;
            // find the clicked nav item
            while(target !== navContainer && !$4ec0aceb0167f552$var$hasAttr(target, 'data-nav'))target = target.parentNode;
            if ($4ec0aceb0167f552$var$hasAttr(target, 'data-nav')) {
                navIndex = navClicked = [].indexOf.call(navItems, target);
                goTo(navIndex, e);
            }
        }
    }
    // autoplay functions
    function setAutoplayTimer() {
        autoplayTimer = setInterval(function() {
            onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);
        animating = true;
    }
    function stopAutoplayTimer() {
        clearInterval(autoplayTimer);
        animating = false;
    }
    function updateAutoplayButton(action, txt) {
        $4ec0aceb0167f552$var$setAttrs(autoplayButton, {
            'data-action': action
        });
        autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }
    function startAutoplay() {
        setAutoplayTimer();
        if (autoplayButton) updateAutoplayButton('stop', autoplayText[1]);
    }
    function stopAutoplay() {
        stopAutoplayTimer();
        if (autoplayButton) updateAutoplayButton('start', autoplayText[0]);
    }
    // programaitcally play/pause the slider
    function play() {
        if (autoplay && !animating) startAutoplay();
    }
    function pause() {
        if (animating) stopAutoplay();
    }
    function toggleAnimation() {
        animating ? stopAutoplay() : startAutoplay();
    }
    function onVisibilityChange() {
        if ($4ec0aceb0167f552$var$doc.hidden) {
            if (animating) {
                stopAutoplayTimer();
                autoplayVisibilityPaused = true;
            }
        } else if (autoplayVisibilityPaused) {
            setAutoplayTimer();
            autoplayVisibilityPaused = false;
        }
    }
    function mouseoverPause() {
        if (animating) {
            stopAutoplayTimer();
            autoplayHoverPaused = true;
        }
    }
    function mouseoutRestart() {
        if (autoplayHoverPaused) {
            setAutoplayTimer();
            autoplayHoverPaused = false;
        }
    }
    // keydown events on document
    function onDocumentKeydown(e) {
        e = e || $4ec0aceb0167f552$var$win.event;
        switch(e.keyCode){
            case $4ec0aceb0167f552$var$KEYS.LEFT:
                onControlsClick(e, -1);
                break;
            case $4ec0aceb0167f552$var$KEYS.RIGHT:
                onControlsClick(e, 1);
        }
    }
    // on key control
    function onControlsKeydown(e) {
        e = e || $4ec0aceb0167f552$var$win.event;
        var code = e.keyCode;
        switch(code){
            case $4ec0aceb0167f552$var$KEYS.LEFT:
            case $4ec0aceb0167f552$var$KEYS.UP:
            case $4ec0aceb0167f552$var$KEYS.PAGEUP:
                if (!prevButton.disabled) onControlsClick(e, -1);
                break;
            case $4ec0aceb0167f552$var$KEYS.RIGHT:
            case $4ec0aceb0167f552$var$KEYS.DOWN:
            case $4ec0aceb0167f552$var$KEYS.PAGEDOWN:
                if (!nextButton.disabled) onControlsClick(e, 1);
                break;
            case $4ec0aceb0167f552$var$KEYS.HOME:
                goTo(0, e);
                break;
            case $4ec0aceb0167f552$var$KEYS.END:
                goTo(slideCount - 1, e);
                break;
        }
    }
    // set focus
    function setFocus(focus) {
        focus.focus();
    }
    // on key nav
    function onNavKeydown(e) {
        var curElement = $4ec0aceb0167f552$var$doc.activeElement;
        if (!$4ec0aceb0167f552$var$hasAttr(curElement, 'data-nav')) return;
        e = e || $4ec0aceb0167f552$var$win.event;
        var code = e.keyCode, navIndex = [].indexOf.call(navItems, curElement), len = visibleNavIndexes.length, current = visibleNavIndexes.indexOf(navIndex);
        if (options.navContainer) {
            len = slideCount;
            current = navIndex;
        }
        function getNavIndex(num) {
            return options.navContainer ? num : visibleNavIndexes[num];
        }
        switch(code){
            case $4ec0aceb0167f552$var$KEYS.LEFT:
            case $4ec0aceb0167f552$var$KEYS.PAGEUP:
                if (current > 0) setFocus(navItems[getNavIndex(current - 1)]);
                break;
            case $4ec0aceb0167f552$var$KEYS.UP:
            case $4ec0aceb0167f552$var$KEYS.HOME:
                if (current > 0) setFocus(navItems[getNavIndex(0)]);
                break;
            case $4ec0aceb0167f552$var$KEYS.RIGHT:
            case $4ec0aceb0167f552$var$KEYS.PAGEDOWN:
                if (current < len - 1) setFocus(navItems[getNavIndex(current + 1)]);
                break;
            case $4ec0aceb0167f552$var$KEYS.DOWN:
            case $4ec0aceb0167f552$var$KEYS.END:
                if (current < len - 1) setFocus(navItems[getNavIndex(len - 1)]);
                break;
            // Can't use onNavClick here,
            // Because onNavClick require event.target as nav items
            case $4ec0aceb0167f552$var$KEYS.ENTER:
            case $4ec0aceb0167f552$var$KEYS.SPACE:
                navClicked = navIndex;
                goTo(navIndex, e);
                break;
        }
    }
    // IE10 scroll function
    function ie10Scroll() {
        doTransform(0, container.scrollLeft());
        indexCached = index;
    }
    function getTarget(e) {
        return e.target || e.srcElement;
    }
    function isTouchEvent(e) {
        return e.type.indexOf('touch') >= 0;
    }
    function preventDefaultBehavior(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
    }
    function onTouchOrMouseStart(e) {
        // reset
        moveDirectionExpected = 0;
        touchedOrDraged = false;
        startX = startY = null;
        if (!running) {
            e = e || $4ec0aceb0167f552$var$win.event;
            var ev;
            if (isTouchEvent(e)) {
                ev = e.changedTouches[0];
                events.emit('touchStart', info(e));
            } else {
                ev = e;
                preventDefaultBehavior(e);
                events.emit('dragStart', info(e));
            }
            startX = parseInt(ev.clientX);
            startY = parseInt(ev.clientY);
            translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, '').replace(transformPostfix, ''));
        }
    }
    function onTouchOrMouseMove(e) {
        // make sure touch started or mouse draged
        if (!running && startX !== null) {
            e = e || $4ec0aceb0167f552$var$win.event;
            var ev;
            if (isTouchEvent(e)) ev = e.changedTouches[0];
            else {
                ev = e;
                preventDefaultBehavior(e);
            }
            disX = parseInt(ev.clientX) - startX;
            disY = parseInt(ev.clientY) - startY;
            if (moveDirectionExpected === 0) moveDirectionExpected = $4ec0aceb0167f552$var$getTouchDirection($4ec0aceb0167f552$var$toDegree(disY, disX), 15) === options.axis;
            if (moveDirectionExpected) {
                if (isTouchEvent(e)) events.emit('touchMove', info(e));
                else {
                    // "mousemove" event after "mousedown" indecate
                    // it is "drag", not "click"
                    if (!isDragEvent) isDragEvent = true;
                    events.emit('dragMove', info(e));
                }
                if (!touchedOrDraged) touchedOrDraged = true;
                var x = translateInit;
                if (horizontal) {
                    if (fixedWidth) {
                        x += disX;
                        x += 'px';
                    } else {
                        var percentageX = $4ec0aceb0167f552$var$TRANSFORM ? disX * items * 100 / (vpInner * slideCountNew) : disX * 100 / vpInner;
                        x += percentageX;
                        x += '%';
                    }
                } else {
                    x += disY;
                    x += 'px';
                }
                if ($4ec0aceb0167f552$var$TRANSFORM) setDurations(0);
                container.style[transformAttr] = transformPrefix + x + transformPostfix;
            }
        }
    }
    function onTouchOrMouseEnd(e) {
        if (!running && touchedOrDraged) {
            e = e || $4ec0aceb0167f552$var$win.event;
            var ev;
            if (isTouchEvent(e)) {
                ev = e.changedTouches[0];
                events.emit('touchEnd', info(e));
            } else {
                ev = e;
                events.emit('dragEnd', info(e));
            }
            disX = parseInt(ev.clientX) - startX;
            disY = parseInt(ev.clientY) - startY;
            var sliderMoved = Boolean(horizontal ? disX : disY);
            // reset
            moveDirectionExpected = 0;
            touchedOrDraged = false;
            startX = startY = null;
            if (horizontal) {
                var indexMoved = -disX * items / vpInner;
                indexMoved = disX > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                index += indexMoved;
            } else {
                var moved = -(translateInit + disY);
                if (moved <= 0) index = indexMin;
                else if (moved >= slideOffsetTops[slideOffsetTops.length - 1]) index = indexMax;
                else {
                    var i = 0;
                    do {
                        i++;
                        index = disY < 0 ? i + 1 : i;
                    }while (i < slideCountNew && moved >= slideOffsetTops[i + 1]);
                }
            }
            render(e, sliderMoved);
            // drag vs click
            if (isDragEvent) {
                // reset isDragEvent
                isDragEvent = false;
                // prevent "click"
                var target = getTarget(e);
                $4ec0aceb0167f552$var$addEvents(target, {
                    'click': function preventClick(e) {
                        preventDefaultBehavior(e);
                        $4ec0aceb0167f552$var$removeEvents(target, {
                            'click': preventClick
                        });
                    }
                });
            }
        }
    }
    // === RESIZE FUNCTIONS === //
    // (slideOffsetTops, index, items) => vertical_conentWrapper.height
    function updateContentWrapperHeight() {
        innerWrapper.style.height = slideOffsetTops[index + items] - slideOffsetTops[index] + 'px';
    }
    /*
       * get nav item indexes per items
       * add 1 more if the nav items cann't cover all slides
       * [0, 1, 2, 3, 4] / 3 => [0, 3]
       */ function getVisibleNavIndex() {
        // reset visibleNavIndexes
        visibleNavIndexes = [];
        var absIndexMin = index % slideCount % items;
        while(absIndexMin < slideCount){
            if (!loop && absIndexMin + items > slideCount) absIndexMin = slideCount - items;
            visibleNavIndexes.push(absIndexMin);
            absIndexMin += items;
        }
        // nav count * items < slide count means
        // some slides can not be displayed only by nav clicking
        if (loop && visibleNavIndexes.length * items < slideCount || !loop && visibleNavIndexes[0] > 0) visibleNavIndexes.unshift(0);
    }
    /*
       * 1. update visible nav items list
       * 2. add "hidden" attributes to previous visible nav items
       * 3. remove "hidden" attrubutes to new visible nav items
       */ function updateNavVisibility() {
        if (!nav || navAsThumbnails) return;
        getVisibleNavIndex();
        if (visibleNavIndexes !== visibleNavIndexesCached) {
            [].forEach.call(navItems, function(el, i) {
                if (visibleNavIndexes.indexOf(i) < 0) $4ec0aceb0167f552$var$hideElement(el);
                else $4ec0aceb0167f552$var$showElement(el);
            });
            // cache visible nav indexes
            visibleNavIndexesCached = visibleNavIndexes;
        }
    }
    function info(e) {
        return {
            container: container,
            slideItems: slideItems,
            navContainer: navContainer,
            navItems: navItems,
            controlsContainer: controlsContainer,
            hasControls: hasControls,
            prevButton: prevButton,
            nextButton: nextButton,
            items: items,
            slideBy: slideBy,
            cloneCount: cloneCount,
            slideCount: slideCount,
            slideCountNew: slideCountNew,
            index: index,
            indexCached: indexCached,
            navCurrentIndex: navCurrentIndex,
            navCurrentIndexCached: navCurrentIndexCached,
            visibleNavIndexes: visibleNavIndexes,
            visibleNavIndexesCached: visibleNavIndexesCached,
            event: e || {}
        };
    }
    return {
        getInfo: info,
        events: events,
        goTo: goTo,
        play: play,
        pause: pause,
        destroy: function() {
            // sheet
            sheet.disabled = true;
            // cloned items
            if (loop) for(var j = cloneCount; j--;){
                if (carousel) slideItems[0].remove();
                slideItems[slideItems.length - 1].remove();
            }
            // Slide Items
            var slideClasses = [
                `${$4ec0aceb0167f552$var$tnsCssPrefix}-item`,
                slideActiveClass
            ];
            if (!carousel) slideClasses = slideClasses.concat(`${$4ec0aceb0167f552$var$tnsCssPrefix}-normal`, animateIn);
            for(var i = slideCount; i--;){
                var slide = slideItems[i];
                if (slide.id.indexOf(slideId + '-item') >= 0) slide.id = '';
                slideClasses.forEach(function(cl) {
                    $4ec0aceb0167f552$var$removeClass(slide, cl);
                });
            }
            $4ec0aceb0167f552$var$removeAttrs(slideItems, [
                'style',
                'aria-hidden',
                'tabindex'
            ]);
            slideItems = slideId = slideCount = slideCountNew = cloneCount = null;
            // controls
            if (controls) {
                $4ec0aceb0167f552$var$removeEvents(controlsContainer, controlsEvents);
                if (options.controlsContainer) {
                    $4ec0aceb0167f552$var$removeAttrs(controlsContainer, [
                        'aria-label',
                        'tabindex'
                    ]);
                    $4ec0aceb0167f552$var$removeAttrs(controlsContainer.children, [
                        'aria-controls',
                        'aria-disabled',
                        'tabindex'
                    ]);
                }
                controlsContainer = prevButton = nextButton = null;
            }
            // nav
            if (nav) {
                $4ec0aceb0167f552$var$removeEvents(navContainer, navEvents);
                if (options.navContainer) {
                    $4ec0aceb0167f552$var$removeAttrs(navContainer, [
                        'aria-label'
                    ]);
                    $4ec0aceb0167f552$var$removeAttrs(navItems, [
                        'aria-selected',
                        'aria-controls',
                        'tabindex'
                    ]);
                }
                navContainer = navItems = null;
            }
            // auto
            if (autoplay) {
                clearInterval(autoplayTimer);
                if (autoplayButton) $4ec0aceb0167f552$var$removeEvents(autoplayButton, {
                    'click': toggleAnimation
                });
                $4ec0aceb0167f552$var$removeEvents(container, hoverEvents);
                $4ec0aceb0167f552$var$removeEvents(container, visibilityEvent);
                if (options.autoplayButton) $4ec0aceb0167f552$var$removeAttrs(autoplayButton, [
                    'data-action'
                ]);
            }
            // container
            container.id = containerIdCached || '';
            container.className = container.className.replace(classContainer, '');
            container.style = '';
            if (carousel && $4ec0aceb0167f552$var$TRANSITIONEND) {
                var eve = {};
                eve[$4ec0aceb0167f552$var$TRANSITIONEND] = onTransitionEnd;
                $4ec0aceb0167f552$var$removeEvents(container, eve);
            }
            $4ec0aceb0167f552$var$removeEvents(container, touchEvents);
            $4ec0aceb0167f552$var$removeEvents(container, dragEvents);
            // outerWrapper
            containerParent.insertBefore(container, outerWrapper);
            outerWrapper.remove();
            outerWrapper = innerWrapper = container = null;
            // remove arrowKeys eventlistener
            $4ec0aceb0167f552$var$removeEvents($4ec0aceb0167f552$var$doc, docmentKeydownEvent);
            // remove win event listeners
            $4ec0aceb0167f552$var$removeEvents($4ec0aceb0167f552$var$win, {
                'resize': onResize
            });
        }
    };
};


class $014896515af4fa26$export$23e5bb5ddc08b59c {
    constructor(){
        this.carouselThumbContainer = document.querySelectorAll('.opc-carousel[data-op-type="thumb-slider"] .carousel-slides') || null;
        this.carouselHeroContainer = document.querySelectorAll('.opc-carousel[data-op-type="hero-slider"] .carousel-slides') || null;
        this.thumbImages = document.querySelectorAll('.opc-asset li') || null;
        if (this.carouselThumbContainer) Array.from(this.carouselThumbContainer).forEach((item)=>{
            this.imageThumbCarousel(item);
        });
        if (this.carouselHeroContainer) Array.from(this.carouselHeroContainer).forEach((item)=>{
            this.imageHeroCarousel(item);
        });
        if (this.thumbImages) Array.from(this.thumbImages).forEach((item)=>{
            // eslint-disable-next-line no-unused-vars
            item.addEventListener('click', (event)=>{
                this.imageZoom(item);
            });
        });
    }
    /**
	 *
	 *
	 * @param {*} item
	 */ imageThumbCarousel(item) {
        // eslint-disable-next-line no-unused-vars
        let thumbSlider = (0, $4ec0aceb0167f552$export$1ce7868306ce1597)({
            container: item,
            slideBy: 'page',
            mode: 'carousel',
            items: 1,
            mouseDrag: false,
            touch: true,
            speed: 400,
            navContainer: `#${item.parentElement.id}-thumbnails`,
            navAsThumbnails: true,
            controls: true,
            controlsText: [
                '',
                ''
            ]
        });
    }
    /**
	 *
	 *
	 * @param {*} item
	 */ imageHeroCarousel(item) {
        // eslint-disable-next-line no-unused-vars
        let heroSlider = (0, $4ec0aceb0167f552$export$1ce7868306ce1597)({
            container: item,
            slideBy: 1,
            mode: 'gallery',
            mouseDrag: false,
            loop: true,
            speed: 1200,
            controls: true,
            controlsText: [
                '',
                ''
            ],
            navAsThumbnails: false,
            nav: true
        });
    }
    /**
	 *
	 *
	 * @param {*} item
	 */ imageZoom(item) {
        if (item) {
            let mainImage = item.parentElement.previousElementSibling;
            if (mainImage.hasAttribute('src')) {
                let source = item.querySelector('img').getAttribute('src');
                let altern = item.querySelector('img').getAttribute('alt');
                mainImage.setAttribute('src', source);
                mainImage.setAttribute('alt', altern);
                Array.from(item.parentElement.children).forEach((child)=>{
                    child.classList.remove('is-selected');
                });
                item.classList.add('is-selected');
            }
        }
    }
}


const $b4c5973f355943c3$export$16dded2130558df5 = new (0, $014896515af4fa26$export$23e5bb5ddc08b59c)();







class $83e75036008392d0$export$78510a3f4496dd24 {
    constructor(form){
        this.form = form;
        this.formFieldSelector = '.opc-form-field';
        this.inputFields = [];
        this.inputFieldList = form.querySelectorAll('[data-op-zipcity-search]');
        // diese keys werden beim keyUp ignoriert
        this.ignoredKeys = [
            9,
            13,
            16,
            17,
            18,
            19,
            20,
            27,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40 // down
        ];
        if (this.inputFieldList.length > 0) // eslint-disable-next-line no-unused-vars
        Array.from(this.inputFieldList).forEach((item, index)=>{
            let fieldWrapper = item.closest(this.formFieldSelector);
            this.inputFields.push({
                inputField: item,
                dropdown: fieldWrapper.querySelector('[data-op-zipcity-list]'),
                country: this.form.querySelector(`#${item.dataset.opCountryId}`),
                isDirty: false,
                data: []
            });
        });
        if (this.inputFields.length > 0) this.attachEventListener();
        this.eventDispatcher = null;
        this.lastSearchTerm = null;
    }
    /**
	 * Split PLZ & Ort
	 *
	 * @param {HTMLElement} value Value des Eingabefeldes
	 * @returns {Object} PLZ und Ort als Objekt
	 */ parseZipCity(value) {
        let zip = undefined;
        let arr = value.split(' ');
        let nbrRegex = new RegExp('^[0-9]+$');
        zip = arr.find((elem)=>{
            if (nbrRegex.test(elem)) return elem;
        });
        if (!zip) {
            let arr = value.split(' ');
            if (arr.length > 1) zip = parseInt(arr[1]);
            if (!zip) zip = '';
        }
        let city = value.replace(zip, '').trim();
        if (city === 'undefined') city = '';
        return {
            zip: zip,
            city: city
        };
    }
    /**
	 * Event Registrierungen im DOM
	 *
	 */ attachEventListener() {
        let liSelected = undefined;
        Array.from(this.inputFields).forEach((item)=>{
            item.inputField.addEventListener('click', ()=>{
                if (item.dropdown.hasChildNodes()) item.dropdown.parentNode.classList.toggle('is-visible');
            });
            item.inputField.addEventListener('keydown', (e)=>{
                if (e.keyCode == 9 || e.keyCode == 13 || e.keyCode == 40) {
                    liSelected = item.dropdown.firstChild;
                    if (liSelected) {
                        item.dropdown.parentNode.classList.add('is-visible');
                        liSelected.focus();
                        e.preventDefault();
                    }
                }
            });
            item.inputField.addEventListener('keyup', (e)=>{
                if (e.keyCode == 9 || e.keyCode == 13 || e.keyCode == 40) return;
                if (this.ignoredKeys.indexOf(e.keyCode) >= 0) return;
                this.searchZip(e.target.value, item);
            });
            item.dropdown.addEventListener('keydown', (e)=>{
                if (e.which === 40) {
                    if (liSelected) {
                        let next = liSelected.nextSibling;
                        liSelected = next !== undefined && next !== null ? next : liSelected;
                    } else liSelected = item.dropdown.firstChild;
                    liSelected.focus();
                    this.setScroller(liSelected, item);
                    e.preventDefault();
                } else if (e.which === 38) {
                    if (liSelected) {
                        var next = liSelected.previousSibling;
                        liSelected = next !== undefined && next !== null ? next : liSelected;
                    } else liSelected = item.dropdown.firstChild;
                    liSelected.focus();
                    this.setScroller(liSelected, item);
                    e.preventDefault();
                } else if (e.which === 13) {
                    this.selectItem(item, liSelected.innerText, liSelected.dataset.opCountry);
                    e.preventDefault();
                } else if (e.which === 9) item.dropdown.parentNode.classList.remove('is-visible');
            });
            item.dropdown.addEventListener('click', (e)=>{
                this.selectItem(item, e.target.innerText, e.target.dataset.opCountry);
            });
            if (item.country !== null && item.country != '') item.country.addEventListener('change', (e)=>{
                if (item.data.length === 0 || item.data.country != e.target.value) {
                    this.clearData(item);
                    item.inputField.value = '';
                }
            });
        });
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} value
	 * @param {*} country
	 */ selectItem(item, value, country) {
        item.inputField.value = value;
        if (item.country !== null) item.country.value = country ? country : '';
        var zipCity = this.parseZipCity(value);
        item.data = [];
        item.data.push({
            zip: zipCity.zip,
            city: zipCity.city,
            country: country
        });
        item.isDirty = false;
        item.inputField.focus();
        item.dropdown.parentNode.classList.remove('is-visible');
    }
    /**
	 *
	 *
	 * @param {*} el
	 * @param {*} item
	 */ setScroller(el, item) {
        let index = Array.prototype.slice.call(item.dropdown.children).indexOf(el);
        let elHeight = el.height;
        let scrollTop = item.dropdown.parentNode.scrollTop;
        let viewport = scrollTop + item.dropdown.parentNode.height;
        let elOffset = elHeight * index;
        if (elOffset < scrollTop || elOffset + elHeight > viewport) item.dropdown.parentNode.scrollTop = elOffset;
    }
    /**
	 *
	 *
	 * @param {*} value
	 * @param {*} item
	 * @returns {*}
	 */ searchZip(value, item) {
        if (value === undefined || value === null) return;
        value = value.trim();
        if (value.length < 2) {
            this.clearData(item);
            return;
        }
        this.lastSearchTerm = value;
        if (this.eventDispatcher) clearTimeout(this.eventDispatcher);
        this.eventDispatcher = setTimeout(()=>{
            this.callApi(value, item);
        }, 300);
    }
    /**
	 *
	 *
	 * @param {*} value
	 * @param {*} item
	 * @returns {*}
	 */ callApi(value, item) {
        if (this.lastSearchTerm !== value) return;
        let country = 'ch';
        if (item.country !== null && item.country.value !== '') country = item.country.value.toLowerCase();
        let zipCity = this.parseZipCity(value);
        let fetchUrl = `/api/portal/v1/zipsearch?zip=${zipCity.zip}&city=${zipCity.city}&country=${country}`;
        (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynGetJson(fetchUrl, this.refreshResultList.bind(this, item));
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} asyncData
	 * @returns {*}
	 */ refreshResultList(item, asyncData) {
        if (!asyncData) return;
        this.clearData(item);
        asyncData.forEach((element)=>{
            let li = document.createElement('li');
            li.dataset.opCountry = element.country;
            li.dataset.opZip = element.zip;
            li.dataset.opCity = element.city;
            li.appendChild(document.createTextNode(`${element.zip} ${element.city}`));
            li.tabIndex = -1;
            item.dropdown.appendChild(li);
            item.data.push({
                zip: element.zip,
                city: element.city,
                country: element.country
            });
        });
        if (item.data.length === 0) {
            let li = document.createElement('li');
            li.appendChild(document.createTextNode((0, $6a5d168af5ede3cd$export$fbedd73e1269236f).messageNoValueFound.text));
            li.classList.add('disabled');
            item.dropdown.appendChild(li);
        }
        item.isDirty = true;
        item.dropdown.parentNode.classList.add('is-visible');
    }
    /**
	 *
	 *
	 * @param {*} item
	 */ clearData(item) {
        while(item.dropdown.firstChild)item.dropdown.removeChild(item.dropdown.firstChild);
        item.data = [];
    }
}


/**
 * XSS Validierung
 *
 */ class $094562a426337aa9$export$3b3c9793f14d5897 {
    constructor(form){
        this.form = form;
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ htmlEncodeXssFields() {
        let attribute = this.form.getAttribute('data-op-no-xss');
        if (attribute !== '1') return;
        let fields = this.form.querySelectorAll('[data-op-no-xss="1"]');
        if (fields.length == 0) return;
        Array.from(fields).forEach((field)=>{
            field.value = this.htmlEncode(field.value);
        });
    }
    /**
	 *
	 *
	 * @param {*} text
	 * @returns {*}
	 */ htmlDecode(text) {
        let div = document.createElement('div');
        div.innerHTML = text;
        return 'textContent' in div ? div.textContent : div.innerText;
    }
    /**
	 *
	 *
	 * @param {*} str
	 * @returns {*}
	 */ htmlEncode(str) {
        let div = document.createElement('div');
        div['textContent' in div ? 'textContent' : 'innerText'] = str;
        return div.innerHTML;
    }
}


class $9a8661df079a6616$export$93014f54d2ef40ae {
    constructor(form, customPostValidationMethod = null){
        this.form = form;
        this.messages = (0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91);
        this.customPostValidation = customPostValidationMethod;
        this.pwdValidationElement = this.form.querySelector('.pwd-strength');
        this.zipSearch = new (0, $83e75036008392d0$export$78510a3f4496dd24)(form);
        this.xssValidation = new (0, $094562a426337aa9$export$3b3c9793f14d5897)(form);
        let emailPattern = '^[\\w\\-.+]+@([A-Za-z0-9_\\-]+\\.)+[A-Za-z]{2,}$';
        let pwdNumberPattern = window.opacc.pwdPattern && window.opacc.pwdPattern.numberPattern ? window.opacc.pwdPattern.numberPattern : '(?=.*([\\d]))';
        let pwdUpperPattern = window.opacc.pwdPattern && window.opacc.pwdPattern.upperPattern ? window.opacc.pwdPattern.upperPattern : '(?=.*([A-Z]))';
        let pwdLengthPattern = window.opacc.pwdPattern && window.opacc.pwdPattern.minLengthPattern && window.opacc.pwdPattern.maxLengthPattern ? `(.{${window.opacc.pwdPattern.minLengthPattern},${window.opacc.pwdPattern.maxLengthPattern}})` : '(.{9,})';
        let pwdCharacterPattern = window.opacc.pwdPattern && window.opacc.pwdPattern.allowedCharacterPattern ? `${window.opacc.pwdPattern.allowedCharacterPattern}+` : '.+';
        let pwdRegex = window.opacc.pwdPattern && window.opacc.pwdPattern.regex ? window.opacc.pwdPattern.regex : '';
        this.emailPattern = emailPattern;
        this.pwdPatternObj = {
            pwdNumberPattern: {
                pattern: pwdNumberPattern,
                match: false
            },
            pwdUpperPattern: {
                pattern: pwdUpperPattern,
                match: false
            },
            pwdLengthPattern: {
                pattern: pwdLengthPattern,
                match: false
            },
            pwdCharacterPattern: {
                pattern: `^${pwdCharacterPattern}$`,
                match: false
            }
        };
        this.pwdPattern = pwdRegex.length > 0 ? pwdRegex : `^${pwdNumberPattern}${pwdUpperPattern}${pwdLengthPattern}$`;
        if (!this.form.hasAttribute('novalidate')) {
            this.form.noValidate = true;
            this.inlineValidation = /true/i.test(this.form.dataset.opValidateInline) || false;
            this.attachEventListener(this.inlineValidation);
        }
    }
    /**
	 * Event Registrierungen im DOM
	 *
	 * @param {boolean} inline Sollen die Formularfelder innerhalb des Formulares beim Fokusverlust validiert werden?
	 */ attachEventListener(inline) {
        this.form.addEventListener('submit', (e)=>{
            e.preventDefault();
            const submitBtns = Array.from(this.form.elements).filter((item)=>{
                return item.type === 'submit';
            });
            this.validateForm(this.form.elements).then((result)=>{
                // disable Submit Button wenn validation ok
                // (enable nicht notwendig, da nach aktualisierung vom response das attribut nicht mehr vorhanden ist)
                if (!result.length) submitBtns.forEach((submitBtn)=>{
                    submitBtn.disabled = true;
                });
                //inject custom Validation
                if (this.customPostValidation != null && (typeof this.customPostValidation == 'function' || typeof this.customPostValidation == 'object')) {
                    if (typeof this.customPostValidation == 'function') result.push(...this.customPostValidation());
                    else this.customPostValidation.forEach((func)=>{
                        result.push(...func());
                    });
                }
                // if no Errors --> submit form / else show error
                if (result.length === 0) {
                    this.xssValidation.htmlEncodeXssFields();
                    let captchaObj = this.checkGRecaptcha(this.form);
                    if (captchaObj.gRecaptchaElem && captchaObj.gRecaptchaApi) {
                        // deprecated --> used for Google ReCAPTCHA V2
                        if (captchaObj.isInvisibleCaptcha) window.grecaptcha.execute();
                        else {
                            let captchaResp = this.form.querySelector('#g-recaptcha-response');
                            if (captchaResp && captchaResp.value != '') this.form.submit();
                        }
                    } else if (captchaObj.hasDedicatedCheck && captchaObj.reCaptchaResponse === '') return;
                    else this.form.submit();
                } else {
                    this.showError(result);
                    // set focus on first formElement with Error
                    result[0].item.focus();
                }
            });
        });
        if (this.pwdValidationElement) {
            let passwordFields = this.form.querySelectorAll('input[type="password"][data-op-check-pwd-strength="true"]');
            Array.from(passwordFields).forEach((item)=>{
                [
                    'focus',
                    'keyup'
                ].forEach((e)=>{
                    item.addEventListener(e, ()=>{
                        this.checkPasswordPattern(item);
                    });
                });
            });
        }
        if (inline) this.validateInline(this.form.elements);
    }
    /**
	 * Validierung der Formularfelder beim Verlassen prüfen
	 *
	 * @param {HTMLElement} formElems Formularfelder innerhalb des Formulares
	 */ validateInline(formElems) {
        Array.from(formElems).forEach((item)=>{
            // // Don't validate submits, buttons, file and reset inputs, disabled and hidden fields
            if (item.disabled || item.type === 'file' || item.type === 'reset' || item.type === 'submit' || item.type === 'button' || item.type === 'hidden' && !item.hasAttribute('data-op-value')) return;
            // Validation for checkboxes and radio's
            item.addEventListener('click', ()=>{
                if (!(item.type === 'checkbox' || item.type === 'radio')) return;
                if (!item.pattern) this.setItemPattern(item);
                this.removeError(item);
                // if results --> show error
                this.validateInput(item).then((result)=>{
                    // custom Function injection
                    if (this.customPostValidation != null && (typeof this.customPostValidation == 'function' || typeof this.customPostValidation == 'object')) {
                        if (typeof this.customPostValidation == 'function') result.push(...this.customPostValidation());
                        else this.customPostValidation.forEach((func)=>{
                            result.push(...func());
                        });
                    }
                    if (result.length != 0) this.showError(result);
                });
            });
            if (item.dataset.opZipcitySearch) item.addEventListener('focus', ()=>{
                let value = item.value.trim();
                if (!value) return;
                let zipCityField = this.zipSearch.inputFields.filter((obj)=>{
                    return obj.inputField == item;
                });
                let zipCity = zipCityField[0].data.find((i)=>value === `${i.zip} ${i.city}`);
                if (!zipCity) item.nextElementSibling.classList.remove('is-visible');
                else this.removeError(item);
            });
            //check if Formfield is blurred by Key "Tab"
            let tabbed = undefined;
            item.addEventListener('keydown', (e)=>{
                tabbed = false;
                if (e.keyCode == 9) tabbed = true;
            });
            item.addEventListener('blur', (e)=>{
                if (!item.pattern) this.setItemPattern(item);
                this.removeError(item);
                // if results --> show error
                this.validateInput(item).then((result)=>{
                    // custom Function injection
                    if (this.customPostValidation != null && (typeof this.customPostValidation == 'function' || typeof this.customPostValidation == 'object')) {
                        if (typeof this.customPostValidation == 'function') result.push(...this.customPostValidation());
                        else this.customPostValidation.forEach((func)=>{
                            result.push(...func());
                        });
                    }
                    if (result.length != 0) this.showError(result);
                    else if (e.relatedTarget && e.relatedTarget.type === 'submit') {
                        e.relatedTarget.focus();
                        if (!tabbed) e.relatedTarget.click();
                    }
                });
            });
        });
    }
    /**
	 * Formular auf Gültigkeit prüfen beim submit
	 *
	 * @param {HTMLElement} formElems Formularelemente des zu übermittelnden Formulares
	 * @returns Promise mit fehlerhaften Formularelementen und Fehlerbeschreibung zur Weiterverarbeitung
	 */ validateForm(formElems) {
        let validationSet = [];
        Array.from(formElems).forEach((item)=>{
            // Don't validate submits, buttons, file and reset inputs, disabled and hidden fields
            if (item.disabled || item.type === 'file' || item.type === 'reset' || item.type === 'submit' || item.type === 'button' || item.type === 'hidden' && !item.hasAttribute('data-op-value')) return;
            if (!item.pattern) this.setItemPattern(item);
            this.removeError(item);
            this.validateInput(item).then((result)=>{
                if (result.length != 0) validationSet.push(result[0]);
            });
        });
        return new Promise((resolve)=>{
            resolve(validationSet);
        });
    }
    /**
	 * Prüfung eines einzelnen Formularfeldes ohne Formwrapper
	 *
	 * @param {HTMLElement} item Formularfeld, welches geprüft werden soll
	 * @returns Promise ob Feld gültig ist (true / false)
	 */ validateField(item) {
        // // Don't validate submits, buttons, file and reset inputs, and disabled fields
        if (item.disabled || item.type === 'file' || item.type === 'reset' || item.type === 'submit' || item.type === 'button') return;
        if (this.pwdValidationElement) [
            'focus',
            'keyup'
        ].forEach((e)=>{
            item.addEventListener(e, ()=>{
                this.checkPasswordPattern(item);
            });
        });
        if (!item.pattern) this.setItemPattern(item);
        this.removeError(item);
        // if results --> show error
        let isInputValid = this.validateInput(item).then((result)=>{
            if (result.length != 0) {
                this.showError(result);
                return false;
            } else return true;
        });
        return Promise.resolve(isInputValid);
    }
    /**
	 * Input-Felder vom Typ Email und Password mit entsprechendem pattern zur Validierung vorbereiten
	 *
	 * @param {HTMLElement} item Formularfeld
	 */ setItemPattern(item) {
        if (item.type === 'email') item.pattern = this.emailPattern;
        if (item.type === 'password') item.pattern = this.pwdPattern;
    }
    /**
	 * Anzeige des Status der Passwort-Validierungs-Richtlinien im DOM aktualisieren
	 *
	 * @param {HTMLElement} item Inputfeld vom Typ "password"
	 */ checkPasswordPattern(item) {
        let conditions = this.pwdValidationElement.querySelectorAll('[data-op-pwd-condition]');
        Object.keys(this.pwdPatternObj).forEach((key)=>{
            let regex = new RegExp(this.pwdPatternObj[key].pattern);
            this.pwdPatternObj[key].match = regex.test(item.value);
            if (conditions) {
                if (this.pwdPatternObj[key].match) Array.from(conditions).filter((i)=>{
                    this.camelCase(i.dataset.opPwdCondition) === key && i.classList.add('is-valid');
                });
                else Array.from(conditions).filter((i)=>{
                    this.camelCase(i.dataset.opPwdCondition) === key && i.classList.remove('is-valid');
                });
            }
        });
    }
    isMatchingInput(item) {
        this.removeError(item);
        this.removeError(this.form.querySelector(item.dataset.opMatchInput));
        let compareInput = this.form.querySelector(item.dataset.opMatchInput) ? this.form.querySelector(item.dataset.opMatchInput).value : '';
        if (compareInput !== '' && item.value !== '') return item.value === compareInput;
        return undefined;
    }
    /**
	 * // ToDO:
	 *
	 * @returns String // ToDo
	 */ keydownEvent() {
        let evt = window.event;
        let charCode = evt.keyCode || evt.which;
        let charStr = String.fromCharCode(charCode);
        return charStr;
    }
    camelCase(string) {
        return string.replace(/-([a-z])/ig, (all, letter)=>{
            return letter.toUpperCase();
        });
    }
    /**
	 * Validierungs-Details für Formularfeld überprüfen und bei Fehler entsprechende Meldung zurückgeben
	 *
	 * @param {HTMLElement} item Formularfeld
	 * @returns Fehlermeldung als String
	 */ getValidityDetails(item) {
        let validity = item.validity;
        if (validity.valueMissing) {
            if (item.dataset.opMessageValueMissing) return item.dataset.opMessageValueMissing;
            if (item.type === 'select-multiple') return this.messages.messageValueMissingSelectMulti.text;
            if (item.type === 'select-one') return this.messages.messageValueMissingSelect.text;
            return this.messages.messageValueMissing.text;
        }
        // If not the right type
        if (validity.typeMismatch) {
            // Email
            if (item.dataset.opMessageTypeMismatchEmail) return item.dataset.opMessageTypeMismatchEmail;
            if (item.type === 'email') return this.messages.messageTypeMismatchEmail.text;
            // URL
            if (item.dataset.opMessageTypeMismatchUrl) return item.dataset.opMessageTypeMismatchUrl;
            if (item.type === 'url') return this.messages.messageTypeMismatchUrl.text;
        }
        // If too short
        if (validity.tooShort) {
            if (item.dataset.opMessageTooShort) {
                if (item.dataset.opMessageTooShort.indexOf('{minLength}') > 0 && item.hasAttribute('minlength')) return item.dataset.opMessageTooShort.replace('{minLength}', item.getAttribute('minlength')).replace('{length}', item.value.length);
            }
            return this.messages.messageTooShort.text.replace('{minLength}', item.getAttribute('minlength')).replace('{length}', item.value.length);
        }
        // If too long
        if (validity.tooLong) {
            if (item.dataset.opMessageTooLong) {
                if (item.dataset.opMessageTooLong.indexOf('{maxLength}') > 0 && item.hasAttribute('maxlength')) return item.dataset.opMessageTooLong.replace('{maxLength}', item.getAttribute('maxlength')).replace('{length}', item.value.length);
            }
            return this.messages.messageTooLong.text.replace('{maxLength}', item.getAttribute('maxlength')).replace('{length}', item.value.length);
        }
        // If number input isn't a number
        if (validity.badInput) {
            if (item.dataset.opMessageBadInput) return item.dataset.opMessageBadInput;
            return this.messages.messageBadInput.text;
        }
        // If a number value doesn't match the step interval
        if (validity.stepMismatch) {
            if (item.dataset.opMessageStepMismatch) {
                if (item.dataset.opMessageStepMismatch.indexOf('{step}') > 0 && item.hasAttribute('step')) return item.dataset.opMessageStepMismatch.replace('{step}', item.getAttribute('step'));
            }
            return this.messages.messageStepMismatch.text.replace('{step}', item.getAttribute('step') || 1);
        }
        // If a number field is over the max
        if (validity.rangeOverflow) {
            if (item.dataset.opMessageRangeOverflow) {
                if (item.dataset.opMessageRangeOverflow.indexOf('{max}') > 0 && item.hasAttribute('max')) return item.dataset.opMessageRangeOverflow.replace('{max}', item.getAttribute('max'));
            }
            return this.messages.messageRangeOverflow.text.replace('{max}', item.getAttribute('max'));
        }
        // If a number field is below the min
        if (validity.rangeUnderflow) {
            if (item.dataset.opMessageRangeUnderflow) {
                if (item.dataset.opMessageRangeUnderflow.indexOf('{min}') > 0 && item.hasAttribute('min')) return item.dataset.opMessageRangeUnderflow.replace('{min}', item.getAttribute('min'));
            }
            return this.messages.messageRangeUnderflow.text.replace('{min}', item.getAttribute('min'));
        }
        // If pattern doesn't match
        if (validity.patternMismatch) {
            // If pattern does not match
            if (item.dataset.opMessagePatternMismatch) return item.dataset.opMessagePatternMismatch;
            return this.messages.messagePatternMismatch.text;
        }
        // Custom Error is Set?
        if (validity.customError) {
            if (item.dataset.opMessageValueMissing) return item.dataset.opMessageValueMissing;
            return this.messages.messageValueMissingSelect.text;
        }
    }
    showError(errObj) {
        errObj.forEach((formItem)=>{
            this.removeError(formItem.item);
            let message = document.createElement('div');
            message.className = 'form-field-error';
            message.htmlFor = formItem.item.id;
            message.innerHTML = formItem.validation;
            this.decorateFormElement(this.getFormElementWrapper(formItem.item), 'add', message);
        });
    }
    removeError(item) {
        this.decorateFormElement(this.getFormElementWrapper(item), 'remove');
    }
    resetForm(items) {
        Array.from(items).forEach((item)=>{
            this.removeError(item);
        });
        this.form.reset();
    }
    getFormElementWrapper(item) {
        let formElementWrapper = undefined;
        switch(item.type){
            case 'radio':
            case 'checkbox':
                formElementWrapper = item.closest('.opc-form-field');
                break;
            default:
                formElementWrapper = item.closest('.opc-form-field');
        }
        return formElementWrapper;
    }
    decorateFormElement(item, decorationType = 'add', msg = null) {
        // do not validate recaptcha elements
        if (item === null || item.classList.contains('g-recaptcha-response')) return;
        if (decorationType === 'add') {
            item.classList.add('is-invalid');
            // check for form field element
            let formFieldElement = item.querySelector('.form-field-element');
            if (formFieldElement) formFieldElement.insertAdjacentElement('afterend', msg);
            else item.appendChild(msg);
        } else if (item.classList.contains('is-invalid')) {
            item.classList.remove('is-invalid');
            let errorElement = item.querySelector('.form-field-error');
            errorElement.remove();
        }
    }
    /**
	 * Validierung der Formularfelder auf gültigen Input
	 *
	 * @param {HTMLElement} item Formularfeld
	 * @returns Array mit Fehlermeldungen
	 */ validateInput(item) {
        let validationSet = [];
        if (!item.checkValidity()) validationSet.push({
            item: item,
            validation: this.getValidityDetails(item)
        });
        else if (item.type === 'hidden' && item.hasAttribute('required')) {
            if (!item.dataset.opValue) validationSet.push({
                item: item,
                validation: this.messages.messageValueMissing.text
            });
        } else if (item.dataset.opZipcityPair) {
            let zipCityFields = [];
            Array.from(item.form.querySelectorAll(`[data-op-zipcity-pair="${item.dataset.opZipcityPair}"]`)).forEach((i)=>{
                this.removeError(i);
                zipCityFields.push(i);
            });
            if (!this.checkZipCityCombination(zipCityFields)) zipCityFields.forEach((field)=>{
                validationSet.push({
                    item: field,
                    validation: field.dataset.opMessageBadCombination
                });
            });
        } else if (item.dataset.opZipcitySearch) {
            let value = item.value.trim();
            let zipCityField = this.zipSearch.inputFields.filter((obj)=>{
                return obj.inputField == item;
            });
            let zipCity = zipCityField[0].data.find((i)=>value === `${i.zip} ${i.city}`);
            if (zipCityField[0].isDirty === true && zipCity) zipCityField[0].isDirty = false;
            if (!zipCity || zipCityField[0].isDirty === true) {
                let validate = true;
                if (zipCityField[0].isDirty === false && value !== null && value !== '') validate = false;
                if (validate) {
                    let msg = item.dataset.opMessageBadCombination;
                    if (!msg) msg = this.messages.messageGeneric.text;
                    validationSet.push({
                        item: item,
                        validation: msg
                    });
                }
            } else item.nextElementSibling.classList.remove('is-visible');
            if (zipCityField[0].data.length == 0) item.nextElementSibling.classList.remove('is-visible');
        } else if (item.dataset.opType == 'autocomplete') {
            let autocompleteWrapper = item.closest('.opc-autocomplete');
            if (autocompleteWrapper.classList.contains('is-loading')) {
                item.setCustomValidity('loading');
                validationSet.push({
                    item: item,
                    validation: this.getValidityDetails(item)
                });
                item.setCustomValidity('');
            }
        } else if (item.dataset.opMatchInput) {
            let isMatchTrue = this.isMatchingInput(item);
            if (!isMatchTrue && isMatchTrue !== undefined) {
                validationSet.push({
                    item: item,
                    validation: this.messages.messageUnequal.text
                });
                validationSet.push({
                    item: this.form.querySelector(item.dataset.opMatchInput),
                    validation: this.messages.messageUnequal.text
                });
            }
        }
        return new Promise((resolve)=>{
            resolve(validationSet);
        });
    }
    checkZipCityCombination(allZipCityFields) {
        const zipCityValidation = {
            currentZip: '',
            currentCity: ''
        };
        allZipCityFields.forEach((field)=>{
            let pairingType = field.dataset.opPairingType;
            if (pairingType) switch(pairingType.toLowerCase()){
                case 'zip':
                    zipCityValidation.currentZip = field;
                    break;
                case 'city':
                    zipCityValidation.currentCity = field;
                    break;
                case 'country':
                    zipCityValidation.currentCountry = field;
                    break;
                default:
                    break;
            }
            else if (field.id === `${field.form.id}-zip`) zipCityValidation.currentZip = field;
            else if (field.id === `${field.form.id}-city`) zipCityValidation.currentCity = field;
        });
        let hasNoInputAmout = 0;
        for (const [, element] of Object.entries(zipCityValidation))if (element.value === '') hasNoInputAmout++;
        if (hasNoInputAmout === Object.keys(zipCityValidation).length) return true;
        let isValid = false;
        let fieldValidationObj = {
            zipIsValid: false,
            cityIsValid: false
        };
        let city = this.getObjects(window.zipCityCombination, '', zipCityValidation.currentCity.value.toLowerCase());
        if (city.length > 0) {
            city.some((item)=>{
                if (item.Zip === zipCityValidation.currentZip.value.toString()) fieldValidationObj.zipIsValid = true;
                if (zipCityValidation.currentCountry) {
                    if (item.Country.toLowerCase() === zipCityValidation.currentCountry.value.toLowerCase()) fieldValidationObj.countryIsValid = true;
                }
                if (item.City.toLowerCase() === zipCityValidation.currentCity.value.toLowerCase()) fieldValidationObj.cityIsValid = true;
            });
            hasNoInputAmout = 0;
            for (const [, value] of Object.entries(fieldValidationObj))if (value) hasNoInputAmout++;
            if (hasNoInputAmout === Object.keys(zipCityValidation).length) isValid = true;
        }
        return isValid;
    }
    getObjects(obj, key, val) {
        let objects = [];
        for(let i in obj){
            // eslint-disable-next-line no-prototype-builtins
            if (!obj.hasOwnProperty(i)) continue;
            if (typeof obj[i] == 'object') objects = objects.concat(this.getObjects(obj[i], key, val));
            else if (i == key && obj[i] == val || i == key && val == '') objects.push(obj);
            else if (obj[i] == val && key == '') {
                if (objects.lastIndexOf(obj) == -1) objects.push(obj);
            }
        }
        return objects;
    }
    checkGRecaptcha(form) {
        let returnObj = {};
        let gRecaptchaElem = form.querySelector('.g-recaptcha') || undefined;
        let isInvisibleCaptcha = undefined;
        let gRecaptchaApi = undefined;
        let hasDedicatedCheck = undefined;
        let reCaptchaVersion = 'v2';
        let reCaptchaResponseElem = form.querySelector('#g-recaptcha-response') || undefined;
        if (gRecaptchaElem) {
            isInvisibleCaptcha = gRecaptchaElem.dataset.size == 'invisible' ? true : false;
            gRecaptchaApi = window.grecaptcha ? true : false;
            hasDedicatedCheck = false;
        } else if (form.querySelector('input.g-recaptcha-response[type="hidden"]')) {
            hasDedicatedCheck = true;
            reCaptchaVersion = form.querySelector('input.g-recaptcha-response[type="hidden"]').getAttribute('data-op-recaptcha-version');
        }
        returnObj.gRecaptchaElem = gRecaptchaElem;
        returnObj.gRecaptchaApi = gRecaptchaApi;
        returnObj.isInvisibleCaptcha = isInvisibleCaptcha;
        returnObj.hasDedicatedCheck = hasDedicatedCheck;
        returnObj.reCaptchaVersion = reCaptchaVersion;
        returnObj.reCaptchaResponse = reCaptchaResponseElem ? reCaptchaResponseElem.value : '';
        return returnObj;
    }
    static isFormValid(form, showErrors = false) {
        let retVal = false;
        const formValidator = new $9a8661df079a6616$export$93014f54d2ef40ae(form);
        return new Promise((resolve)=>{
            formValidator.validateForm(form.elements).then((result)=>{
                if (result.length === 0) retVal = true;
                if (showErrors && result.length > 0) {
                    formValidator.showError(result);
                    // set focus on first formElement with Error
                    result[0].item.focus();
                }
                resolve(retVal);
            });
        });
    }
}


class $5961c51de156bbf5$export$b165f57eb862003b {
    constructor(){
        this.contentContainer = document.querySelector('body');
        this.countContainer = document.querySelectorAll('.favorite-count');
        this.requestData = {};
        this.messages = Object.assign({}, (0, $6a5d168af5ede3cd$export$329e838a9ba51357), (0, $6a5d168af5ede3cd$export$39227038979f1988));
        this.modalWindowSelector = '.opc-favorite-modal';
        this.attachEventListener();
    }
    /**
	 * Event Registrierung im DOM
	 *
	 */ attachEventListener() {
        if (this.contentContainer) this.contentContainer.addEventListener('click', (event)=>{
            let button = event.target.closest('[data-op-multifavoritesaction]');
            if (button) this.selectFavoriteList(button);
            let deleteBtn = event.target.closest('#delete-form .opc-button');
            if (deleteBtn && deleteBtn.type == 'submit') {
                event.preventDefault();
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showConfirm(this.messages.messageDeleteConfirmation.text, this.messages.messageOk.text, this.messages.messageCancel.text, this.confirmDeletionFavoriteList.bind(this, deleteBtn), undefined, undefined, 'confirm-delete');
            }
        });
    }
    /**
	 *
	 *
	 * @param {*} button
	 */ selectFavoriteList(button) {
        this.checkMaximum(button).then((resolve)=>{
            if (resolve) {
                if (button.dataset.opMultifavoritesaction === 'added') button.classList.add('is-progress');
                this.sendAjaxRequest(button);
            }
        });
    }
    /**
	 *
	 *
	 * @param {*} button
	 */ confirmDeletionFavoriteList(button) {
        let deleteForm = button.closest('form');
        deleteForm.submit();
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */ checkMaximum(item) {
        let action = item.dataset.opMultifavoritesaction;
        let countList = Number(this.countContainer[0] ? this.countContainer[0].textContent : 0);
        let countPosition = Number(item.querySelector('.favorite-list-item-count') ? item.querySelector('.favorite-list-item-count').textContent : 0);
        let maxList = Number(item.dataset.opMaxlist);
        let maxPosition = Number(item.dataset.opMaxposition);
        let nameField = this.contentContainer.querySelector('.favorite-modal-footer input');
        let name = nameField ? nameField.value : '';
        let target = item.dataset.opSaldocboidtarget;
        // eslint-disable-next-line no-unused-vars
        let type = '';
        let valid = true;
        if (action === 'added' || action === 'moved') {
            // Maximale Anzahl Positionen pruefen
            if (target && maxPosition > 0 && countPosition >= maxPosition) {
                valid = false;
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage(this.messages.messageMaxPositions);
            } else if (!target && name && maxList > 0 && countList >= maxList) {
                valid = false;
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage(this.messages.messageMaxLists);
            }
        }
        if ((action === 'added' || action === 'moved') && !target && valid) {
            nameField.dataset.opMessagePatternMismatch = this.messages.messageInvalidName.text;
            return new (0, $9a8661df079a6616$export$93014f54d2ef40ae)(nameField.closest('.opc-form-field')).validateField(nameField);
        }
        return Promise.resolve(valid);
    }
    /**
	 *
	 *
	 * @param {*} item
	 */ sendAjaxRequest(item) {
        let nameField = this.contentContainer.querySelector('.favorite-modal-footer input');
        this.requestData = {
            Type: 'favorite',
            ArtFavorite_ArtNo: item.dataset.opArtno,
            ArtFavorite_ArtBoId: item.dataset.opArtboid,
            ArtFavorite_ListName: nameField ? nameField.value : '',
            ArtFavorite_MultiAction: item.dataset.opMultifavoritesaction,
            ArtFavorite_OnList: item.dataset.opOnlist ? item.dataset.opOnlist : '',
            ArtFavorite_SalDocBoIdSource: item.dataset.opSaldocboidsource ? item.dataset.opSaldocboidsource : '',
            ArtFavorite_SalDocBoIdTarget: item.dataset.opSaldocboidtarget ? item.dataset.opSaldocboidtarget : '',
            maxLists: item.dataset.opMaxlist,
            maxPositions: item.dataset.opMaxposition
        };
        for(var property in item.dataset)if (property.startsWith('opSaldocitem.')) this.requestData[property.substring(2).toLowerCase()] = item.dataset[property];
        this.hookBeforeSendAjaxRequest(item);
        let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
        (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, this.hookBeforeReturnPrepareDataSubmission(item, this.requestData), this.refreshContent.bind(this, item), this.asyncErrorHandler.bind(this), true);
    }
    /**
	 *
	 *
	 * @param {*} button
	 * @param {*} response
	 */ refreshContent(button, response) {
        response = this.hookBeforeRefreshContent(button, response);
        if (response.success) {
            // CSS-Klassen aktualisieren
            if (this.contentContainer) {
                let items = this.contentContainer.querySelectorAll(`.opc-favorite-button[data-op-artboid="${response.dataAsJson.artBoId}"]`);
                Array.from(items).forEach((item)=>{
                    if (response.dataAsJson.onList) {
                        item.classList.add('is-active');
                        item.dataset.opOnlist = response.dataAsJson.onList;
                    } else item.classList.remove('is-active');
                });
            }
            // Artikel aus Merklisten-Ansicht entfernen
            if (response.dataAsJson.action === 'deleted' || response.dataAsJson.action === 'moved') this.removeFavoriteItem(response.dataAsJson.artBoId);
            // Modal-Dialog anzeigen/ausblenden
            if (response.dataAsJson.action === 'added' || response.dataAsJson.action === 'deleted' || response.dataAsJson.action === 'moved') {
                button.classList.remove('is-progress');
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).hideModal();
                // Merklistenzaehler aktualisieren
                if (this.countContainer) Array.from(this.countContainer).forEach((item)=>{
                    item.textContent = response.dataAsJson.favoriteCount;
                });
                if (response.dataAsJson.action === 'moved' && !button.dataset.opSaldocboidtarget) window.location.reload();
            } else (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showModal(response.dataAsJson.message);
            // Wechsel zwischen Hinzufügen und Löschen als Gast (nur eine Merkliste möglich)
            if (response.dataAsJson.isGuest && this.contentContainer) {
                let items = this.contentContainer.querySelectorAll(`.opc-favorite-button[data-op-artboid="${response.dataAsJson.artBoId}"]`);
                if (response.dataAsJson.action === 'added') Array.from(items).forEach((item)=>{
                    item.dataset.opMultifavoritesaction = "deleted";
                    item.dataset.opOnlist = response.dataAsJson.onList;
                    item.dataset.opSaldocboidtarget = response.dataAsJson.salDocBoIdTarget;
                    item.title = response.dataAsJson.titleDelete;
                });
                else if (response.dataAsJson.action === 'deleted') Array.from(items).forEach((item)=>{
                    item.dataset.opMultifavoritesaction = "added";
                    item.dataset.opOnlist = "";
                    item.dataset.opSaldocboidtarget = response.dataAsJson.salDocBoIdTarget;
                    item.title = response.dataAsJson.titleAdd;
                });
            }
        } else button.classList.remove('is-progress');
        this.hookAfterRefreshContent(button, response);
    }
    /**
	 *
	 *
	 * @param {*} artBoId
	 */ removeFavoriteItem(artBoId) {
        if (this.contentContainer) {
            let items = this.contentContainer.querySelectorAll(`button[data-op-multifavoritesaction^="delete"][data-op-artboid="${artBoId}"]`);
            Array.from(items).forEach((item)=>{
                let favItem = item.closest('li[data-op-iscatitem]');
                if (favItem) {
                    let parent = favItem.parentNode;
                    if (parent) {
                        parent.removeChild(favItem);
                        if (parent.querySelectorAll('li').length == 0) window.location.reload();
                    }
                }
            });
        }
    }
    /**
	 *
	 *
	 * @param {*} error
	 */ asyncErrorHandler(error) {
        // eslint-disable-next-line no-console
        console.error('Request failed: ', error.message);
        this.hookAfterAsyncErrorHandler(error);
    }
    // ---------------------------------
    /**
	 *
	 *
	 * @param {*} item
	 */ // eslint-disable-next-line no-unused-vars
    hookBeforeSendAjaxRequest(item) {}
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */ hookBeforeReturnPrepareDataSubmission(item, data) {
        return data;
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */ hookBeforeRefreshContent(item, data) {
        return data;
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterRefreshContent(item, data) {}
    /**
	 *
	 *
	 * @param {*} error
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterAsyncErrorHandler(error) {}
}


const $8449158a2b06cdc8$export$81f9ac8d7b5c3347 = new (0, $5961c51de156bbf5$export$b165f57eb862003b)();


function $57d2c2f49ca4016c$var$autocomplete(settings) {
    // just an alias to minimize JS file size
    const doc = document;
    const container = settings.container != null ? settings.container : doc.createElement('div');
    const containerStyle = container.style;
    const userAgent = navigator.userAgent;
    const mobileFirefox = userAgent.indexOf('Firefox') !== -1 && userAgent.indexOf('Mobile') !== -1;
    const debounceWaitMs = settings.debounceWaitMs || 0;
    // 'keyup' event will not be fired on Mobile Firefox, so we have to use 'input' event instead
    const keyUpEventName = mobileFirefox ? 'input' : 'keyup';
    let items = [];
    let inputValue = '';
    let minLen = 2;
    const showOnFocus = settings.showOnFocus;
    let selected;
    let keypressCounter = 0;
    let debounceTimer;
    if (settings.minLength !== undefined) minLen = settings.minLength;
    if (!settings.input) throw new Error('input undefined');
    const input = settings.input;
    container.className = 'select-list ' + (settings.className || '');
    /**
     * Detach the container from DOM
     */ function detach() {
        let parent = container.parentNode;
        parent.classList.add('is-hidden');
        if (container.childElementCount > 0) while(container.hasChildNodes())container.removeChild(container.firstChild);
    }
    /**
     * Clear debouncing timer if assigned
     */ function clearDebounceTimer() {
        if (debounceTimer) window.clearTimeout(debounceTimer);
    }
    /**
     * Attach the container to DOM
     */ function attach() {
        let parent = container.parentNode;
        parent.classList.remove('is-hidden');
        if (!container.parentNode) doc.body.appendChild(container);
    }
    /**
     * Check if container for autocomplete is displayed
     */ function containerDisplayed() {
        let parent = container.parentNode;
        return parent.classList.contains('is-hidden') ? false : !!parent;
    }
    /**
     * Clear autocomplete state and hide container
     */ function clear() {
        keypressCounter++;
        items = [];
        inputValue = '';
        selected = undefined;
        detach();
    }
    /**
     * Update autocomplete position
     */ function updatePosition() {
        if (!containerDisplayed()) return;
        containerStyle.height = 'auto';
        containerStyle.width = input.offsetWidth + 'px';
        const inputRect = input.getBoundingClientRect();
        const top = inputRect.top + input.offsetHeight;
        let maxHeight = window.innerHeight - top;
        containerStyle.top = top + 'px';
        containerStyle.bottom = '';
        containerStyle.left = inputRect.left + 'px';
        if (settings.customize) settings.customize(input, inputRect, container, maxHeight);
    }
    /**
     * Redraw the autocomplete div element with suggestions
     */ function update() {
        // delete all children from autocomplete DOM container
        while(container.firstChild)container.removeChild(container.firstChild);
        // function for rendering autocomplete suggestions
        // eslint-disable-next-line no-unused-vars
        let render = function(item, currentValue) {
            const itemElement = doc.createElement('div');
            itemElement.textContent = item.label || '';
            return itemElement;
        };
        if (settings.render) render = settings.render;
        // function to render autocomplete groups
        // eslint-disable-next-line no-unused-vars
        let renderGroup = function(groupName, currentValue) {
            const groupDiv = doc.createElement('div');
            groupDiv.textContent = groupName;
            return groupDiv;
        };
        if (settings.renderGroup) renderGroup = settings.renderGroup;
        const fragment = doc.createDocumentFragment();
        let prevGroup = '#9?$';
        items.forEach(function(item) {
            if (item.group && item.group !== prevGroup) {
                prevGroup = item.group;
                const groupDiv = renderGroup(item.group, inputValue);
                if (groupDiv) {
                    groupDiv.className += ' group';
                    fragment.appendChild(groupDiv);
                }
            }
            const div = render(item, inputValue);
            if (div) {
                div.addEventListener('click', function(ev) {
                    settings.onSelect(item, input);
                    clear();
                    ev.preventDefault();
                    ev.stopPropagation();
                });
                if (item === selected) div.className += ' selected';
                fragment.appendChild(div);
            }
        });
        container.appendChild(fragment);
        if (items.length < 1) {
            if (settings.emptyMsg) {
                const empty = doc.createElement('li');
                empty.className = 'empty';
                empty.textContent = settings.emptyMsg;
                container.appendChild(empty);
            } else {
                clear();
                return;
            }
        }
        attach();
        updatePosition();
        updateScroll();
    }
    function updateIfDisplayed() {
        if (containerDisplayed()) update();
    }
    function resizeEventHandler() {
        updateIfDisplayed();
    }
    function keyupEventHandler(ev) {
        const keyCode = ev.which || ev.keyCode || 0;
        const ignore = [
            35 /* End */ ,
            36 /* Home */ ,
            38 /* Up */ ,
            13 /* Enter */ ,
            27 /* Esc */ ,
            39 /* Right */ ,
            37 /* Left */ ,
            16 /* Shift */ ,
            17 /* Ctrl */ ,
            18 /* Alt */ ,
            20 /* CapsLock */ ,
            91 /* WindowsKey */ ,
            9 /* Tab */ 
        ];
        for (const key of ignore){
            if (keyCode === key) return;
        }
        // the down key is used to open autocomplete
        if (keyCode === 40 /* Down */  && containerDisplayed()) return;
        startFetch(0 /* Keyboard */ );
    }
    /**
     * Automatically move scroll bar if selected item is not visible
     */ function updateScroll() {
        const elements = container.getElementsByClassName('selected');
        if (elements.length > 0) {
            let element = elements[0];
            // make group visible
            const previous = element.previousElementSibling;
            if (previous && previous.className.indexOf('group') !== -1 && !previous.previousElementSibling) element = previous;
            if (element.offsetTop < container.scrollTop) container.scrollTop = element.offsetTop;
            else {
                const selectBottom = element.offsetTop + element.offsetHeight;
                const containerBottom = container.scrollTop + container.offsetHeight;
                if (selectBottom > containerBottom) container.scrollTop += selectBottom - containerBottom;
            }
        }
    }
    /**
     * Select the previous item in suggestions
     */ function selectPrev() {
        if (items.length < 1) selected = undefined;
        else if (selected === items[0]) selected = items[items.length - 1];
        else {
            for(let i = items.length - 1; i > 0; i--)if (selected === items[i] || i === 1) {
                selected = items[i - 1];
                break;
            }
        }
    }
    /**
     * Select the next item in suggestions
     */ function selectNext() {
        if (items.length < 1) selected = undefined;
        if (!selected || selected === items[items.length - 1]) {
            selected = items[0];
            return;
        }
        for(let i = 0; i < items.length - 1; i++)if (selected === items[i]) {
            selected = items[i + 1];
            break;
        }
    }
    function keydownEventHandler(ev) {
        const keyCode = ev.which || ev.keyCode || 0;
        if (keyCode === 38 /* Up */  || keyCode === 40 /* Down */  || keyCode === 27 /* Esc */ ) {
            const containerIsDisplayed = containerDisplayed();
            if (keyCode === 27 /* Esc */ ) clear();
            else {
                if (!containerDisplayed || items.length < 1) return;
                keyCode === 38 /* Up */  ? selectPrev() : selectNext();
                update();
            }
            ev.preventDefault();
            if (containerIsDisplayed) ev.stopPropagation();
            return;
        }
        if (keyCode === 13 /* Enter */  && selected) {
            ev.preventDefault();
            settings.onSelect(selected, input);
            clear();
        }
    }
    function focusEventHandler() {
        if (showOnFocus) startFetch(1 /* Focus */ );
    }
    function startFetch(trigger) {
        // if multiple keys were pressed, before we get update from server,
        // this may cause redrawing our autocomplete multiple times after the last key press.
        // to avoid this, the number of times keyboard was pressed will be
        // saved and checked before redraw our autocomplete box.
        const savedKeypressCounter = ++keypressCounter;
        const val = input.value;
        if (val.length >= minLen || trigger === 1 /* Focus */ ) {
            clearDebounceTimer();
            debounceTimer = window.setTimeout(function() {
                settings.fetch(val, function(elements) {
                    if (keypressCounter === savedKeypressCounter && elements) {
                        items = elements;
                        inputValue = val;
                        selected = items.length > 0 ? items[0] : undefined;
                        update();
                    }
                }, 0 /* Keyboard */ );
            }, trigger === 0 /* Keyboard */  ? debounceWaitMs : 0);
        } else clear();
    }
    function blurEventHandler() {
        // we need to delay clear, because when we click on an item, blur will be called before click and remove items from DOM
        setTimeout(()=>{
            if (doc.activeElement !== input) clear();
        }, 200);
    }
    /**
     * Fixes #26: on long clicks focus will be lost and onSelect method will not be called
     */ container.addEventListener('mousedown', function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
    });
    /**
     * This function will remove DOM elements and clear event handlers
     */ function destroy() {
        input.removeEventListener('focus', focusEventHandler);
        input.removeEventListener('keydown', keydownEventHandler);
        input.removeEventListener(keyUpEventName, keyupEventHandler);
        input.removeEventListener('blur', blurEventHandler);
        window.removeEventListener('resize', resizeEventHandler);
        clearDebounceTimer();
        clear();
        // prevent the update call if there are pending AJAX requests
        keypressCounter++;
    }
    // setup event handlers
    input.addEventListener('keydown', keydownEventHandler);
    input.addEventListener(keyUpEventName, keyupEventHandler);
    input.addEventListener('blur', blurEventHandler);
    input.addEventListener('focus', focusEventHandler);
    window.addEventListener('resize', resizeEventHandler);
    return {
        destroy: destroy
    };
}
var $57d2c2f49ca4016c$export$2e2bcd8739ae039 = $57d2c2f49ca4016c$var$autocomplete;






class $0fc5485f94a8164d$export$7f675ee6ba2f1942 {
    constructor(customSettings = null){
        // default Wert für die Thresholds, wenn in gGetBoAttrField kein Wert für Threshold gesetzt wurde
        this.defaultThreshold = 3;
        this.wrapperElement = document.querySelector('.content');
        this.autocompleteWrapperSelector = '.opc-autocomplete';
        this.autocompleteFields = this.wrapperElement.querySelectorAll(`${this.autocompleteWrapperSelector}`);
        Array.from(this.autocompleteFields).forEach((item)=>{
            this.settings = null;
            let inputField = item.querySelector('[data-op-type="autocomplete"]');
            let hiddenField = inputField.parentElement.querySelector('input[type="hidden"]');
            // start-loading animation
            item.classList.add('is-loading');
            // check for Async-Data
            const dataLoaded = this.loadData(item, hiddenField, inputField);
            dataLoaded.then((result)=>{
                if (result === true) item.classList.remove('is-loading');
            });
            //default properties
            const defaultSettings = {
                minLength: item.dataset.opThreshold || this.defaultThreshold,
                input: inputField,
                onSelect: this.onSelectFnc.bind(this, hiddenField),
                showOnFocus: item.dataset.opAutoload ? item.dataset.opAutoload.toLowerCase() === 'true' : true,
                fetch: this.filterList.bind(this, hiddenField, inputField, item),
                render: this.renderList.bind(this, item),
                emptyMsg: (0, $6a5d168af5ede3cd$export$fbedd73e1269236f).messageNoValueFound.text,
                renderGroup: this.renderGroup.bind(this),
                container: item.querySelector('.form-field-list > ul.select-list')
            };
            if (customSettings) {
                if (typeof customSettings != 'object') throw new Error('inputparameter must be an Object!');
            }
            this.settings = Object.assign(defaultSettings, customSettings);
            this.attachEventListener(inputField, hiddenField);
            this.autocomplete = new (0, $57d2c2f49ca4016c$export$2e2bcd8739ae039)(this.settings);
        });
    }
    /**
	 * Diese Methode wird der Autocomplete-Library übergeben und dient zur Aufbereitung der Autocomplete-Liste.
	 *
	 * @param {HTMLElement} hiddenField Verstecktes Formularfeld, dient der Speicherung des ausgewählten Wertes
	 * @param {HTMLElement} inputField Angezeigtes Formularfeld, dient der Anzeige des ausgewählten Labels
	 * @param {HTMLElement} el Autocomplete Element
	 * @param {string} text Suchstring
	 * @param {Function} update Vorschläge des Autocomplete-Feldes aktualisieren
	 */ filterList(hiddenField, inputField, el, text, update) {
        // add loading-animation
        el.classList.add('is-loading');
        let match = text.toLowerCase();
        let dataLoaded = this.getAsynData(this.prepareAsyncUrl(inputField, el));
        dataLoaded.then((result)=>{
            if (Array.isArray(result)) {
                let suggestions = null;
                if ('opExtendedSearch' in inputField.dataset && inputField.dataset.opExtendedSearch.toLowerCase() === 'true') suggestions = result;
                else suggestions = result.filter((item)=>{
                    let label = item.label;
                    return label.toLowerCase().indexOf(match) !== -1;
                });
                update(suggestions);
            }
            if (inputField.defaultValue != inputField.value) this.clearInputFieldSelection(hiddenField);
            // remove loading-animation
            el.classList.remove('is-loading');
        }).catch(()=>{
            throw new Error('Filtered list could not be loaded');
        });
    }
    /**
	 * Diese Methode wird der Autocomplete-Library übergeben. Beim auswählen eines Items aus der Liste wird diese Methode ausgeführt.
	 *
	 * @param {HTMLElement} hiddenField verstecktes Formularfeld, dient der Speicherung des ausgewählten Wertes
	 * @param {Object} item Ausgewähltes Element aus der Liste
	 * @param {HTMLElement} inputField angezeigtes Formularfeld, dient der Anzeige des ausgewählten Labels
	 */ onSelectFnc(hiddenField, item, inputField) {
        hiddenField.value = item.value;
        inputField.value = item.label;
        inputField.defaultValue = inputField.value;
        if (this.settings.onSelectHook) this.settings.onSelectHook(item, inputField);
    }
    /**
	 * Diese Methode wird der Autocomplete-Library übergeben und legt das Rendering der Rückgabe-Liste fest. Für jeden Autocomplete-Vorschlag wird diese Methode 1 x ausgeführt.
	 *
	 * @param {HTMLElement} el Autocomplete Element
	 * @param {Object} item Einzelnes Element aus der Resultats-Liste
	 * @param {string} currentValue Aktueller Suchstring
	 * @returns Formatierter Autocomplete-Vorschlag
	 */ renderList(el, item, currentValue) {
        let element = document.createElement('li');
        let highLightMatch = el.dataset.opHighlight.toLowerCase() === 'true';
        this.returnElementMarkup(element, item, highLightMatch, currentValue);
        return element;
    }
    /**
	 *  Diese Methode wird der Autocomplete-Library übergeben und legt das Rendering für eine allfällige Gruppierung der Rückgabe-Elemente fest. Für Jede Gruppe wird diese Methode 1 x ausgeführt.
	 *
	 * @param {string} groupName Anzuzeigender Gruppenname
	 * @param {string} currentValue Aktueller Suchstring
	 * @returns Formatierter Gruppenname als Listenelement für Autocomplete-Ergebnis
	 * @memberof OpaccFormElementAutoComplete
	 */ // eslint-disable-next-line no-unused-vars
    renderGroup(groupName, currentValue) {
        let element = document.createElement('li');
        element.textContent = groupName;
        return element;
    }
    /***************************************
	 * Opacc-Specific autocomplete-Methods *
	 ***************************************/ /**
	 * Event Registrierungen im DOM
	 *
	 * @param {HTMLElement} inputField angezeigtes Formularfeld, dient der Anzeige des ausgewählten Labels
	 * @param {HTMLElement} hiddenField verstecktes Formularfeld, dient der Speicherung des ausgewählten Wertes
	 */ attachEventListener(inputField, hiddenField) {
        inputField.addEventListener('blur', (e)=>{
            this.blurEventHandler(inputField, hiddenField, e);
        });
    }
    /**
	 * Handler des Blur-Events. Dieser Handler wird durch den Event "blur" ausgeführt.
	 *
	 * @param {HTMLElement} inputField angezeigtes Formularfeld, dient der Anzeige des ausgewählten Labels
	 * @param {HTMLElement} hiddenField verstecktes Formularfeld, dient der Speicherung des ausgewählten Wertes
	 * @param {Event} e Event, der durch den Listener ausgelöst wurde
	 */ blurEventHandler(inputField, hiddenField, e) {
        e.preventDefault();
        if (hiddenField.value != '') return;
        this.clearInputFieldSelection(inputField);
        this.clearInputFieldSelection(hiddenField);
    }
    /**
	 * Löschen des value Attributs auf dem Input-Element.
	 *
	 * @param {HTMLElement} element angezeigtes Formularfeld zum Löschen des Wertes
	 */ clearInputFieldSelection(element) {
        element.value = '';
        element.defaultValue = '';
    }
    /**
	 * Rückgabe der aufbereiteten HTML-Elemente (Bild, Beschreibung, Label).
	 *
	 * @param {HTMLElement} el "li" Tag zur Anreicherung der Attribute
	 * @param {Object} item Einzelner Autocomplete-Vorschlag
	 * @param {boolean } highLightMatch Bestimmt, ob der Suchtext in der Ergebnis-Liste hervorgehoben werden soll
	 * @param {string} currentVal Aktueller Suchstring
	 * @returns Formatiertes "li" Tag
	 */ returnElementMarkup(el, item, highLightMatch, currentVal) {
        let returnEl = el;
        returnEl.dataset.opValue = item.value;
        returnEl.setAttribute('tabindex', '-1');
        let imageTag = this.createImageTag(item);
        let descriptionTag = this.createDescriptionTag(item);
        let labelInnerHTML = this.createLabelTag(item);
        let wrapperTag = this.createWrapperTag(item);
        if (highLightMatch) {
            let regex = new RegExp(currentVal, 'gi');
            let inner = item.label.replace(regex, (match)=>{
                return this.highlightMarkup(match);
            });
            labelInnerHTML.innerHTML = inner;
        }
        returnEl.append(imageTag);
        returnEl.append(wrapperTag);
        if (wrapperTag) {
            wrapperTag.append(labelInnerHTML);
            wrapperTag.append(descriptionTag);
        } else {
            returnEl.append(labelInnerHTML);
            returnEl.append(descriptionTag);
        }
        return returnEl;
    }
    /**
	 * Rückgabe des Suchstring im Wrapper-Markup zur farblichen Kennzeichnug innerhalb des Resultates.
	 *
	 * @param {string} match Suchstring
	 * @returns Formatiertes HTML-Element zur farblichen Kennzeichnung innerhalb des Resultats.
	 */ highlightMarkup(match) {
        return `<span class='autocomplete-highlight'>${match}</span>`;
    }
    /**
	 * Erstellung des Wrapper-Elementes für Titel und Beschreibung.
	 *
	 * @param {Object} item Einzelner Autocomplete-Vorschlag
	 * @returns Formatierter Wrapper Tag für Titel und Beschreibung
	 */ createWrapperTag(item) {
        if (!item.image && !item.description) return '';
        let wrapperTag = document.createElement('div');
        wrapperTag.setAttribute('class', 'list-item-wrapper');
        return wrapperTag;
    }
    /**
	 * Erstellung des Bild-Elementes
	 *
	 * @param {Object} item Einzelner Autocomplete-Vorschlag
	 * @returns Rückgabe des aufbereiteten Bild-Elementes.
	 */ createImageTag(item) {
        if (!item.image) return '';
        let imageTag = document.createElement('img');
        imageTag.setAttribute('class', 'list-item-image');
        imageTag.src = item.image;
        imageTag.alt = item.label;
        return imageTag;
    }
    /**
	 * Erstellung der Beschreibung für das Autocomplete-Element
	 *
	 * @param {Object} item Einzelner Autocomplete-Vorschlag
	 * @returns Rückgabe des aufbereiteten Beschreibung-Elementes.
	 */ createDescriptionTag(item) {
        if (!item.description) return '';
        let descriptionTag = document.createElement('span');
        descriptionTag.setAttribute('class', 'list-item-description');
        descriptionTag.innerHTML = item.description;
        return descriptionTag;
    }
    /**
	 * Erstellung des Label-Elementes
	 *
	 * @param {Object} item Einzelner Autocomplete-Vorschlag
	 * @returns Rückgabe des aufbereiteten Label-Elementes.
	 */ createLabelTag(item) {
        let labelTag = document.createElement('span');
        labelTag.setAttribute('class', 'list-item-name');
        labelTag.innerHTML = item.label;
        return labelTag;
    }
    /**
	 * Ermittlung des Defaultwertes, falls ein Defaultwert definiert wurde.
	 *
	 * @param {Object} item Einzelner Autocomplete-Vorschlag
	 * @param {string} initValue Default-Wert zur Initialen Anzeige eines Resultates
	 * @param {HTMLElement} inputField Angezeigtes Formularfeld, dient der Anzeige des ausgewählten Labels
	 * @returns Promise zur Weiterverarbeitung der asynchronen Operation
	 */ getByInitValue(item, initValue, inputField) {
        return new Promise((resolve, reject)=>{
            let initialLoad = this.getAsynData(this.prepareAsyncUrl(inputField, item));
            initialLoad.then((result)=>{
                let selection = result.filter((item)=>{
                    return item.value === initValue;
                });
                let retVal = '';
                if (selection.length > 0) retVal = selection[0].label;
                resolve(retVal);
            }).catch((error)=>{
                reject(error);
            });
        });
    }
    /**
	 * Aufbereitung der asynchronen URL
	 *
	 * @param {HTMLElement} inputField Formularfeld für die Autocomplete-Suche
	 * @param {HTMLElement} item Autocomplete-Element
	 * @returns URL für die asynchrone Abfrage
	 */ prepareAsyncUrl(inputField, item) {
        let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl(true);
        let asyncUrl = item.dataset.opUrl || `${url}?type=${inputField.dataset.opType}&crypt=${inputField.dataset.opCrypt}`;
        let separator = asyncUrl.indexOf('?') > 0 ? '&' : '?';
        let valueParam = `value=${encodeURI(inputField.value)}`;
        let selectedParam = '';
        let inputs = item.getElementsByTagName('input');
        if (inputs.length > 0 && inputs[0].value) selectedParam = `&selected=${encodeURI(inputs[0].value)}`;
        return `${asyncUrl}${separator}${valueParam}${selectedParam}`;
    }
    /**
	 * Aufruf des asynchronen Requests.
	 *
	 * @param {string} url Ziel-URL als String
	 * @returns Promise zur Weiterverarbeitung der asynchronen Operation
	 */ getAsynData(url) {
        return new Promise((resolve)=>{
            (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynGetJson(url, this.getResultList.bind(this, resolve), this.asyncErrorHandler.bind(this), true);
        });
    }
    /**
	 * Freigabe (resolve) des asynchronen Requests (Promise) zur Weiterverarbeitung des Resultats.
	 *
	 * @param {Function} resolve Funktion um das ausstehende Resultat der Promise freizugeben
	 * @param {Object} response Ergebnisobjekt mit dem Resultat des asynchronen Requests.
	 */ getResultList(resolve, response) {
        if (response.success) {
            let autocompleteList = response.dataAsJson;
            resolve(autocompleteList);
        }
    }
    /**
	 * Ermittlung des Status des Autocomplete-Feldes.
	 *
	 * @param {Object} item Einzelner Autocomplete-Vorschlag
	 * @param {HTMLElement} hiddenField Verstecktes Formularfeld, dient der Speicherung des ausgewählten Wertes
	 * @param {HTMLElement} inputField Angezeigtes Formularfeld, dient der Anzeige des ausgewählten Labels
	 * @returns Promise mit Status des Ladevorgangs
	 */ loadData(item, hiddenField, inputField) {
        return new Promise((resolve, reject)=>{
            if (hiddenField && hiddenField.value) {
                let initData = this.getByInitValue(item, hiddenField.value, inputField);
                initData.then((result)=>{
                    inputField.value = result;
                    inputField.defaultValue = inputField.value;
                    resolve(true);
                }).catch((error)=>{
                    reject(error);
                });
            } else resolve(true);
        });
    }
    /**
	 * Methode für fehlerhaften Ajax-Request
	 *
	 * @param {DOMException} error Error-Object der asynchronen Operation
	 */ asyncErrorHandler(error) {
        // eslint-disable-next-line no-console
        console.error('Request failed: ', error.message);
        this.hookAfterAsyncErrorHandler(error);
    }
    /**
	 * Hook um bei fehlerhaftem asynchronen Request weitere Funktionalitäten ausführen zu können.
	 *
	 * @param {DOMException} error Error-Object der asynchronen Operation
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterAsyncErrorHandler(error) {}
}


/* flatpickr v4.6.13, @license MIT */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $3f401514818d15ee$var$__assign = function() {
    $3f401514818d15ee$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3f401514818d15ee$var$__assign.apply(this, arguments);
};
function $3f401514818d15ee$var$__spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
var $3f401514818d15ee$var$HOOKS = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $3f401514818d15ee$var$defaults = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};
var $3f401514818d15ee$var$english = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $3f401514818d15ee$var$pad = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $3f401514818d15ee$var$int = function(bool) {
    return bool === true ? 1 : 0;
};
/* istanbul ignore next */ function $3f401514818d15ee$var$debounce(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $3f401514818d15ee$var$arrayify = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};
function $3f401514818d15ee$var$toggleClass(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $3f401514818d15ee$var$createElement(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $3f401514818d15ee$var$clearNode(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $3f401514818d15ee$var$findParent(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $3f401514818d15ee$var$findParent(node.parentNode, condition);
    return undefined; // nothing found
}
function $3f401514818d15ee$var$createNumberInput(inputClassName, opts) {
    var wrapper = $3f401514818d15ee$var$createElement("div", "numInputWrapper"), numInput = $3f401514818d15ee$var$createElement("input", "numInput " + inputClassName), arrowUp = $3f401514818d15ee$var$createElement("span", "arrowUp"), arrowDown = $3f401514818d15ee$var$createElement("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $3f401514818d15ee$var$getEventTarget(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}
var $3f401514818d15ee$var$doNothing = function() {
    return undefined;
};
var $3f401514818d15ee$var$monthToStr = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $3f401514818d15ee$var$revFormat = {
    D: $3f401514818d15ee$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * $3f401514818d15ee$var$int(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $3f401514818d15ee$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $3f401514818d15ee$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $3f401514818d15ee$var$tokenRegex = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $3f401514818d15ee$var$formats = {
    // get the date in UTC
    Z: function(date) {
        return date.toISOString();
    },
    // weekday name, short, e.g. Thu
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$3f401514818d15ee$var$formats.w(date, locale, options)];
    },
    // full month name e.g. January
    F: function(date, locale, options) {
        return $3f401514818d15ee$var$monthToStr($3f401514818d15ee$var$formats.n(date, locale, options) - 1, false, locale);
    },
    // padded hour 1-12
    G: function(date, locale, options) {
        return $3f401514818d15ee$var$pad($3f401514818d15ee$var$formats.h(date, locale, options));
    },
    // hours with leading zero e.g. 03
    H: function(date) {
        return $3f401514818d15ee$var$pad(date.getHours());
    },
    // day (1-30) with ordinal suffix e.g. 1st, 2nd
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    // AM/PM
    K: function(date, locale) {
        return locale.amPM[$3f401514818d15ee$var$int(date.getHours() > 11)];
    },
    // shorthand month e.g. Jan, Sep, Oct, etc
    M: function(date, locale) {
        return $3f401514818d15ee$var$monthToStr(date.getMonth(), true, locale);
    },
    // seconds 00-59
    S: function(date) {
        return $3f401514818d15ee$var$pad(date.getSeconds());
    },
    // unix timestamp
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    // full year e.g. 2016, padded (0001-9999)
    Y: function(date) {
        return $3f401514818d15ee$var$pad(date.getFullYear(), 4);
    },
    // day in month, padded (01-30)
    d: function(date) {
        return $3f401514818d15ee$var$pad(date.getDate());
    },
    // hour from 1-12 (am/pm)
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    // minutes, padded with leading zero e.g. 09
    i: function(date) {
        return $3f401514818d15ee$var$pad(date.getMinutes());
    },
    // day in month (1-30)
    j: function(date) {
        return date.getDate();
    },
    // weekday name, full, e.g. Thursday
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    // padded month number (01-12)
    m: function(date) {
        return $3f401514818d15ee$var$pad(date.getMonth() + 1);
    },
    // the month number (1-12)
    n: function(date) {
        return date.getMonth() + 1;
    },
    // seconds 0-59
    s: function(date) {
        return date.getSeconds();
    },
    // Unix Milliseconds
    u: function(date) {
        return date.getTime();
    },
    // number of the day of the week
    w: function(date) {
        return date.getDay();
    },
    // last two digits of year e.g. 16 for 2016
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};
var $3f401514818d15ee$var$createDateFormatter = function(_a) {
    var _b = _a.config, config = _b === void 0 ? $3f401514818d15ee$var$defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? $3f401514818d15ee$var$english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return $3f401514818d15ee$var$formats[c] && arr[i - 1] !== "\\" ? $3f401514818d15ee$var$formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $3f401514818d15ee$var$createDateParser = function(_a) {
    var _b = _a.config, config = _b === void 0 ? $3f401514818d15ee$var$defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? $3f401514818d15ee$var$english : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined // timestamp
        ) // create a copy
        parsedDate = new Date(date);
        else if (typeof date === "string") {
            // date string
            var format = givenFormat || (config || $3f401514818d15ee$var$defaults).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr) // datestrings w/ timezone
            ) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token_1 = format[i];
                    var isBackSlash = token_1 === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ($3f401514818d15ee$var$tokenRegex[token_1] && !escaped) {
                        regexStr += $3f401514818d15ee$var$tokenRegex[token_1];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token_1 !== "Y" ? "push" : "unshift"]({
                            fn: $3f401514818d15ee$var$revFormat[token_1],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += "."; // don't really care
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        /* istanbul ignore next */ if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
/**
 * Compute the difference in dates, measured in ms
 */ function $3f401514818d15ee$var$compareDates(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
var $3f401514818d15ee$var$isBetween = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $3f401514818d15ee$var$calculateSecondsSinceMidnight = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $3f401514818d15ee$var$parseSeconds = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $3f401514818d15ee$var$duration = {
    DAY: 86400000
};
function $3f401514818d15ee$var$getDefaultHours(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};
var $3f401514818d15ee$var$DEBOUNCED_CHANGE_MS = 300;
function $3f401514818d15ee$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $3f401514818d15ee$var$__assign($3f401514818d15ee$var$__assign({}, $3f401514818d15ee$var$defaults), $3f401514818d15ee$var$flatpickr.defaultConfig),
        l10n: $3f401514818d15ee$var$english
    };
    self.parseDate = $3f401514818d15ee$var$createDateParser({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = $3f401514818d15ee$var$createElement;
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        /* TODO: investigate this further

          Currently, there is weird positioning behavior in safari causing pages
          to scroll up. https://github.com/chmln/flatpickr/issues/563

          However, most browsers are not Safari and positioning is expensive when used
          in scale. https://github.com/chmln/flatpickr/issues/1096
        */ if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                // var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                // self.daysContainer.style.width = daysWidth + "px";
                // self.calendarContainer.style.width =
                //     daysWidth +
                //         (self.weekWrapper !== undefined
                //             ? self.weekWrapper.offsetWidth
                //             : 0) +
                //         "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    /**
     * The handler for all events targeting the time inputs
     */ function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || $3f401514818d15ee$var$compareDates(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = $3f401514818d15ee$var$getDefaultHours(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * $3f401514818d15ee$var$int(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    /**
     * Syncs the selected date object time with user's time input
     */ function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && $3f401514818d15ee$var$compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && $3f401514818d15ee$var$compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = $3f401514818d15ee$var$calculateSecondsSinceMidnight(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = $3f401514818d15ee$var$calculateSecondsSinceMidnight(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = $3f401514818d15ee$var$calculateSecondsSinceMidnight(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = $3f401514818d15ee$var$parseSeconds(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    /**
     * Syncs time input values with a date
     */ function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    /**
     * Sets the hours, minutes, and optionally seconds
     * of the latest selected date object and the
     * corresponding time inputs
     * @param {Number} hours the hour. whether its military
     *                 or am-pm gets inferred from config
     * @param {Number} minutes the minutes
     * @param {Number} seconds the seconds (optional)
     */ function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = $3f401514818d15ee$var$pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * $3f401514818d15ee$var$int(hours % 12 === 0) : hours);
        self.minuteElement.value = $3f401514818d15ee$var$pad(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[$3f401514818d15ee$var$int(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = $3f401514818d15ee$var$pad(seconds);
    }
    /**
     * Handles the year input and incrementing events
     * @param {Event} event the keyup or increment event
     */ function onYearInput(event) {
        var eventTarget = $3f401514818d15ee$var$getEventTarget(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    /**
     * Essentially addEventListener + tracking
     * @param {Element} element the element to addEventListener to
     * @param {String} event the event name
     * @param {Function} handler the event handler
     */ function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    /**
     * Adds all the necessary event listeners
     */ function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = $3f401514818d15ee$var$debounce(onResize, 50);
        self._debouncedChange = $3f401514818d15ee$var$debounce(triggerChange, $3f401514818d15ee$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver($3f401514818d15ee$var$getEventTarget(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return $3f401514818d15ee$var$getEventTarget(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    /**
     * Set the calendar view to a particular date.
     * @param {Date} jumpDate the date to set the view to
     * @param {boolean} triggerChange if change events should be triggered
     */ function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            /* istanbul ignore next */ e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    /**
     * The up/down arrow handler for time inputs
     * @param {Event} e the click event
     */ function timeIncrement(e) {
        var eventTarget = $3f401514818d15ee$var$getEventTarget(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    /**
     * Increments/decrements the value of input associ-
     * ated with the up/down arrow by dispatching an
     * "increment" event on the input.
     *
     * @param {Event} e the click event
     * @param {Number} delta the diff (usually 1 or -1)
     * @param {Element} inputElem the input element
     */ function incrementNumInput(e, delta, inputElem) {
        var target = e && $3f401514818d15ee$var$getEventTarget(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = $3f401514818d15ee$var$createElement("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = $3f401514818d15ee$var$createElement("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = $3f401514818d15ee$var$createElement("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = $3f401514818d15ee$var$createElement("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "animate", self.config.animate === true);
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = $3f401514818d15ee$var$createElement("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = $3f401514818d15ee$var$createElement("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && $3f401514818d15ee$var$compareDates(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    $3f401514818d15ee$var$toggleClass(dayElement, "startRange", self.selectedDates[0] && $3f401514818d15ee$var$compareDates(date, self.selectedDates[0], true) === 0);
                    $3f401514818d15ee$var$toggleClass(dayElement, "endRange", self.selectedDates[1] && $3f401514818d15ee$var$compareDates(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        // prepend days from the ending of previous month
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        // Start at 1 since there is no 0th day
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        // append days from the next month
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        //updateNavigationCurrentMonth();
        var dayContainer = $3f401514818d15ee$var$createElement("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        $3f401514818d15ee$var$clearNode(self.daysContainer);
        // TODO: week numbers for each month
        if (self.weekNumbers) $3f401514818d15ee$var$clearNode(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = $3f401514818d15ee$var$createElement("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = $3f401514818d15ee$var$monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = $3f401514818d15ee$var$createElement("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = $3f401514818d15ee$var$createElement("span", "cur-month");
        else {
            self.monthsDropdownContainer = $3f401514818d15ee$var$createElement("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = $3f401514818d15ee$var$getEventTarget(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = $3f401514818d15ee$var$createNumberInput("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = $3f401514818d15ee$var$createElement("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        $3f401514818d15ee$var$clearNode(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = $3f401514818d15ee$var$createElement("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = $3f401514818d15ee$var$createElement("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = $3f401514818d15ee$var$createElement("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    $3f401514818d15ee$var$toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    $3f401514818d15ee$var$toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = $3f401514818d15ee$var$getDefaultHours(self.config);
        self.timeContainer = $3f401514818d15ee$var$createElement("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = $3f401514818d15ee$var$createElement("span", "flatpickr-time-separator", ":");
        var hourInput = $3f401514818d15ee$var$createNumberInput("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = $3f401514818d15ee$var$createNumberInput("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = $3f401514818d15ee$var$pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = $3f401514818d15ee$var$pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = $3f401514818d15ee$var$createNumberInput("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = $3f401514818d15ee$var$pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild($3f401514818d15ee$var$createElement("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            // add self.amPM if appropriate
            self.amPM = $3f401514818d15ee$var$createElement("span", "flatpickr-am-pm", self.l10n.amPM[$3f401514818d15ee$var$int((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = $3f401514818d15ee$var$createElement("div", "flatpickr-weekdays");
        else $3f401514818d15ee$var$clearNode(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = $3f401514818d15ee$var$createElement("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $3f401514818d15ee$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $3f401514818d15ee$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    /* istanbul ignore next */ function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = $3f401514818d15ee$var$createElement("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild($3f401514818d15ee$var$createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = $3f401514818d15ee$var$createElement("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = $3f401514818d15ee$var$getDefaultHours(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) // triggerChangeEvent is true (default) or an Event
        triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = $3f401514818d15ee$var$getEventTarget(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || // web components
            // e.path is not present in all browsers. circumventing typechecks
            e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless); // timeless
        if (self.config.minDate && dateToCheck && $3f401514818d15ee$var$compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && $3f401514818d15ee$var$compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck) // disabled by function
            ) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) // disabled by date
            return bool;
            else if (typeof d === "string") {
                // disabled by date string
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (// disabled by range
            typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        // e.key                      e.keyCode
        // "Backspace"                        8
        // "Tab"                              9
        // "Enter"                           13
        // "Escape"     (IE "Esc")           27
        // "ArrowLeft"  (IE "Left")          37
        // "ArrowUp"    (IE "Up")            38
        // "ArrowRight" (IE "Right")         39
        // "ArrowDown"  (IE "Down")          40
        // "Delete"     (IE "Del")           46
        var eventTarget = $3f401514818d15ee$var$getEventTarget(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += $3f401514818d15ee$var$duration.DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && $3f401514818d15ee$var$isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = $3f401514818d15ee$var$getEventTarget(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $3f401514818d15ee$var$__assign($3f401514818d15ee$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $3f401514818d15ee$var$flatpickr.defaultConfig.dateFormat || $3f401514818d15ee$var$defaults.dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $3f401514818d15ee$var$flatpickr.defaultConfig.altFormat || $3f401514818d15ee$var$defaults.altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)// https://github.com/microsoft/TypeScript/issues/31663
        self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        $3f401514818d15ee$var$HOOKS.filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = $3f401514818d15ee$var$arrayify(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ($3f401514818d15ee$var$HOOKS.indexOf(key) > -1) self.config[key] = $3f401514818d15ee$var$arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $3f401514818d15ee$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $3f401514818d15ee$var$__assign($3f401514818d15ee$var$__assign({}, $3f401514818d15ee$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $3f401514818d15ee$var$flatpickr.l10ns[self.config.locale] : undefined);
        $3f401514818d15ee$var$tokenRegex.D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        $3f401514818d15ee$var$tokenRegex.l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        $3f401514818d15ee$var$tokenRegex.M = "(" + self.l10n.months.shorthand.join("|") + ")";
        $3f401514818d15ee$var$tokenRegex.F = "(" + self.l10n.months.longhand.join("|") + ")";
        $3f401514818d15ee$var$tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $3f401514818d15ee$var$__assign($3f401514818d15ee$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $3f401514818d15ee$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = $3f401514818d15ee$var$createDateFormatter(self);
        self.parseDate = $3f401514818d15ee$var$createDateParser({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "arrowCenter", isCenter);
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        $3f401514818d15ee$var$toggleClass(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            // some testing environments don't have css support
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            $3f401514818d15ee$var$toggleClass(self.calendarContainer, "rightMost", false);
            $3f401514818d15ee$var$toggleClass(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) // hack - bugs in the way IE handles focus keeps the calendar open
        setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = $3f401514818d15ee$var$findParent($3f401514818d15ee$var$getEventTarget(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            // unless selecting same date twice, sort ascendingly
            if ($3f401514818d15ee$var$compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        // maintain focus
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ($3f401514818d15ee$var$HOOKS.indexOf(option) > -1) self.config[option] = $3f401514818d15ee$var$arrayify(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        }); // remove falsy values
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        // Workaround IE11 setting placeholder as the input's value
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        /* istanbul ignore next */ if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        // hack: store previous type to restore it after destroy()
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            // replicate self.element
            self.altInput = $3f401514818d15ee$var$createElement(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = $3f401514818d15ee$var$createElement("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate($3f401514818d15ee$var$getEventTarget(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        // If the instance has been destroyed already, all hooks have been removed
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            // many front-end frameworks bind to the input event
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && $3f401514818d15ee$var$compareDates(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return $3f401514818d15ee$var$compareDates(date, self.selectedDates[0]) >= 0 && $3f401514818d15ee$var$compareDates(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = $3f401514818d15ee$var$monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    /**
     * Updates the values of inputs associated with the calendar
     */ function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = $3f401514818d15ee$var$getEventTarget(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = $3f401514818d15ee$var$getEventTarget(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[$3f401514818d15ee$var$int(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + $3f401514818d15ee$var$int(!isHourElem) + ($3f401514818d15ee$var$int(isHourElem) && $3f401514818d15ee$var$int(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - $3f401514818d15ee$var$int(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[$3f401514818d15ee$var$int(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = $3f401514818d15ee$var$pad(newValue);
        }
    }
    init();
    return self;
}
/* istanbul ignore next */ function $3f401514818d15ee$var$_flatpickr(nodeList, config) {
    // static list
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $3f401514818d15ee$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
/* istanbul ignore next */ if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    // browser env
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $3f401514818d15ee$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $3f401514818d15ee$var$_flatpickr([
            this
        ], config);
    };
}
/* istanbul ignore next */ var $3f401514818d15ee$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $3f401514818d15ee$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $3f401514818d15ee$var$_flatpickr([
        selector
    ], config);
    else return $3f401514818d15ee$var$_flatpickr(selector, config);
};
/* istanbul ignore next */ $3f401514818d15ee$var$flatpickr.defaultConfig = {};
$3f401514818d15ee$var$flatpickr.l10ns = {
    en: $3f401514818d15ee$var$__assign({}, $3f401514818d15ee$var$english),
    default: $3f401514818d15ee$var$__assign({}, $3f401514818d15ee$var$english)
};
$3f401514818d15ee$var$flatpickr.localize = function(l10n) {
    $3f401514818d15ee$var$flatpickr.l10ns.default = $3f401514818d15ee$var$__assign($3f401514818d15ee$var$__assign({}, $3f401514818d15ee$var$flatpickr.l10ns.default), l10n);
};
$3f401514818d15ee$var$flatpickr.setDefaults = function(config) {
    $3f401514818d15ee$var$flatpickr.defaultConfig = $3f401514818d15ee$var$__assign($3f401514818d15ee$var$__assign({}, $3f401514818d15ee$var$flatpickr.defaultConfig), config);
};
$3f401514818d15ee$var$flatpickr.parseDate = $3f401514818d15ee$var$createDateParser({});
$3f401514818d15ee$var$flatpickr.formatDate = $3f401514818d15ee$var$createDateFormatter({});
$3f401514818d15ee$var$flatpickr.compareDates = $3f401514818d15ee$var$compareDates;
/* istanbul ignore next */ if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $3f401514818d15ee$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $3f401514818d15ee$var$flatpickr;
var $3f401514818d15ee$export$2e2bcd8739ae039 = $3f401514818d15ee$var$flatpickr;




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $69c921925b448778$var$__assign = function() {
    $69c921925b448778$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $69c921925b448778$var$__assign.apply(this, arguments);
};
var $69c921925b448778$var$fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Arabic = {
    weekdays: {
        shorthand: [
            "\u0623\u062D\u062F",
            "\u0627\u062B\u0646\u064A\u0646",
            "\u062B\u0644\u0627\u062B\u0627\u0621",
            "\u0623\u0631\u0628\u0639\u0627\u0621",
            "\u062E\u0645\u064A\u0633",
            "\u062C\u0645\u0639\u0629",
            "\u0633\u0628\u062A"
        ],
        longhand: [
            "\u0627\u0644\u0623\u062D\u062F",
            "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
            "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
            "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
            "\u0627\u0644\u062E\u0645\u064A\u0633",
            "\u0627\u0644\u062C\u0645\u0639\u0629",
            "\u0627\u0644\u0633\u0628\u062A"
        ]
    },
    months: {
        shorthand: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12"
        ],
        longhand: [
            "\u064A\u0646\u0627\u064A\u0631",
            "\u0641\u0628\u0631\u0627\u064A\u0631",
            "\u0645\u0627\u0631\u0633",
            "\u0623\u0628\u0631\u064A\u0644",
            "\u0645\u0627\u064A\u0648",
            "\u064A\u0648\u0646\u064A\u0648",
            "\u064A\u0648\u0644\u064A\u0648",
            "\u0623\u063A\u0633\u0637\u0633",
            "\u0633\u0628\u062A\u0645\u0628\u0631",
            "\u0623\u0643\u062A\u0648\u0628\u0631",
            "\u0646\u0648\u0641\u0645\u0628\u0631",
            "\u062F\u064A\u0633\u0645\u0628\u0631"
        ]
    },
    firstDayOfWeek: 6,
    rangeSeparator: " \u0625\u0644\u0649 ",
    weekAbbreviation: "Wk",
    scrollTitle: "\u0642\u0645 \u0628\u0627\u0644\u062A\u0645\u0631\u064A\u0631 \u0644\u0644\u0632\u064A\u0627\u062F\u0629",
    toggleTitle: "\u0627\u0636\u063A\u0637 \u0644\u0644\u062A\u0628\u062F\u064A\u0644",
    amPM: [
        "\u0635",
        "\u0645"
    ],
    yearAriaLabel: "\u0633\u0646\u0629",
    monthAriaLabel: "\u0634\u0647\u0631",
    hourAriaLabel: "\u0633\u0627\u0639\u0629",
    minuteAriaLabel: "\u062F\u0642\u064A\u0642\u0629",
    time_24hr: false
};
$69c921925b448778$var$fp.l10ns.ar = $69c921925b448778$var$Arabic;
$69c921925b448778$var$fp.l10ns;
var $69c921925b448778$var$fp$1 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Austria = {
    weekdays: {
        shorthand: [
            "So",
            "Mo",
            "Di",
            "Mi",
            "Do",
            "Fr",
            "Sa"
        ],
        longhand: [
            "Sonntag",
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag"
        ]
    },
    months: {
        shorthand: [
            "J\xe4n",
            "Feb",
            "M\xe4r",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dez"
        ],
        longhand: [
            "J\xe4nner",
            "Februar",
            "M\xe4rz",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember"
        ]
    },
    firstDayOfWeek: 1,
    weekAbbreviation: "KW",
    rangeSeparator: " bis ",
    scrollTitle: "Zum \xc4ndern scrollen",
    toggleTitle: "Zum Umschalten klicken",
    time_24hr: true
};
$69c921925b448778$var$fp$1.l10ns.at = $69c921925b448778$var$Austria;
$69c921925b448778$var$fp$1.l10ns;
var $69c921925b448778$var$fp$2 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Azerbaijan = {
    weekdays: {
        shorthand: [
            "B.",
            "B.e.",
            "\xc7.a.",
            "\xc7.",
            "C.a.",
            "C.",
            "\u015E."
        ],
        longhand: [
            "Bazar",
            "Bazar ert\u0259si",
            "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
            "\xc7\u0259r\u015F\u0259nb\u0259",
            "C\xfcm\u0259 ax\u015Fam\u0131",
            "C\xfcm\u0259",
            "\u015E\u0259nb\u0259"
        ]
    },
    months: {
        shorthand: [
            "Yan",
            "Fev",
            "Mar",
            "Apr",
            "May",
            "\u0130yn",
            "\u0130yl",
            "Avq",
            "Sen",
            "Okt",
            "Noy",
            "Dek"
        ],
        longhand: [
            "Yanvar",
            "Fevral",
            "Mart",
            "Aprel",
            "May",
            "\u0130yun",
            "\u0130yul",
            "Avqust",
            "Sentyabr",
            "Oktyabr",
            "Noyabr",
            "Dekabr"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return ".";
    },
    rangeSeparator: " - ",
    weekAbbreviation: "Hf",
    scrollTitle: "Art\u0131rmaq \xfc\xe7\xfcn s\xfcr\xfc\u015Fd\xfcr\xfcn",
    toggleTitle: "A\xe7 / Ba\u011Fla",
    amPM: [
        "G\u018F",
        "GS"
    ],
    time_24hr: true
};
$69c921925b448778$var$fp$2.l10ns.az = $69c921925b448778$var$Azerbaijan;
$69c921925b448778$var$fp$2.l10ns;
var $69c921925b448778$var$fp$3 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Belarusian = {
    weekdays: {
        shorthand: [
            "\u041D\u0434",
            "\u041F\u043D",
            "\u0410\u045E",
            "\u0421\u0440",
            "\u0427\u0446",
            "\u041F\u0442",
            "\u0421\u0431"
        ],
        longhand: [
            "\u041D\u044F\u0434\u0437\u0435\u043B\u044F",
            "\u041F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
            "\u0410\u045E\u0442\u043E\u0440\u0430\u043A",
            "\u0421\u0435\u0440\u0430\u0434\u0430",
            "\u0427\u0430\u0446\u0432\u0435\u0440",
            "\u041F\u044F\u0442\u043D\u0456\u0446\u0430",
            "\u0421\u0443\u0431\u043E\u0442\u0430"
        ]
    },
    months: {
        shorthand: [
            "\u0421\u0442\u0443",
            "\u041B\u044E\u0442",
            "\u0421\u0430\u043A",
            "\u041A\u0440\u0430",
            "\u0422\u0440\u0430",
            "\u0427\u044D\u0440",
            "\u041B\u0456\u043F",
            "\u0416\u043D\u0456",
            "\u0412\u0435\u0440",
            "\u041A\u0430\u0441",
            "\u041B\u0456\u0441",
            "\u0421\u043D\u0435"
        ],
        longhand: [
            "\u0421\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
            "\u041B\u044E\u0442\u044B",
            "\u0421\u0430\u043A\u0430\u0432\u0456\u043A",
            "\u041A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
            "\u0422\u0440\u0430\u0432\u0435\u043D\u044C",
            "\u0427\u044D\u0440\u0432\u0435\u043D\u044C",
            "\u041B\u0456\u043F\u0435\u043D\u044C",
            "\u0416\u043D\u0456\u0432\u0435\u043D\u044C",
            "\u0412\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
            "\u041A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
            "\u041B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
            "\u0421\u043D\u0435\u0436\u0430\u043D\u044C"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    rangeSeparator: " \u2014 ",
    weekAbbreviation: "\u0422\u044B\u0434.",
    scrollTitle: "\u041F\u0440\u0430\u043A\u0440\u0443\u0446\u0456\u0446\u0435 \u0434\u043B\u044F \u043F\u0430\u0432\u0435\u043B\u0456\u0447\u044D\u043D\u043D\u044F",
    toggleTitle: "\u041D\u0430\u0446\u0456\u0441\u043D\u0456\u0446\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0430\u043A\u043B\u044E\u0447\u044D\u043D\u043D\u044F",
    amPM: [
        "\u0414\u041F",
        "\u041F\u041F"
    ],
    yearAriaLabel: "\u0413\u043E\u0434",
    time_24hr: true
};
$69c921925b448778$var$fp$3.l10ns.be = $69c921925b448778$var$Belarusian;
$69c921925b448778$var$fp$3.l10ns;
var $69c921925b448778$var$fp$4 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Bosnian = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: [
            "Ned",
            "Pon",
            "Uto",
            "Sri",
            "\u010Cet",
            "Pet",
            "Sub"
        ],
        longhand: [
            "Nedjelja",
            "Ponedjeljak",
            "Utorak",
            "Srijeda",
            "\u010Cetvrtak",
            "Petak",
            "Subota"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Maj",
            "Jun",
            "Jul",
            "Avg",
            "Sep",
            "Okt",
            "Nov",
            "Dec"
        ],
        longhand: [
            "Januar",
            "Februar",
            "Mart",
            "April",
            "Maj",
            "Juni",
            "Juli",
            "Avgust",
            "Septembar",
            "Oktobar",
            "Novembar",
            "Decembar"
        ]
    },
    time_24hr: true
};
$69c921925b448778$var$fp$4.l10ns.bs = $69c921925b448778$var$Bosnian;
$69c921925b448778$var$fp$4.l10ns;
var $69c921925b448778$var$fp$5 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Bulgarian = {
    weekdays: {
        shorthand: [
            "\u041D\u0434",
            "\u041F\u043D",
            "\u0412\u0442",
            "\u0421\u0440",
            "\u0427\u0442",
            "\u041F\u0442",
            "\u0421\u0431"
        ],
        longhand: [
            "\u041D\u0435\u0434\u0435\u043B\u044F",
            "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
            "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
            "\u0421\u0440\u044F\u0434\u0430",
            "\u0427\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
            "\u041F\u0435\u0442\u044A\u043A",
            "\u0421\u044A\u0431\u043E\u0442\u0430"
        ]
    },
    months: {
        shorthand: [
            "\u042F\u043D\u0443",
            "\u0424\u0435\u0432",
            "\u041C\u0430\u0440\u0442",
            "\u0410\u043F\u0440",
            "\u041C\u0430\u0439",
            "\u042E\u043D\u0438",
            "\u042E\u043B\u0438",
            "\u0410\u0432\u0433",
            "\u0421\u0435\u043F",
            "\u041E\u043A\u0442",
            "\u041D\u043E\u0435",
            "\u0414\u0435\u043A"
        ],
        longhand: [
            "\u042F\u043D\u0443\u0430\u0440\u0438",
            "\u0424\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
            "\u041C\u0430\u0440\u0442",
            "\u0410\u043F\u0440\u0438\u043B",
            "\u041C\u0430\u0439",
            "\u042E\u043D\u0438",
            "\u042E\u043B\u0438",
            "\u0410\u0432\u0433\u0443\u0441\u0442",
            "\u0421\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
            "\u041E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
            "\u041D\u043E\u0435\u043C\u0432\u0440\u0438",
            "\u0414\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
        ]
    },
    time_24hr: true,
    firstDayOfWeek: 1
};
$69c921925b448778$var$fp$5.l10ns.bg = $69c921925b448778$var$Bulgarian;
$69c921925b448778$var$fp$5.l10ns;
var $69c921925b448778$var$fp$6 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Bangla = {
    weekdays: {
        shorthand: [
            "\u09B0\u09AC\u09BF",
            "\u09B8\u09CB\u09AE",
            "\u09AE\u0999\u09CD\u0997\u09B2",
            "\u09AC\u09C1\u09A7",
            "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF",
            "\u09B6\u09C1\u0995\u09CD\u09B0",
            "\u09B6\u09A8\u09BF"
        ],
        longhand: [
            "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
            "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
            "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
            "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
            "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0",
            "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
            "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
        ]
    },
    months: {
        shorthand: [
            "\u099C\u09BE\u09A8\u09C1",
            "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
            "\u09AE\u09BE\u09B0\u09CD\u099A",
            "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
            "\u09AE\u09C7",
            "\u099C\u09C1\u09A8",
            "\u099C\u09C1\u09B2\u09BE\u0987",
            "\u0986\u0997",
            "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7",
            "\u0985\u0995\u09CD\u099F\u09CB",
            "\u09A8\u09AD\u09C7",
            "\u09A1\u09BF\u09B8\u09C7"
        ],
        longhand: [
            "\u099C\u09BE\u09A8\u09C1\u09AF\u09BC\u09BE\u09B0\u09C0",
            "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09AF\u09BC\u09BE\u09B0\u09C0",
            "\u09AE\u09BE\u09B0\u09CD\u099A",
            "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
            "\u09AE\u09C7",
            "\u099C\u09C1\u09A8",
            "\u099C\u09C1\u09B2\u09BE\u0987",
            "\u0986\u0997\u09B8\u09CD\u099F",
            "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
            "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
            "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
            "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
        ]
    }
};
$69c921925b448778$var$fp$6.l10ns.bn = $69c921925b448778$var$Bangla;
$69c921925b448778$var$fp$6.l10ns;
var $69c921925b448778$var$fp$7 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Catalan = {
    weekdays: {
        shorthand: [
            "Dg",
            "Dl",
            "Dt",
            "Dc",
            "Dj",
            "Dv",
            "Ds"
        ],
        longhand: [
            "Diumenge",
            "Dilluns",
            "Dimarts",
            "Dimecres",
            "Dijous",
            "Divendres",
            "Dissabte"
        ]
    },
    months: {
        shorthand: [
            "Gen",
            "Febr",
            "Mar\xe7",
            "Abr",
            "Maig",
            "Juny",
            "Jul",
            "Ag",
            "Set",
            "Oct",
            "Nov",
            "Des"
        ],
        longhand: [
            "Gener",
            "Febrer",
            "Mar\xe7",
            "Abril",
            "Maig",
            "Juny",
            "Juliol",
            "Agost",
            "Setembre",
            "Octubre",
            "Novembre",
            "Desembre"
        ]
    },
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "\xe8";
        switch(s % 10){
            case 1:
                return "r";
            case 2:
                return "n";
            case 3:
                return "r";
            case 4:
                return "t";
            default:
                return "\xe8";
        }
    },
    firstDayOfWeek: 1,
    rangeSeparator: " a ",
    time_24hr: true
};
$69c921925b448778$var$fp$7.l10ns.cat = $69c921925b448778$var$fp$7.l10ns.ca = $69c921925b448778$var$Catalan;
$69c921925b448778$var$fp$7.l10ns;
var $69c921925b448778$var$fp$8 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Kurdish = {
    weekdays: {
        shorthand: [
            "\u06CC\u06D5\u06A9\u0634\u06D5\u0645\u0645\u06D5",
            "\u062F\u0648\u0648\u0634\u06D5\u0645\u0645\u06D5",
            "\u0633\u06CE\u0634\u06D5\u0645\u0645\u06D5",
            "\u0686\u0648\u0627\u0631\u0634\u06D5\u0645\u0645\u06D5",
            "\u067E\u06CE\u0646\u062C\u0634\u06D5\u0645\u0645\u06D5",
            "\u0647\u06D5\u06CC\u0646\u06CC",
            "\u0634\u06D5\u0645\u0645\u06D5"
        ],
        longhand: [
            "\u06CC\u06D5\u06A9\u0634\u06D5\u0645\u0645\u06D5",
            "\u062F\u0648\u0648\u0634\u06D5\u0645\u0645\u06D5",
            "\u0633\u06CE\u0634\u06D5\u0645\u0645\u06D5",
            "\u0686\u0648\u0627\u0631\u0634\u06D5\u0645\u0645\u06D5",
            "\u067E\u06CE\u0646\u062C\u0634\u06D5\u0645\u0645\u06D5",
            "\u0647\u06D5\u06CC\u0646\u06CC",
            "\u0634\u06D5\u0645\u0645\u06D5"
        ]
    },
    months: {
        shorthand: [
            "\u0695\u06CE\u0628\u06D5\u0646\u062F\u0627\u0646",
            "\u0695\u06D5\u0634\u06D5\u0645\u06D5",
            "\u0646\u06D5\u0648\u0631\u06C6\u0632",
            "\u06AF\u0648\u06B5\u0627\u0646",
            "\u062C\u06C6\u0632\u06D5\u0631\u062F\u0627\u0646",
            "\u067E\u0648\u0648\u0634\u067E\u06D5\u0695",
            "\u06AF\u06D5\u0644\u0627\u0648\u06CE\u0698",
            "\u062E\u06D5\u0631\u0645\u0627\u0646\u0627\u0646",
            "\u0695\u06D5\u0632\u0628\u06D5\u0631",
            "\u06AF\u06D5\u06B5\u0627\u0695\u06CE\u0632\u0627\u0646",
            "\u0633\u06D5\u0631\u0645\u0627\u0648\u06D5\u0632",
            "\u0628\u06D5\u0641\u0631\u0627\u0646\u0628\u0627\u0631"
        ],
        longhand: [
            "\u0695\u06CE\u0628\u06D5\u0646\u062F\u0627\u0646",
            "\u0695\u06D5\u0634\u06D5\u0645\u06D5",
            "\u0646\u06D5\u0648\u0631\u06C6\u0632",
            "\u06AF\u0648\u06B5\u0627\u0646",
            "\u062C\u06C6\u0632\u06D5\u0631\u062F\u0627\u0646",
            "\u067E\u0648\u0648\u0634\u067E\u06D5\u0695",
            "\u06AF\u06D5\u0644\u0627\u0648\u06CE\u0698",
            "\u062E\u06D5\u0631\u0645\u0627\u0646\u0627\u0646",
            "\u0695\u06D5\u0632\u0628\u06D5\u0631",
            "\u06AF\u06D5\u06B5\u0627\u0695\u06CE\u0632\u0627\u0646",
            "\u0633\u06D5\u0631\u0645\u0627\u0648\u06D5\u0632",
            "\u0628\u06D5\u0641\u0631\u0627\u0646\u0628\u0627\u0631"
        ]
    },
    firstDayOfWeek: 6,
    ordinal: function() {
        return "";
    }
};
$69c921925b448778$var$fp$8.l10ns.ckb = $69c921925b448778$var$Kurdish;
$69c921925b448778$var$fp$8.l10ns;
var $69c921925b448778$var$fp$9 = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Czech = {
    weekdays: {
        shorthand: [
            "Ne",
            "Po",
            "\xdat",
            "St",
            "\u010Ct",
            "P\xe1",
            "So"
        ],
        longhand: [
            "Ned\u011Ble",
            "Pond\u011Bl\xed",
            "\xdater\xfd",
            "St\u0159eda",
            "\u010Ctvrtek",
            "P\xe1tek",
            "Sobota"
        ]
    },
    months: {
        shorthand: [
            "Led",
            "\xdan",
            "B\u0159e",
            "Dub",
            "Kv\u011B",
            "\u010Cer",
            "\u010Cvc",
            "Srp",
            "Z\xe1\u0159",
            "\u0158\xedj",
            "Lis",
            "Pro"
        ],
        longhand: [
            "Leden",
            "\xdanor",
            "B\u0159ezen",
            "Duben",
            "Kv\u011Bten",
            "\u010Cerven",
            "\u010Cervenec",
            "Srpen",
            "Z\xe1\u0159\xed",
            "\u0158\xedjen",
            "Listopad",
            "Prosinec"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return ".";
    },
    rangeSeparator: " do ",
    weekAbbreviation: "T\xfdd.",
    scrollTitle: "Rolujte pro zm\u011Bnu",
    toggleTitle: "P\u0159epnout dopoledne/odpoledne",
    amPM: [
        "dop.",
        "odp."
    ],
    yearAriaLabel: "Rok",
    time_24hr: true
};
$69c921925b448778$var$fp$9.l10ns.cs = $69c921925b448778$var$Czech;
$69c921925b448778$var$fp$9.l10ns;
var $69c921925b448778$var$fp$a = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Welsh = {
    weekdays: {
        shorthand: [
            "Sul",
            "Llun",
            "Maw",
            "Mer",
            "Iau",
            "Gwe",
            "Sad"
        ],
        longhand: [
            "Dydd Sul",
            "Dydd Llun",
            "Dydd Mawrth",
            "Dydd Mercher",
            "Dydd Iau",
            "Dydd Gwener",
            "Dydd Sadwrn"
        ]
    },
    months: {
        shorthand: [
            "Ion",
            "Chwef",
            "Maw",
            "Ebr",
            "Mai",
            "Meh",
            "Gorff",
            "Awst",
            "Medi",
            "Hyd",
            "Tach",
            "Rhag"
        ],
        longhand: [
            "Ionawr",
            "Chwefror",
            "Mawrth",
            "Ebrill",
            "Mai",
            "Mehefin",
            "Gorffennaf",
            "Awst",
            "Medi",
            "Hydref",
            "Tachwedd",
            "Rhagfyr"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function(nth) {
        if (nth === 1) return "af";
        if (nth === 2) return "ail";
        if (nth === 3 || nth === 4) return "ydd";
        if (nth === 5 || nth === 6) return "ed";
        if (nth >= 7 && nth <= 10 || nth == 12 || nth == 15 || nth == 18 || nth == 20) return "fed";
        if (nth == 11 || nth == 13 || nth == 14 || nth == 16 || nth == 17 || nth == 19) return "eg";
        if (nth >= 21 && nth <= 39) return "ain";
        // Inconclusive.
        return "";
    },
    time_24hr: true
};
$69c921925b448778$var$fp$a.l10ns.cy = $69c921925b448778$var$Welsh;
$69c921925b448778$var$fp$a.l10ns;
var $69c921925b448778$var$fp$b = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Danish = {
    weekdays: {
        shorthand: [
            "s\xf8n",
            "man",
            "tir",
            "ons",
            "tors",
            "fre",
            "l\xf8r"
        ],
        longhand: [
            "s\xf8ndag",
            "mandag",
            "tirsdag",
            "onsdag",
            "torsdag",
            "fredag",
            "l\xf8rdag"
        ]
    },
    months: {
        shorthand: [
            "jan",
            "feb",
            "mar",
            "apr",
            "maj",
            "jun",
            "jul",
            "aug",
            "sep",
            "okt",
            "nov",
            "dec"
        ],
        longhand: [
            "januar",
            "februar",
            "marts",
            "april",
            "maj",
            "juni",
            "juli",
            "august",
            "september",
            "oktober",
            "november",
            "december"
        ]
    },
    ordinal: function() {
        return ".";
    },
    firstDayOfWeek: 1,
    rangeSeparator: " til ",
    weekAbbreviation: "uge",
    time_24hr: true
};
$69c921925b448778$var$fp$b.l10ns.da = $69c921925b448778$var$Danish;
$69c921925b448778$var$fp$b.l10ns;
var $69c921925b448778$var$fp$c = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$German = {
    weekdays: {
        shorthand: [
            "So",
            "Mo",
            "Di",
            "Mi",
            "Do",
            "Fr",
            "Sa"
        ],
        longhand: [
            "Sonntag",
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "M\xe4r",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dez"
        ],
        longhand: [
            "Januar",
            "Februar",
            "M\xe4rz",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember"
        ]
    },
    firstDayOfWeek: 1,
    weekAbbreviation: "KW",
    rangeSeparator: " bis ",
    scrollTitle: "Zum \xc4ndern scrollen",
    toggleTitle: "Zum Umschalten klicken",
    time_24hr: true
};
$69c921925b448778$var$fp$c.l10ns.de = $69c921925b448778$var$German;
$69c921925b448778$var$fp$c.l10ns;
var $69c921925b448778$var$english = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $69c921925b448778$var$fp$d = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Esperanto = {
    firstDayOfWeek: 1,
    rangeSeparator: " \u011Dis ",
    weekAbbreviation: "Sem",
    scrollTitle: "Rulumu por pligrandigi la valoron",
    toggleTitle: "Klaku por \u015Dalti",
    weekdays: {
        shorthand: [
            "Dim",
            "Lun",
            "Mar",
            "Mer",
            "\u0134a\u016D",
            "Ven",
            "Sab"
        ],
        longhand: [
            "diman\u0109o",
            "lundo",
            "mardo",
            "merkredo",
            "\u0135a\u016Ddo",
            "vendredo",
            "sabato"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Maj",
            "Jun",
            "Jul",
            "A\u016Dg",
            "Sep",
            "Okt",
            "Nov",
            "Dec"
        ],
        longhand: [
            "januaro",
            "februaro",
            "marto",
            "aprilo",
            "majo",
            "junio",
            "julio",
            "a\u016Dgusto",
            "septembro",
            "oktobro",
            "novembro",
            "decembro"
        ]
    },
    ordinal: function() {
        return "-a";
    },
    time_24hr: true
};
$69c921925b448778$var$fp$d.l10ns.eo = $69c921925b448778$var$Esperanto;
$69c921925b448778$var$fp$d.l10ns;
var $69c921925b448778$var$fp$e = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Spanish = {
    weekdays: {
        shorthand: [
            "Dom",
            "Lun",
            "Mar",
            "Mi\xe9",
            "Jue",
            "Vie",
            "S\xe1b"
        ],
        longhand: [
            "Domingo",
            "Lunes",
            "Martes",
            "Mi\xe9rcoles",
            "Jueves",
            "Viernes",
            "S\xe1bado"
        ]
    },
    months: {
        shorthand: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic"
        ],
        longhand: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ]
    },
    ordinal: function() {
        return "\xba";
    },
    firstDayOfWeek: 1,
    rangeSeparator: " a ",
    time_24hr: true
};
$69c921925b448778$var$fp$e.l10ns.es = $69c921925b448778$var$Spanish;
$69c921925b448778$var$fp$e.l10ns;
var $69c921925b448778$var$fp$f = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Estonian = {
    weekdays: {
        shorthand: [
            "P",
            "E",
            "T",
            "K",
            "N",
            "R",
            "L"
        ],
        longhand: [
            "P\xfchap\xe4ev",
            "Esmasp\xe4ev",
            "Teisip\xe4ev",
            "Kolmap\xe4ev",
            "Neljap\xe4ev",
            "Reede",
            "Laup\xe4ev"
        ]
    },
    months: {
        shorthand: [
            "Jaan",
            "Veebr",
            "M\xe4rts",
            "Apr",
            "Mai",
            "Juuni",
            "Juuli",
            "Aug",
            "Sept",
            "Okt",
            "Nov",
            "Dets"
        ],
        longhand: [
            "Jaanuar",
            "Veebruar",
            "M\xe4rts",
            "Aprill",
            "Mai",
            "Juuni",
            "Juuli",
            "August",
            "September",
            "Oktoober",
            "November",
            "Detsember"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return ".";
    },
    weekAbbreviation: "N\xe4d",
    rangeSeparator: " kuni ",
    scrollTitle: "Keri, et suurendada",
    toggleTitle: "Kl\xf5psa, et vahetada",
    time_24hr: true
};
$69c921925b448778$var$fp$f.l10ns.et = $69c921925b448778$var$Estonian;
$69c921925b448778$var$fp$f.l10ns;
var $69c921925b448778$var$fp$g = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Persian = {
    weekdays: {
        shorthand: [
            "\u06CC\u06A9",
            "\u062F\u0648",
            "\u0633\u0647",
            "\u0686\u0647\u0627\u0631",
            "\u067E\u0646\u062C",
            "\u062C\u0645\u0639\u0647",
            "\u0634\u0646\u0628\u0647"
        ],
        longhand: [
            "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647",
            "\u062F\u0648\u0634\u0646\u0628\u0647",
            "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
            "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
            "\u067E\u0646\u0686\u200C\u0634\u0646\u0628\u0647",
            "\u062C\u0645\u0639\u0647",
            "\u0634\u0646\u0628\u0647"
        ]
    },
    months: {
        shorthand: [
            "\u0698\u0627\u0646\u0648\u06CC\u0647",
            "\u0641\u0648\u0631\u06CC\u0647",
            "\u0645\u0627\u0631\u0633",
            "\u0622\u0648\u0631\u06CC\u0644",
            "\u0645\u0647",
            "\u0698\u0648\u0626\u0646",
            "\u0698\u0648\u0626\u06CC\u0647",
            "\u0627\u0648\u062A",
            "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
            "\u0627\u06A9\u062A\u0628\u0631",
            "\u0646\u0648\u0627\u0645\u0628\u0631",
            "\u062F\u0633\u0627\u0645\u0628\u0631"
        ],
        longhand: [
            "\u0698\u0627\u0646\u0648\u06CC\u0647",
            "\u0641\u0648\u0631\u06CC\u0647",
            "\u0645\u0627\u0631\u0633",
            "\u0622\u0648\u0631\u06CC\u0644",
            "\u0645\u0647",
            "\u0698\u0648\u0626\u0646",
            "\u0698\u0648\u0626\u06CC\u0647",
            "\u0627\u0648\u062A",
            "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
            "\u0627\u06A9\u062A\u0628\u0631",
            "\u0646\u0648\u0627\u0645\u0628\u0631",
            "\u062F\u0633\u0627\u0645\u0628\u0631"
        ]
    },
    firstDayOfWeek: 6,
    ordinal: function() {
        return "";
    }
};
$69c921925b448778$var$fp$g.l10ns.fa = $69c921925b448778$var$Persian;
$69c921925b448778$var$fp$g.l10ns;
var $69c921925b448778$var$fp$h = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Finnish = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: [
            "su",
            "ma",
            "ti",
            "ke",
            "to",
            "pe",
            "la"
        ],
        longhand: [
            "sunnuntai",
            "maanantai",
            "tiistai",
            "keskiviikko",
            "torstai",
            "perjantai",
            "lauantai"
        ]
    },
    months: {
        shorthand: [
            "tammi",
            "helmi",
            "maalis",
            "huhti",
            "touko",
            "kes\xe4",
            "hein\xe4",
            "elo",
            "syys",
            "loka",
            "marras",
            "joulu"
        ],
        longhand: [
            "tammikuu",
            "helmikuu",
            "maaliskuu",
            "huhtikuu",
            "toukokuu",
            "kes\xe4kuu",
            "hein\xe4kuu",
            "elokuu",
            "syyskuu",
            "lokakuu",
            "marraskuu",
            "joulukuu"
        ]
    },
    ordinal: function() {
        return ".";
    },
    time_24hr: true
};
$69c921925b448778$var$fp$h.l10ns.fi = $69c921925b448778$var$Finnish;
$69c921925b448778$var$fp$h.l10ns;
var $69c921925b448778$var$fp$i = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Faroese = {
    weekdays: {
        shorthand: [
            "Sun",
            "M\xe1n",
            "T\xfds",
            "Mik",
            "H\xf3s",
            "Fr\xed",
            "Ley"
        ],
        longhand: [
            "Sunnudagur",
            "M\xe1nadagur",
            "T\xfdsdagur",
            "Mikudagur",
            "H\xf3sdagur",
            "Fr\xedggjadagur",
            "Leygardagur"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Des"
        ],
        longhand: [
            "Januar",
            "Februar",
            "Mars",
            "Apr\xedl",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "Septembur",
            "Oktobur",
            "Novembur",
            "Desembur"
        ]
    },
    ordinal: function() {
        return ".";
    },
    firstDayOfWeek: 1,
    rangeSeparator: " til ",
    weekAbbreviation: "vika",
    scrollTitle: "Rulla fyri at broyta",
    toggleTitle: "Tr\xfdst fyri at skifta",
    yearAriaLabel: "\xc1r",
    time_24hr: true
};
$69c921925b448778$var$fp$i.l10ns.fo = $69c921925b448778$var$Faroese;
$69c921925b448778$var$fp$i.l10ns;
var $69c921925b448778$var$fp$j = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$French = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: [
            "dim",
            "lun",
            "mar",
            "mer",
            "jeu",
            "ven",
            "sam"
        ],
        longhand: [
            "dimanche",
            "lundi",
            "mardi",
            "mercredi",
            "jeudi",
            "vendredi",
            "samedi"
        ]
    },
    months: {
        shorthand: [
            "janv",
            "f\xe9vr",
            "mars",
            "avr",
            "mai",
            "juin",
            "juil",
            "ao\xfbt",
            "sept",
            "oct",
            "nov",
            "d\xe9c"
        ],
        longhand: [
            "janvier",
            "f\xe9vrier",
            "mars",
            "avril",
            "mai",
            "juin",
            "juillet",
            "ao\xfbt",
            "septembre",
            "octobre",
            "novembre",
            "d\xe9cembre"
        ]
    },
    ordinal: function(nth) {
        if (nth > 1) return "";
        return "er";
    },
    rangeSeparator: " au ",
    weekAbbreviation: "Sem",
    scrollTitle: "D\xe9filer pour augmenter la valeur",
    toggleTitle: "Cliquer pour basculer",
    time_24hr: true
};
$69c921925b448778$var$fp$j.l10ns.fr = $69c921925b448778$var$French;
$69c921925b448778$var$fp$j.l10ns;
var $69c921925b448778$var$fp$k = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Greek = {
    weekdays: {
        shorthand: [
            "\u039A\u03C5",
            "\u0394\u03B5",
            "\u03A4\u03C1",
            "\u03A4\u03B5",
            "\u03A0\u03AD",
            "\u03A0\u03B1",
            "\u03A3\u03AC"
        ],
        longhand: [
            "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
            "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
            "\u03A4\u03C1\u03AF\u03C4\u03B7",
            "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
            "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
            "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
            "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
        ]
    },
    months: {
        shorthand: [
            "\u0399\u03B1\u03BD",
            "\u03A6\u03B5\u03B2",
            "\u039C\u03AC\u03C1",
            "\u0391\u03C0\u03C1",
            "\u039C\u03AC\u03B9",
            "\u0399\u03BF\u03CD\u03BD",
            "\u0399\u03BF\u03CD\u03BB",
            "\u0391\u03CD\u03B3",
            "\u03A3\u03B5\u03C0",
            "\u039F\u03BA\u03C4",
            "\u039D\u03BF\u03AD",
            "\u0394\u03B5\u03BA"
        ],
        longhand: [
            "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
            "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
            "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
            "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
            "\u039C\u03AC\u03B9\u03BF\u03C2",
            "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
            "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
            "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
            "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
            "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
            "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
            "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    weekAbbreviation: "\u0395\u03B2\u03B4",
    rangeSeparator: " \u03AD\u03C9\u03C2 ",
    scrollTitle: "\u039C\u03B5\u03C4\u03B1\u03BA\u03C5\u03BB\u03AE\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B1\u03CD\u03BE\u03B7\u03C3\u03B7",
    toggleTitle: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE",
    amPM: [
        "\u03A0\u039C",
        "\u039C\u039C"
    ],
    yearAriaLabel: "\u03C7\u03C1\u03CC\u03BD\u03BF\u03C2",
    monthAriaLabel: "\u03BC\u03AE\u03BD\u03B1\u03C2",
    hourAriaLabel: "\u03CE\u03C1\u03B1",
    minuteAriaLabel: "\u03BB\u03B5\u03C0\u03C4\u03CC"
};
$69c921925b448778$var$fp$k.l10ns.gr = $69c921925b448778$var$Greek;
$69c921925b448778$var$fp$k.l10ns;
var $69c921925b448778$var$fp$l = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Hebrew = {
    weekdays: {
        shorthand: [
            "\u05D0",
            "\u05D1",
            "\u05D2",
            "\u05D3",
            "\u05D4",
            "\u05D5",
            "\u05E9"
        ],
        longhand: [
            "\u05E8\u05D0\u05E9\u05D5\u05DF",
            "\u05E9\u05E0\u05D9",
            "\u05E9\u05DC\u05D9\u05E9\u05D9",
            "\u05E8\u05D1\u05D9\u05E2\u05D9",
            "\u05D7\u05DE\u05D9\u05E9\u05D9",
            "\u05E9\u05D9\u05E9\u05D9",
            "\u05E9\u05D1\u05EA"
        ]
    },
    months: {
        shorthand: [
            "\u05D9\u05E0\u05D5\u05F3",
            "\u05E4\u05D1\u05E8\u05F3",
            "\u05DE\u05E8\u05E5",
            "\u05D0\u05E4\u05E8\u05F3",
            "\u05DE\u05D0\u05D9",
            "\u05D9\u05D5\u05E0\u05D9",
            "\u05D9\u05D5\u05DC\u05D9",
            "\u05D0\u05D5\u05D2\u05F3",
            "\u05E1\u05E4\u05D8\u05F3",
            "\u05D0\u05D5\u05E7\u05F3",
            "\u05E0\u05D5\u05D1\u05F3",
            "\u05D3\u05E6\u05DE\u05F3"
        ],
        longhand: [
            "\u05D9\u05E0\u05D5\u05D0\u05E8",
            "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
            "\u05DE\u05E8\u05E5",
            "\u05D0\u05E4\u05E8\u05D9\u05DC",
            "\u05DE\u05D0\u05D9",
            "\u05D9\u05D5\u05E0\u05D9",
            "\u05D9\u05D5\u05DC\u05D9",
            "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
            "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
            "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
            "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
            "\u05D3\u05E6\u05DE\u05D1\u05E8"
        ]
    },
    rangeSeparator: " \u05D0\u05DC ",
    time_24hr: true
};
$69c921925b448778$var$fp$l.l10ns.he = $69c921925b448778$var$Hebrew;
$69c921925b448778$var$fp$l.l10ns;
var $69c921925b448778$var$fp$m = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Hindi = {
    weekdays: {
        shorthand: [
            "\u0930\u0935\u093F",
            "\u0938\u094B\u092E",
            "\u092E\u0902\u0917\u0932",
            "\u092C\u0941\u0927",
            "\u0917\u0941\u0930\u0941",
            "\u0936\u0941\u0915\u094D\u0930",
            "\u0936\u0928\u093F"
        ],
        longhand: [
            "\u0930\u0935\u093F\u0935\u093E\u0930",
            "\u0938\u094B\u092E\u0935\u093E\u0930",
            "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
            "\u092C\u0941\u0927\u0935\u093E\u0930",
            "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
            "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
            "\u0936\u0928\u093F\u0935\u093E\u0930"
        ]
    },
    months: {
        shorthand: [
            "\u091C\u0928",
            "\u092B\u0930",
            "\u092E\u093E\u0930\u094D\u091A",
            "\u0905\u092A\u094D\u0930\u0947\u0932",
            "\u092E\u0908",
            "\u091C\u0942\u0928",
            "\u091C\u0942\u0932\u093E\u0908",
            "\u0905\u0917",
            "\u0938\u093F\u0924",
            "\u0905\u0915\u094D\u091F",
            "\u0928\u0935",
            "\u0926\u093F"
        ],
        longhand: [
            "\u091C\u0928\u0935\u0930\u0940 ",
            "\u092B\u0930\u0935\u0930\u0940",
            "\u092E\u093E\u0930\u094D\u091A",
            "\u0905\u092A\u094D\u0930\u0947\u0932",
            "\u092E\u0908",
            "\u091C\u0942\u0928",
            "\u091C\u0942\u0932\u093E\u0908",
            "\u0905\u0917\u0938\u094D\u0924 ",
            "\u0938\u093F\u0924\u092E\u094D\u092C\u0930",
            "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
            "\u0928\u0935\u092E\u094D\u092C\u0930",
            "\u0926\u093F\u0938\u092E\u094D\u092C\u0930"
        ]
    }
};
$69c921925b448778$var$fp$m.l10ns.hi = $69c921925b448778$var$Hindi;
$69c921925b448778$var$fp$m.l10ns;
var $69c921925b448778$var$fp$n = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Croatian = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: [
            "Ned",
            "Pon",
            "Uto",
            "Sri",
            "\u010Cet",
            "Pet",
            "Sub"
        ],
        longhand: [
            "Nedjelja",
            "Ponedjeljak",
            "Utorak",
            "Srijeda",
            "\u010Cetvrtak",
            "Petak",
            "Subota"
        ]
    },
    months: {
        shorthand: [
            "Sij",
            "Velj",
            "O\u017Eu",
            "Tra",
            "Svi",
            "Lip",
            "Srp",
            "Kol",
            "Ruj",
            "Lis",
            "Stu",
            "Pro"
        ],
        longhand: [
            "Sije\u010Danj",
            "Velja\u010Da",
            "O\u017Eujak",
            "Travanj",
            "Svibanj",
            "Lipanj",
            "Srpanj",
            "Kolovoz",
            "Rujan",
            "Listopad",
            "Studeni",
            "Prosinac"
        ]
    },
    time_24hr: true
};
$69c921925b448778$var$fp$n.l10ns.hr = $69c921925b448778$var$Croatian;
$69c921925b448778$var$fp$n.l10ns;
var $69c921925b448778$var$fp$o = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Hungarian = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: [
            "V",
            "H",
            "K",
            "Sz",
            "Cs",
            "P",
            "Szo"
        ],
        longhand: [
            "Vas\xe1rnap",
            "H\xe9tf\u0151",
            "Kedd",
            "Szerda",
            "Cs\xfct\xf6rt\xf6k",
            "P\xe9ntek",
            "Szombat"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "M\xe1r",
            "\xc1pr",
            "M\xe1j",
            "J\xfan",
            "J\xfal",
            "Aug",
            "Szep",
            "Okt",
            "Nov",
            "Dec"
        ],
        longhand: [
            "Janu\xe1r",
            "Febru\xe1r",
            "M\xe1rcius",
            "\xc1prilis",
            "M\xe1jus",
            "J\xfanius",
            "J\xfalius",
            "Augusztus",
            "Szeptember",
            "Okt\xf3ber",
            "November",
            "December"
        ]
    },
    ordinal: function() {
        return ".";
    },
    weekAbbreviation: "H\xe9t",
    scrollTitle: "G\xf6rgessen",
    toggleTitle: "Kattintson a v\xe1lt\xe1shoz",
    rangeSeparator: " - ",
    time_24hr: true
};
$69c921925b448778$var$fp$o.l10ns.hu = $69c921925b448778$var$Hungarian;
$69c921925b448778$var$fp$o.l10ns;
var $69c921925b448778$var$fp$p = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Armenian = {
    weekdays: {
        shorthand: [
            "\u053F\u056B\u0580",
            "\u0535\u0580\u056F",
            "\u0535\u0580\u0584",
            "\u0549\u0580\u0584",
            "\u0540\u0576\u0563",
            "\u0548\u0582\u0580\u0562",
            "\u0547\u0562\u0569"
        ],
        longhand: [
            "\u053F\u056B\u0580\u0561\u056F\u056B",
            "\u0535\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
            "\u0535\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
            "\u0549\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
            "\u0540\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
            "\u0548\u0582\u0580\u0562\u0561\u0569",
            "\u0547\u0561\u0562\u0561\u0569"
        ]
    },
    months: {
        shorthand: [
            "\u0540\u0576\u057E",
            "\u0553\u057F\u0580",
            "\u0544\u0561\u0580",
            "\u0531\u057A\u0580",
            "\u0544\u0561\u0575",
            "\u0540\u0576\u057D",
            "\u0540\u056C\u057D",
            "\u0555\u0563\u057D",
            "\u054D\u0565\u057A",
            "\u0540\u0578\u056F",
            "\u0546\u0574\u0562",
            "\u0534\u0565\u056F"
        ],
        longhand: [
            "\u0540\u0578\u0582\u0576\u057E\u0561\u0580",
            "\u0553\u0565\u057F\u0580\u057E\u0561\u0580",
            "\u0544\u0561\u0580\u057F",
            "\u0531\u057A\u0580\u056B\u056C",
            "\u0544\u0561\u0575\u056B\u057D",
            "\u0540\u0578\u0582\u0576\u056B\u057D",
            "\u0540\u0578\u0582\u056C\u056B\u057D",
            "\u0555\u0563\u0578\u057D\u057F\u0578\u057D",
            "\u054D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
            "\u0540\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
            "\u0546\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
            "\u0534\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    rangeSeparator: " \u2014 ",
    weekAbbreviation: "\u0547\u0532\u054F",
    scrollTitle: "\u0548\u056C\u0578\u0580\u0565\u0584\u055D \u0574\u0565\u056E\u0561\u0581\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
    toggleTitle: "\u054D\u0565\u0572\u0574\u0565\u0584\u055D \u0583\u0578\u056D\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
    amPM: [
        "\u0544\u053F",
        "\u053F\u0540"
    ],
    yearAriaLabel: "\u054F\u0561\u0580\u056B",
    monthAriaLabel: "\u0531\u0574\u056B\u057D",
    hourAriaLabel: "\u053A\u0561\u0574",
    minuteAriaLabel: "\u0550\u0578\u057A\u0565",
    time_24hr: true
};
$69c921925b448778$var$fp$p.l10ns.hy = $69c921925b448778$var$Armenian;
$69c921925b448778$var$fp$p.l10ns;
var $69c921925b448778$var$fp$q = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Indonesian = {
    weekdays: {
        shorthand: [
            "Min",
            "Sen",
            "Sel",
            "Rab",
            "Kam",
            "Jum",
            "Sab"
        ],
        longhand: [
            "Minggu",
            "Senin",
            "Selasa",
            "Rabu",
            "Kamis",
            "Jumat",
            "Sabtu"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Agu",
            "Sep",
            "Okt",
            "Nov",
            "Des"
        ],
        longhand: [
            "Januari",
            "Februari",
            "Maret",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Agustus",
            "September",
            "Oktober",
            "November",
            "Desember"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    time_24hr: true,
    rangeSeparator: " - "
};
$69c921925b448778$var$fp$q.l10ns.id = $69c921925b448778$var$Indonesian;
$69c921925b448778$var$fp$q.l10ns;
var $69c921925b448778$var$fp$r = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Icelandic = {
    weekdays: {
        shorthand: [
            "Sun",
            "M\xe1n",
            "\xderi",
            "Mi\xf0",
            "Fim",
            "F\xf6s",
            "Lau"
        ],
        longhand: [
            "Sunnudagur",
            "M\xe1nudagur",
            "\xderi\xf0judagur",
            "Mi\xf0vikudagur",
            "Fimmtudagur",
            "F\xf6studagur",
            "Laugardagur"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Ma\xed",
            "J\xfan",
            "J\xfal",
            "\xc1g\xfa",
            "Sep",
            "Okt",
            "N\xf3v",
            "Des"
        ],
        longhand: [
            "Jan\xfaar",
            "Febr\xfaar",
            "Mars",
            "Apr\xedl",
            "Ma\xed",
            "J\xfan\xed",
            "J\xfal\xed",
            "\xc1g\xfast",
            "September",
            "Okt\xf3ber",
            "N\xf3vember",
            "Desember"
        ]
    },
    ordinal: function() {
        return ".";
    },
    firstDayOfWeek: 1,
    rangeSeparator: " til ",
    weekAbbreviation: "vika",
    yearAriaLabel: "\xc1r",
    time_24hr: true
};
$69c921925b448778$var$fp$r.l10ns.is = $69c921925b448778$var$Icelandic;
$69c921925b448778$var$fp$r.l10ns;
var $69c921925b448778$var$fp$s = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Italian = {
    weekdays: {
        shorthand: [
            "Dom",
            "Lun",
            "Mar",
            "Mer",
            "Gio",
            "Ven",
            "Sab"
        ],
        longhand: [
            "Domenica",
            "Luned\xec",
            "Marted\xec",
            "Mercoled\xec",
            "Gioved\xec",
            "Venerd\xec",
            "Sabato"
        ]
    },
    months: {
        shorthand: [
            "Gen",
            "Feb",
            "Mar",
            "Apr",
            "Mag",
            "Giu",
            "Lug",
            "Ago",
            "Set",
            "Ott",
            "Nov",
            "Dic"
        ],
        longhand: [
            "Gennaio",
            "Febbraio",
            "Marzo",
            "Aprile",
            "Maggio",
            "Giugno",
            "Luglio",
            "Agosto",
            "Settembre",
            "Ottobre",
            "Novembre",
            "Dicembre"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "\xb0";
    },
    rangeSeparator: " al ",
    weekAbbreviation: "Se",
    scrollTitle: "Scrolla per aumentare",
    toggleTitle: "Clicca per cambiare",
    time_24hr: true
};
$69c921925b448778$var$fp$s.l10ns.it = $69c921925b448778$var$Italian;
$69c921925b448778$var$fp$s.l10ns;
var $69c921925b448778$var$fp$t = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Japanese = {
    weekdays: {
        shorthand: [
            "\u65E5",
            "\u6708",
            "\u706B",
            "\u6C34",
            "\u6728",
            "\u91D1",
            "\u571F"
        ],
        longhand: [
            "\u65E5\u66DC\u65E5",
            "\u6708\u66DC\u65E5",
            "\u706B\u66DC\u65E5",
            "\u6C34\u66DC\u65E5",
            "\u6728\u66DC\u65E5",
            "\u91D1\u66DC\u65E5",
            "\u571F\u66DC\u65E5"
        ]
    },
    months: {
        shorthand: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        longhand: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ]
    },
    time_24hr: true,
    rangeSeparator: " \u304B\u3089 ",
    monthAriaLabel: "\u6708",
    amPM: [
        "\u5348\u524D",
        "\u5348\u5F8C"
    ],
    yearAriaLabel: "\u5E74",
    hourAriaLabel: "\u6642\u9593",
    minuteAriaLabel: "\u5206"
};
$69c921925b448778$var$fp$t.l10ns.ja = $69c921925b448778$var$Japanese;
$69c921925b448778$var$fp$t.l10ns;
var $69c921925b448778$var$fp$u = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Georgian = {
    weekdays: {
        shorthand: [
            "\u10D9\u10D5",
            "\u10DD\u10E0",
            "\u10E1\u10D0",
            "\u10DD\u10D7",
            "\u10EE\u10E3",
            "\u10DE\u10D0",
            "\u10E8\u10D0"
        ],
        longhand: [
            "\u10D9\u10D5\u10D8\u10E0\u10D0",
            "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
            "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
            "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
            "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
            "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
            "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
        ]
    },
    months: {
        shorthand: [
            "\u10D8\u10D0\u10DC",
            "\u10D7\u10D4\u10D1",
            "\u10DB\u10D0\u10E0",
            "\u10D0\u10DE\u10E0",
            "\u10DB\u10D0\u10D8",
            "\u10D8\u10D5\u10DC",
            "\u10D8\u10D5\u10DA",
            "\u10D0\u10D2\u10D5",
            "\u10E1\u10D4\u10E5",
            "\u10DD\u10E5\u10E2",
            "\u10DC\u10DD\u10D4",
            "\u10D3\u10D4\u10D9"
        ],
        longhand: [
            "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
            "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
            "\u10DB\u10D0\u10E0\u10E2\u10D8",
            "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
            "\u10DB\u10D0\u10D8\u10E1\u10D8",
            "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
            "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
            "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
            "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
            "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
            "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
            "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    rangeSeparator: " \u2014 ",
    weekAbbreviation: "\u10D9\u10D5.",
    scrollTitle: "\u10D3\u10D0\u10E1\u10E5\u10E0\u10DD\u10DA\u10D4\u10D7 \u10D2\u10D0\u10E1\u10D0\u10D3\u10D8\u10D3\u10D4\u10D1\u10DA\u10D0\u10D3",
    toggleTitle: "\u10D3\u10D0\u10D0\u10D9\u10DA\u10D8\u10D9\u10D4\u10D7 \u10D2\u10D0\u10D3\u10D0\u10E0\u10D7\u10D5\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "\u10EC\u10D4\u10DA\u10D8",
    time_24hr: true
};
$69c921925b448778$var$fp$u.l10ns.ka = $69c921925b448778$var$Georgian;
$69c921925b448778$var$fp$u.l10ns;
var $69c921925b448778$var$fp$v = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Korean = {
    weekdays: {
        shorthand: [
            "\uC77C",
            "\uC6D4",
            "\uD654",
            "\uC218",
            "\uBAA9",
            "\uAE08",
            "\uD1A0"
        ],
        longhand: [
            "\uC77C\uC694\uC77C",
            "\uC6D4\uC694\uC77C",
            "\uD654\uC694\uC77C",
            "\uC218\uC694\uC77C",
            "\uBAA9\uC694\uC77C",
            "\uAE08\uC694\uC77C",
            "\uD1A0\uC694\uC77C"
        ]
    },
    months: {
        shorthand: [
            "1\uC6D4",
            "2\uC6D4",
            "3\uC6D4",
            "4\uC6D4",
            "5\uC6D4",
            "6\uC6D4",
            "7\uC6D4",
            "8\uC6D4",
            "9\uC6D4",
            "10\uC6D4",
            "11\uC6D4",
            "12\uC6D4"
        ],
        longhand: [
            "1\uC6D4",
            "2\uC6D4",
            "3\uC6D4",
            "4\uC6D4",
            "5\uC6D4",
            "6\uC6D4",
            "7\uC6D4",
            "8\uC6D4",
            "9\uC6D4",
            "10\uC6D4",
            "11\uC6D4",
            "12\uC6D4"
        ]
    },
    ordinal: function() {
        return "\uC77C";
    },
    rangeSeparator: " ~ ",
    amPM: [
        "\uC624\uC804",
        "\uC624\uD6C4"
    ]
};
$69c921925b448778$var$fp$v.l10ns.ko = $69c921925b448778$var$Korean;
$69c921925b448778$var$fp$v.l10ns;
var $69c921925b448778$var$fp$w = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Khmer = {
    weekdays: {
        shorthand: [
            "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
            "\u1785\u1793\u17D2\u1791",
            "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
            "\u1796\u17BB\u1792",
            "\u1796\u17D2\u179A\u17A0\u179F.",
            "\u179F\u17BB\u1780\u17D2\u179A",
            "\u179F\u17C5\u179A\u17CD"
        ],
        longhand: [
            "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
            "\u1785\u1793\u17D2\u1791",
            "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
            "\u1796\u17BB\u1792",
            "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
            "\u179F\u17BB\u1780\u17D2\u179A",
            "\u179F\u17C5\u179A\u17CD"
        ]
    },
    months: {
        shorthand: [
            "\u1798\u1780\u179A\u17B6",
            "\u1780\u17BB\u1798\u17D2\u1797\u17C7",
            "\u1798\u17B8\u1793\u17B6",
            "\u1798\u17C1\u179F\u17B6",
            "\u17A7\u179F\u1797\u17B6",
            "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
            "\u1780\u1780\u17D2\u1780\u178A\u17B6",
            "\u179F\u17B8\u17A0\u17B6",
            "\u1780\u1789\u17D2\u1789\u17B6",
            "\u178F\u17BB\u179B\u17B6",
            "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
            "\u1792\u17D2\u1793\u17BC"
        ],
        longhand: [
            "\u1798\u1780\u179A\u17B6",
            "\u1780\u17BB\u1798\u17D2\u1797\u17C7",
            "\u1798\u17B8\u1793\u17B6",
            "\u1798\u17C1\u179F\u17B6",
            "\u17A7\u179F\u1797\u17B6",
            "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
            "\u1780\u1780\u17D2\u1780\u178A\u17B6",
            "\u179F\u17B8\u17A0\u17B6",
            "\u1780\u1789\u17D2\u1789\u17B6",
            "\u178F\u17BB\u179B\u17B6",
            "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
            "\u1792\u17D2\u1793\u17BC"
        ]
    },
    ordinal: function() {
        return "";
    },
    firstDayOfWeek: 1,
    rangeSeparator: " \u178A\u179B\u17CB ",
    weekAbbreviation: "\u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    scrollTitle: "\u179A\u17C6\u1780\u17B7\u179B\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1794\u1784\u17D2\u1780\u17BE\u1793",
    toggleTitle: "\u1785\u17BB\u1785\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1795\u17D2\u179B\u17B6\u179F\u17CB\u1794\u17D2\u178A\u17BC\u179A",
    yearAriaLabel: "\u1786\u17D2\u1793\u17B6\u17C6",
    time_24hr: true
};
$69c921925b448778$var$fp$w.l10ns.km = $69c921925b448778$var$Khmer;
$69c921925b448778$var$fp$w.l10ns;
var $69c921925b448778$var$fp$x = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Kazakh = {
    weekdays: {
        shorthand: [
            "\u0416\u0441",
            "\u0414\u0441",
            "\u0421c",
            "\u0421\u0440",
            "\u0411\u0441",
            "\u0416\u043C",
            "\u0421\u0431"
        ],
        longhand: [
            "\u0416\u0435\u043A\u0441\u0435\u043D\u0431i",
            "\u0414\u04AF\u0439\u0441\u0435\u043D\u0431i",
            "\u0421\u0435\u0439\u0441\u0435\u043D\u0431i",
            "\u0421\u04D9\u0440\u0441\u0435\u043D\u0431i",
            "\u0411\u0435\u0439\u0441\u0435\u043D\u0431i",
            "\u0416\u04B1\u043C\u0430",
            "\u0421\u0435\u043D\u0431i"
        ]
    },
    months: {
        shorthand: [
            "\u049A\u0430\u04A3",
            "\u0410\u049B\u043F",
            "\u041D\u0430\u0443",
            "\u0421\u04D9\u0443",
            "\u041C\u0430\u043C",
            "\u041C\u0430\u0443",
            "\u0428i\u043B",
            "\u0422\u0430\u043C",
            "\u049A\u044B\u0440",
            "\u049A\u0430\u0437",
            "\u049A\u0430\u0440",
            "\u0416\u0435\u043B"
        ],
        longhand: [
            "\u049A\u0430\u04A3\u0442\u0430\u0440",
            "\u0410\u049B\u043F\u0430\u043D",
            "\u041D\u0430\u0443\u0440\u044B\u0437",
            "\u0421\u04D9\u0443i\u0440",
            "\u041C\u0430\u043C\u044B\u0440",
            "\u041C\u0430\u0443\u0441\u044B\u043C",
            "\u0428i\u043B\u0434\u0435",
            "\u0422\u0430\u043C\u044B\u0437",
            "\u049A\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
            "\u049A\u0430\u0437\u0430\u043D",
            "\u049A\u0430\u0440\u0430\u0448\u0430",
            "\u0416\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    rangeSeparator: " \u2014 ",
    weekAbbreviation: "\u0410\u043F\u0442\u0430",
    scrollTitle: "\u04AE\u043B\u043A\u0435\u0439\u0442\u0443 \u04AF\u0448\u0456\u043D \u0430\u0439\u043D\u0430\u043B\u0434\u044B\u0440\u044B\u04A3\u044B\u0437",
    toggleTitle: "\u0410\u0443\u044B\u0441\u0442\u044B\u0440\u0443 \u04AF\u0448\u0456\u043D \u0431\u0430\u0441\u044B\u04A3\u044B\u0437",
    amPM: [
        "\u0422\u0414",
        "\u0422\u041A"
    ],
    yearAriaLabel: "\u0416\u044B\u043B"
};
$69c921925b448778$var$fp$x.l10ns.kz = $69c921925b448778$var$Kazakh;
$69c921925b448778$var$fp$x.l10ns;
var $69c921925b448778$var$fp$y = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Lithuanian = {
    weekdays: {
        shorthand: [
            "S",
            "Pr",
            "A",
            "T",
            "K",
            "Pn",
            "\u0160"
        ],
        longhand: [
            "Sekmadienis",
            "Pirmadienis",
            "Antradienis",
            "Tre\u010Diadienis",
            "Ketvirtadienis",
            "Penktadienis",
            "\u0160e\u0161tadienis"
        ]
    },
    months: {
        shorthand: [
            "Sau",
            "Vas",
            "Kov",
            "Bal",
            "Geg",
            "Bir",
            "Lie",
            "Rgp",
            "Rgs",
            "Spl",
            "Lap",
            "Grd"
        ],
        longhand: [
            "Sausis",
            "Vasaris",
            "Kovas",
            "Balandis",
            "Gegu\u017E\u0117",
            "Bir\u017Eelis",
            "Liepa",
            "Rugpju\u0304tis",
            "Rugse\u0307jis",
            "Spalis",
            "Lapkritis",
            "Gruodis"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "-a";
    },
    rangeSeparator: " iki ",
    weekAbbreviation: "Sav",
    scrollTitle: "Keisti laik\u0105 pel\u0117s rateliu",
    toggleTitle: "Perjungti laiko format\u0105",
    time_24hr: true
};
$69c921925b448778$var$fp$y.l10ns.lt = $69c921925b448778$var$Lithuanian;
$69c921925b448778$var$fp$y.l10ns;
var $69c921925b448778$var$fp$z = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Latvian = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: [
            "Sv",
            "Pr",
            "Ot",
            "Tr",
            "Ce",
            "Pk",
            "Se"
        ],
        longhand: [
            "Sv\u0113tdiena",
            "Pirmdiena",
            "Otrdiena",
            "Tre\u0161diena",
            "Ceturtdiena",
            "Piektdiena",
            "Sestdiena"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "J\u016Bn",
            "J\u016Bl",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dec"
        ],
        longhand: [
            "Janv\u0101ris",
            "Febru\u0101ris",
            "Marts",
            "Apr\u012Blis",
            "Maijs",
            "J\u016Bnijs",
            "J\u016Blijs",
            "Augusts",
            "Septembris",
            "Oktobris",
            "Novembris",
            "Decembris"
        ]
    },
    rangeSeparator: " l\u012Bdz ",
    time_24hr: true
};
$69c921925b448778$var$fp$z.l10ns.lv = $69c921925b448778$var$Latvian;
$69c921925b448778$var$fp$z.l10ns;
var $69c921925b448778$var$fp$A = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Macedonian = {
    weekdays: {
        shorthand: [
            "\u041D\u0435",
            "\u041F\u043E",
            "\u0412\u0442",
            "\u0421\u0440",
            "\u0427\u0435",
            "\u041F\u0435",
            "\u0421\u0430"
        ],
        longhand: [
            "\u041D\u0435\u0434\u0435\u043B\u0430",
            "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
            "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
            "\u0421\u0440\u0435\u0434\u0430",
            "\u0427\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
            "\u041F\u0435\u0442\u043E\u043A",
            "\u0421\u0430\u0431\u043E\u0442\u0430"
        ]
    },
    months: {
        shorthand: [
            "\u0408\u0430\u043D",
            "\u0424\u0435\u0432",
            "\u041C\u0430\u0440",
            "\u0410\u043F\u0440",
            "\u041C\u0430\u0458",
            "\u0408\u0443\u043D",
            "\u0408\u0443\u043B",
            "\u0410\u0432\u0433",
            "\u0421\u0435\u043F",
            "\u041E\u043A\u0442",
            "\u041D\u043E\u0435",
            "\u0414\u0435\u043A"
        ],
        longhand: [
            "\u0408\u0430\u043D\u0443\u0430\u0440\u0438",
            "\u0424\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
            "\u041C\u0430\u0440\u0442",
            "\u0410\u043F\u0440\u0438\u043B",
            "\u041C\u0430\u0458",
            "\u0408\u0443\u043D\u0438",
            "\u0408\u0443\u043B\u0438",
            "\u0410\u0432\u0433\u0443\u0441\u0442",
            "\u0421\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
            "\u041E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
            "\u041D\u043E\u0435\u043C\u0432\u0440\u0438",
            "\u0414\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
        ]
    },
    firstDayOfWeek: 1,
    weekAbbreviation: "\u041D\u0435\u0434.",
    rangeSeparator: " \u0434\u043E ",
    time_24hr: true
};
$69c921925b448778$var$fp$A.l10ns.mk = $69c921925b448778$var$Macedonian;
$69c921925b448778$var$fp$A.l10ns;
var $69c921925b448778$var$fp$B = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Mongolian = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: [
            "\u0414\u0430",
            "\u041C\u044F",
            "\u041B\u0445",
            "\u041F\u04AF",
            "\u0411\u0430",
            "\u0411\u044F",
            "\u041D\u044F"
        ],
        longhand: [
            "\u0414\u0430\u0432\u0430\u0430",
            "\u041C\u044F\u0433\u043C\u0430\u0440",
            "\u041B\u0445\u0430\u0433\u0432\u0430",
            "\u041F\u04AF\u0440\u044D\u0432",
            "\u0411\u0430\u0430\u0441\u0430\u043D",
            "\u0411\u044F\u043C\u0431\u0430",
            "\u041D\u044F\u043C"
        ]
    },
    months: {
        shorthand: [
            "1-\u0440 \u0441\u0430\u0440",
            "2-\u0440 \u0441\u0430\u0440",
            "3-\u0440 \u0441\u0430\u0440",
            "4-\u0440 \u0441\u0430\u0440",
            "5-\u0440 \u0441\u0430\u0440",
            "6-\u0440 \u0441\u0430\u0440",
            "7-\u0440 \u0441\u0430\u0440",
            "8-\u0440 \u0441\u0430\u0440",
            "9-\u0440 \u0441\u0430\u0440",
            "10-\u0440 \u0441\u0430\u0440",
            "11-\u0440 \u0441\u0430\u0440",
            "12-\u0440 \u0441\u0430\u0440"
        ],
        longhand: [
            "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
            "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
            "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
            "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
            "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
            "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
            "\u0414\u043E\u043B\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
            "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
            "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
            "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
            "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
            "\u0410\u0440\u0432\u0430\u043D\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
        ]
    },
    rangeSeparator: "-\u0441 ",
    time_24hr: true
};
$69c921925b448778$var$fp$B.l10ns.mn = $69c921925b448778$var$Mongolian;
$69c921925b448778$var$fp$B.l10ns;
var $69c921925b448778$var$fp$C = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Malaysian = {
    weekdays: {
        shorthand: [
            "Aha",
            "Isn",
            "Sel",
            "Rab",
            "Kha",
            "Jum",
            "Sab"
        ],
        longhand: [
            "Ahad",
            "Isnin",
            "Selasa",
            "Rabu",
            "Khamis",
            "Jumaat",
            "Sabtu"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mac",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Ogo",
            "Sep",
            "Okt",
            "Nov",
            "Dis"
        ],
        longhand: [
            "Januari",
            "Februari",
            "Mac",
            "April",
            "Mei",
            "Jun",
            "Julai",
            "Ogos",
            "September",
            "Oktober",
            "November",
            "Disember"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    }
};
$69c921925b448778$var$fp$C.l10ns.ms = $69c921925b448778$var$Malaysian;
$69c921925b448778$var$fp$C.l10ns;
var $69c921925b448778$var$fp$D = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Burmese = {
    weekdays: {
        shorthand: [
            "\u1014\u103D\u1031",
            "\u101C\u102C",
            "\u1002\u102B",
            "\u101F\u1030\u1038",
            "\u1000\u103C\u102C",
            "\u101E\u1031\u102C",
            "\u1014\u1031"
        ],
        longhand: [
            "\u1010\u1014\u1004\u103A\u1039\u1002\u1014\u103D\u1031",
            "\u1010\u1014\u1004\u103A\u1039\u101C\u102C",
            "\u1021\u1004\u103A\u1039\u1002\u102B",
            "\u1017\u102F\u1012\u1039\u1013\u101F\u1030\u1038",
            "\u1000\u103C\u102C\u101E\u1015\u1010\u1031\u1038",
            "\u101E\u1031\u102C\u1000\u103C\u102C",
            "\u1005\u1014\u1031"
        ]
    },
    months: {
        shorthand: [
            "\u1007\u1014\u103A",
            "\u1016\u1031",
            "\u1019\u1010\u103A",
            "\u1015\u103C\u102E",
            "\u1019\u1031",
            "\u1007\u103D\u1014\u103A",
            "\u101C\u102D\u102F\u1004\u103A",
            "\u101E\u103C",
            "\u1005\u1000\u103A",
            "\u1021\u1031\u102C\u1000\u103A",
            "\u1014\u102D\u102F",
            "\u1012\u102E"
        ],
        longhand: [
            "\u1007\u1014\u103A\u1014\u101D\u102B\u101B\u102E",
            "\u1016\u1031\u1016\u1031\u102C\u103A\u101D\u102B\u101B\u102E",
            "\u1019\u1010\u103A",
            "\u1027\u1015\u103C\u102E",
            "\u1019\u1031",
            "\u1007\u103D\u1014\u103A",
            "\u1007\u1030\u101C\u102D\u102F\u1004\u103A",
            "\u101E\u103C\u1002\u102F\u1010\u103A",
            "\u1005\u1000\u103A\u1010\u1004\u103A\u1018\u102C",
            "\u1021\u1031\u102C\u1000\u103A\u1010\u102D\u102F\u1018\u102C",
            "\u1014\u102D\u102F\u101D\u1004\u103A\u1018\u102C",
            "\u1012\u102E\u1007\u1004\u103A\u1018\u102C"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    time_24hr: true
};
$69c921925b448778$var$fp$D.l10ns.my = $69c921925b448778$var$Burmese;
$69c921925b448778$var$fp$D.l10ns;
var $69c921925b448778$var$fp$E = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Dutch = {
    weekdays: {
        shorthand: [
            "zo",
            "ma",
            "di",
            "wo",
            "do",
            "vr",
            "za"
        ],
        longhand: [
            "zondag",
            "maandag",
            "dinsdag",
            "woensdag",
            "donderdag",
            "vrijdag",
            "zaterdag"
        ]
    },
    months: {
        shorthand: [
            "jan",
            "feb",
            "mrt",
            "apr",
            "mei",
            "jun",
            "jul",
            "aug",
            "sept",
            "okt",
            "nov",
            "dec"
        ],
        longhand: [
            "januari",
            "februari",
            "maart",
            "april",
            "mei",
            "juni",
            "juli",
            "augustus",
            "september",
            "oktober",
            "november",
            "december"
        ]
    },
    firstDayOfWeek: 1,
    weekAbbreviation: "wk",
    rangeSeparator: " t/m ",
    scrollTitle: "Scroll voor volgende / vorige",
    toggleTitle: "Klik om te wisselen",
    time_24hr: true,
    ordinal: function(nth) {
        if (nth === 1 || nth === 8 || nth >= 20) return "ste";
        return "de";
    }
};
$69c921925b448778$var$fp$E.l10ns.nl = $69c921925b448778$var$Dutch;
$69c921925b448778$var$fp$E.l10ns;
var $69c921925b448778$var$fp$F = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$NorwegianNynorsk = {
    weekdays: {
        shorthand: [
            "S\xf8.",
            "M\xe5.",
            "Ty.",
            "On.",
            "To.",
            "Fr.",
            "La."
        ],
        longhand: [
            "S\xf8ndag",
            "M\xe5ndag",
            "Tysdag",
            "Onsdag",
            "Torsdag",
            "Fredag",
            "Laurdag"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mars",
            "Apr",
            "Mai",
            "Juni",
            "Juli",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Des"
        ],
        longhand: [
            "Januar",
            "Februar",
            "Mars",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Desember"
        ]
    },
    firstDayOfWeek: 1,
    rangeSeparator: " til ",
    weekAbbreviation: "Veke",
    scrollTitle: "Scroll for \xe5 endre",
    toggleTitle: "Klikk for \xe5 veksle",
    time_24hr: true,
    ordinal: function() {
        return ".";
    }
};
$69c921925b448778$var$fp$F.l10ns.nn = $69c921925b448778$var$NorwegianNynorsk;
$69c921925b448778$var$fp$F.l10ns;
var $69c921925b448778$var$fp$G = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Norwegian = {
    weekdays: {
        shorthand: [
            "S\xf8n",
            "Man",
            "Tir",
            "Ons",
            "Tor",
            "Fre",
            "L\xf8r"
        ],
        longhand: [
            "S\xf8ndag",
            "Mandag",
            "Tirsdag",
            "Onsdag",
            "Torsdag",
            "Fredag",
            "L\xf8rdag"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Des"
        ],
        longhand: [
            "Januar",
            "Februar",
            "Mars",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Desember"
        ]
    },
    firstDayOfWeek: 1,
    rangeSeparator: " til ",
    weekAbbreviation: "Uke",
    scrollTitle: "Scroll for \xe5 endre",
    toggleTitle: "Klikk for \xe5 veksle",
    time_24hr: true,
    ordinal: function() {
        return ".";
    }
};
$69c921925b448778$var$fp$G.l10ns.no = $69c921925b448778$var$Norwegian;
$69c921925b448778$var$fp$G.l10ns;
var $69c921925b448778$var$fp$H = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Punjabi = {
    weekdays: {
        shorthand: [
            "\u0A10\u0A24",
            "\u0A38\u0A4B\u0A2E",
            "\u0A2E\u0A70\u0A17\u0A32",
            "\u0A2C\u0A41\u0A71\u0A27",
            "\u0A35\u0A40\u0A30",
            "\u0A38\u0A3C\u0A41\u0A71\u0A15\u0A30",
            "\u0A38\u0A3C\u0A28\u0A3F\u0A71\u0A1A\u0A30"
        ],
        longhand: [
            "\u0A10\u0A24\u0A35\u0A3E\u0A30",
            "\u0A38\u0A4B\u0A2E\u0A35\u0A3E\u0A30",
            "\u0A2E\u0A70\u0A17\u0A32\u0A35\u0A3E\u0A30",
            "\u0A2C\u0A41\u0A71\u0A27\u0A35\u0A3E\u0A30",
            "\u0A35\u0A40\u0A30\u0A35\u0A3E\u0A30",
            "\u0A38\u0A3C\u0A41\u0A71\u0A15\u0A30\u0A35\u0A3E\u0A30",
            "\u0A38\u0A3C\u0A28\u0A3F\u0A71\u0A1A\u0A30\u0A35\u0A3E\u0A30"
        ]
    },
    months: {
        shorthand: [
            "\u0A1C\u0A28",
            "\u0A2B\u0A3C\u0A30",
            "\u0A2E\u0A3E\u0A30",
            "\u0A05\u0A2A\u0A4D\u0A30\u0A48",
            "\u0A2E\u0A08",
            "\u0A1C\u0A42\u0A28",
            "\u0A1C\u0A41\u0A32\u0A3E",
            "\u0A05\u0A17",
            "\u0A38\u0A24\u0A70",
            "\u0A05\u0A15",
            "\u0A28\u0A35\u0A70",
            "\u0A26\u0A38\u0A70"
        ],
        longhand: [
            "\u0A1C\u0A28\u0A35\u0A30\u0A40",
            "\u0A2B\u0A3C\u0A30\u0A35\u0A30\u0A40",
            "\u0A2E\u0A3E\u0A30\u0A1A",
            "\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32",
            "\u0A2E\u0A08",
            "\u0A1C\u0A42\u0A28",
            "\u0A1C\u0A41\u0A32\u0A3E\u0A08",
            "\u0A05\u0A17\u0A38\u0A24",
            "\u0A38\u0A24\u0A70\u0A2C\u0A30",
            "\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30",
            "\u0A28\u0A35\u0A70\u0A2C\u0A30",
            "\u0A26\u0A38\u0A70\u0A2C\u0A30"
        ]
    },
    time_24hr: true
};
$69c921925b448778$var$fp$H.l10ns.pa = $69c921925b448778$var$Punjabi;
$69c921925b448778$var$fp$H.l10ns;
var $69c921925b448778$var$fp$I = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Polish = {
    weekdays: {
        shorthand: [
            "Nd",
            "Pn",
            "Wt",
            "\u015Ar",
            "Cz",
            "Pt",
            "So"
        ],
        longhand: [
            "Niedziela",
            "Poniedzia\u0142ek",
            "Wtorek",
            "\u015Aroda",
            "Czwartek",
            "Pi\u0105tek",
            "Sobota"
        ]
    },
    months: {
        shorthand: [
            "Sty",
            "Lut",
            "Mar",
            "Kwi",
            "Maj",
            "Cze",
            "Lip",
            "Sie",
            "Wrz",
            "Pa\u017A",
            "Lis",
            "Gru"
        ],
        longhand: [
            "Stycze\u0144",
            "Luty",
            "Marzec",
            "Kwiecie\u0144",
            "Maj",
            "Czerwiec",
            "Lipiec",
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            "Listopad",
            "Grudzie\u0144"
        ]
    },
    rangeSeparator: " do ",
    weekAbbreviation: "tydz.",
    scrollTitle: "Przewi\u0144, aby zwi\u0119kszy\u0107",
    toggleTitle: "Kliknij, aby prze\u0142\u0105czy\u0107",
    firstDayOfWeek: 1,
    time_24hr: true,
    ordinal: function() {
        return ".";
    }
};
$69c921925b448778$var$fp$I.l10ns.pl = $69c921925b448778$var$Polish;
$69c921925b448778$var$fp$I.l10ns;
var $69c921925b448778$var$fp$J = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Portuguese = {
    weekdays: {
        shorthand: [
            "Dom",
            "Seg",
            "Ter",
            "Qua",
            "Qui",
            "Sex",
            "S\xe1b"
        ],
        longhand: [
            "Domingo",
            "Segunda-feira",
            "Ter\xe7a-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "S\xe1bado"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez"
        ],
        longhand: [
            "Janeiro",
            "Fevereiro",
            "Mar\xe7o",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro"
        ]
    },
    rangeSeparator: " at\xe9 ",
    time_24hr: true
};
$69c921925b448778$var$fp$J.l10ns.pt = $69c921925b448778$var$Portuguese;
$69c921925b448778$var$fp$J.l10ns;
var $69c921925b448778$var$fp$K = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Romanian = {
    weekdays: {
        shorthand: [
            "Dum",
            "Lun",
            "Mar",
            "Mie",
            "Joi",
            "Vin",
            "S\xe2m"
        ],
        longhand: [
            "Duminic\u0103",
            "Luni",
            "Mar\u021Bi",
            "Miercuri",
            "Joi",
            "Vineri",
            "S\xe2mb\u0103t\u0103"
        ]
    },
    months: {
        shorthand: [
            "Ian",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Iun",
            "Iul",
            "Aug",
            "Sep",
            "Oct",
            "Noi",
            "Dec"
        ],
        longhand: [
            "Ianuarie",
            "Februarie",
            "Martie",
            "Aprilie",
            "Mai",
            "Iunie",
            "Iulie",
            "August",
            "Septembrie",
            "Octombrie",
            "Noiembrie",
            "Decembrie"
        ]
    },
    firstDayOfWeek: 1,
    time_24hr: true,
    ordinal: function() {
        return "";
    }
};
$69c921925b448778$var$fp$K.l10ns.ro = $69c921925b448778$var$Romanian;
$69c921925b448778$var$fp$K.l10ns;
var $69c921925b448778$var$fp$L = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Russian = {
    weekdays: {
        shorthand: [
            "\u0412\u0441",
            "\u041F\u043D",
            "\u0412\u0442",
            "\u0421\u0440",
            "\u0427\u0442",
            "\u041F\u0442",
            "\u0421\u0431"
        ],
        longhand: [
            "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
            "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
            "\u0421\u0440\u0435\u0434\u0430",
            "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
            "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
            "\u0421\u0443\u0431\u0431\u043E\u0442\u0430"
        ]
    },
    months: {
        shorthand: [
            "\u042F\u043D\u0432",
            "\u0424\u0435\u0432",
            "\u041C\u0430\u0440\u0442",
            "\u0410\u043F\u0440",
            "\u041C\u0430\u0439",
            "\u0418\u044E\u043D\u044C",
            "\u0418\u044E\u043B\u044C",
            "\u0410\u0432\u0433",
            "\u0421\u0435\u043D",
            "\u041E\u043A\u0442",
            "\u041D\u043E\u044F",
            "\u0414\u0435\u043A"
        ],
        longhand: [
            "\u042F\u043D\u0432\u0430\u0440\u044C",
            "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
            "\u041C\u0430\u0440\u0442",
            "\u0410\u043F\u0440\u0435\u043B\u044C",
            "\u041C\u0430\u0439",
            "\u0418\u044E\u043D\u044C",
            "\u0418\u044E\u043B\u044C",
            "\u0410\u0432\u0433\u0443\u0441\u0442",
            "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
            "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
            "\u041D\u043E\u044F\u0431\u0440\u044C",
            "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    rangeSeparator: " \u2014 ",
    weekAbbreviation: "\u041D\u0435\u0434.",
    scrollTitle: "\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u0438\u0442\u0435 \u0434\u043B\u044F \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u044F",
    toggleTitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F",
    amPM: [
        "\u0414\u041F",
        "\u041F\u041F"
    ],
    yearAriaLabel: "\u0413\u043E\u0434",
    time_24hr: true
};
$69c921925b448778$var$fp$L.l10ns.ru = $69c921925b448778$var$Russian;
$69c921925b448778$var$fp$L.l10ns;
var $69c921925b448778$var$fp$M = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Sinhala = {
    weekdays: {
        shorthand: [
            "\u0D89",
            "\u0DC3",
            "\u0D85",
            "\u0DB6",
            "\u0DB6\u0DCA\u200D\u0DBB",
            "\u0DC3\u0DD2",
            "\u0DC3\u0DD9"
        ],
        longhand: [
            "\u0D89\u0DBB\u0DD2\u0DAF\u0DCF",
            "\u0DC3\u0DB3\u0DD4\u0DAF\u0DCF",
            "\u0D85\u0D9F\u0DC4\u0DBB\u0DD4\u0DC0\u0DCF\u0DAF\u0DCF",
            "\u0DB6\u0DAF\u0DCF\u0DAF\u0DCF",
            "\u0DB6\u0DCA\u200D\u0DBB\u0DC4\u0DC3\u0DCA\u0DB4\u0DAD\u0DD2\u0DB1\u0DCA\u0DAF\u0DCF",
            "\u0DC3\u0DD2\u0D9A\u0DD4\u0DBB\u0DCF\u0DAF\u0DCF",
            "\u0DC3\u0DD9\u0DB1\u0DC3\u0DD4\u0DBB\u0DCF\u0DAF\u0DCF"
        ]
    },
    months: {
        shorthand: [
            "\u0DA2\u0DB1",
            "\u0DB4\u0DD9\u0DB6",
            "\u0DB8\u0DCF\u0DBB\u0DCA",
            "\u0D85\u0DB4\u0DCA\u200D\u0DBB\u0DDA",
            "\u0DB8\u0DD0\u0DBA\u0DD2",
            "\u0DA2\u0DD4\u0DB1\u0DD2",
            "\u0DA2\u0DD6\u0DBD\u0DD2",
            "\u0D85\u0D9C\u0DDD",
            "\u0DC3\u0DD0\u0DB4\u0DCA",
            "\u0D94\u0D9A\u0DCA",
            "\u0DB1\u0DDC\u0DC0\u0DD0",
            "\u0DAF\u0DD9\u0DC3\u0DD0"
        ],
        longhand: [
            "\u0DA2\u0DB1\u0DC0\u0DCF\u0DBB\u0DD2",
            "\u0DB4\u0DD9\u0DB6\u0DBB\u0DC0\u0DCF\u0DBB\u0DD2",
            "\u0DB8\u0DCF\u0DBB\u0DCA\u0DAD\u0DD4",
            "\u0D85\u0DB4\u0DCA\u200D\u0DBB\u0DDA\u0DBD\u0DCA",
            "\u0DB8\u0DD0\u0DBA\u0DD2",
            "\u0DA2\u0DD4\u0DB1\u0DD2",
            "\u0DA2\u0DD6\u0DBD\u0DD2",
            "\u0D85\u0D9C\u0DDD\u0DC3\u0DCA\u0DAD\u0DD4",
            "\u0DC3\u0DD0\u0DB4\u0DCA\u0DAD\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA",
            "\u0D94\u0D9A\u0DCA\u0DAD\u0DDD\u0DB6\u0DBB\u0DCA",
            "\u0DB1\u0DDC\u0DC0\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA",
            "\u0DAF\u0DD9\u0DC3\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA"
        ]
    },
    time_24hr: true
};
$69c921925b448778$var$fp$M.l10ns.si = $69c921925b448778$var$Sinhala;
$69c921925b448778$var$fp$M.l10ns;
var $69c921925b448778$var$fp$N = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Slovak = {
    weekdays: {
        shorthand: [
            "Ned",
            "Pon",
            "Ut",
            "Str",
            "\u0160tv",
            "Pia",
            "Sob"
        ],
        longhand: [
            "Nede\u013Ea",
            "Pondelok",
            "Utorok",
            "Streda",
            "\u0160tvrtok",
            "Piatok",
            "Sobota"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "M\xe1j",
            "J\xfan",
            "J\xfal",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dec"
        ],
        longhand: [
            "Janu\xe1r",
            "Febru\xe1r",
            "Marec",
            "Apr\xedl",
            "M\xe1j",
            "J\xfan",
            "J\xfal",
            "August",
            "September",
            "Okt\xf3ber",
            "November",
            "December"
        ]
    },
    firstDayOfWeek: 1,
    rangeSeparator: " do ",
    time_24hr: true,
    ordinal: function() {
        return ".";
    }
};
$69c921925b448778$var$fp$N.l10ns.sk = $69c921925b448778$var$Slovak;
$69c921925b448778$var$fp$N.l10ns;
var $69c921925b448778$var$fp$O = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Slovenian = {
    weekdays: {
        shorthand: [
            "Ned",
            "Pon",
            "Tor",
            "Sre",
            "\u010Cet",
            "Pet",
            "Sob"
        ],
        longhand: [
            "Nedelja",
            "Ponedeljek",
            "Torek",
            "Sreda",
            "\u010Cetrtek",
            "Petek",
            "Sobota"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Maj",
            "Jun",
            "Jul",
            "Avg",
            "Sep",
            "Okt",
            "Nov",
            "Dec"
        ],
        longhand: [
            "Januar",
            "Februar",
            "Marec",
            "April",
            "Maj",
            "Junij",
            "Julij",
            "Avgust",
            "September",
            "Oktober",
            "November",
            "December"
        ]
    },
    firstDayOfWeek: 1,
    rangeSeparator: " do ",
    time_24hr: true,
    ordinal: function() {
        return ".";
    }
};
$69c921925b448778$var$fp$O.l10ns.sl = $69c921925b448778$var$Slovenian;
$69c921925b448778$var$fp$O.l10ns;
var $69c921925b448778$var$fp$P = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Albanian = {
    weekdays: {
        shorthand: [
            "Di",
            "H\xeb",
            "Ma",
            "M\xeb",
            "En",
            "Pr",
            "Sh"
        ],
        longhand: [
            "E Diel",
            "E H\xebn\xeb",
            "E Mart\xeb",
            "E M\xebrkur\xeb",
            "E Enjte",
            "E Premte",
            "E Shtun\xeb"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Shk",
            "Mar",
            "Pri",
            "Maj",
            "Qer",
            "Kor",
            "Gus",
            "Sht",
            "Tet",
            "N\xebn",
            "Dhj"
        ],
        longhand: [
            "Janar",
            "Shkurt",
            "Mars",
            "Prill",
            "Maj",
            "Qershor",
            "Korrik",
            "Gusht",
            "Shtator",
            "Tetor",
            "N\xebntor",
            "Dhjetor"
        ]
    },
    firstDayOfWeek: 1,
    rangeSeparator: " deri ",
    weekAbbreviation: "Java",
    yearAriaLabel: "Viti",
    monthAriaLabel: "Muaji",
    hourAriaLabel: "Ora",
    minuteAriaLabel: "Minuta",
    time_24hr: true
};
$69c921925b448778$var$fp$P.l10ns.sq = $69c921925b448778$var$Albanian;
$69c921925b448778$var$fp$P.l10ns;
var $69c921925b448778$var$fp$Q = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Serbian = {
    weekdays: {
        shorthand: [
            "Ned",
            "Pon",
            "Uto",
            "Sre",
            "\u010Cet",
            "Pet",
            "Sub"
        ],
        longhand: [
            "Nedelja",
            "Ponedeljak",
            "Utorak",
            "Sreda",
            "\u010Cetvrtak",
            "Petak",
            "Subota"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Maj",
            "Jun",
            "Jul",
            "Avg",
            "Sep",
            "Okt",
            "Nov",
            "Dec"
        ],
        longhand: [
            "Januar",
            "Februar",
            "Mart",
            "April",
            "Maj",
            "Jun",
            "Jul",
            "Avgust",
            "Septembar",
            "Oktobar",
            "Novembar",
            "Decembar"
        ]
    },
    firstDayOfWeek: 1,
    weekAbbreviation: "Ned.",
    rangeSeparator: " do ",
    time_24hr: true
};
$69c921925b448778$var$fp$Q.l10ns.sr = $69c921925b448778$var$Serbian;
$69c921925b448778$var$fp$Q.l10ns;
var $69c921925b448778$var$fp$R = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Swedish = {
    firstDayOfWeek: 1,
    weekAbbreviation: "v",
    weekdays: {
        shorthand: [
            "s\xf6n",
            "m\xe5n",
            "tis",
            "ons",
            "tor",
            "fre",
            "l\xf6r"
        ],
        longhand: [
            "s\xf6ndag",
            "m\xe5ndag",
            "tisdag",
            "onsdag",
            "torsdag",
            "fredag",
            "l\xf6rdag"
        ]
    },
    months: {
        shorthand: [
            "jan",
            "feb",
            "mar",
            "apr",
            "maj",
            "jun",
            "jul",
            "aug",
            "sep",
            "okt",
            "nov",
            "dec"
        ],
        longhand: [
            "januari",
            "februari",
            "mars",
            "april",
            "maj",
            "juni",
            "juli",
            "augusti",
            "september",
            "oktober",
            "november",
            "december"
        ]
    },
    rangeSeparator: " till ",
    time_24hr: true,
    ordinal: function() {
        return ".";
    }
};
$69c921925b448778$var$fp$R.l10ns.sv = $69c921925b448778$var$Swedish;
$69c921925b448778$var$fp$R.l10ns;
var $69c921925b448778$var$fp$S = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Thai = {
    weekdays: {
        shorthand: [
            "\u0E2D\u0E32",
            "\u0E08",
            "\u0E2D",
            "\u0E1E",
            "\u0E1E\u0E24",
            "\u0E28",
            "\u0E2A"
        ],
        longhand: [
            "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
            "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
            "\u0E1E\u0E38\u0E18",
            "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
            "\u0E28\u0E38\u0E01\u0E23\u0E4C",
            "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
        ]
    },
    months: {
        shorthand: [
            "\u0E21.\u0E04.",
            "\u0E01.\u0E1E.",
            "\u0E21\u0E35.\u0E04.",
            "\u0E40\u0E21.\u0E22.",
            "\u0E1E.\u0E04.",
            "\u0E21\u0E34.\u0E22.",
            "\u0E01.\u0E04.",
            "\u0E2A.\u0E04.",
            "\u0E01.\u0E22.",
            "\u0E15.\u0E04.",
            "\u0E1E.\u0E22.",
            "\u0E18.\u0E04."
        ],
        longhand: [
            "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
            "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
            "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
            "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
            "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
            "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
            "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
            "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
            "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
            "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
            "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
            "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
        ]
    },
    firstDayOfWeek: 1,
    rangeSeparator: " \u0E16\u0E36\u0E07 ",
    scrollTitle: "\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E14",
    toggleTitle: "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19",
    time_24hr: true,
    ordinal: function() {
        return "";
    }
};
$69c921925b448778$var$fp$S.l10ns.th = $69c921925b448778$var$Thai;
$69c921925b448778$var$fp$S.l10ns;
var $69c921925b448778$var$fp$T = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Turkish = {
    weekdays: {
        shorthand: [
            "Paz",
            "Pzt",
            "Sal",
            "\xc7ar",
            "Per",
            "Cum",
            "Cmt"
        ],
        longhand: [
            "Pazar",
            "Pazartesi",
            "Sal\u0131",
            "\xc7ar\u015Famba",
            "Per\u015Fembe",
            "Cuma",
            "Cumartesi"
        ]
    },
    months: {
        shorthand: [
            "Oca",
            "\u015Eub",
            "Mar",
            "Nis",
            "May",
            "Haz",
            "Tem",
            "A\u011Fu",
            "Eyl",
            "Eki",
            "Kas",
            "Ara"
        ],
        longhand: [
            "Ocak",
            "\u015Eubat",
            "Mart",
            "Nisan",
            "May\u0131s",
            "Haziran",
            "Temmuz",
            "A\u011Fustos",
            "Eyl\xfcl",
            "Ekim",
            "Kas\u0131m",
            "Aral\u0131k"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return ".";
    },
    rangeSeparator: " - ",
    weekAbbreviation: "Hf",
    scrollTitle: "Art\u0131rmak i\xe7in kayd\u0131r\u0131n",
    toggleTitle: "A\xe7/Kapa",
    amPM: [
        "\xd6\xd6",
        "\xd6S"
    ],
    time_24hr: true
};
$69c921925b448778$var$fp$T.l10ns.tr = $69c921925b448778$var$Turkish;
$69c921925b448778$var$fp$T.l10ns;
var $69c921925b448778$var$fp$U = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Ukrainian = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: [
            "\u041D\u0434",
            "\u041F\u043D",
            "\u0412\u0442",
            "\u0421\u0440",
            "\u0427\u0442",
            "\u041F\u0442",
            "\u0421\u0431"
        ],
        longhand: [
            "\u041D\u0435\u0434\u0456\u043B\u044F",
            "\u041F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
            "\u0412\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
            "\u0421\u0435\u0440\u0435\u0434\u0430",
            "\u0427\u0435\u0442\u0432\u0435\u0440",
            "\u041F'\u044F\u0442\u043D\u0438\u0446\u044F",
            "\u0421\u0443\u0431\u043E\u0442\u0430"
        ]
    },
    months: {
        shorthand: [
            "\u0421\u0456\u0447",
            "\u041B\u044E\u0442",
            "\u0411\u0435\u0440",
            "\u041A\u0432\u0456",
            "\u0422\u0440\u0430",
            "\u0427\u0435\u0440",
            "\u041B\u0438\u043F",
            "\u0421\u0435\u0440",
            "\u0412\u0435\u0440",
            "\u0416\u043E\u0432",
            "\u041B\u0438\u0441",
            "\u0413\u0440\u0443"
        ],
        longhand: [
            "\u0421\u0456\u0447\u0435\u043D\u044C",
            "\u041B\u044E\u0442\u0438\u0439",
            "\u0411\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
            "\u041A\u0432\u0456\u0442\u0435\u043D\u044C",
            "\u0422\u0440\u0430\u0432\u0435\u043D\u044C",
            "\u0427\u0435\u0440\u0432\u0435\u043D\u044C",
            "\u041B\u0438\u043F\u0435\u043D\u044C",
            "\u0421\u0435\u0440\u043F\u0435\u043D\u044C",
            "\u0412\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
            "\u0416\u043E\u0432\u0442\u0435\u043D\u044C",
            "\u041B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
            "\u0413\u0440\u0443\u0434\u0435\u043D\u044C"
        ]
    },
    time_24hr: true
};
$69c921925b448778$var$fp$U.l10ns.uk = $69c921925b448778$var$Ukrainian;
$69c921925b448778$var$fp$U.l10ns;
var $69c921925b448778$var$fp$V = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Uzbek = {
    weekdays: {
        shorthand: [
            "\u042F\u043A\u0448",
            "\u0414\u0443\u0448",
            "\u0421\u0435\u0448",
            "\u0427\u043E\u0440",
            "\u041F\u0430\u0439",
            "\u0416\u0443\u043C",
            "\u0428\u0430\u043D"
        ],
        longhand: [
            "\u042F\u043A\u0448\u0430\u043D\u0431\u0430",
            "\u0414\u0443\u0448\u0430\u043D\u0431\u0430",
            "\u0421\u0435\u0448\u0430\u043D\u0431\u0430",
            "\u0427\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
            "\u041F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
            "\u0416\u0443\u043C\u0430",
            "\u0428\u0430\u043D\u0431\u0430"
        ]
    },
    months: {
        shorthand: [
            "\u042F\u043D\u0432",
            "\u0424\u0435\u0432",
            "\u041C\u0430\u0440",
            "\u0410\u043F\u0440",
            "\u041C\u0430\u0439",
            "\u0418\u044E\u043D",
            "\u0418\u044E\u043B",
            "\u0410\u0432\u0433",
            "\u0421\u0435\u043D",
            "\u041E\u043A\u0442",
            "\u041D\u043E\u044F",
            "\u0414\u0435\u043A"
        ],
        longhand: [
            "\u042F\u043D\u0432\u0430\u0440",
            "\u0424\u0435\u0432\u0440\u0430\u043B",
            "\u041C\u0430\u0440\u0442",
            "\u0410\u043F\u0440\u0435\u043B",
            "\u041C\u0430\u0439",
            "\u0418\u044E\u043D",
            "\u0418\u044E\u043B",
            "\u0410\u0432\u0433\u0443\u0441\u0442",
            "\u0421\u0435\u043D\u0442\u044F\u0431\u0440",
            "\u041E\u043A\u0442\u044F\u0431\u0440",
            "\u041D\u043E\u044F\u0431\u0440",
            "\u0414\u0435\u043A\u0430\u0431\u0440"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    rangeSeparator: " \u2014 ",
    weekAbbreviation: "\u04B2\u0430\u0444\u0442\u0430",
    scrollTitle: "\u041A\u0430\u0442\u0442\u0430\u043B\u0430\u0448\u0442\u0438\u0440\u0438\u0448 \u0443\u0447\u0443\u043D \u0430\u0439\u043B\u0430\u043D\u0442\u0438\u0440\u0438\u043D\u0433",
    toggleTitle: "\u040E\u0442\u0438\u0448 \u0443\u0447\u0443\u043D \u0431\u043E\u0441\u0438\u043D\u0433",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "\u0419\u0438\u043B",
    time_24hr: true
};
$69c921925b448778$var$fp$V.l10ns.uz = $69c921925b448778$var$Uzbek;
$69c921925b448778$var$fp$V.l10ns;
var $69c921925b448778$var$fp$W = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$UzbekLatin = {
    weekdays: {
        shorthand: [
            "Ya",
            "Du",
            "Se",
            "Cho",
            "Pa",
            "Ju",
            "Sha"
        ],
        longhand: [
            "Yakshanba",
            "Dushanba",
            "Seshanba",
            "Chorshanba",
            "Payshanba",
            "Juma",
            "Shanba"
        ]
    },
    months: {
        shorthand: [
            "Yan",
            "Fev",
            "Mar",
            "Apr",
            "May",
            "Iyun",
            "Iyul",
            "Avg",
            "Sen",
            "Okt",
            "Noy",
            "Dek"
        ],
        longhand: [
            "Yanvar",
            "Fevral",
            "Mart",
            "Aprel",
            "May",
            "Iyun",
            "Iyul",
            "Avgust",
            "Sentabr",
            "Oktabr",
            "Noyabr",
            "Dekabr"
        ]
    },
    firstDayOfWeek: 1,
    ordinal: function() {
        return "";
    },
    rangeSeparator: " \u2014 ",
    weekAbbreviation: "Hafta",
    scrollTitle: "Kattalashtirish uchun aylantiring",
    toggleTitle: "O\u2018tish uchun bosing",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Yil",
    time_24hr: true
};
$69c921925b448778$var$fp$W.l10ns["uz_latn"] = $69c921925b448778$var$UzbekLatin;
$69c921925b448778$var$fp$W.l10ns;
var $69c921925b448778$var$fp$X = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Vietnamese = {
    weekdays: {
        shorthand: [
            "CN",
            "T2",
            "T3",
            "T4",
            "T5",
            "T6",
            "T7"
        ],
        longhand: [
            "Ch\u1EE7 nh\u1EADt",
            "Th\u1EE9 hai",
            "Th\u1EE9 ba",
            "Th\u1EE9 t\u01B0",
            "Th\u1EE9 n\u0103m",
            "Th\u1EE9 s\xe1u",
            "Th\u1EE9 b\u1EA3y"
        ]
    },
    months: {
        shorthand: [
            "Th1",
            "Th2",
            "Th3",
            "Th4",
            "Th5",
            "Th6",
            "Th7",
            "Th8",
            "Th9",
            "Th10",
            "Th11",
            "Th12"
        ],
        longhand: [
            "Th\xe1ng m\u1ED9t",
            "Th\xe1ng hai",
            "Th\xe1ng ba",
            "Th\xe1ng t\u01B0",
            "Th\xe1ng n\u0103m",
            "Th\xe1ng s\xe1u",
            "Th\xe1ng b\u1EA3y",
            "Th\xe1ng t\xe1m",
            "Th\xe1ng ch\xedn",
            "Th\xe1ng m\u01B0\u1EDDi",
            "Th\xe1ng m\u01B0\u1EDDi m\u1ED9t",
            "Th\xe1ng m\u01B0\u1EDDi hai"
        ]
    },
    firstDayOfWeek: 1,
    rangeSeparator: " \u0111\u1EBFn "
};
$69c921925b448778$var$fp$X.l10ns.vn = $69c921925b448778$var$Vietnamese;
$69c921925b448778$var$fp$X.l10ns;
var $69c921925b448778$var$fp$Y = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$Mandarin = {
    weekdays: {
        shorthand: [
            "\u5468\u65E5",
            "\u5468\u4E00",
            "\u5468\u4E8C",
            "\u5468\u4E09",
            "\u5468\u56DB",
            "\u5468\u4E94",
            "\u5468\u516D"
        ],
        longhand: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ]
    },
    months: {
        shorthand: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        longhand: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ]
    },
    rangeSeparator: " \u81F3 ",
    weekAbbreviation: "\u5468",
    scrollTitle: "\u6EDA\u52A8\u5207\u6362",
    toggleTitle: "\u70B9\u51FB\u5207\u6362 12/24 \u5C0F\u65F6\u65F6\u5236"
};
$69c921925b448778$var$fp$Y.l10ns.zh = $69c921925b448778$var$Mandarin;
$69c921925b448778$var$fp$Y.l10ns;
var $69c921925b448778$var$fp$Z = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
};
var $69c921925b448778$var$MandarinTraditional = {
    weekdays: {
        shorthand: [
            "\u9031\u65E5",
            "\u9031\u4E00",
            "\u9031\u4E8C",
            "\u9031\u4E09",
            "\u9031\u56DB",
            "\u9031\u4E94",
            "\u9031\u516D"
        ],
        longhand: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ]
    },
    months: {
        shorthand: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        longhand: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ]
    },
    rangeSeparator: " \u81F3 ",
    weekAbbreviation: "\u9031",
    scrollTitle: "\u6EFE\u52D5\u5207\u63DB",
    toggleTitle: "\u9EDE\u64CA\u5207\u63DB 12/24 \u5C0F\u6642\u6642\u5236"
};
$69c921925b448778$var$fp$Z.l10ns.zh_tw = $69c921925b448778$var$MandarinTraditional;
$69c921925b448778$var$fp$Z.l10ns;
var $69c921925b448778$var$l10n = {
    ar: $69c921925b448778$var$Arabic,
    at: $69c921925b448778$var$Austria,
    az: $69c921925b448778$var$Azerbaijan,
    be: $69c921925b448778$var$Belarusian,
    bg: $69c921925b448778$var$Bulgarian,
    bn: $69c921925b448778$var$Bangla,
    bs: $69c921925b448778$var$Bosnian,
    ca: $69c921925b448778$var$Catalan,
    ckb: $69c921925b448778$var$Kurdish,
    cat: $69c921925b448778$var$Catalan,
    cs: $69c921925b448778$var$Czech,
    cy: $69c921925b448778$var$Welsh,
    da: $69c921925b448778$var$Danish,
    de: $69c921925b448778$var$German,
    default: $69c921925b448778$var$__assign({}, $69c921925b448778$var$english),
    en: $69c921925b448778$var$english,
    eo: $69c921925b448778$var$Esperanto,
    es: $69c921925b448778$var$Spanish,
    et: $69c921925b448778$var$Estonian,
    fa: $69c921925b448778$var$Persian,
    fi: $69c921925b448778$var$Finnish,
    fo: $69c921925b448778$var$Faroese,
    fr: $69c921925b448778$var$French,
    gr: $69c921925b448778$var$Greek,
    he: $69c921925b448778$var$Hebrew,
    hi: $69c921925b448778$var$Hindi,
    hr: $69c921925b448778$var$Croatian,
    hu: $69c921925b448778$var$Hungarian,
    hy: $69c921925b448778$var$Armenian,
    id: $69c921925b448778$var$Indonesian,
    is: $69c921925b448778$var$Icelandic,
    it: $69c921925b448778$var$Italian,
    ja: $69c921925b448778$var$Japanese,
    ka: $69c921925b448778$var$Georgian,
    ko: $69c921925b448778$var$Korean,
    km: $69c921925b448778$var$Khmer,
    kz: $69c921925b448778$var$Kazakh,
    lt: $69c921925b448778$var$Lithuanian,
    lv: $69c921925b448778$var$Latvian,
    mk: $69c921925b448778$var$Macedonian,
    mn: $69c921925b448778$var$Mongolian,
    ms: $69c921925b448778$var$Malaysian,
    my: $69c921925b448778$var$Burmese,
    nl: $69c921925b448778$var$Dutch,
    nn: $69c921925b448778$var$NorwegianNynorsk,
    no: $69c921925b448778$var$Norwegian,
    pa: $69c921925b448778$var$Punjabi,
    pl: $69c921925b448778$var$Polish,
    pt: $69c921925b448778$var$Portuguese,
    ro: $69c921925b448778$var$Romanian,
    ru: $69c921925b448778$var$Russian,
    si: $69c921925b448778$var$Sinhala,
    sk: $69c921925b448778$var$Slovak,
    sl: $69c921925b448778$var$Slovenian,
    sq: $69c921925b448778$var$Albanian,
    sr: $69c921925b448778$var$Serbian,
    sv: $69c921925b448778$var$Swedish,
    th: $69c921925b448778$var$Thai,
    tr: $69c921925b448778$var$Turkish,
    uk: $69c921925b448778$var$Ukrainian,
    vn: $69c921925b448778$var$Vietnamese,
    zh: $69c921925b448778$var$Mandarin,
    zh_tw: $69c921925b448778$var$MandarinTraditional,
    uz: $69c921925b448778$var$Uzbek,
    uz_latn: $69c921925b448778$var$UzbekLatin
};
var $69c921925b448778$export$2e2bcd8739ae039 = $69c921925b448778$var$l10n;


class $135e26651cefb271$export$14647c88ce36fe14 {
    /**
	 *
	 *
	 * @param {*} inputField
	 * @param {*} config
	 * @returns {*}
	 */ createDateTimePicker(inputField, config) {
        return new (0, $3f401514818d15ee$export$2e2bcd8739ae039)(inputField, config);
    }
    /**
	 *
	 *
	 * @param {*} element
	 */ triggerDateTimePickerEvents(element) {
        element.config.onChange.push((selectedDates, dateStr, instance)=>{
            instance.input.setAttribute('value', dateStr);
        });
        element.config.onClose.push((selectedDates, dateStr, instance)=>{
            if (instance.config.allowInput) instance.setDate(instance._input.value, true);
        });
    }
    // /**
    //  *
    //  *
    //  * @param {*} lang
    //  * @returns {*}
    //  */
    // async getLocale(lang) {
    // 	let locale = null;
    //     let filename = null;
    // 	switch (+lang) {
    // 	case 1:
    // 		locale = 'German';
    //         filename = 'de.js';
    // 		break;
    //     case 2:
    //         locale = 'French';
    //         filename = 'fr.js';
    // 		break;
    //     case 3:
    //         locale = 'Italian';
    //         filename = 'it.js';
    // 		break;
    // 	default:
    // 		locale = 'English';
    //         filename = 'default.js';
    // 		break;
    // 	}
    //     await import(`./../../lib/daterangepicker/l10n/${filename}`);
    // 	return locale;
    // }
    /**
	 *
	 *
	 * @param {*} lang
	 * @returns {*}
	 */ getLocale(lang) {
        var locale = null;
        switch(+lang){
            case 1:
                locale = 'de';
                break;
            case 2:
                locale = 'fr';
                break;
            case 3:
                locale = 'it';
                break;
            default:
                locale = 'en';
                break;
        }
        return (0, $69c921925b448778$export$2e2bcd8739ae039)[locale];
    }
}


class $3e6948b5dd5d5e80$export$c0c7e16993e6362e extends (0, $135e26651cefb271$export$14647c88ce36fe14) {
    constructor(customSettings = null){
        super();
        this.wrapperElement = document.querySelector('.content');
        this.timePickerWrapperSelector = '.opc-time';
        this.timePickerFields = this.wrapperElement.querySelectorAll(`${this.timePickerWrapperSelector}`);
        this.initTimePicker(customSettings);
    }
    initTimePicker(customSettings) {
        Array.from(this.timePickerFields).forEach((item)=>{
            let inputField = item.querySelector('input[type="text"]');
            const defaultSettings = {
                enableTime: true,
                noCalendar: true,
                dateFormat: 'H.i',
                altFormat: 'H:i',
                altInput: true,
                time_24hr: true,
                minuteIncrement: 1,
                enableSeconds: false,
                appendTo: item,
                allowInput: true,
                static: true
            };
            if (customSettings) {
                if (typeof customSettings != 'object') throw new Error('inputparameter must be an Object!');
            }
            let settings = Object.assign(defaultSettings, customSettings);
            this.createTimePicker(inputField, settings);
        });
    }
    /**
	 *
	 *
	 * @param {*} inputField
	 * @param {*} config
	 */ createTimePicker(inputField, config) {
        this.timePicker = this.createDateTimePicker(inputField, config);
        this.triggerTimePickerEvents();
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ triggerTimePickerEvents() {
        return this.triggerDateTimePickerEvents(this.timePicker);
    }
}



class $215d185b039a9acb$export$5fe1800497971b35 extends (0, $135e26651cefb271$export$14647c88ce36fe14) {
    constructor(customSettings = null, wrapper = null){
        super();
        this.wrapperElement = wrapper || document.querySelector('body');
        this.datePickerWrapperSelector = '.opc-date';
        this.datePickerFields = this.wrapperElement.querySelectorAll(`${this.datePickerWrapperSelector}`);
        this.initDatePicker(customSettings);
    }
    /**
	 *
	 *
	 * @param {*} dateFormat
	 * @param {*} separator
	 * @returns {*}
	 */ dateFormatMapping(dateFormat, separator) {
        if (!dateFormat || !separator) return 'd.m.Y';
        let mappedDate = dateFormat.toLowerCase().split('.').map((item)=>{
            let datePart = item.charAt(0);
            return datePart == 'y' ? datePart.toUpperCase() : datePart;
        });
        return mappedDate.join(separator);
    }
    /**
	 *
	 *
	 * @param {*} customSettings
	 */ initDatePicker(customSettings) {
        Array.from(this.datePickerFields).forEach((item)=>{
            let inputField = item.querySelector('input[type="text"]');
            let currentDateFormat = inputField.dataset.opDateFormat || null;
            let currentDateSeparator = inputField.dataset.opDateSeparator || null;
            let currentLang = inputField.dataset.opLang || null;
            const defaultSettings = {
                dateFormat: 'd.m.Y',
                altFormat: this.dateFormatMapping(currentDateFormat, currentDateSeparator),
                altInput: true,
                locale: this.getLocale(currentLang),
                appendTo: item,
                disableMobile: true,
                allowInput: true,
                weekNumbers: true,
                monthSelectorType: 'dropdown',
                static: true
            };
            if (customSettings) {
                if (typeof customSettings != 'object') throw new Error('inputparameter must be an Object!');
            }
            let settings = Object.assign(defaultSettings, customSettings);
            this.createDatePicker(inputField, settings);
        });
    }
    /**
	 *
	 *
	 * @param {*} inputField
	 * @param {*} config
	 */ createDatePicker(inputField, config) {
        this.datePicker = this.createDateTimePicker(inputField, config);
        this.triggerDatePickerEvents();
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ triggerDatePickerEvents() {
        return this.triggerDateTimePickerEvents(this.datePicker);
    }
}


/** @module form */ /**
 * Wrapper Klasse für den WYSIWYG Editor
 *
 * @property {Object} wysiwygEditor EditorInstance
 */ var $c08a85e7ceb076e9$import_meta = Object.assign(Object.create(null), {
    url: "file:///webportal/config/layout/themes/project/js/src/vendor/script/classes/opacc.class.form.element.wysiwyg.js"
});

class $c08a85e7ceb076e9$export$f8e2324a133cee57 {
    constructor(){
        let wysiwygSelector = 'textarea[data-op-editor="wysiwyg"]';
        if (document.querySelector(wysiwygSelector)) (parcelRequire("aJdSK")).then(()=>{
            this.wysiwygEditor = window.opaccEditor;
            this.initEditor(wysiwygSelector);
        });
    }
    /**
	 * Initialisierung des WYSIWYG Elementes
	 *
	 * @param {string} selector HTMLQuerySelector
	 */ initEditor(selector) {
        // Editor must be removed before initialisation
        this.wysiwygEditor.remove(selector);
        const wysiwygEditorUrl = this.getEditorFileUrl();
        const fileTypes = {
            image: 1,
            file: 2,
            media: 3
        };
        this.wysiwygEditor.init({
            selector: selector,
            language: this.getLanguage(),
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'pagebreak',
                'searchreplace',
                'wordcount',
                'visualblocks',
                'visualchars',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'nonbreaking',
                'table',
                'directionality',
                'emoticons',
                'quickbars'
            ],
            insertdatetime_formats: [
                '%d.%m.%Y',
                '%H:%M'
            ],
            menubar: false,
            contextmenu: false,
            encoding: 'xml',
            tools: 'inserttable',
            toolbar: "undo redo | formatselect | bold italic | backcolor | alignleft aligncenteralignright alignjustify | bullist numlist outdent indent | link image media |preview print | removeformat | code",
            width: '100%',
            base_url: `//${wysiwygEditorUrl.host}${wysiwygEditorUrl.pathname}/lib/editor/`,
            language_url: `//${wysiwygEditorUrl.host}${wysiwygEditorUrl.pathname}/lib/editor/translations/${this.getLanguage()}.js`,
            promotion: false,
            extended_valid_elements: 'i[*]',
            license_key: 'gpl',
            init_instance_callback: (editor)=>{
                editor.targetElm.setAttribute('tabindex', '-1');
                let iframe = document.getElementById(editor.id + '_ifr');
                editor.dom.setAttrib(iframe, 'tabindex', 0);
                if (editor.targetElm.hasAttribute('disabled')) {
                    editor.mode.set('readonly');
                    editor.editorContainer.classList.add('is-disabled');
                    editor.contentDocument.firstElementChild.classList.add('is-disabled');
                    let iframe = document.getElementById(editor.id + '_ifr');
                    editor.dom.setAttrib(iframe, 'tabindex', '-1');
                    editor.off();
                }
            },
            setup: (editor)=>{
                editor.on('SaveContent', (ed)=>{
                    // Augrund des HTML Encodings durch Aktivieren des application.cnf Parameters 'NoXSSValidation' => htmlEncodeFields()
                    // und dem standartmässig eingeschaltetem forced_root_block: <p> beim initialisieren wird der folgende content zuerst
                    // nochmals decodiert ( &lt;p&gt; => <p>) und anschliessend encodiert ( <p> => &lt;p&gt; ).
                    ed.content = this.htmlEncode(this.htmlDecode(ed.content));
                });
                editor.on('blur keydown', (e)=>{
                    this.setContentToTextarea(editor, e);
                });
            },
            file_picker_callback: (callback, value, meta)=>{
                let type = fileTypes[meta.filetype];
                window.tinymce.activeEditor.windowManager.openUrl({
                    title: 'Fileupload Area',
                    url: this.getFileManagerURL(window.tinymce.activeEditor, type),
                    width: 800,
                    height: 600
                });
            }
        });
    }
    getFileManagerURL(editor, type) {
        return `/webportal/filemanager.aspx?editor=${editor.id}&type=${type}&lang=${this.getLanguage()}`;
    }
    /**
	 * WYSIWYG Content encoden
	 *
	 * @param {string} content
	 * @returns {string} content
	 */ htmlEncode(content) {
        return content.toString().replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    /**
	 * WYSIWYG Content decoren
	 *
	 * @param {string} content
	 * @returns {string} content
	 */ htmlDecode(content) {
        return content.toString().replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    }
    /**
	 * Ermittlung des aktuellen Dateipfades
	 *
	 * @returns {*} URLObject
	 */ getEditorFileUrl() {
        const editorUrl = $c08a85e7ceb076e9$import_meta !== undefined ? new URL("file:///webportal/config/layout/themes/project/js/src/vendor/script/classes/opacc.class.form.element.wysiwyg.js") : {};
        if ('pathname' in editorUrl) for(let x = 0; x < 3; x++)editorUrl.pathname = editorUrl.pathname.substring(0, editorUrl.pathname.lastIndexOf("/"));
        else {
            editorUrl.host = 'cdn.was.local';
            editorUrl.pathname = '/was/dev/src'; //Versionsnummer wird beim Deployment des CDN aus Bamboo-Variable übernommen
        }
        return editorUrl;
    }
    /**
	 * Bestimmung der aktuellen Sprache aus der URL
	 *
	 * @returns {string} locale
	 */ getLanguage() {
        if (location.href.indexOf('/en/') !== -1) return 'en_GB';
        else if (location.href.indexOf('/fr/') !== -1) return 'fr_FR';
        else if (location.href.indexOf('/it/') !== -1) return 'it';
        else return 'de';
    }
    /**
	 * WYSIWYG Content in die entsprechende Textarea einfügen und Prüfung auf Eingabe
	 *
	 * @param {Object} ed active Editor instance
	 */ setContentToTextarea(ed, e) {
        if (document.activeElement.tagName == 'IFRAME') {
            let keyCode = e.keyCode;
            if (keyCode === 9 || e.type == 'blur') {
                ed.save();
                ed.targetElm.focus();
                ed.targetElm.style.zIndex = '-1';
                ed.targetElm.style.display = 'block';
                ed.targetElm.blur();
                ed.targetElm.style.display = 'none';
            }
        }
    }
}


/** @module form */ /**
 * Funktionalität zum Spam-Schutz bei Formularen
 * @property {NodeList} captcha Nodelist of Captcha HTMLElements
 */ class $bad266abd6972ab7$export$c1918eead6aac897 {
    constructor(){
        this.captcha = document.querySelectorAll('.wpCaptchaButton');
        this.attachEventListener();
        this.init();
    }
    init() {
        let googleRecaptchaElems = document.querySelectorAll('input.g-recaptcha-response[type="hidden"]');
        if (googleRecaptchaElems.length == 0) return;
        Array.from(googleRecaptchaElems).forEach((elem)=>{
            this.renderGoogleRecaptcha(elem);
        });
    }
    /**
	 * Event Registrierungen im DOM
	 */ attachEventListener() {
        Array.from(this.captcha).forEach((button)=>{
            button.removeAttribute('onclick');
            button.addEventListener('click', ()=>{
                let parent = button.parentNode;
                if (parent) {
                    let id = parent.querySelector('.wpCaptchaInput').getAttribute('name').replace('wpCaptchaInput_', '');
                    parent.querySelector('img').setAttribute('src', `/WebPortal/ShowCaptcha.aspx?id=${id}&time=${Date.now()}`);
                }
            });
        });
    }
    renderGoogleRecaptcha(reCaptcha) {
        let reCaptchaObj = this.getReCaptchaConfig(reCaptcha);
        reCaptchaObj.formSubmitBtn.addEventListener('click', ()=>{
            if (reCaptchaObj.reCaptchaSiteKey && reCaptchaObj.reCaptchaAction) window.grecaptcha.ready(()=>{
                window.grecaptcha.execute(reCaptchaObj.reCaptchaSiteKey, {
                    action: reCaptchaObj.reCaptchaAction
                }).then((token)=>{
                    reCaptchaObj.reCaptchaRespElem.value = token;
                    reCaptchaObj.selectedForm.dispatchEvent(new Event('submit'));
                });
            });
            else throw new Error('Opacc formvalidator: Google reCAPTCHA is not configured.');
        });
    }
    getReCaptchaConfig(elem) {
        let returnObj = {
            reCaptchaRespElem: elem,
            reCaptchaSiteKey: elem.dataset.opSitekey ? elem.dataset.opSitekey : '',
            reCaptchaAction: elem.dataset.opAction ? elem.dataset.opAction : '',
            selectedForm: elem.closest('form'),
            formSubmitBtn: elem.closest('form').querySelector('[type="submit"]')
        };
        return returnObj;
    }
}


/** @module form */ /**
 * Material-Design auf Formular-Elementen anwenden
 *
 * @property {NodeList} forms List with all forms
 * @property {Array}  materialElements All formElements with materialdesign
 */ class $0c7b11aef876d78e$export$6999125d7eda2d77 {
    constructor(){
        //this.wrapperElement = document.querySelector('.content');
        this.forms = document.querySelectorAll('form');
        this.materialElements = this.getAllMaterialElements();
        if (this.materialElements) this.attachEventListener();
    }
    /**
	 * Event Registrierungen im DOM
	 *
	 */ attachEventListener() {
        document.addEventListener('focus', (e)=>{
            this.setFocusEventHandler(e);
        }, true);
        document.addEventListener('blur', (e)=>{
            this.setBlurEventHandler(e);
        }, true);
    }
    /**
	 * Handler für den Event "onFocus"
	 *
	 * @param {Event} e Current event
	 */ setFocusEventHandler(e) {
        let element = this.materialElements.find((item)=>{
            return item.formField == e.target;
        });
        if (element) element.formFieldWrapper.classList.add('is-materialized');
    }
    /**
	 * Handler für den Event "onBlur"
	 *
	 * @param {Event} e Current event
	 */ setBlurEventHandler(e) {
        let element = this.materialElements.find((item)=>{
            return item.formField == e.target;
        });
        if (element) {
            if (element.formField.value.length > 0) return;
            element.formFieldWrapper.classList.remove('is-materialized');
        }
    }
    /**
	 *
	 * Identifiziere alle Material-Form-Elemente sämtlicher Formularen
	 *
	 * @returns {Array} Array mit allen Material-Form-Elementen
	 */ getAllMaterialElements() {
        let materialElements = [];
        Array.from(this.forms).forEach((form)=>{
            let currentFormElements = Array.from(form.elements).map((item)=>{
                let formFieldWrapper = item.closest('.opc-form-field');
                if (formFieldWrapper && 'opLabel' in formFieldWrapper.dataset) return formFieldWrapper.dataset.opLabel === 'material' ? {
                    'formFieldWrapper': formFieldWrapper,
                    'formField': item
                } : '';
            }).filter((item)=>{
                return typeof item === 'object';
            });
            materialElements.push(currentFormElements);
        });
        // flatten array to 1 dimension
        return [].concat(...materialElements);
    }
}


const $c5541820cd3789ec$export$ec34f2bc8aa7b5ec = new (0, $0fc5485f94a8164d$export$7f675ee6ba2f1942)();
const $c5541820cd3789ec$export$87e769e6855c081 = new (0, $3e6948b5dd5d5e80$export$c0c7e16993e6362e)();
const $c5541820cd3789ec$export$be7fbb4ce4b64223 = new (0, $215d185b039a9acb$export$5fe1800497971b35)();
const $c5541820cd3789ec$export$eb96811c06077f12 = new (0, $c08a85e7ceb076e9$export$f8e2324a133cee57)();
const $c5541820cd3789ec$export$49ca6bfbcce0fd47 = new (0, $bad266abd6972ab7$export$c1918eead6aac897)();
const $c5541820cd3789ec$export$86511d0769c67afd = new (0, $0c7b11aef876d78e$export$6999125d7eda2d77)();



class $67b4e6c5b8f4f2fd$export$ff76bb9ad96f86c0 {
    constructor(){
        this.wrapperElement = document.querySelector('.content');
        this.AddrType = this.wrapperElement.querySelectorAll('.page-register-login input[name="field-reg-type"]');
        if (this.AddrType.length > 0) {
            this.AddrTypeContainer = this.AddrType[0].closest('.opc-button-wrapper');
            this.toggleSelectedForm();
        }
        this.radioListener();
        this.checkboxListener();
        this.validateListener();
        this.slideContentBoxes();
    }
    /**
	 *
	 *
	 */ slideContentBoxes() {
        this.toggleButtons = document.querySelectorAll('.page-register-login .content-box-body > .opc-button');
        this.contentBoxes = document.querySelectorAll('.page-register-login .content-box-body > .content-box-slide-content');
        Array.from(this.toggleButtons).forEach((button)=>{
            button.addEventListener('click', ()=>{
                if (button.previousElementSibling && button.previousElementSibling.classList.contains('content-box-slide-content')) {
                    Array.from(this.contentBoxes).forEach((box)=>{
                        box.removeEventListener('transitionend', this.transitionEvent);
                        box.classList.remove('is-open');
                        box.removeAttribute('style');
                        box.style.height = '0';
                    });
                    button.previousElementSibling.addEventListener('transitionend', this.transitionEvent);
                    button.previousElementSibling.classList.add('is-open');
                    button.previousElementSibling.style.height = button.previousElementSibling.scrollHeight + 'px';
                }
            });
        });
    }
    /**
	 *
	 *
	 */ toggleSelectedForm() {
        let initial = this.AddrTypeContainer.querySelector('input[checked]');
        if (initial) this.showActiveForm(initial);
        this.AddrTypeContainer.addEventListener('click', (e)=>{
            let btn = e.target.closest('.page-register-login input[name="field-reg-type"]');
            if (btn) this.showActiveForm(btn);
        });
        this.AddrTypeContainer.addEventListener('keydown', (e)=>{
            if (e.keyCode == 13) {
                let btn = e.target.previousElementSibling;
                if (btn) {
                    btn.checked = true;
                    btn.setAttribute('checked', 'checked');
                    this.showActiveForm(btn);
                }
            }
        });
    }
    /**
	 *
	 *
	 * @param {*} btn
	 */ showActiveForm(btn) {
        let registerFormContainer = this.AddrType[0].closest('.content-box-body');
        let registerForms = registerFormContainer.querySelectorAll('form');
        let activeForm = registerFormContainer.querySelector(`#${btn.dataset.opFormType}`);
        let openContentBox = document.querySelectorAll('.content-box-slide-content.is-open');
        if (openContentBox.length > 0) Array.from(openContentBox).forEach((box)=>{
            box.style.height = 'auto';
        });
        Array.from(registerForms).forEach((item)=>{
            if (item === activeForm) item.style.display = 'flex';
            else item.style.display = 'none';
        });
    }
    /**
	 *
	 *
	 */ radioListener() {
        this.wrapperElement.addEventListener('keydown', (e)=>{
            if (e.keyCode == 32 && e.target.classList.contains('opc-radio')) {
                let input = e.target.querySelector('input');
                if (input) {
                    input.checked = true;
                    input.setAttribute('checked', 'checked');
                }
                e.preventDefault();
            }
        });
    }
    /**
	 *
	 *
	 */ checkboxListener() {
        this.wrapperElement.addEventListener('keydown', (e)=>{
            if (e.keyCode == 32 && e.target.classList.contains('opc-checkbox')) {
                let input = e.target.querySelector('input');
                if (input) {
                    if (input.checked) {
                        input.checked = false;
                        input.setAttribute('checked', '');
                    } else {
                        input.checked = true;
                        input.setAttribute('checked', 'checked');
                    }
                }
                e.preventDefault();
            }
        });
    }
    /**
	 *
	 *
	 */ validateListener() {
        document.addEventListener('DOMContentLoaded', ()=>{
            const forms = document.querySelectorAll('form');
            Array.from(forms).forEach((form)=>{
                new (0, $9a8661df079a6616$export$93014f54d2ef40ae)(form);
            });
        });
    }
    /**
	 *
	 *
	 * @param {*} e
	 */ transitionEvent(e) {
        if (e.currentTarget.style.height != '0') e.currentTarget.style.height = 'auto';
    }
}


const $c09b664d5532e1c0$export$5259ede0c48e9a21 = new (0, $67b4e6c5b8f4f2fd$export$ff76bb9ad96f86c0)();



class $5560042e6cde484c$export$5b5ca4474c2389b9 {
    constructor(){
        this.browserLink = {
            'chrome': 'https://www.google.com/chrome',
            'chrome-de': 'https://www.google.com/chrome',
            'chrome-en': 'https://www.google.com/chrome',
            'chrome-fr': 'https://www.google.com/chrome',
            'firefox': 'https://www.mozilla.org',
            'firefox-de': 'https://www.mozilla.org/de/',
            'firefox-en': 'https://www.mozilla.org/en-gb/',
            'firefox-fr': 'https://www.mozilla.org/fr/',
            'edge': 'https://www.microsoft.com/edge',
            'edge-de': 'https://www.microsoft.com/de-ch/windows/microsoft-edge',
            'edge-en': 'https://www.microsoft.com/en-gb/windows/microsoft-edge',
            'edge-fr': 'https://www.microsoft.com/fr-ch/windows/microsoft-edge'
        };
        this.container = document.querySelector('.not-supported');
        this.attachEventListener();
    }
    /**
	 * Event Registrierung im DOM
	 */ attachEventListener() {
        if (this.container) this.container.addEventListener('click', (event)=>{
            // Browser-Link aufrufen
            if (event.target.hasAttribute('data-op-browser')) {
                var browser = event.target.getAttribute('data-op-browser');
                var link = this.browserLink[browser];
                if (link) window.location.href = link;
            }
            // Meldung ausblenden und asynchroner Aufruf (falls vorhanden)
            if (event.target.classList.contains('opc-button')) {
                this.container.style.display = 'none';
                var url = this.container.getAttribute('data-op-acknowledge');
                if (url) (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, {});
            }
        });
    }
}



class $f4a86a987bafc806$export$70f0b4a0787bde41 {
    constructor(){
        this.container = document.querySelector('.opc-manager-cookie');
        this.attachEventListener();
        this.sendAjaxRequest();
    }
    /**
	 * Event Registrierung im DOM
	 *
	 */ attachEventListener() {
        if (this.container) this.container.addEventListener('click', (event)=>{
            if (event.target.classList.contains('opc-button')) {
                // Bei Klick auf "Akzeptieren", Trace zur Nachverfolgung speichern
                let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
                (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, {
                    crypt: this.container.getAttribute('data-op-crypt2')
                }, this.refreshContent.bind(this), this.getDefaultErrorFnc, true);
            }
        });
    }
    /**
	 *
	 *
	 */ sendAjaxRequest() {
        if (this.container && !this.cookieUsageAccepted()) {
            // Pruefen, ob die Nutzung von Cookies bereits akzeptiert wurde
            let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
            (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, {
                crypt: this.container.getAttribute('data-op-crypt1')
            }, this.refreshContent.bind(this), this.getDefaultErrorFnc, true);
        }
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ cookieUsageAccepted() {
        let decodedCookie = decodeURIComponent(document.cookie);
        let cookies = decodedCookie.split(';');
        for (const cookie of cookies){
            if (cookie.trim() === 'CookieUsageConfirmed=true') return true;
        }
        return false;
    }
    /**
	 *
	 *
	 * @param {*} response
	 */ refreshContent(response) {
        if (response.dataAsHtml) this.container.innerHTML = response.dataAsHtml;
        else this.container.innerHTML = '';
    }
}


/** @module manager */ /**
 * Funktionalität für Traces mit dem Tagmanager
 *
 */ class $5efa80dac5008a6d$export$5b3ea097816fc5ac {
    constructor(){
        this.basketId = document.querySelector('.otm-basketid');
        this.pushData();
        window.dataLayer.push(function() {
            this.reset();
        });
        this.pushDataGA4();
    }
    /**
	 *
	 *
	 */ pushData() {
        let data = null;
        if (this.basketId) data = this.getPurchaseData();
        if (data && window.dataLayer) window.dataLayer.push(data);
    }
    pushDataGA4() {
        let data2 = null;
        if (this.basketId) data2 = this.getPurchaseDataGA4();
        if (data2 && window.dataLayer) window.dataLayer.push(data2);
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ getPurchaseData() {
        return {
            'event': 'event-purchase',
            'ecommerce': {
                'purchase': {
                    'actionField': this.getActionData(),
                    'products': this.getProductData()
                }
            }
        };
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ getActionData() {
        let data = {};
        let affiliation = document.querySelector('.otm-affiliation');
        let revenue = document.querySelector('.otm-revenue');
        let tax = document.querySelector('.otm-tax');
        let shipping = document.querySelector('.otm-shipping');
        let currency = document.querySelector('.otm-currency');
        data['id'] = this.basketId.innerText;
        data['affiliation'] = affiliation ? affiliation.innerText : '';
        data['revenue'] = revenue ? parseFloat(revenue.innerText) : '';
        data['tax'] = tax ? parseFloat(tax.innerText) : '';
        data['shipping'] = shipping ? parseFloat(shipping.innerText) : '';
        data['currency'] = currency ? currency.innerText : '';
        return data;
    }
    /**
	 *
	 *
	 * @returns {*}
	 */ getProductData() {
        let data = [];
        let items = document.querySelectorAll('.otm-item');
        Array.from(items).forEach((item)=>{
            let id = item.querySelector('.otm-id');
            let name = item.querySelector('.otm-name');
            let brand = item.querySelector('.otm-brand');
            let category = item.querySelector('.otm-category');
            let price = item.querySelector('.otm-price');
            let quantity = item.querySelector('.otm-quantity');
            let position = item.querySelector('.otm-position');
            let currency = item.querySelector('.otm-itemcurrency');
            data.push({
                'id': id ? id.innerText : '',
                'name': name ? name.innerText : '',
                'brand': brand ? brand.innerText : '',
                'category': category ? category.innerText : '',
                'price': price ? parseFloat(price.innerText) : '',
                'quantity': quantity ? parseFloat(quantity.innerText) : '',
                'position': position ? parseFloat(position.innerText) : '',
                'currency': currency ? currency.innerText : ''
            });
        });
        return data;
    }
    /** GA4 Tracking */ getPurchaseDataGA4() {
        return {
            'event': 'event-purchase-ga4',
            'ecommerce': this.getActionDataGA4()
        };
    }
    getActionDataGA4() {
        let data2 = {};
        let affiliation = document.querySelector('.otm-affiliation');
        let revenue = document.querySelector('.otm-revenue');
        let tax = document.querySelector('.otm-tax');
        let shipping = document.querySelector('.otm-shipping');
        let currency = document.querySelector('.otm-currency');
        data2['transaction_id'] = this.basketId.innerText;
        data2['affiliation'] = affiliation ? affiliation.innerText : '';
        data2['value'] = revenue ? parseFloat(revenue.innerText) : '';
        data2['tax'] = tax ? parseFloat(tax.innerText) : '';
        data2['shipping'] = shipping ? parseFloat(shipping.innerText) : '';
        data2['currency'] = currency ? currency.innerText : '';
        data2['items'] = this.getProductDataGA4();
        return data2;
    }
    getProductDataGA4() {
        let data2 = [];
        let items = document.querySelectorAll('.otm-item');
        Array.from(items).forEach((item)=>{
            let id = item.querySelector('.otm-id');
            let name = item.querySelector('.otm-name');
            let brand = item.querySelector('.otm-brand');
            let category = item.querySelector('.otm-category');
            let price = item.querySelector('.otm-price');
            let quantity = item.querySelector('.otm-quantity');
            let position = item.querySelector('.otm-position');
            let currency = item.querySelector('.otm-itemcurrency');
            data2.push({
                'item_id': id ? id.innerText : '',
                'item_name': name ? name.innerText : '',
                'item_brand': brand ? brand.innerText : '',
                'item_category': category ? category.innerText : '',
                'price': price ? parseFloat(price.innerText) : '',
                'quantity': quantity ? parseFloat(quantity.innerText) : ''
            });
        });
        return data2;
    }
}


const $5447bb28ceba58e9$export$b59dd72ededbb597 = new (0, $5560042e6cde484c$export$5b5ca4474c2389b9)();
const $5447bb28ceba58e9$export$f864ea2566c78a6b = new (0, $f4a86a987bafc806$export$70f0b4a0787bde41)();
const $5447bb28ceba58e9$export$7bc1f6b66d1f378a = new (0, $5efa80dac5008a6d$export$5b3ea097816fc5ac)();





class $c0f1e51770d9929c$export$bafec49fd4471dd5 {
    constructor(selector = '.opc-basket-info'){
        this.basketInfoButtonSelector = 'button';
        this.wrapperElement = document.querySelector('body');
        this.basketInfo = document.querySelector(selector);
        this.basketList = this.wrapperElement.querySelector('.basket-list');
        this.basketOverview = this.wrapperElement.querySelector('.page-basket');
        if (this.basketInfo) {
            this.miniBasket = this.basketInfo.querySelector('.mini-basket');
            this.basketAsyncTemplate = this.basketInfo.dataset.opAsynctemplate || '';
        }
        if (this.miniBasket) {
            this.miniBasketList = this.miniBasket.querySelector('[data-op-asyncbasket="basket-items"]');
            this.miniBasketItems = this.miniBasket.querySelectorAll('.basket-item');
            this.redirectMiniBasket = undefined;
            this.redirectMiniBasketLink = this.miniBasket.querySelector('.opc-button[data-op-type="checkout"]').href;
            this.offCanvasNaviElement = document.querySelector('.offcanvas-menu-trigger');
        }
    }
    /**
	 *
	 *
	 */ attachEventListener() {}
    /**
	 *
	 *
	 * @param {*} item
	 */ sendAjaxRequest(item) {
        let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
        if (this.constructor.name === 'OpaccBasketInfo') url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl(false);
        this.hookBeforeSendAjaxRequest(item);
        (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, this.prepareDataSubmission(item), this.refreshResultList.bind(this, item), this.asyncErrorHandler.bind(this), true);
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */ prepareDataSubmission(item) {
        let data = {
            type: 'basket',
            action: item.dataset.opBtnaction,
            module: item.dataset.opModule,
            originalUrl: window.location.href
        };
        if (data.action == 'change') {
            var selectElement = item.previousElementSibling;
            while(selectElement && selectElement.tagName !== 'SELECT')selectElement = selectElement.previousElementSibling;
            if (selectElement) data.artdimvariantno = selectElement.value;
        }
        if (item.dataset.opArtinternalno) data.artInternalNo = item.dataset.opArtinternalno;
        if (item.dataset.opSaldocitemboid) data.salDocItemBoId = item.dataset.opSaldocitemboid;
        if (item.dataset.opSaldocboid) data.salDocBoId = item.dataset.opSaldocboid;
        if (item.dataset.opOption) data.addalloptions = item.dataset.opOption;
        if (item.dataset.opVariant) data.artDimVariantNo = item.dataset.opVariant;
        if (item.dataset.opQuantityid1) data.catItemQuantityDim1 = this.getButtonDimValue(item, item.dataset.opQuantityid1);
        if (item.dataset.opQuantityid2) data.catItemQuantityDim2 = this.getButtonDimValue(item, item.dataset.opQuantityid2);
        if (item.dataset.opQuantityid3) data.catItemQuantityDim3 = this.getButtonDimValue(item, item.dataset.opQuantityid3);
        if (item.dataset.opAsynctemplate) data.template = item.dataset.opAsynctemplate;
        if (item.dataset.opRequest) data.request = item.dataset.opRequest;
        if (item.dataset.opEncrypted) data.encrypted = item.dataset.opEncrypted;
        Array.from(item.attributes).forEach((property)=>{
            if (property.name.indexOf('data-op-saldocitem.') === 0) data[property.name.substring(8)] = property.value;
        });
        if (item.dataset.opBtnaction === 'addall') {
            data.addall = this.getNewQuantityFromPosition();
            if (data.addall === '{}') delete data.addall;
        }
        return this.hookBeforeReturnPrepareDataSubmission(item, data);
    }
    /**
	 * Angepasste Menge der Quelldokument-Positionen ermitteln
	 *
	 * @returns {*}
	 */ getNewQuantityFromPosition() {
        let dimIndex = {};
        let listItems = this.wrapperElement.querySelectorAll('.opc-item-list .list-item, .opc-article-list li');
        Array.from(listItems).forEach((item)=>{
            let internalNo = null;
            if (item.dataset.opInternalno) internalNo = item.dataset.opInternalno;
            if (internalNo) {
                // find Basekt-button from current Item
                let itemBasket = item.querySelector('.opc-basket-button');
                if (itemBasket) {
                    let itemBasketDim = itemBasket.querySelectorAll('.basket-button-dim-1:not(.is-inactive), .basket-button-dim-2:not(.is-inactive), .basket-button-dim-3:not(.is-inactive)');
                    Array.from(itemBasketDim).forEach((dim, index)=>{
                        dimIndex[`position${internalNo}dim${index + 1}`] = dim.querySelector('.basket-button-quantity').value;
                    });
                }
            }
        });
        return JSON.stringify(dimIndex);
    }
    /**
	 *
	 *
	 * @param {*} data
	 */ updateMiniBasket(data) {
        if (this.miniBasket && !this.basketOverview) {
            this.miniBasket.querySelector('.mini-basket-quantity').innerHTML = data.quantity;
            this.miniBasketList.innerHTML = data.items;
            let amount = this.miniBasket.querySelector('.mini-basket-footer-total');
            if (amount) {
                let amountText = amount.firstElementChild;
                amount.innerHTML = `${amountText.outerHTML} ${data.currency} ${data.amount}`;
            }
        }
        if (this.basketInfo) this.basketInfo.querySelector('.basket-info-count').innerHTML = data.quantity > 0 ? data.quantity : '';
        this.hookAfterUpdateMiniBasket(data);
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */ updateBasket(item, data) {
        if (this.basketList) {
            if (item.dataset.opBtnaction == 'delete' || item.dataset.opBtnaction == 'deleteall') {
                if (+data.quantity === 0) {
                    // if quickorder activated, refresh page
                    if (this.basketList.dataset.opQuickorder === "true") location.reload();
                    else {
                        let emptyInfo = document.createElement('div');
                        emptyInfo.classList.add('opc-message');
                        emptyInfo.dataset.opType = 'info';
                        emptyInfo.innerHTML = (0, $6a5d168af5ede3cd$export$287bafa924522a4d).messageEmptyBasket.text;
                        this.basketList.parentNode.replaceChild(emptyInfo, this.basketList);
                    }
                } else {
                    let basketPos = this.basketList.querySelector(`[data-op-internalno="${item.dataset.opInternalno}"]`) || item.closest('.basket-list-item');
                    if (basketPos) basketPos.remove();
                }
            } else if (item.dataset.opBtnaction == 'change') {
                // update item price and amount
                let price = item.closest('.basket-list-item').querySelector('[data-op-asyncbasket="itemPrice"]');
                if (price) price.innerHTML = `${data.currency} ${data.itemPrice}`;
                let amount = item.closest('.basket-list-item').querySelector('[data-op-asyncbasket="itemAmount"]');
                if (amount) amount.innerHTML = `${data.currency} ${data.itemAmount}`;
            } else if (item.closest('.opc-quickorder')) {
                // update after quickorder
                let quickorder = item.closest('.opc-quickorder');
                if (quickorder.dataset.opRefresh === 'false') (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynGetForm(quickorder.dataset.opUrlRefresh, this.refreshBasketList.bind(this), this.asyncErrorHandler.bind(this), true);
            }
            // update total amount and VAT
            let totalAmount = this.basketList.querySelector('[data-op-asyncbasket="totalAmount"]');
            if (totalAmount) totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
            let totalVat = this.basketList.querySelector('[data-op-asyncbasket="totalVat"]');
            if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        } else if (item.closest('.opc-quickorder')) {
            // refresh after quickorder
            let quickorder = item.closest('.opc-quickorder');
            if (quickorder.dataset.opRefresh === 'true') window.location.href = quickorder.dataset.opUrlRefresh;
        }
        this.hookAfterUpdateBasket(item, data);
    }
    /**
	 *
	 * @param {*} response
	 */ refreshBasketList(response) {
        if (response && response.success) {
            const basketListBodyWrapper = this.basketList.querySelector('.basket-list-body-wrapper');
            if (basketListBodyWrapper) basketListBodyWrapper.innerHTML = response.dataAsHtml;
        }
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} response
	 */ refreshResultList(item, response) {
        response = this.hookBeforeRefreshResultList(item, response);
        item.classList.remove('is-progress');
        let basketButtons = this.wrapperElement.querySelectorAll(`${this.basketButtonContainer}[data-op-modal],${this.basketButtonContainer} button[data-op-btnaction], ${this.basketButtonContainer} button[data-op-qtychange]`);
        this.toggleButtonState(Array.from(basketButtons).filter((basketItem)=>basketItem != item), 'all');
        this.toggleQuantityChangerState(this.getQuantityChangerElements(item), 'all');
        if (response.success) {
            this.showSuccessIndicator(item);
            this.updateMiniBasket(response.dataAsJson);
            this.updateBasket(item, response.dataAsJson);
            if (response.dataAsJson.action === 'added') {
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).hideModal();
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage(this.getQuantityMessage(item));
            }
        }
        this.hookAfterRefreshResultList(item, response);
    }
    /**
	 *
	 *
	 * @param {*} [targetId=null]
	 * @param {*} response
	 */ refreshContent(targetId = null, response) {
        if (response.success) {
            let url = targetId ? targetId : window.location.href;
            (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, {}, this.refreshPageContent.bind(this), this.asyncErrorHandler.bind(this), true);
        }
    }
    /**
	 *
	 *
	 * @param {*} response
	 */ refreshPageContent(response) {
        if (response.success) {
            let htmlObj = document.createElement('div');
            htmlObj.innerHTML = response.dataAsHtml;
            document.querySelector('#checkout-content').innerHTML = htmlObj.querySelector('#checkout-content').innerHTML;
        }
    }
    /**
	 *
	 *
	 * @param {*} button
	 * @param {*} dimNumIdVal
	 * @returns {*}
	 */ getButtonDimValue(button, dimNumIdVal) {
        let retVal = '';
        let parent = button.parentElement;
        let dim = parent.querySelector(`[data-op-dim="${dimNumIdVal}"]`);
        let inactive = dim.classList.contains('is-inactive');
        let input = dim.querySelector('input.basket-button-quantity');
        let value = input.value;
        let defaultValue = input.min || 1;
        if (!inactive) {
            if (isNaN(value) || value <= 0) {
                input.value = defaultValue;
                retVal = defaultValue;
            } else retVal = value;
        }
        return retVal;
    }
    /**
	 *
	 *
	 * @param {*} button
	 * @param {*} dimNumIdVal
	 * @returns {*}
	 */ getButtonDimUnit(button, dimNumIdVal) {
        let unit = '';
        let parent = button.parentElement;
        let dim = parent.querySelector(`[data-op-dim="${dimNumIdVal}"]`);
        let inactive = dim.classList.contains('is-inactive');
        if (!inactive) {
            let unitElement = dim.querySelector('.basket-button-dim-unit');
            if (unitElement) unit = unitElement.innerText;
        }
        return unit;
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */ getQuantityMessage(item) {
        let message = Object.assign({}, (0, $6a5d168af5ede3cd$export$287bafa924522a4d).messageAddedToBasket);
        let dim1Value = this.getButtonDimValue(item, item.dataset.opQuantityid1);
        let dim1Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid1);
        let dim2Value = this.getButtonDimValue(item, item.dataset.opQuantityid2);
        let dim2Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid2);
        let dim3Value = this.getButtonDimValue(item, item.dataset.opQuantityid3);
        let dim3Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid3);
        let quantity = `${dim1Value} ${dim1Unit} `;
        if (dim2Value) quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
        if (dim3Value) quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
        message.text = quantity + (0, $6a5d168af5ede3cd$export$287bafa924522a4d).messageAddedToBasket.text;
        return message;
    }
    /**
	 *
	 *
	 * @param {*} e
	 * @returns {*}
	 */ eventPath(e) {
        let path = e.composedPath && e.composedPath() || e.path, target = e.target;
        if (path != null) // Safari doesn't include Window, but it should.
        return path.indexOf(window) < 0 ? path.concat(window) : path;
        if (target === window) return [
            window
        ];
        function getParents(node, memo) {
            memo = memo || [];
            var parentNode = node.parentNode;
            if (!parentNode) return memo;
            else return getParents(parentNode, memo.concat(parentNode));
        }
        return [
            target
        ].concat(getParents(target), window);
    }
    /**
	 *
	 *
	 * @param {*} target
	 * @returns {*}
	 */ getQuantityChangerElements(target) {
        let buttonArray = [];
        if (this.basketList) buttonArray = Array.from(this.basketList.querySelectorAll('.opc-button[data-op-qtychange="dec"], .opc-button[data-op-qtychange="inc"]'));
        else {
            let decrementButton = target.parentElement.querySelector('.opc-button[data-op-qtychange="dec"]');
            let incrementButton = target.parentElement.querySelector('.opc-button[data-op-qtychange="inc"]');
            if (decrementButton === null || incrementButton === null) return [];
            buttonArray = [
                decrementButton,
                incrementButton
            ];
        }
        return buttonArray;
    }
    /**
	 *
	 *
	 * @param {*} buttons
	 * @param {*} value
	 */ toggleQuantityChangerState(buttons, value) {
        this.toggleButtonState(buttons, value);
    }
    /**
	 *
	 *
	 * @param {*} buttons
	 * @param {*} value
	 */ toggleButtonState(buttons, value) {
        Array.from(buttons).forEach((item)=>{
            item.style.pointerEvents = value;
            if (value === 'none' && !item.classList.contains('opc-basket-info')) item.parentElement.style.cursor = 'not-allowed';
            else item.parentElement.style.cursor = 'default';
        });
    }
    /**
	 *
	 *
	 * @param {*} error
	 */ asyncErrorHandler(error) {
        // eslint-disable-next-line no-console
        console.error('Request failed: ', error.message);
        this.hookAfterAsyncErrorHandler(error);
    }
    // ---------------------------------
    /**
	 *
	 *
	 * @param {*} item
	 */ // eslint-disable-next-line no-unused-vars
    hookBeforeSendAjaxRequest(item) {}
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */ hookBeforeReturnPrepareDataSubmission(item, data) {
        return data;
    }
    /**
	 *
	 *
	 * @param {*} data
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterUpdateMiniBasket(data) {}
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterUpdateBasket(item, data) {}
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */ hookBeforeRefreshResultList(item, data) {
        return data;
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterRefreshResultList(item, data) {}
    /**
	 *
	 *
	 * @param {*} error
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterAsyncErrorHandler(error) {}
}


class $34e260eadd36b70e$export$346e946584e7b817 extends (0, $c0f1e51770d9929c$export$bafec49fd4471dd5) {
    constructor(){
        super();
        if (this.miniBasket) {
            let basketItemsQuantitySelector = this.basketInfo.querySelector('.basket-info-count');
            let basketItemsQuantity = null;
            if (basketItemsQuantitySelector) basketItemsQuantity = +basketItemsQuantitySelector.innerHTML;
            if (basketItemsQuantity && this.miniBasketList.childElementCount === 0) {
                let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl(false);
                let request = this.basketInfo.dataset.opRequest;
                let data = {
                    type: 'basket',
                    action: 'items',
                    template: this.basketAsyncTemplate,
                    request: request
                };
                if (!this.basketOverview) (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, data, this.updateItemsOnly.bind(this), this.asyncErrorHandler.bind(this), true);
            }
            this.attachEventListener();
        }
    }
    /**
	 *
	 *
	 * @param {*} [status=null]
	 */ // eslint-disable-next-line no-unused-vars
    toggleMiniBasket(status = null) {
        this.miniBasket.classList.toggle('is-open');
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} response
	 */ refreshResultList(item, response) {
        if (response.success) {
            this.updateMiniBasket(response.dataAsJson);
            this.updateBasket(item, response.dataAsJson);
        }
    }
    /**
	 *
	 *
	 * @param {*} basket
	 * @param {*} item
	 */ deleteBasketItem(basket, item) {
        item.dataset.opAsynctemplate = this.basketAsyncTemplate;
        this.sendAjaxRequest(item);
        basket.removeChild(item.parentNode.parentNode);
    }
    /**
	 *
	 *
	 * @param {*} response
	 */ updateItemsOnly(response) {
        if (response.success) this.miniBasketList.innerHTML = response.dataAsJson.updateItemsOnly;
    }
    /**
	 *
	 *
	 */ attachEventListener() {
        if (this.basketInfo) document.addEventListener('click', (e)=>{
            if (e.target.closest(`.${this.basketInfo.className} ${this.basketInfoButtonSelector}`)) {
                if (this.offCanvasNaviElement) // Redirect miniBasket to basket if mobile-navigation is shown
                this.redirectMiniBasket = window.getComputedStyle(this.offCanvasNaviElement).getPropertyValue('display') === 'none' ? false : true;
                if (!this.redirectMiniBasket) this.toggleMiniBasket('is-open');
                else window.location.href = this.redirectMiniBasketLink;
            } else if (e.target.closest(`.${this.basketInfo.className}`) === null) {
                let emptyBasket = true;
                let eventPath = this.eventPath(e);
                eventPath.some((path)=>{
                    if (path == this.basketInfo && this.miniBasketList.childElementCount > 0) return emptyBasket = false;
                });
                if (emptyBasket && this.miniBasket.classList.contains('is-open')) this.toggleMiniBasket();
            }
        }, false);
        if (this.miniBasketList) this.miniBasketList.addEventListener('click', (e)=>{
            let delButtonSelector = '.basket-item-actions [data-op-btnaction="delete"]';
            if (e.target.closest(delButtonSelector) == null) return;
            let items = e.currentTarget.querySelectorAll(delButtonSelector);
            this.toggleButtonState(Array.from(items).filter((basketItem)=>basketItem != e.target.closest(delButtonSelector)), 'none');
            Array.from(items).forEach((item)=>{
                if (e.target.closest(delButtonSelector) == item) {
                    item.classList.add('is-progress');
                    this.deleteBasketItem(e.currentTarget, item);
                }
            });
        }, false);
    }
}




class $3ae1d90c642d526d$export$8a42bddcfd60a6dc {
    constructor(selector = '.opc-basket-info'){
        this.basketInfoButtonSelector = 'button';
        this.wrapperElement = document.querySelector('body');
        this.basketInfo = document.querySelector(selector);
        this.basketList = this.wrapperElement.querySelector('.basket-list');
        if (this.basketInfo) this.miniBasket = this.basketInfo.querySelector('.mini-basket');
        if (this.miniBasket) {
            this.miniBasketList = this.miniBasket.querySelector('[data-op-asyncbasket="basket-items"]');
            this.miniBasketItems = this.miniBasket.querySelectorAll('.basket-item');
            this.redirectMiniBasket = undefined;
            this.redirectMiniBasketLink = this.miniBasket.querySelector('.opc-button[data-op-type="checkout"]').href;
            this.offCanvasNaviElement = document.querySelector('.offcanvas-menu-trigger');
        }
    }
    /**
	 *
	 *
	 */ attachEventListener() {}
    /**
	 *
	 *
	 * @param {*} item
	 */ sendAjaxRequest(item) {
        let url = '/WebPortal/async.aspx';
        this.hookBeforeSendAjaxRequest(item);
        (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, this.prepareDataSubmission(item), this.refreshResultList.bind(this, item), this.asyncErrorHandler.bind(this), true);
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */ prepareDataSubmission(item) {
        let data = {
            type: 'basket',
            action: item.dataset.opBtnaction,
            module: item.dataset.opModule,
            originalUrl: window.location.href
        };
        if (item.dataset.opArtinternalno) data.artInternalNo = item.dataset.opArtinternalno;
        if (item.dataset.opSaldocitemboid) data.salDocItemBoId = item.dataset.opSaldocitemboid;
        if (item.dataset.opSaldocboid) data.salDocBoId = item.dataset.opSaldocboid;
        if (item.dataset.opOption) data.addalloptions = item.dataset.opOption;
        if (item.dataset.opVariant) data.artDimVariantNo = item.dataset.opVariant;
        if (item.dataset.opQuantityid1) data.catItemQuantityDim1 = this.getButtonDimValue(item, item.dataset.opQuantityid1);
        if (item.dataset.opQuantityid2) data.catItemQuantityDim2 = this.getButtonDimValue(item, item.dataset.opQuantityid2);
        if (item.dataset.opQuantityid3) data.catItemQuantityDim3 = this.getButtonDimValue(item, item.dataset.opQuantityid3);
        if (item.dataset.opAsynctemplate) data.template = item.dataset.opAsynctemplate;
        if (item.dataset.opEncrypted) data.encrypted = item.dataset.opEncrypted;
        Array.from(item.attributes).forEach((property)=>{
            if (property.name.indexOf('data-op-saldocitem.') === 0) data[property.name.substring(8)] = property.value;
        });
        if (item.dataset.opBtnaction === 'addall') {
            data.addall = this.getNewQuantityFromPosition();
            if (data.addall === '{}') delete data.addall;
        }
        return this.hookBeforeReturnPrepareDataSubmission(item, data);
    }
    /**
	 * Angepasste Menge der Quelldokument-Positionen ermitteln
	 *
	 * @returns {*}
	 */ getNewQuantityFromPosition() {
        let dimIndex = {};
        let listItems = this.wrapperElement.querySelectorAll('.opc-item-list .list-item, .opc-article-list li');
        Array.from(listItems).forEach((item)=>{
            let internalNo = null;
            if (item.dataset.opInternalno) internalNo = item.dataset.opInternalno;
            if (internalNo) {
                // find Basekt-button from current Item
                let itemBasket = item.querySelector('.opc-basket-button');
                if (itemBasket) {
                    let itemBasketDim = itemBasket.querySelectorAll('.basket-button-dim-1:not(.is-inactive), .basket-button-dim-2:not(.is-inactive), .basket-button-dim-3:not(.is-inactive)');
                    Array.from(itemBasketDim).forEach((dim, index)=>{
                        dimIndex[`position${internalNo}dim${index + 1}`] = dim.querySelector('.basket-button-quantity').value;
                    });
                }
            }
        });
        return JSON.stringify(dimIndex);
    }
    /**
	 *
	 *
	 * @param {*} data
	 */ updateMiniBasket(data) {
        if (this.miniBasket) {
            this.miniBasket.querySelector('.mini-basket-quantity').innerHTML = data.quantity;
            this.miniBasketList.innerHTML = data.items;
            let amount = this.miniBasket.querySelector('.mini-basket-footer-total');
            if (amount) {
                let amountText = amount.firstElementChild;
                amount.innerHTML = `${amountText.outerHTML} ${data.currency} ${data.amount}`;
            }
        }
        if (this.basketInfo) this.basketInfo.querySelector('.basket-info-count').innerHTML = data.quantity > 0 ? data.quantity : '';
        this.hookAfterUpdateMiniBasket(data);
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */ updateBasket(item, data) {
        if (this.basketList) {
            if (item.dataset.opBtnaction == 'delete' || item.dataset.opBtnaction == 'deleteall') {
                if (+data.quantity === 0) {
                    let emptyInfo = document.createElement('div');
                    emptyInfo.classList.add('opc-message');
                    emptyInfo.dataset.opType = 'info';
                    emptyInfo.innerHTML = (0, $6a5d168af5ede3cd$export$287bafa924522a4d).messageEmptyBasket.text;
                    this.basketList.parentNode.replaceChild(emptyInfo, this.basketList);
                } else {
                    let basketPos = this.basketList.querySelector(`[data-op-internalno="${item.dataset.opInternalno}"]`) || item.closest('.basket-list-item');
                    if (basketPos) basketPos.remove();
                }
            } else if (item.dataset.opBtnaction == 'change') // update item amount
            item.closest('.basket-list-item').querySelector('[data-op-asyncbasket="itemAmount"]').innerHTML = `${data.currency} ${data.itemAmount}`;
            // update total amount
            this.basketList.querySelector('[data-op-asyncbasket="totalAmount"]').innerHTML = `${data.currency} ${data.totalAmount}`;
            // update VAT
            if (this.basketList.querySelector('[data-op-asyncbasket="totalVat"]')) this.basketList.querySelector('[data-op-asyncbasket="totalVat"]').innerHTML = `${data.currency} ${data.totalVat}`;
            // Mindestumsatz
            this.mindestUmsatz(data);
        }
        this.hookAfterUpdateBasket(item, data);
    }
    /**
	 * Mindestumsatz: Hinweis bzw. Checkout-Button ein-/ausblenden (nur auf der Warenkorbseite vorhanden)
	 *
	 * @param {*} data
	 */ mindestUmsatz(data) {
        let minturnoverwrapper = document.querySelector('#mindestumsatz');
        let checkoutbtn = document.querySelector('#tocheckout');
        let minvalelem = document.querySelector('#mindestumsatzamt');
        if (!minturnoverwrapper || !checkoutbtn || !minvalelem || !data || data.totalAmount === undefined) return;
        let minvalint = parseFloat(minvalelem.dataset.min);
        // Tausendertrennzeichen (z.B. 1'234.50) entfernen
        let actturnover = parseFloat(String(data.totalAmount).replace(/[^\d.-]/g, ''));
        if (minvalint && !isNaN(actturnover)) {
            // gleiche Bedingung wie in BASKET-List.oc (>=)
            if (actturnover >= minvalint) {
                minturnoverwrapper.style.display = 'none';
                checkoutbtn.style.display = 'inline-flex';
            } else {
                checkoutbtn.style.display = 'none';
                minturnoverwrapper.style.display = 'block';
            }
        }
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} response
	 */ refreshResultList(item, response) {
        response = this.hookBeforeRefreshResultList(item, response);
        item.classList.remove('is-progress');
        this.toggleQuantityChangerState(this.getQuantityChangerElements(item), 'all');
        if (response.success) {
            this.showSuccessIndicator(item);
            this.updateMiniBasket(response.dataAsJson);
            this.updateBasket(item, response.dataAsJson);
            if (response.dataAsJson.action === 'added') {
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).hideModal();
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage(this.getQuantityMessage(item));
            }
        }
        this.hookAfterRefreshResultList(item, response);
    }
    /**
	 *
	 *
	 * @param {*} [targetId=null]
	 * @param {*} response
	 */ refreshContent(targetId = null, response) {
        if (response.success) {
            let url = targetId ? targetId : window.location.href;
            (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, {}, this.refreshPageContent.bind(this), this.asyncErrorHandler.bind(this), true);
        }
    }
    /**
	 *
	 *
	 * @param {*} response
	 */ refreshPageContent(response) {
        if (response.success) {
            let htmlObj = document.createElement('div');
            htmlObj.innerHTML = response.dataAsHtml;
            document.querySelector('#checkout-content').innerHTML = htmlObj.querySelector('#checkout-content').innerHTML;
        }
    }
    /**
	 *
	 *
	 * @param {*} button
	 * @param {*} dimNumIdVal
	 * @returns {*}
	 */ getButtonDimValue(button, dimNumIdVal) {
        let retVal = '';
        let parent = button.parentElement;
        let dim = parent.querySelector(`[data-op-dim="${dimNumIdVal}"]`);
        let inactive = dim.classList.contains('is-inactive');
        let input = dim.querySelector('input.basket-button-quantity');
        let value = input.value;
        let defaultValue = input.min || 1;
        if (!inactive) {
            if (isNaN(value) || value <= 0) {
                input.value = defaultValue;
                retVal = defaultValue;
            } else retVal = value;
        }
        return retVal;
    }
    /**
	 *
	 *
	 * @param {*} button
	 * @param {*} dimNumIdVal
	 * @returns {*}
	 */ getButtonDimUnit(button, dimNumIdVal) {
        let unit = '';
        let parent = button.parentElement;
        let dim = parent.querySelector(`[data-op-dim="${dimNumIdVal}"]`);
        let inactive = dim.classList.contains('is-inactive');
        if (!inactive) {
            let unitElement = dim.querySelector('.basket-button-dim-unit');
            if (unitElement) unit = unitElement.innerText;
        }
        return unit;
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */ getQuantityMessage(item) {
        let message = Object.assign({}, (0, $6a5d168af5ede3cd$export$287bafa924522a4d).messageAddedToBasket);
        let dim1Value = this.getButtonDimValue(item, item.dataset.opQuantityid1);
        let dim1Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid1);
        let dim2Value = this.getButtonDimValue(item, item.dataset.opQuantityid2);
        let dim2Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid2);
        let dim3Value = this.getButtonDimValue(item, item.dataset.opQuantityid3);
        let dim3Unit = this.getButtonDimUnit(item, item.dataset.opQuantityid3);
        let quantity = `${dim1Value} ${dim1Unit} `;
        if (dim2Value) quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
        if (dim3Value) quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
        message.text = quantity + (0, $6a5d168af5ede3cd$export$287bafa924522a4d).messageAddedToBasket.text;
        return message;
    }
    /**
	 *
	 *
	 * @param {*} e
	 * @returns {*}
	 */ eventPath(e) {
        let path = e.composedPath && e.composedPath() || e.path, target = e.target;
        if (path != null) // Safari doesn't include Window, but it should.
        return path.indexOf(window) < 0 ? path.concat(window) : path;
        if (target === window) return [
            window
        ];
        function getParents(node, memo) {
            memo = memo || [];
            var parentNode = node.parentNode;
            if (!parentNode) return memo;
            else return getParents(parentNode, memo.concat(parentNode));
        }
        return [
            target
        ].concat(getParents(target), window);
    }
    /**
	 *
	 *
	 * @param {*} target
	 * @returns {*}
	 */ getQuantityChangerElements(target) {
        let decrementButton = target.parentElement.querySelector('.opc-button[data-op-qtychange="dec"]');
        let incrementButton = target.parentElement.querySelector('.opc-button[data-op-qtychange="inc"]');
        if (decrementButton === null || incrementButton === null) return [];
        return [
            decrementButton,
            incrementButton
        ];
    }
    /**
	 *
	 *
	 * @param {*} buttons
	 * @param {*} value
	 */ toggleQuantityChangerState(buttons, value) {
        Array.from(buttons).forEach((item)=>{
            item.style.pointerEvents = value;
        });
    }
    /**
	 *
	 *
	 * @param {*} error
	 */ asyncErrorHandler(error) {
        // eslint-disable-next-line no-console
        console.error('Request failed: ', error.message);
        this.hookAfterAsyncErrorHandler(error);
    }
    // ---------------------------------
    /**
	 *
	 *
	 * @param {*} item
	 */ // eslint-disable-next-line no-unused-vars
    hookBeforeSendAjaxRequest(item) {}
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */ hookBeforeReturnPrepareDataSubmission(item, data) {
        return data;
    }
    /**
	 *
	 *
	 * @param {*} data
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterUpdateMiniBasket(data) {}
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterUpdateBasket(item, data) {}
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */ hookBeforeRefreshResultList(item, data) {
        return data;
    }
    /**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterRefreshResultList(item, data) {}
    /**
	 *
	 *
	 * @param {*} error
	 */ // eslint-disable-next-line no-unused-vars
    hookAfterAsyncErrorHandler(error) {}
}




class $5095b12b38fb97ef$export$c42c30b194410598 extends (0, $3ae1d90c642d526d$export$8a42bddcfd60a6dc) {
    constructor(basketButtonContainer = '.opc-basket-button', basketButtonSelector = 'button'){
        super();
        this.basketButtonContainer = basketButtonContainer;
        this.basketButtonSelector = basketButtonSelector;
        this.attachEventListener();
        let articleAllowanceUrlWrapper = document.getElementById('article-allowance-url');
        if (articleAllowanceUrlWrapper && articleAllowanceUrlWrapper.hasAttribute('data-op-url') && articleAllowanceUrlWrapper.getAttribute('data-op-url') != '') this.articleAllowanceUrl = articleAllowanceUrlWrapper.getAttribute('data-op-url');
    }
    /**
	 *
	 *
	 */ attachEventListener() {
        if (this.wrapperElement) {
            this.changeDimVariant();
            // Ausloesen des Click-Events bei Aenderung (nur Touch-Button "Change")
            this.wrapperElement.addEventListener('change', (e)=>{
                let inputItem = e.target.closest(`${this.basketButtonContainer}[data-op-layout="touch"]`);
                if (inputItem) {
                    let basketBtn = inputItem.querySelector('button[data-op-btnaction="change"]');
                    if (basketBtn) basketBtn.click();
                }
            });
            this.wrapperElement.addEventListener('click', (e)=>{
                let modalButton = e.target.closest('[data-op-modal]');
                if (modalButton) {
                    let base64 = modalButton.dataset.opModal;
                    let htmlEncoded = window.atob(base64);
                    let htmlDecode = document.createElement('div');
                    htmlDecode.innerHTML = htmlEncoded;
                    (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showModal(htmlDecode.innerText);
                }
                // change Quantity with + and - Buttons
                let itemChangeQuantity = e.target.closest(`${this.basketButtonContainer}[data-op-layout="touch"]`);
                if (itemChangeQuantity && e.target.hasAttribute('data-op-qtychange')) {
                    if (this.quantityChanger(e)) {
                        let item = itemChangeQuantity.querySelector(`${this.basketButtonContainer} button[data-op-btnaction="change"]`);
                        if (item) // if change-button is present, then trigger the quantity change
                        item.click();
                    }
                }
                let itemsAdd = e.currentTarget.querySelectorAll(`${this.basketButtonContainer} button[data-op-btnaction="add"], ${this.basketButtonContainer} button[data-op-btnaction="addall"]`);
                Array.from(itemsAdd).forEach((item)=>{
                    // laufender Request: Doppelklick ignorieren
                    if (item == e.target.closest(this.basketButtonSelector) && !item.classList.contains('is-progress')) {
                        let inputField = item.parentElement.querySelector('input.basket-button-quantity');
                        let isValid = true;
                        if (inputField) isValid = this.validateQuantity(inputField, true);
                        if (isValid) {
                            if (this.basketInfo) item.dataset.opAsynctemplate = this.basketInfo.dataset.opAsynctemplate;
                            item.classList.add('is-progress');
                            // sendAjaxRequest wird nach erfolgreicher Freigabepruefung in showAllowanceInfo ausgefuehrt
                            this.checkAllowance(item);
                        }
                    }
                });
                let itemsModify = e.currentTarget.querySelectorAll(`${this.basketButtonContainer} button[data-op-btnaction="delete"], 
					${this.basketButtonContainer} button[data-op-btnaction="change"],
					${this.basketButtonContainer} button[data-op-btnaction="deleteall"]`);
                Array.from(itemsModify).forEach((item)=>{
                    // laufender Request: Doppelklick ignorieren
                    if (item == e.target.closest(this.basketButtonSelector) && !item.classList.contains('is-progress')) {
                        if (item.dataset.opBtnaction == 'change') {
                            this.validateQuantity(item.parentElement.querySelector('input.basket-button-quantity'), true);
                            this.toggleQuantityChangerState(this.getQuantityChangerElements(e.target), 'none');
                        }
                        if (this.basketInfo) item.dataset.opAsynctemplate = this.basketInfo.dataset.opAsynctemplate;
                        item.classList.add('is-progress');
                        this.sendAjaxRequest(item);
                    }
                });
            });
        }
    }
    /**
	 * Freigabepruefung (Bewilligung) vor dem Hinzufuegen in den Warenkorb
	 *
	 * @param {*} item
	 */ checkAllowance(item) {
        // ohne Pruef-URL direkt hinzufuegen, damit der Warenkorb nicht blockiert
        if (!this.articleAllowanceUrl) {
            this.sendAjaxRequest(item);
            return;
        }
        let data = {
            artIntNo: item.dataset.opArtinternalno
        };
        (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(this.articleAllowanceUrl, data, this.showAllowanceInfo.bind(this, item), this.allowanceErrorHandler.bind(this, item), true);
    }
    /**
	 *
	 * @param {*} item
	 * @param {*} response
	 */ showAllowanceInfo(item, response) {
        let result = response && response.dataAsJson;
        if (!result) {
            this.allowanceErrorHandler(item);
            return;
        }
        if (result.code == '0') {
            item.classList.remove('is-progress');
            (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showModal(result.showInfoMessage);
        } else this.sendAjaxRequest(item);
    }
    /**
	 *
	 * @param {*} item
	 * @param {*} error
	 */ allowanceErrorHandler(item, error) {
        item.classList.remove('is-progress');
        (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).getDefaultErrorFnc(error);
    }
    /**
	 *
	 *
	 * @param {*} e
	 * @returns {*}
	 */ quantityChanger(e) {
        let decrementButton = e.target.parentElement.querySelector('.opc-button[data-op-qtychange="dec"]');
        let incrementButton = e.target.parentElement.querySelector('.opc-button[data-op-qtychange="inc"]');
        let inputField = e.target.parentElement.querySelector('input.basket-button-quantity');
        let step = parseFloat(inputField.getAttribute('step') || 1);
        let min = parseFloat(inputField.getAttribute('min') || step);
        let max = parseFloat(inputField.getAttribute('max') || 0);
        let isMaxSet = inputField.getAttribute('max') ? true : false;
        let artDimCheck = inputField.dataset.opArtdimcheckcd ? inputField.dataset.opArtdimcheckcd : 0;
        let oldValue = parseFloat(inputField.value) || 0;
        let hasChanged = false;
        let operator = null;
        // Wert erhoehen
        if (incrementButton && e.target === incrementButton) {
            operator = '+';
            if (oldValue < min) operator = '-';
        } else if (decrementButton && e.target === decrementButton) {
            operator = '-';
            if (oldValue > max && isMaxSet) operator = '+';
        } else if (e.keyCode === 13) {
            if (oldValue > max) operator = '+';
            else if (oldValue < min) operator = '-';
        }
        if (+artDimCheck > 0) {
            let multiplikator = this.countDecimals(step);
            let currentValPow = oldValue * Math.pow(10, multiplikator);
            let stepPow = step * Math.pow(10, multiplikator);
            if (currentValPow === 0 || currentValPow % stepPow !== 0 && oldValue >= min) {
                let result = (currentValPow + stepPow - currentValPow % stepPow) / Math.pow(10, multiplikator);
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage((0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageStepAdjust, (0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageStepAdjust.text.replace('{currentValue}', oldValue).replace('{newValue}', result).replace('{step}', step));
                operator = '+';
            }
        }
        hasChanged = this.setCalculatedQuantityField(oldValue, operator, inputField, step, min, max);
        return hasChanged;
    }
    /**
	 *
	 *
	 * @param {*} qtyField
	 * @param {boolean} [changeToValidQuantity=true]
	 * @returns {*}
	 */ validateQuantity(qtyField, changeToValidQuantity = true) {
        let step = parseFloat(qtyField.getAttribute('step') || 1);
        let min = parseFloat(qtyField.getAttribute('min') || step);
        let max = parseFloat(qtyField.getAttribute('max') || 0);
        let isMaxSet = qtyField.getAttribute('max') ? true : false;
        let currentVal = parseFloat(qtyField.value) || 0;
        let artDimCheck = qtyField.dataset.opArtdimcheckcd ? qtyField.dataset.opArtdimcheckcd : 0;
        if (currentVal < min || currentVal > max && isMaxSet) {
            let operator = null;
            if (currentVal > max && isMaxSet) operator = '+';
            else if (currentVal < min) operator = '-';
            this.setCalculatedQuantityField(currentVal, operator, qtyField, step, min, max);
            return false;
        }
        if (+artDimCheck > 0) {
            let multiplikator = this.countDecimals(step);
            let currentValPow = currentVal * Math.pow(10, multiplikator);
            let stepPow = step * Math.pow(10, multiplikator);
            if (currentValPow === 0 || currentValPow % stepPow !== 0) {
                if (changeToValidQuantity) {
                    let result = (currentValPow + stepPow - currentValPow % stepPow) / Math.pow(10, multiplikator);
                    (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage((0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageStepAdjust, (0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageStepAdjust.text.replace('{currentValue}', currentVal).replace('{newValue}', result).replace('{step}', step));
                    return this.setCalculatedQuantityField(currentVal, '+', qtyField, step, min, max);
                }
                return false;
            }
        } else if (+artDimCheck === 0) {
            let multiplikator = this.countDecimals(+qtyField.value);
            if (multiplikator > 2) {
                let result = parseFloat(qtyField.value).toFixed(2);
                qtyField.value = result;
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage((0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageToMuchDec, (0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageToMuchDec.text.replace('{newValue}', result));
            }
        }
        return true;
    }
    /**
	 *
	 *
	 * @param {*} currentVal
	 * @param {*} operator
	 * @param {*} qtyField
	 * @param {*} step
	 * @param {*} min
	 * @param {*} [max=null]
	 * @returns {*}
	 */ setCalculatedQuantityField(currentVal, operator, qtyField, step, min, max = null) {
        let multiplikator = this.countDecimals(step);
        let currentValPow = currentVal * Math.pow(10, multiplikator);
        let stepPow = step * Math.pow(10, multiplikator);
        let minPow = min * Math.pow(10, multiplikator);
        let maxPow = max * Math.pow(10, multiplikator);
        let newValuePow = currentValPow;
        let artDimCheck = qtyField.dataset.opArtdimcheckcd ? qtyField.dataset.opArtdimcheckcd : 0;
        switch(operator){
            case '-':
                newValuePow = currentValPow - (+artDimCheck === 0 ? stepPow : currentValPow % stepPow == 0 ? stepPow : currentValPow % stepPow);
                if (newValuePow < minPow) {
                    newValuePow = minPow;
                    (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage((0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageRangeUnderflow, (0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageRangeUnderflow.text.replace('{min}', min));
                }
                break;
            case '+':
            default:
                newValuePow = currentValPow + stepPow - (+artDimCheck > 0 ? currentValPow % stepPow : 0);
                if (maxPow != null && +maxPow > 0 && newValuePow > maxPow) {
                    newValuePow = maxPow;
                    (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage((0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageRangeOverflow, (0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageRangeOverflow.text.replace('{max}', max));
                }
                break;
        }
        // Wert veraendert und Step beruecksichtigt?
        if (newValuePow !== currentValPow) {
            if (newValuePow % stepPow === 0) {
                qtyField.value = parseFloat(newValuePow / Math.pow(10, multiplikator));
                return true;
            } else if (+artDimCheck === 0) {
                qtyField.value = parseFloat(newValuePow / Math.pow(10, multiplikator));
                return true;
            } else {
                newValuePow = currentValPow;
                (0, $aaf3d0fad38bd1f9$export$7c27567fcd9c9edb).showMessage((0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageStepMismatch, (0, $6a5d168af5ede3cd$export$7ea287b8bcd34b91).messageStepMismatch.text.replace('{step}', step));
            }
        }
        return false;
    }
    /**
	 *
	 *
	 * @param {*} value
	 * @returns {*}
	 */ countDecimals(value) {
        if (Math.floor(value) === value) return 0;
        return value.toString().split('.')[1].length || 0;
    }
    /**
	 *
	 *
	 */ changeDimVariant() {
        this.wrapperElement.addEventListener('change', (e)=>{
            let dimVariantSelectBox = e.target.closest('.basket-button-dim-variants');
            if (dimVariantSelectBox) {
                let selectedOption = dimVariantSelectBox.querySelector(`option[value="${dimVariantSelectBox.value}"]`);
                let dim1Value = selectedOption.dataset.opDim1value ? selectedOption.dataset.opDim1value : 0;
                let dim2Value = selectedOption.dataset.opDim2value ? selectedOption.dataset.opDim2value : 0;
                let dim3Value = selectedOption.dataset.opDim3value ? selectedOption.dataset.opDim3value : 0;
                let dim1Name = selectedOption.dataset.opDim1name ? selectedOption.dataset.opDim1name : '';
                let dim2Name = selectedOption.dataset.opDim2name ? selectedOption.dataset.opDim2name : '';
                let dim3Name = selectedOption.dataset.opDim3name ? selectedOption.dataset.opDim3name : '';
                let dim1Unit = selectedOption.dataset.opDim1unit ? selectedOption.dataset.opDim1unit : '';
                let dim2Unit = selectedOption.dataset.opDim2unit ? selectedOption.dataset.opDim2unit : '';
                let dim3Unit = selectedOption.dataset.opDim3unit ? selectedOption.dataset.opDim3unit : '';
                let artDimCheckCd = selectedOption.dataset.opArtdimcheckcd ? selectedOption.dataset.opArtdimcheckcd : '';
                let dim1Min = selectedOption.dataset.opDim1min ? selectedOption.dataset.opDim1min : '';
                let dim1Max = selectedOption.dataset.opDim1max ? selectedOption.dataset.opDim1max : '';
                let dim1Step = selectedOption.dataset.opStep ? selectedOption.dataset.opStep : '';
                // Überprüfung, ob die Dimensionen aktiv sind
                let dim1Active = dim1Name || dim1Unit;
                let dim2Active = dim2Name || dim2Unit;
                let dim3Active = dim3Name || dim3Unit;
                let basketButtonElem = e.target.closest(this.basketButtonContainer);
                let basketButton = basketButtonElem.querySelector('button[data-op-btnaction="add"]');
                if (!basketButton) basketButton = basketButtonElem.querySelector('button[data-op-btnaction="change"]');
                // Wenn Dimensionsvariante ändert, diese auf dem Warenkorb-Button nachführen
                if (basketButton && basketButton.dataset.opVariant) basketButton.dataset.opVariant = dimVariantSelectBox.value;
                let dim1 = basketButtonElem.querySelector('.basket-button-dim-1');
                let dim2 = basketButtonElem.querySelector('.basket-button-dim-2');
                let dim3 = basketButtonElem.querySelector('.basket-button-dim-3');
                dim1.classList.remove('is-inactive');
                dim2.classList.remove('is-inactive');
                dim3.classList.remove('is-inactive');
                // Falls Dimension 1 und 2 nicht aktiv sind, wird das Element als "inactive" gekennzeichnet
                if (!(dim1Active && dim2Active)) dim2.classList.add('is-inactive');
                // Falls Dimension 1 und 3 nicht aktiv sind, wird das Element als "inactive" gekennzeichnet
                if (!(dim1Active && dim3Active)) dim3.classList.add('is-inactive');
                // Falls mehrere Dimensionen aktiv sind, wird das umschliessende Element als "multi-dim" gekennzeichnet
                if (dim2Active || dim3Active) basketButtonElem.dataset.opType = 'multi-dim';
                else basketButtonElem.dataset.opType = 'single-dim';
                let inputFieldDim1 = dim1.querySelector('.basket-button-quantity');
                let inputFieldDim2 = dim2.querySelector('.basket-button-quantity');
                let inputFieldDim3 = dim3.querySelector('.basket-button-quantity');
                inputFieldDim1.value = dim1Value ? dim1Value : '';
                inputFieldDim1.dataset.opArtdimcheckcd = artDimCheckCd ? artDimCheckCd : '';
                if (+dim1Min > 0) inputFieldDim1.setAttribute('min', dim1Min);
                else inputFieldDim1.removeAttribute('min');
                if (+dim1Max > 0) inputFieldDim1.setAttribute('max', dim1Max);
                else inputFieldDim1.removeAttribute('max');
                if (+dim1Step > 0) inputFieldDim1.setAttribute('step', dim1Step);
                else inputFieldDim1.removeAttribute('step');
                inputFieldDim2.value = dim2Value ? dim2Value : '';
                inputFieldDim3.value = dim3Value ? dim3Value : '';
                let dim1NameElement = dim1.querySelector('.basket-button-dim-name') || undefined;
                let dim1UnitElement = dim1.querySelector('.basket-button-dim-unit') || undefined;
                let dim2NameElement = dim2.querySelector('.basket-button-dim-name') || undefined;
                let dim2UnitElement = dim2.querySelector('.basket-button-dim-unit') || undefined;
                let dim3NameElement = dim3.querySelector('.basket-button-dim-name') || undefined;
                let dim3UnitElement = dim3.querySelector('.basket-button-dim-unit') || undefined;
                if (dim1NameElement) dim1NameElement.innerHTML = dim1Name.length > 0 ? dim1Name : '';
                if (dim1UnitElement) dim1UnitElement.innerHTML = dim1Unit.length > 0 ? dim1Unit : '';
                if (dim2NameElement) dim2NameElement.innerHTML = dim2Name.length > 0 ? dim2Name : '';
                if (dim2UnitElement) dim2UnitElement.innerHTML = dim2Unit.length > 0 ? dim2Unit : '';
                if (dim3NameElement) dim3NameElement.innerHTML = dim3Name.length > 0 ? dim3Name : '';
                if (dim3UnitElement) dim3UnitElement.innerHTML = dim3Unit.length > 0 ? dim3Unit : '';
            }
        });
    }
    /**
	 *
	 *
	 * @param {*} item
	 */ showSuccessIndicator(item) {
        item.classList.toggle('is-success');
        let indicator = setTimeout(()=>{
            item.classList.toggle('is-success');
            clearTimeout(indicator);
        }, 1500);
    }
}




class $de1a07f4e1b8eb42$export$50cf78501d88e325 extends (0, $c0f1e51770d9929c$export$bafec49fd4471dd5) {
    constructor(){
        super();
        this.attachEventListener();
    }
    /**
	 *
	 *
	 */ attachEventListener() {
        if (this.wrapperElement) this.wrapperElement.addEventListener('click', (e)=>{
            let button = e.target.closest('.opc-payment-infos .opc-radio > label');
            if (button) {
                let parent = button.closest('.opc-payment-infos');
                let targetId = parent.closest('.payment-selection').dataset.opHref;
                let allOptions = parent.querySelectorAll('input');
                let selectedOption = button.parentNode.querySelector('input');
                Array.from(allOptions).forEach((item)=>{
                    item.removeAttribute('checked');
                });
                if (selectedOption) {
                    selectedOption.setAttribute('checked', 'checked');
                    let data = {
                        type: 'basket',
                        action: 'payment',
                        paymentType: selectedOption.value,
                        pluginId: 'paymentType'
                    };
                    let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
                    (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, data, this.refreshContent.bind(this, targetId), this.asyncErrorHandler.bind(this), true);
                }
            }
        }, false);
    }
}




class $16a3d4e028618c99$export$45b39005ea43b62b extends (0, $c0f1e51770d9929c$export$bafec49fd4471dd5) {
    constructor(){
        super();
        this.basketShippingAmountSelector = '[data-op-asyncbasket="shippingTotalAmount"]';
        this.attachEventListener();
    }
    /**
	 *
	 *
	 */ attachEventListener() {
        if (this.wrapperElement) this.wrapperElement.addEventListener('click', (e)=>{
            // get selected Option
            let button = e.target.closest('.opc-shipping-infos .opc-radio > label');
            if (button) {
                let parent = button.closest('.opc-shipping-infos');
                let targetId = parent.closest('.delivery-selection').dataset.opHref;
                let allOptions = parent.querySelectorAll('input');
                let selectedOption = button.parentNode.querySelector('input');
                Array.from(allOptions).forEach((item)=>{
                    item.removeAttribute('checked');
                });
                if (selectedOption) {
                    selectedOption.setAttribute('checked', 'checked');
                    let data = {
                        type: 'basket',
                        action: 'shipping',
                        shippingNo: selectedOption.value,
                        pluginId: 'deliveryType'
                    };
                    let url = (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).setAsyncUrl();
                    (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, data, this.refreshContent.bind(this, targetId), this.asyncErrorHandler.bind(this), true);
                }
            }
        }, false);
    }
}


const $a49765a0f94717ea$export$4ac91e258d633ce3 = new (0, $34e260eadd36b70e$export$346e946584e7b817)();
const $a49765a0f94717ea$export$f2dc53b01268984e = new (0, $5095b12b38fb97ef$export$c42c30b194410598)();
const $a49765a0f94717ea$export$884c3cdfd727bc7b = new (0, $de1a07f4e1b8eb42$export$50cf78501d88e325)();
const $a49765a0f94717ea$export$d5e25ff28ab0a4f3 = new (0, $16a3d4e028618c99$export$45b39005ea43b62b)();




class $7e8fe7cc6354827b$export$6d5235c27656a24f {
    constructor(){
        this.replaceToActionUrl();
        this.searchTermAsUrlParam = true;
        this.navigationSectionSelector = '.section a';
        this.buttonOpen = document.querySelectorAll('.search-toggle');
        this.buttonClose = document.querySelectorAll('.search-head > .opc-button');
        this.wrapperElement = document.querySelectorAll('.opc-search');
        this.attachEventListener();
    }
    /**
	 *
	 *
	 */ attachEventListener() {
        //search-toggle
        Array.from(this.buttonOpen).forEach((elem)=>{
            elem.addEventListener('click', (e)=>{
                if (e.target.classList.contains('mobile')) {
                    document.querySelector('html').classList.add('search-open');
                    let search = document.querySelector(".search-query");
                    if (search) search.focus();
                } else Array.from(this.wrapperElement).forEach((wrapper)=>{
                    let searchType = false;
                    if (wrapper.dataset.opType) searchType = wrapper.dataset.opType;
                });
            });
        });
        Array.from(this.buttonClose).forEach((elem)=>{
            elem.addEventListener('click', ()=>{
                document.querySelector('html').classList.remove('search-open');
            });
        });
        document.addEventListener('click', (e)=>{
            if (e.target.closest('.opc-search') === null) Array.from(this.wrapperElement).forEach((wrapper)=>{
                let searchType = false;
                if (wrapper.dataset.opType) searchType = wrapper.dataset.opType;
            });
        });
        Array.from(this.wrapperElement).forEach((wrapper)=>{
            let directSearchForm = wrapper.querySelector('form');
            let timer = 0;
            // close mobile overlay on click
            let mobileSearchOverlay = directSearchForm.querySelector('.opc-button[data-op-action=\'close\']');
            if (mobileSearchOverlay) mobileSearchOverlay.addEventListener('click', ()=>{
                wrapper.classList.remove('is-open');
            });
            // keyup on input-field
            directSearchForm.querySelector('.opc-search-content > .opc-search-query > input').addEventListener('keyup', (e)=>{
                let queryWrapper = e.target.closest(".opc-search-query");
                queryWrapper.classList.add("loading");
                let input = e.currentTarget;
                let asyncViewElement = wrapper.querySelector('.opc-search-results');
                if (input instanceof HTMLInputElement && this.keyCodeAllowed(e.keyCode)) {
                    clearTimeout(timer);
                    timer = setTimeout(()=>{
                        this.getSuggest(input, wrapper);
                    }, 500);
                    asyncViewElement.innerHTML = '';
                } else if (e.keyCode === 27) {
                    this.hideAsyncViewElement(wrapper);
                    queryWrapper.classList.remove("loading");
                } else if (e.keyCode === 40) {
                    asyncViewElement.querySelector(this.navigationSectionSelector).parentNode.firstElementChild.classList.add('focus').focus();
                    queryWrapper.classList.remove("loading");
                }
            });
            //Submit search
            directSearchForm.addEventListener('submit', (e)=>{
                let formInputElement = e.currentTarget.querySelector('.opc-search-content > .opc-search-query > input');
                let input = this.validateSearchInput(formInputElement);
                if (input.valid) {
                    let searchTermUrlParam = formInputElement.getAttribute('data-urlParam');
                    let filter = this.getFilter(formInputElement);
                    // add hidden-field to form
                    let hidden = document.createElement('input');
                    hidden.setAttribute('type', 'hidden');
                    hidden.setAttribute('name', 'f-directsearchsuggest-filter-attribute');
                    hidden.setAttribute('value', filter.attribute);
                    directSearchForm.appendChild(hidden);
                    let searchTerm = document.createElement('input');
                    searchTerm.setAttribute('type', 'hidden');
                    searchTerm.setAttribute('name', searchTermUrlParam);
                    searchTerm.setAttribute('value', input.value);
                    directSearchForm.appendChild(searchTerm);
                    if (this.searchTermAsUrlParam && searchTermUrlParam) {
                        let action = directSearchForm.action;
                        if (action.indexOf('?') > 0) action += `&${searchTermUrlParam}=${encodeURIComponent(input.value)}`;
                        else action += `?${searchTermUrlParam}=${encodeURIComponent(input.value)}`;
                        directSearchForm.action = action;
                        sessionStorage.setItem('searchActionUrl', action); // setzt temporär die Action URL in den Session Storage
                    }
                    return true;
                }
                e.preventDefault();
                return false;
            });
        });
    }
    /**
	 *
	 *
	 * @param {*} elem
	 * @returns {*}
	 */ getFilter(elem) {
        let filter = elem.parentNode.querySelector('.f-directsearchsuggest-filter');
        let filterObj = {
            object: undefined,
            value: undefined,
            attribute: undefined
        };
        if (filter) {
            filterObj.object = filter;
            filterObj.value = filter.value;
            filterObj.attribute = filter.dataset.opDirectsearchsuggestFilterAttribute;
        }
        return filterObj;
    }
    /**
	 *
	 *
	 * @param {*} elem
	 * @returns {*}
	 */ validateSearchInput(elem) {
        let inputVal = elem.value.trim();
        let minLength = elem.dataset.opMinlength;
        return {
            minimum: minLength,
            value: inputVal,
            valid: inputVal && minLength && inputVal.length >= minLength
        };
    }
    /**
	 *
	 *
	 * @param {*} elem
	 * @param {*} wrapper
	 */ getSuggest(elem, wrapper) {
        let input = this.validateSearchInput(elem);
        let queryWrapper = elem.closest(".opc-search-query");
        if (input.valid) {
            let filter = this.getFilter(elem);
            //prepare Data for async
            let data = {
                type: 'directsearchsuggest',
                inputValue: input.value
            };
            if (filter.attribute) data.filterAttribute = filter.attribute;
            if (filter.value) data.filterValue = filter.value;
            let url = '/WebPortal/async.aspx';
            this.showAsnycViewElement(wrapper);
            (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(url, data, this.getDirectSearchSuggestDataFromResult.bind(this, wrapper), this.getDefaultErrorFnc, true);
        } else if (elem.value.trim().length > 0) {
            let msgTextNode = document.createTextNode((0, $6a5d168af5ede3cd$export$f625b980042672da).messageTooShort.text.replace('%1', input.minimum));
            let msgElem = document.createElement('div');
            msgElem.setAttribute('class', 'opc-directsearch-message');
            msgElem.dataset.opType = 'info';
            msgElem.appendChild(msgTextNode);
            let asyncViewElement = wrapper.querySelector('.opc-search-results');
            asyncViewElement.insertAdjacentElement('afterbegin', msgElem);
            this.showAsnycViewElement(wrapper);
            queryWrapper.classList.remove("loading");
        } else {
            this.hideAsyncViewElement(wrapper);
            queryWrapper.classList.remove("loading");
        }
    }
    /**
	 *
	 *
	 * @param {*} wrapper
	 */ showAsnycViewElement(wrapper) {
        let asyncViewElement = wrapper.querySelector('.opc-search-results');
        asyncViewElement.classList.add('is-open');
        asyncViewElement.style.display = 'block';
    }
    /**
	 *
	 *
	 * @param {*} wrapper
	 */ hideAsyncViewElement(wrapper) {
        let asyncViewElement = wrapper.querySelector('.opc-search-results');
        if (asyncViewElement.classList.contains('is-open')) {
            asyncViewElement.classList.remove('is-open');
            asyncViewElement.style.display = 'none';
            let msgElem = asyncViewElement.querySelector('opc-directsearch-message');
            if (msgElem) msgElem.remove();
        }
    }
    /**
	 *
	 *
	 * @param {*} wrapper
	 * @param {*} response
	 */ getDirectSearchSuggestDataFromResult(wrapper, response) {
        let asyncViewElement = wrapper.querySelector('.opc-search-results');
        asyncViewElement.innerHTML = response.dataAsJson.html;
        let queryWrapper = wrapper.querySelector(".opc-search-query");
        if (queryWrapper) queryWrapper.classList.remove("loading");
    }
    /**
	 *
	 *
	 * @param {*} keyCode
	 * @returns {*}
	 */ keyCodeAllowed(keyCode) {
        return keyCode !== 13 //ENTER
         && keyCode !== 37 //LEFT
         && keyCode !== 39 //RIGHT
         && keyCode !== 38 //UP
         && keyCode !== 40 //DOWN
         && keyCode !== 27 //ESCAPE);
        ;
    }
    /**
	 * Methode ersetzt die "GET URL" zu der "POST ACTION URL" aus dem Session Storage,
	 * damit die Paramter der URL wie die der "SearchTerm.URLParam" aus der application.cnf entsprechen.
	 */ replaceToActionUrl() {
        var actionUrl = sessionStorage.getItem('searchActionUrl');
        if (actionUrl) {
            history.replaceState(null, 'searchActionUrl', actionUrl);
            sessionStorage.removeItem('searchActionUrl');
        }
    }
}
new $7e8fe7cc6354827b$export$6d5235c27656a24f();



'use strict';
class $6f6d8709c9bfeb82$export$4aecfe44adafd14e {
    constructor(){
        this.articleAmountPerRequest = 20;
        this.buttonElementSelector = '.opc-segment-navigation .opc-button[data-op-href]';
        let articlePriceUrlWrapper = document.getElementById('article-price-url');
        if (articlePriceUrlWrapper && articlePriceUrlWrapper.hasAttribute('data-op-url') && articlePriceUrlWrapper.getAttribute('data-op-url') != '') {
            this.articlePriceUrl = articlePriceUrlWrapper.getAttribute('data-op-url');
            this.collectData();
        }
    }
    collectData() {
        this.artInternalNumbers = [];
        let artPriceWrappers = document.querySelectorAll('.article-price-wrapper[data-op-status="pending"]');
        Array.from(artPriceWrappers).forEach((artPriceWrapper)=>{
            if (artPriceWrapper.hasAttribute('data-op-art-internalno') && artPriceWrapper.getAttribute('data-op-art-internalno') != '') {
                this.artInternalNumbers.push(artPriceWrapper.getAttribute('data-op-art-internalno'));
                artPriceWrapper.setAttribute('data-op-status', 'loading');
            }
        });
        if (this.artInternalNumbers.length > 0) this.loadPrice();
    }
    loadPrice() {
        let artIntNoString = '';
        let totalCounter = 1;
        let currentCounter = 1;
        //group artinternals for multiple requests
        this.artInternalNumbers.forEach((artInternalNo)=>{
            if (currentCounter > 1) artIntNoString += ',';
            artIntNoString += String(artInternalNo);
            // group articles for requests
            if (currentCounter % this.articleAmountPerRequest === 0 || totalCounter === this.artInternalNumbers.length) {
                let data = {
                    artIntNoPrice: artIntNoString
                };
                (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).fetchAsynPostForm(this.articlePriceUrl, data, this.showPrice.bind(this), (0, $aaf3d0fad38bd1f9$export$404e5c179052a7f8).getDefaultErrorFnc, true);
                currentCounter = 1;
                artIntNoString = '';
            } else currentCounter++;
            totalCounter++;
        });
    }
    showPrice(response) {
        let jsonResponse = JSON.parse(response.dataAsHtml);
        Array.from(jsonResponse.price).forEach((priceInfo)=>{
            let priceTargetWrappers = document.querySelectorAll('.article-price-wrapper[data-op-art-internalno="' + priceInfo.artIntNo + '"]');
            Array.from(priceTargetWrappers).forEach((priceTargetWrapper)=>{
                priceTargetWrapper.innerHTML = this.htmlDecode(priceInfo.text);
                let additionalevpcontainter = priceTargetWrapper.parentElement.nextElementSibling;
                if (additionalevpcontainter) priceTargetWrapper.parentElement.nextElementSibling.innerHTML = this.htmlDecode(priceInfo.evp);
                priceTargetWrapper.setAttribute('data-op-status', 'done');
            });
        });
        let resultWrapperSelector = '.result-view-wrapper';
        if (document.querySelector(resultWrapperSelector)) {
            if (document.querySelector(this.buttonElementSelector)) (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).set('persistentView', (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).getCurrentURI(), resultWrapperSelector, this.buttonElementSelector);
            else (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).set('persistentView', (0, $aaf3d0fad38bd1f9$export$9cb8825bd162cc38).getCurrentURI(), resultWrapperSelector);
        }
    }
    htmlDecode(input) {
        if (!this.shadowPlaceholder) this.shadowPlaceholder = document.createElement('div');
        else this.shadowPlaceholder.innerHTML = '';
        this.shadowPlaceholder.innerHTML = input;
        return this.shadowPlaceholder.childNodes[0].nodeValue;
    }
}




class $8faf236c931786f5$export$b6032183171af19f {
    constructor(){
        new (0, $6f6d8709c9bfeb82$export$4aecfe44adafd14e);
        this.contentChangeEventListener();
        this.headerActions = document.querySelector('.header-actions');
        this.userMenu = document.querySelector('.account-link-user-menu');
        this.viewPort = document.querySelector('.viewport');
        this.scrollBar;
        this.initScrollbars();
        this.initScrollbarsDirectSearch();
        // editmode all
        this.editMode = document.querySelectorAll('button[data-op-editmode-all]');
        this.editClass = 'is-changing';
        this.datePickers = document.querySelectorAll('.swa-timepicker');
        if (this.datePickers) {
            this.OpaccFormElementDateTimePicker = new (0, $135e26651cefb271$export$14647c88ce36fe14);
            this.initCustomDateTimePickers();
        }
        this.attachEventListener();
        this.loadMoreItems = document.querySelector(".opc-segment-navigation .opc-button");
        this.initArticleListScrollObserver();
    }
    attachEventListener() {
        // Edit-Mode aktivieren im Account
        if (this.editMode) Array.from(this.editMode).forEach((button)=>{
            button.addEventListener('click', (event)=>{
                if (button.getAttribute('data-op-editmode-all') === 'column') {
                    event.preventDefault();
                    button.setAttribute("data-op-editmode-all", "check");
                    let form = button.closest("form");
                    let editableColumns = form.querySelectorAll('.editmode');
                    Array.from(editableColumns).forEach((e)=>{
                        let column = e.closest(".opc-col");
                        if (!column.classList.contains(this.editClass)) column.classList.add(this.editClass);
                    });
                }
            });
        });
        if (this.headerActions && this.userMenu) this.viewPort.addEventListener('click', (e)=>{
            if (e.target.closest('.account-link > a')) {
                e.preventDefault();
                this.userMenu.classList.add("is-open");
            } else this.userMenu.classList.remove("is-open");
        });
        document.addEventListener("click", (e)=>{
            if (e.target.closest('.close-addr-edit-form')) e.target.closest('.is-changing').classList.remove("is-changing");
        });
    }
    contentChangeEventListener() {
        let contentWrapper = document.querySelector('.content');
        if (contentWrapper) contentWrapper.addEventListener('change', (e)=>{
            this.loadMoreItems = document.querySelector(".opc-segment-navigation:last-child .opc-button");
            new (0, $6f6d8709c9bfeb82$export$4aecfe44adafd14e);
        });
    }
    initArticleListScrollObserver() {
        document.addEventListener("scroll", (e)=>{
            if (this.loadMoreItems && !this.loadMoreItems.parentElement.parentElement.classList.contains('custadmin')) {
                let bounding = this.loadMoreItems.getBoundingClientRect();
                if (this.loadMoreItems.offsetParent !== null) {
                    if (bounding.bottom - 100 <= (window.innerHeight || document.documentElement.clientHeight)) {
                        if (!this.loadMoreItems.classList.contains("is-progress")) this.loadMoreItems.click();
                    }
                }
            }
        });
    }
    initScrollbars() {
        let sbfullscreenMenu = document.querySelector('.offcanvas-menu-wrapper');
        if (sbfullscreenMenu != null) this.scrollBar = new SimpleBar(sbfullscreenMenu, {
            autoHide: false,
            forceVisible: false
        });
    }
    initScrollbarsDirectSearch() {
        let sbfullscreenMenu = document.querySelector('.search-body');
        if (sbfullscreenMenu != null) this.scrollBar = new SimpleBar(sbfullscreenMenu, {
            autoHide: false,
            forceVisible: false
        });
    }
    initCustomDateTimePickers() {
        Array.from(this.datePickers).forEach((datePicker)=>{
            let inputField = datePicker.querySelector('input[type="text"]');
            let langCode = datePicker.dataset.langcode;
            if (inputField) {
                const defaultSettings = {
                    enableTime: true,
                    noCalendar: false,
                    dateFormat: 'd.m.Y H:i',
                    time_24hr: true,
                    minTime: "09:00",
                    maxTime: "18:00",
                    minuteIncrement: 30,
                    enableSeconds: false,
                    appendTo: datePicker,
                    allowInput: true,
                    locale: (0, $69c921925b448778$export$2e2bcd8739ae039)[langCode],
                    minDate: "today",
                    "disable": [
                        function(date) {
                            // return true to disable
                            return date.getDay() === 0 || date.getDay() === 1;
                        }
                    ]
                };
                let timePicker = this.OpaccFormElementDateTimePicker.createDateTimePicker(inputField, defaultSettings);
                this.OpaccFormElementDateTimePicker.triggerDateTimePickerEvents(timePicker);
            }
        });
    }
}
new $8faf236c931786f5$export$b6032183171af19f();





})();
//# sourceMappingURL=basket.js.map
